import { AlertModule } from 'ngx-bootstrap/alert';
export { AlertModule } from 'ngx-bootstrap/alert';
export { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
export { TooltipModule } from 'ngx-bootstrap/tooltip';
export { AgmCoreModule } from '@agm/core';
import { EventEmitter, Component, Input, Output, NgModule, Inject, ViewChild, HostListener, forwardRef, Host, SkipSelf, ElementRef, Renderer2, ViewEncapsulation, Optional, ComponentFactoryResolver, ViewContainerRef, Injectable, ɵɵdefineInjectable, ɵɵinject, Directive, CUSTOM_ELEMENTS_SCHEMA, HostBinding, Pipe } from '@angular/core';
import { CommonModule, DOCUMENT, DatePipe, TitleCasePipe } from '@angular/common';
import { trigger, state, style, transition, animate, query, stagger } from '@angular/animations';
import { NG_VALUE_ACCESSOR, ControlContainer, FormControl, FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, NgControl, Validators } from '@angular/forms';
import { __values, __extends, __assign } from 'tslib';
import { BsLocaleService, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { esLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BehaviorSubject, Subject as Subject$1, EMPTY, interval } from 'rxjs';
import { debounceTime, tap, takeUntil, map, filter, distinctUntilChanged } from 'rxjs/operators';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subject } from 'rxjs/internal/Subject';
import { isNullOrUndefined } from 'util';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Observable } from 'rxjs/index';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, By } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/icon/icon.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconComponent = /** @class */ (function () {
    function IconComponent() {
        this.id = '';
        this.class = '';
        this.size = '1';
        this.disabled = false;
        this.click = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    IconComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        /** @type {?} */
        var shouldSetClasses = !!(changes.icon || changes.class);
        if (shouldSetClasses) {
            this.setClasses();
        }
    };
    /**
     * @return {?}
     */
    IconComponent.prototype.setClasses = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var classes = {};
        classes['sc-icon--clickable'] = !!this.click.observers.length;
        classes['sc-icon--disabled'] = this.disabled;
        classes["sc-icon--" + this.size + "x"] = !!this.size;
        classes["icon-" + this.icon] = !!this.icon;
        classes[this.class] = true;
        if (classes['icon-loading']) {
            classes['sc-animate-spin-normal'] = true;
        }
        else {
            delete classes['sc-animate-spin-normal'];
        }
        this.classes = classes;
    };
    IconComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-icon',
                    template: "<span class=\"sc-icon\" [id]=\"id\" [ngClass]=\"classes\"></span>",
                    styles: [".sc-icon--0_5x{font-size:.5rem}.sc-icon--0_75x{font-size:.75rem}.sc-icon--1x{font-size:1rem}.sc-icon--1_25x{font-size:1.25rem}.sc-icon--1_5x{font-size:1.5rem}.sc-icon--1_75x{font-size:1.75rem}.sc-icon--2x{font-size:2rem}.arrow-down-dropdown-blue,.arrow-up-dropdown-blue{color:#0070cc;font-size:14px}.icon-check:before{color:#3dcc98}.has-errors .arrow-down-dropdown-blue:before,.icon-close-elipse:before{color:#dc3545}.icon-loading{display:inline-block}.sc-icon--disabled{color:#424f66}"]
                }] }
    ];
    /** @nocollapse */
    IconComponent.ctorParameters = function () { return []; };
    IconComponent.propDecorators = {
        icon: [{ type: Input }],
        size: [{ type: Input }],
        class: [{ type: Input }],
        id: [{ type: Input }],
        disabled: [{ type: Input }],
        click: [{ type: Output }]
    };
    return IconComponent;
}());
if (false) {
    /** @type {?} */
    IconComponent.prototype.icon;
    /** @type {?} */
    IconComponent.prototype.size;
    /** @type {?} */
    IconComponent.prototype.class;
    /** @type {?} */
    IconComponent.prototype.id;
    /** @type {?} */
    IconComponent.prototype.disabled;
    /** @type {?} */
    IconComponent.prototype.click;
    /** @type {?} */
    IconComponent.prototype.classes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/icon/icon.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconModule = /** @class */ (function () {
    function IconModule() {
    }
    IconModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [IconComponent],
                    exports: [IconComponent]
                },] }
    ];
    return IconModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/animations/slide-fade.animation.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var slideFade = trigger('slideFade', [
    state('void', style({
        height: 0,
        overflow: 'hidden'
    })),
    state('out', style({
        height: 0,
        overflow: 'hidden',
        zIndex: -1,
        opacity: 0
    })),
    state('in', style({
        zIndex: 100
    })),
    transition('* <=> *', animate('300ms')),
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accordion/policy-change-validation.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolicyChangeValidationModel = /** @class */ (function () {
    function PolicyChangeValidationModel() {
    }
    return PolicyChangeValidationModel;
}());
if (false) {
    /** @type {?} */
    PolicyChangeValidationModel.prototype.canStart;
    /** @type {?} */
    PolicyChangeValidationModel.prototype.message;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accordion/accordion.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccordionComponent = /** @class */ (function () {
    function AccordionComponent() {
        this.canEdit = false;
        this.editClicked = new EventEmitter();
        this.changed = new EventEmitter();
    }
    /**
     * @return {?}
     */
    AccordionComponent.prototype.onClickOpen = /**
     * @return {?}
     */
    function () {
        this.isOpen = !this.isOpen;
        this.changed.emit();
    };
    /**
     * @return {?}
     */
    AccordionComponent.prototype.handleEditClicked = /**
     * @return {?}
     */
    function () {
        this.editClicked.emit();
    };
    AccordionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-accordion',
                    template: "<div class=\"row accordion\">\n  <div class=\"col-md-8 col-sm-9 accordion__cursor\">\n    <sc-title type=\"h3\" [content]=\"title\" (click)=\"onClickOpen()\"></sc-title>\n  </div>\n  <div class=\"col-md-4 col-sm-3 text-right\">\n    <sc-edit-button\n      *ngIf=\"canEdit\"\n      class=\"accordion__edit-button\"\n      [loading]=\"editLoading\"\n      [disabled]=\"editValidation?.canStart === false\"\n      [disabledMessage]=\"editValidation?.message\"\n      [tooltipText]=\"tooltipText\"\n      (click)=\"handleEditClicked()\"></sc-edit-button>\n    <sc-icon class=\"accordion__toggler\" [class.accordion__toggler--open]=\"isOpen\" icon=\"arrow-down\" (click)=\"onClickOpen()\"></sc-icon>\n  </div>\n  <div class=\"col-md-12 pl-0 pr-0\" [@slideFade]=\"isOpen ? 'in' : 'out'\">\n    <ng-content>\n    </ng-content>\n  </div>\n</div>",
                    animations: [slideFade],
                    styles: [".accordion{border-bottom:1px solid #ccd2dd;margin:0;padding:1.25rem 0}.accordion__edit-button{margin-right:1rem}.accordion__toggler{cursor:pointer;display:inline-block;line-height:.5rem;color:#0070cc;margin-top:.5rem;transition:.3s ease-in-out}.accordion__toggler--open{transform:rotate(180deg)}@media screen and (max-width:768px){.accordion__edit-button{margin-right:.5rem}.accordion__toggler{transform:rotate(-90deg)}}.accordion__cursor{cursor:pointer;padding-left:0}"]
                }] }
    ];
    /** @nocollapse */
    AccordionComponent.ctorParameters = function () { return []; };
    AccordionComponent.propDecorators = {
        title: [{ type: Input }],
        isOpen: [{ type: Input }],
        canEdit: [{ type: Input }],
        editLoading: [{ type: Input }],
        editValidation: [{ type: Input }],
        tooltipText: [{ type: Input }],
        changed: [{ type: Output }],
        editClicked: [{ type: Output }]
    };
    return AccordionComponent;
}());
if (false) {
    /** @type {?} */
    AccordionComponent.prototype.title;
    /** @type {?} */
    AccordionComponent.prototype.isOpen;
    /** @type {?} */
    AccordionComponent.prototype.canEdit;
    /** @type {?} */
    AccordionComponent.prototype.editLoading;
    /** @type {?} */
    AccordionComponent.prototype.editValidation;
    /** @type {?} */
    AccordionComponent.prototype.tooltipText;
    /** @type {?} */
    AccordionComponent.prototype.changed;
    /** @type {?} */
    AccordionComponent.prototype.editClicked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accordion/edit-button/edit-button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EditButtonComponent = /** @class */ (function () {
    function EditButtonComponent() {
        this.loading = false;
        this.disabled = false;
    }
    EditButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-edit-button',
                    template: "<sc-icon\n    *ngIf=\"!(loading || disabled)\"\n    icon=\"edit\" \n    class=\"edit-button\"></sc-icon>\n<sc-icon icon=\"loading\" *ngIf=\"loading && !disabled\" class=\"loading\"></sc-icon>\n<sc-tooltip *ngIf=\"disabled\"\n    [description]=\"disabledMessage\"\n    position=\"left\"\n    class=\"small\"\n    descriptionClasses=\"text-left\">\n    <sc-icon icon=\"edit\" class=\"edit-button edit-button--disabled\"></sc-icon>\n</sc-tooltip>\n<span class=\"basic-tooltip\">{{ tooltipText }}</span>",
                    styles: [":host{position:relative;padding:1rem}:host .edit-button{color:#0070cc;cursor:pointer}:host .edit-button--disabled{color:#8993a4;cursor:default}:host .loading{color:#0070cc}:host .basic-tooltip{position:absolute;left:0;top:0;transform:translate(-15%,-110%);font-size:.875rem;line-height:1rem;background-color:#fff;padding:.5rem;word-wrap:none;opacity:0;border:1px solid #edf0f5;box-shadow:0 2px 4px 0 rgba(0,0,0,.27);border-radius:4px;text-align:center;transition:.1s ease-out}:host .edit-button:hover+.basic-tooltip{transform:translate(-15%,-90%);opacity:1}"]
                }] }
    ];
    EditButtonComponent.propDecorators = {
        loading: [{ type: Input }],
        disabled: [{ type: Input }],
        disabledMessage: [{ type: Input }],
        tooltipText: [{ type: Input }]
    };
    return EditButtonComponent;
}());
if (false) {
    /** @type {?} */
    EditButtonComponent.prototype.loading;
    /** @type {?} */
    EditButtonComponent.prototype.disabled;
    /** @type {?} */
    EditButtonComponent.prototype.disabledMessage;
    /** @type {?} */
    EditButtonComponent.prototype.tooltipText;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/tooltip/tooltip.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TooltipComponent = /** @class */ (function () {
    function TooltipComponent(document) {
        this.document = document;
        this.position = 'right';
        this.isTooltipOpen = false;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    TooltipComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes && changes.externallyOpen) {
            this.toggleTooltip(changes.externallyOpen.currentValue);
        }
    };
    /**
     * @return {?}
     */
    TooltipComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.isMobile = (window.innerWidth <= 768);
        this.contentPositionClass = "sc-tooltip__content--" + this.position;
        this.carretPositionClass = "content__carret--" + this.position;
    };
    /**
     * @return {?}
     */
    TooltipComponent.prototype.onResize = /**
     * @return {?}
     */
    function () {
        this.isMobile = (window.innerWidth <= 768);
    };
    /**
     * @param {?} shouldOpen
     * @return {?}
     */
    TooltipComponent.prototype.toggleTooltip = /**
     * @param {?} shouldOpen
     * @return {?}
     */
    function (shouldOpen) {
        this.isTooltipOpen = shouldOpen;
        if (this.tooltipContentRef) {
            /** @type {?} */
            var bottom = this.document.documentElement.clientHeight - this.tooltipContentRef.nativeElement.getBoundingClientRect().bottom;
            if (bottom < 10) {
                this.position = this.position === 'left' ? 'top-left' : 'top';
            }
        }
        this.contentPositionClass = "sc-tooltip__content--" + this.position;
        this.carretPositionClass = "content__carret--" + this.position;
    };
    TooltipComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-tooltip',
                    template: "<div class=\"sc-tooltip\" (mouseenter)=\"toggleTooltip(true)\" (mouseleave)=\"toggleTooltip(false)\">\n    <ng-content></ng-content>\n    <div class=\"sc-tooltip__overlay\" *ngIf=\"isMobile && isTooltipOpen\"></div>\n    <div class=\"sc-tooltip__content\"\n        [class.no-title]=\"!title\"\n        [class.no-description]=\"!description\"\n        [ngClass]=\"contentPositionClass\" [class.open]=\"isTooltipOpen\" #tooltipContent>\n        <span class=\"sc-icon icon-close-elipse content__close-button\" (click)=\"toggleTooltip(false)\"\n              *ngIf=\"isMobile\"></span>\n        <div class=\"content__title\" *ngIf=\"title\" [ngClass]=\"titleClasses\" [innerHTML]=\"title\"></div>\n        <div class=\"content__description\" *ngIf=\"description\" [ngClass]=\"descriptionClasses\" [innerHTML]=\"description\"></div>\n        <div class=\"content__carret\" [ngClass]=\"carretPositionClass\" *ngIf=\"isTooltipOpen\"></div>\n    </div>\n</div>\n",
                    styles: [".sc-tooltip{display:inline-block;position:relative}.sc-tooltip__content{visibility:hidden;position:absolute;min-width:20rem;border:1px solid #ccd2dd;border-radius:2px;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,28,51,.06);z-index:999;padding:25px;text-align:center}.sc-tooltip__content--right{left:calc(100% + 25px);top:-31px}.sc-tooltip__content--top{bottom:calc(100% + 25px);left:-31px}.sc-tooltip__content--top-left{bottom:calc(100% + 25px);left:initial;right:-1rem}.sc-tooltip__content--left{right:calc(100% + 25px);top:-31px}.sc-tooltip__content .content__title{font-size:14px}.sc-tooltip__content .content__description{color:#8993a4;font-size:14px;line-height:24px}.sc-tooltip__content .content__carret{position:absolute;width:19px;height:19px;background-color:#fff;transform:rotate(45deg)}.sc-tooltip__content .content__carret--right{top:30px;left:-10px;border-bottom:1px solid #ccd2dd;border-left:1px solid #ccd2dd}.sc-tooltip__content .content__carret--top{bottom:-10px;left:30px;border-bottom:1px solid #ccd2dd;border-right:1px solid #ccd2dd}.sc-tooltip__content .content__carret--top-left{bottom:-10px;left:initial;right:1rem;border-bottom:1px solid #ccd2dd;border-right:1px solid #ccd2dd}.sc-tooltip__content .content__carret--left{top:30px;right:-10px;border:1px solid #ccd2dd;border-bottom-width:0;border-left-width:0}.sc-tooltip__content:not(.no-description) .content__title{margin-bottom:15px}.sc-tooltip .open{visibility:visible}@media (max-width:768px){.sc-tooltip__overlay{position:fixed;top:0;left:0;height:100%;width:100%;z-index:998;background-color:rgba(0,0,0,.38)}.sc-tooltip__content{position:fixed;top:initial;left:0;bottom:0;width:100%;background-color:#fff;padding:1rem;font-size:14px;line-height:24px;border:initial;max-height:0;transition:max-height .5s;z-index:999;text-align:right}.sc-tooltip__content .content__title{text-align:left;margin:0 0 15px 25px}.sc-tooltip__content .content__description{text-align:left;margin:25px}.sc-tooltip__content .content__carret{display:none}.sc-tooltip__content .content__close-button{color:#0070cc}.sc-tooltip__content.no-title .content__description{margin-top:0}.sc-tooltip .open{max-height:300px;transition:max-height .5s}}:host(.small) .sc-tooltip__content{padding:.5rem 1rem;min-height:3rem;top:-1rem;left:calc(100% + 1.25rem)}:host(.small) .sc-tooltip__content--left{left:initial;right:calc(100% + 1.25rem)}:host(.small) .sc-tooltip__content--top{top:initial;bottom:calc(100% + 1rem);left:-1rem}:host(.small) .sc-tooltip__content--top-left{top:initial;bottom:calc(100% + 1rem);left:initial;right:-1rem}@media (max-width:768px){:host(.small) .sc-tooltip__content{top:initial;bottom:0;left:0;right:0}}:host(.small) .sc-tooltip__content .content__carret{width:14px;height:14px;top:calc(1rem - 2px);left:-8px}:host(.small) .sc-tooltip__content .content__carret--left{left:initial;right:-8px}:host(.small) .sc-tooltip__content .content__carret--top{top:initial;bottom:-8px;left:1rem}:host(.small) .sc-tooltip__content .content__carret--top-left{top:initial;bottom:-8px;left:initial;right:1rem}"]
                }] }
    ];
    /** @nocollapse */
    TooltipComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    TooltipComponent.propDecorators = {
        title: [{ type: Input }],
        description: [{ type: Input }],
        position: [{ type: Input }],
        externallyOpen: [{ type: Input }],
        titleClasses: [{ type: Input }],
        descriptionClasses: [{ type: Input }],
        tooltipContentRef: [{ type: ViewChild, args: ['tooltipContent', { static: true },] }],
        onResize: [{ type: HostListener, args: ['window:resize',] }]
    };
    return TooltipComponent;
}());
if (false) {
    /** @type {?} */
    TooltipComponent.prototype.title;
    /** @type {?} */
    TooltipComponent.prototype.description;
    /** @type {?} */
    TooltipComponent.prototype.position;
    /** @type {?} */
    TooltipComponent.prototype.externallyOpen;
    /** @type {?} */
    TooltipComponent.prototype.titleClasses;
    /** @type {?} */
    TooltipComponent.prototype.descriptionClasses;
    /** @type {?} */
    TooltipComponent.prototype.tooltipContentRef;
    /** @type {?} */
    TooltipComponent.prototype.isTooltipOpen;
    /** @type {?} */
    TooltipComponent.prototype.isMobile;
    /** @type {?} */
    TooltipComponent.prototype.contentPositionClass;
    /** @type {?} */
    TooltipComponent.prototype.carretPositionClass;
    /**
     * @type {?}
     * @private
     */
    TooltipComponent.prototype.document;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/tooltip/tooltip-custom.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TooltipCustomModule = /** @class */ (function () {
    function TooltipCustomModule() {
    }
    TooltipCustomModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        TooltipComponent
                    ],
                    exports: [
                        TooltipComponent
                    ]
                },] }
    ];
    return TooltipCustomModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accordion/edit-button/edit-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var EditButtonModule = /** @class */ (function () {
    function EditButtonModule() {
    }
    EditButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule,
                        TooltipCustomModule
                    ],
                    declarations: [EditButtonComponent],
                    exports: [EditButtonComponent]
                },] }
    ];
    return EditButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/title/title.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TitleComponent = /** @class */ (function () {
    function TitleComponent() {
        this.class = '';
        this.type = 'h1';
    }
    /**
     * @return {?}
     */
    TitleComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.setClasses();
    };
    /**
     * @return {?}
     */
    TitleComponent.prototype.setClasses = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var classes = {};
        classes[this.class] = true;
        classes['main-title'] = this.type === 'h1';
        classes['section-title'] = this.type === 'h2';
        classes['subtitle'] = this.type === 'h3';
        this.classes = classes;
    };
    TitleComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-title',
                    template: "<h1 *ngIf=\"type === 'h1'\" [ngClass]=\"classes\" class=\"sc-title\">{{content}}</h1>\n<h2 *ngIf=\"type === 'h2'\" [ngClass]=\"classes\" class=\"sc-title\">{{content}}</h2>\n<h3 *ngIf=\"type === 'h3'\" [ngClass]=\"classes\" class=\"sc-title\">{{content}}</h3>",
                    styles: [".sc-title{margin:0;word-break:break-word}"]
                }] }
    ];
    /** @nocollapse */
    TitleComponent.ctorParameters = function () { return []; };
    TitleComponent.propDecorators = {
        class: [{ type: Input }],
        content: [{ type: Input }],
        type: [{ type: Input }]
    };
    return TitleComponent;
}());
if (false) {
    /** @type {?} */
    TitleComponent.prototype.classes;
    /** @type {?} */
    TitleComponent.prototype.class;
    /** @type {?} */
    TitleComponent.prototype.content;
    /** @type {?} */
    TitleComponent.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/title/title.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TitleModule = /** @class */ (function () {
    function TitleModule() {
    }
    TitleModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [TitleComponent],
                    exports: [TitleComponent]
                },] }
    ];
    return TitleModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accordion/accordion.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccordionModule = /** @class */ (function () {
    function AccordionModule() {
    }
    AccordionModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        AccordionComponent
                    ],
                    imports: [
                        CommonModule,
                        IconModule,
                        TitleModule,
                        EditButtonModule
                    ],
                    exports: [
                        AccordionComponent
                    ]
                },] }
    ];
    return AccordionModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/action-menu/action-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActionItem = /** @class */ (function () {
    function ActionItem(actions) {
        this.label = actions.label;
        this.action = actions.action;
        this.icon = actions.icon;
        this.id = actions.id ? actions.id : this.generateIdFromLabel(actions.label);
    }
    /**
     * @private
     * @param {?} label
     * @return {?}
     */
    ActionItem.prototype.generateIdFromLabel = /**
     * @private
     * @param {?} label
     * @return {?}
     */
    function (label) {
        return label
            .trim()
            // https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/(\s|\r|\n|\W)+/g, '-')
            .replace(/(^-)|-$/g, '');
    };
    return ActionItem;
}());
if (false) {
    /** @type {?} */
    ActionItem.prototype.label;
    /** @type {?} */
    ActionItem.prototype.action;
    /** @type {?} */
    ActionItem.prototype.icon;
    /** @type {?} */
    ActionItem.prototype.id;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/action-menu/action-menu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActionMenuComponent = /** @class */ (function () {
    function ActionMenuComponent() {
        this.actionClicked = new EventEmitter();
    }
    ActionMenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-action-menu',
                    template: "<ul class=\"sc-action-menu__list\">\n  <li *ngFor=\"let action of items\" class=\"sc-action-menu__list-item\">\n    <a\n      class=\"sc-action-menu__list-item-link\"\n      [attr.id]=\"action.id\"\n      (click)=\"actionClicked.emit(action)\">\n      <sc-icon\n        class=\"sc-action-menu__list-item-icon\"\n        [icon]=\"action.icon\" size=\"1\"></sc-icon>\n      {{action.label}}\n    </a>\n  </li>\n</ul>\n",
                    styles: [":host{display:block;box-shadow:0 3px 15px 0 rgba(0,0,0,.2);background-color:#fff}.sc-action-menu__list{margin:0;padding:0;list-style-type:none}.sc-action-menu__list-item{font-weight:700;cursor:pointer;position:relative}.sc-action-menu__list-item:hover{background-color:#edf0f5}.sc-action-menu__list-item:active{background-color:#ccd2dd}.sc-action-menu__list-item-link{display:block;width:100%;padding:.75rem .75rem .75rem 2.75rem;font-size:.875rem;text-align:left}.sc-action-menu__list-item-icon{position:absolute;top:.75rem;left:1rem}"]
                }] }
    ];
    ActionMenuComponent.propDecorators = {
        items: [{ type: Input }],
        actionClicked: [{ type: Output }]
    };
    return ActionMenuComponent;
}());
if (false) {
    /** @type {?} */
    ActionMenuComponent.prototype.items;
    /** @type {?} */
    ActionMenuComponent.prototype.actionClicked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/action-menu/action-menu.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActionMenuModule = /** @class */ (function () {
    function ActionMenuModule() {
    }
    ActionMenuModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, IconModule,],
                    declarations: [ActionMenuComponent],
                    exports: [ActionMenuComponent]
                },] }
    ];
    return ActionMenuModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/button/button.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
        this.id = '';
        this.loading = false;
        this.text = '';
        this.type = 'primary';
        this.onClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.setClasses();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    ButtonComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        /** @type {?} */
        var shouldSetClasses = !!(changes.type
            || changes.prefixIcon
            || changes.suffixIcon
            || changes.iconOnly
            || changes.loading);
        if (shouldSetClasses) {
            this.setClasses();
        }
    };
    /**
     * @return {?}
     */
    ButtonComponent.prototype.setClasses = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var classes = {};
        classes['sc-button'] = true;
        classes["sc-button--" + this.type] = true;
        classes['sc-button--prefix-icon'] = !!this.prefixIcon;
        classes['sc-button--suffix-icon'] = !!this.suffixIcon;
        classes['sc-button--icon-only'] = !!this.iconOnly;
        classes['sc-button--loading'] = !!this.loading;
        if (this.type === 'link-secondary') {
            classes["sc-button--" + this.type + "--prefix-icon"] = !!this.prefixIcon;
            classes["sc-button--" + this.type + "--icon-only"] = !!this.iconOnly;
        }
        this.classes = classes;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ButtonComponent.prototype.onClickHandler = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.type.startsWith('link')) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!(this.disabled || this.loading)) {
            this.onClick.emit(event);
        }
    };
    ButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-button',
                    template: "<button [id]=\"id\" [title]=\"title || text\" (click)=\"onClickHandler($event)\" [disabled]=\"disabled\" [ngClass]=\"classes\">\n    <sc-icon *ngIf=\"prefixIcon || loading\" class=\"sc-button__icon\" [icon]=\"(loading) ? 'loading' : prefixIcon\"></sc-icon>\n    <span *ngIf=\"!loading && !iconOnly\" class=\"sc-button__content\">\n        <span *ngIf=\"!text\">\n            <ng-content></ng-content>\n        </span>\n        <span *ngIf=\"text\">{{text}}</span>\n    </span>\n    <sc-icon *ngIf=\"suffixIcon\" class=\"sc-button__icon\" [icon]=\"suffixIcon\"></sc-icon>\n</button>",
                    styles: [":host(.filter-button) .sc-button{width:108px;min-width:108px;line-height:normal}@media only screen and (max-width:768px){:host(.filter-button) .sc-button{border:none;width:auto;min-width:unset}}:host(.full-width) .sc-button{width:100%}:host(.no-outline) .sc-button{outline:0}"]
                }] }
    ];
    /** @nocollapse */
    ButtonComponent.ctorParameters = function () { return []; };
    ButtonComponent.propDecorators = {
        disabled: [{ type: Input }],
        iconOnly: [{ type: Input }],
        id: [{ type: Input }],
        loading: [{ type: Input }],
        prefixIcon: [{ type: Input }],
        suffixIcon: [{ type: Input }],
        text: [{ type: Input }],
        title: [{ type: Input }],
        type: [{ type: Input }],
        onClick: [{ type: Output }]
    };
    return ButtonComponent;
}());
if (false) {
    /** @type {?} */
    ButtonComponent.prototype.disabled;
    /** @type {?} */
    ButtonComponent.prototype.iconOnly;
    /** @type {?} */
    ButtonComponent.prototype.id;
    /** @type {?} */
    ButtonComponent.prototype.loading;
    /** @type {?} */
    ButtonComponent.prototype.prefixIcon;
    /** @type {?} */
    ButtonComponent.prototype.suffixIcon;
    /** @type {?} */
    ButtonComponent.prototype.text;
    /** @type {?} */
    ButtonComponent.prototype.title;
    /** @type {?} */
    ButtonComponent.prototype.type;
    /** @type {?} */
    ButtonComponent.prototype.onClick;
    /** @type {?} */
    ButtonComponent.prototype.classes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/button/button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ButtonModule = /** @class */ (function () {
    function ButtonModule() {
    }
    ButtonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule
                    ],
                    declarations: [
                        ButtonComponent
                    ],
                    exports: [ButtonComponent]
                },] }
    ];
    return ButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/checkbox/checkbox.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return CheckboxComponent; })),
    multi: true
};
var CheckboxComponent = /** @class */ (function () {
    function CheckboxComponent(controlContainer) {
        this.controlContainer = controlContainer;
        this.isDisabled = false;
        this.isReadOnly = false;
        this.value = false;
        this.change = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    CheckboxComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (this.control && (changes.isDisabled || changes.isReadOnly)) {
            this.setClasses();
        }
    };
    /**
     * @return {?}
     */
    CheckboxComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.control = this.controlContainer.control.get(this.formControlName);
        this.setClasses();
        if (this.formControlName && !this.id) {
            this.id = "field_" + this.formControlName + "__checkbox";
        }
    };
    /**
     * @return {?}
     */
    CheckboxComponent.prototype.setClasses = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var classes = {};
        classes['sc-checkbox__square'] = true;
        classes['sc-checkbox__square--checked'] = this.control.value && !this.isDisabled;
        classes['sc-checkbox__square--disabled'] = this.isDisabled;
        classes['sc-checkbox__square--read-only'] = this.isReadOnly;
        this.squareClasses = classes;
    };
    /**
     * @return {?}
     */
    CheckboxComponent.prototype.handleClick = /**
     * @return {?}
     */
    function () {
        if (!this.isDisabled && !this.isReadOnly) {
            this.control.setValue(!this.control.value);
            this.setClasses();
            this.change.emit(this.control.value);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    CheckboxComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        this.setClasses();
    };
    /**
     * @return {?}
     */
    CheckboxComponent.prototype.registerOnChange = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    CheckboxComponent.prototype.registerOnTouched = /**
     * @return {?}
     */
    function () {
    };
    CheckboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-checkbox',
                    template: "<div class=\"sc-checkbox\" (click)=\"handleClick()\">\n    <input class=\"sc-checkbox__input\" type=\"checkbox\" [checked]=\"value\" [disabled]=\"isDisabled\" [readonly]=\"isReadOnly\" [id]=\"id\" />\n    <div [ngClass]=\"squareClasses\"></div>\n    <label class=\"sc-checkbox__label\" [class.disabled]=\"isDisabled || isReadOnly\">\n        <ng-content></ng-content>\n    </label>\n</div>",
                    providers: [CONTROL_VALUE_ACCESSOR],
                    styles: [".sc-checkbox{position:relative;width:100%;display:flex}.sc-checkbox__input{visibility:hidden;width:20px;position:static}.sc-checkbox__square{cursor:pointer;display:inline-block}.sc-checkbox__square:after,.sc-checkbox__square:before{content:\"\";left:0;position:absolute;z-index:1}.sc-checkbox__square:after{border-radius:2px;border:2px solid #8993a4;height:18px;top:0;transition:background-color .2s,border-color .2s;width:18px}.sc-checkbox__square:before{border:2px solid transparent;left:1px;top:2px;transform-origin:100% 100%;transform:rotateZ(45deg) scale(1);transition:transform .2s}.sc-checkbox__square--checked:before{border-bottom:2px solid #fff;border-right:2px solid #fff;height:11px;width:6px;transform-origin:100% 100%;transform:rotateZ(45deg) scale(1);transition:transform .2s}.sc-checkbox__square--checked:after{top:0;border:2px solid #3dcc98;background-color:#3dcc98;box-sizing:border-box;z-index:0}.sc-checkbox__square--checked.sc-checkbox__square--read-only{pointer-events:none}.sc-checkbox__square--checked.sc-checkbox__square--read-only:after{border:2px solid #ccd2dd;background-color:#ccd2dd}.sc-checkbox__square--disabled,.sc-checkbox__square--read-only{pointer-events:none}.sc-checkbox__square--disabled:after,.sc-checkbox__square--read-only:after{border:2px solid #ccd2dd}.sc-checkbox__label{display:inline-block;margin-left:.8rem;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:Roboto,sans-serif;font-size:16px;line-height:20px;cursor:pointer}.sc-checkbox__label.disabled{color:#ccd2dd}:host(.sc-checkbox__small) .sc-checkbox__label{font-size:.75rem;margin-left:0;line-height:14px}:host(.sc-checkbox__small) .sc-checkbox__square:after{height:14px;width:14px}:host(.sc-checkbox__small) .sc-checkbox__square:before{left:0;top:0}:host(.sc-checkbox__small) .sc-checkbox__square--checked:before{border-bottom:2px solid #fff;border-right:2px solid #fff;height:11px;width:6px}@media (max-width:768px){.sc-checkbox__label{max-width:90%}}"]
                }] }
    ];
    /** @nocollapse */
    CheckboxComponent.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: Host }, { type: SkipSelf }] }
    ]; };
    CheckboxComponent.propDecorators = {
        formControlName: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isReadOnly: [{ type: Input }],
        id: [{ type: Input }],
        change: [{ type: Output }]
    };
    return CheckboxComponent;
}());
if (false) {
    /** @type {?} */
    CheckboxComponent.prototype.formControlName;
    /** @type {?} */
    CheckboxComponent.prototype.isDisabled;
    /** @type {?} */
    CheckboxComponent.prototype.isReadOnly;
    /** @type {?} */
    CheckboxComponent.prototype.id;
    /** @type {?} */
    CheckboxComponent.prototype.change;
    /** @type {?} */
    CheckboxComponent.prototype.control;
    /** @type {?} */
    CheckboxComponent.prototype.squareClasses;
    /** @type {?} */
    CheckboxComponent.prototype.value;
    /**
     * @type {?}
     * @private
     */
    CheckboxComponent.prototype.controlContainer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/checkbox/checkbox.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxModule = /** @class */ (function () {
    function CheckboxModule() {
    }
    CheckboxModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        CheckboxComponent
                    ],
                    exports: [CheckboxComponent]
                },] }
    ];
    return CheckboxModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/icon-bar/icon-bar.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBarOptions = /** @class */ (function () {
    function IconBarOptions() {
    }
    return IconBarOptions;
}());
if (false) {
    /** @type {?} */
    IconBarOptions.prototype.backgroundColor;
    /** @type {?} */
    IconBarOptions.prototype.iconColor;
    /** @type {?} */
    IconBarOptions.prototype.displayImage;
    /** @type {?} */
    IconBarOptions.prototype.displaySvg;
    /** @type {?} */
    IconBarOptions.prototype.icon;
    /** @type {?} */
    IconBarOptions.prototype.route;
    /** @type {?} */
    IconBarOptions.prototype.svgColor;
    /** @type {?} */
    IconBarOptions.prototype.src;
    /** @type {?} */
    IconBarOptions.prototype.closeBarTitle;
    /** @type {?} */
    IconBarOptions.prototype.hideTopButton;
    /** @type {?} */
    IconBarOptions.prototype.closeButtonId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/icon-bar/icon-bar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBarComponent = /** @class */ (function () {
    function IconBarComponent(el) {
        this.iconClicked = new EventEmitter();
        this.domElem = el;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    IconBarComponent.prototype.handleClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.iconClicked.emit(event);
    };
    IconBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-icon-bar',
                    template: "<!-- DESKTOP SIDEBAR -->\n<div class=\"icon-bar hide-mobile\" [ngStyle]=\"{'background-color': options && options.backgroundColor}\">\n  <div class=\"icon-bar__top\">\n    <div class=\"icon-bar__top-btn\" *ngIf=\"!options.hideTopButton\">\n      <sc-icon [icon]=\"options.icon ? options.icon : 'close'\" id=\"{{options.closeButtonId}}\" (click)=\"handleClick($event)\" class=\"icon-bar__top-btn--icon\" [ngClass]=\"options.iconColor ? 'sc-color-' + options.iconColor : 'sc-color-white'\"></sc-icon>\n    </div>\n  </div>\n  <div class=\"icon-bar__bottom\">\n    <div class=\"icon-bar__bottom-img\" *ngIf=\"options && options.displayImage && options.src\">\n      <img [src]=\"options.src\" alt=\"bottom_img\">\n    </div>\n    <div class=\"icon-bar__bottom-svg\" *ngIf=\"options && options.displaySvg\" [ngStyle]=\"{ 'fill': options && options.svgColor ? options.svgColor: '#fff' }\" >\n      <svg fill=\"inherit\" width=\"30px\" height=\"40px\" viewBox=\"0 0 30 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n        <g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"inherit\" fill-rule=\"evenodd\">\n          <g id=\"01-atm/logos/logo-main_nav\" fill=\"inherit\">\n            <path d=\"M20.2938995,6.03694581 L29.3077192,6.02128487 L28.7790609,7.22012964 L14.7136176,39.4746135 L0.670886951,7.57641597 L-0.000313278987,6.07218292 L9.01428958,6.05730503 C9.06128143,2.98697823 11.5612477,0.509417918 14.643913,0.504719637 C17.7273614,0.498455262 20.2343765,2.96661901 20.2938995,6.03694581 Z M6.22143986,11.285755 C8.32946134,12.2871865 9.88463617,11.3688158 9.88463617,11.3688158 C9.88463617,11.3688158 7.30912256,13.2204454 8.97940852,16.4872433 L7.50019137,17.2653509 L9.53773665,21.8180244 C9.53773665,21.8180244 11.08743,21.6950004 11.4264988,20.9545053 C11.4264988,20.9545053 10.5009114,18.9257838 10.9417792,18.0763693 C10.9417792,18.0763693 11.2683189,18.2785362 11.9080862,18.428986 C12.6198958,18.5951077 13.4076632,18.5998092 14.2604252,18.107713 C14.5548591,17.938457 14.6879808,17.697894 14.7005099,18.0528615 C14.7122559,18.4086126 15.4115365,19.7093765 14.0020125,21.5296623 C12.5924884,23.3491645 10.8963612,24.8066469 11.2777157,25.7226668 L14.7435787,33.5585937 L20.554733,20.3997216 C20.554733,20.3997216 19.5500556,20.7264798 19.0872619,20.0408362 C18.6557909,19.4022081 18.804574,18.3984259 19.7583519,17.8593141 C19.7583519,17.8593141 19.4333783,16.5577666 20.0065848,16.709 C20.0065848,16.709 20.2305425,16.8978459 20.4631139,17.0216535 C20.6949023,17.1462448 21.4881511,17.9243523 22.1012941,16.5373932 C22.5797492,15.4536845 24.6611463,10.3658172 25.5961306,8.10828662 L24.1779928,8.10828662 L21.0057807,15.3729745 C21.0057807,15.3729745 21.3135268,14.4044539 21.3714739,13.7956024 C21.5586273,12.1241992 20.8828389,11.4001595 20.8828389,11.4001595 C20.8851881,11.3758682 20.8875373,11.3507932 20.8891034,11.3257182 C20.8914526,11.2810534 20.8938018,11.2160152 20.8930188,11.1368724 L20.8961511,11.1368724 C20.8969341,10.9409742 20.8789235,10.7630987 20.8452516,10.6048129 L20.8405532,10.6048129 C20.8303733,10.5483943 20.8178442,10.4896248 20.8029659,10.4308554 C20.4615478,9.28916081 19.3033889,9.1724055 19.3033889,9.1724055 C18.9126375,9.10501653 18.8202354,8.87855824 18.3175052,8.83154268 C17.5594945,8.76101934 16.7270922,9.16300239 16.7270922,9.16300239 C16.7270922,9.16300239 16.0677482,9.55244796 15.9542032,8.78922867 C15.8696318,8.21877319 16.6346901,7.96645635 16.6346901,7.96645635 C16.6589652,7.94059779 17.2165103,7.77525973 16.9996002,7.26200651 C17.2266902,6.97207722 17.7771876,6.201022 17.281505,5.69952268 C16.7991346,5.21212802 16.5743938,4.59857494 15.9448064,4.41678144 C15.2329968,4.21148015 14.9730179,4.37525103 14.9730179,4.37525103 C14.0012294,3.54385918 13.4436843,4.36819869 13.4436843,4.36819869 C12.6418218,4.45831185 12.9761922,5.57414785 12.9761922,5.57414785 C12.2072185,6.09210262 12.7890387,6.79733604 12.7741604,6.94543506 C12.7600652,7.09588486 12.5212292,7.28081274 12.3528693,7.59424982 C12.1837265,7.9069033 12.5658641,8.26500516 12.5658641,8.26500516 C12.5658641,8.26500516 12.7913879,8.51262045 12.2338429,8.36217066 C11.6762978,8.21093727 11.1367633,7.73216213 9.81024463,8.57687505 C8.08984225,9.67233764 6.61767272,9.54931359 6.61767272,9.54931359 C6.61767272,9.54931359 5.50649795,8.6466148 4.7876407,8.40213388 C4.08444483,8.16157093 3.64357703,8.4428807 3.52220136,8.92792458 C3.45015902,9.21471951 3.58797914,9.69192746 4.05860355,9.74599535 C4.05860355,9.74599535 3.91530194,9.84316085 3.86988395,10.0993957 C3.7829633,10.5875739 4.81426504,11.285755 6.22143986,11.285755 Z M12.6010548,14.4985041 C15.3167595,14.877672 14.6174968,16.6841584 14.6174968,16.6841584 C13.5216724,18.9995689 10.6088602,16.6903743 10.6088602,16.6903743 C7.78521565,14.4969501 10.6393649,11.6873782 10.6393649,11.6873782 C12.8497858,9.48152228 9.5482336,10.7969552 9.5482336,10.7969552 C8.41486492,11.1986556 7.71951312,11.0922089 7.01790394,10.9375892 C6.57206533,10.8404662 6.29048305,10.7798615 6.29048305,10.7798615 L6.23338442,10.7689838 C5.79380319,10.9632296 5.3792515,10.6858466 5.3792515,10.6858466 C5.24080688,10.5654141 4.65574147,10.3338731 4.65574147,10.3338731 C4.36320877,10.19557 4.39449569,10.0331805 4.52511858,10.0005472 C4.74021616,9.96247501 5.26270772,10.2087787 5.3385785,10.242966 C5.39645931,10.2693835 5.43947882,10.1683756 5.43947882,10.0906773 C5.43947882,10.0673678 5.43556796,10.0471662 5.42774623,10.0324035 C5.41366711,10.00754 5.40349886,9.98811546 5.39176627,9.96635992 C5.16337175,9.53591112 4.32410012,9.29116135 4.32410012,9.29116135 C3.87435065,9.23832648 3.96977575,9.00756241 3.96977575,9.00756241 C3.99011225,8.95938944 4.5102573,9.073606 4.5102573,9.073606 C4.25761542,8.99279972 4.26309063,8.73251028 4.26309063,8.73251028 C4.43438651,8.59498422 5.49423093,9.30048515 5.49423093,9.30048515 C5.56540867,9.30514705 5.77815973,9.33467242 5.83760488,9.41703266 C5.90487176,9.51260162 6.47820457,10.0269646 6.47820457,10.0269646 C8.48447831,10.2002319 9.58421355,9.37662952 10.7488692,8.88479903 C11.7719514,8.45201928 12.5408275,9.22744871 13.0906951,9.26318995 C13.6405627,9.29737722 13.9909762,9.19947731 13.9909762,9.19947731 C12.7019551,8.73406425 13.5490485,8.23524091 13.411386,7.97495147 C13.2745058,7.71310806 12.9655474,7.71310806 13.3261292,7.4256242 C13.6874931,7.13814035 13.524019,6.95166433 13.524019,6.95166433 C13.1063386,5.9703343 13.8384525,5.83203125 13.8384525,5.83203125 C14.202163,6.19565948 15.1165232,6.22440787 15.1165232,6.22440787 C15.2189879,6.98507462 15.5748766,7.1777665 15.5748766,7.1777665 C15.9597057,7.10550704 16.0981503,7.14668716 16.0316656,7.52041618 C15.9667452,7.89259123 15.3566503,8.04410299 15.3566503,8.04410299 C15.0695928,9.95470517 16.3022975,9.83582671 16.3022975,9.83582671 C14.6026355,10.5591983 14.762981,12.5552686 14.2326677,13.6679088 C13.650731,14.8877728 11.7578723,13.4876487 11.778991,13.9856951 C11.796981,14.4309065 12.6010548,14.4985041 12.6010548,14.4985041 Z M19.2744499,10.5739693 C19.2744499,10.5739693 20.1808303,13.8344066 18.3742041,14.638848 L17.454021,15.2773438 C17.454021,15.2773438 16.7776865,13.3294577 17.594349,12.9414609 C17.5905149,12.9627968 17.5874476,12.9865033 17.5874476,13.0102098 C17.5874476,13.1848479 17.725475,13.3262968 17.8934085,13.3255066 C18.0306691,13.3255066 18.1479925,13.2314707 18.1863334,13.1026653 C18.4194465,13.1895892 18.6609945,13.236212 18.6832323,13.0765881 C18.7231069,12.7597109 17.3558682,11.7956455 17.0698446,12.9414609 L16.5307707,14.0288001 C16.5307707,14.0288001 15.3560036,13.8446795 15.0845496,14.0809545 C15.0845496,14.0809545 15.0347063,12.9809718 15.6013857,12.5661076 C15.6803681,12.5068413 15.7386464,12.4594282 15.761651,12.378826 C15.8091937,12.4878761 15.9173153,12.5661076 16.0430736,12.5661076 C16.155796,12.5661076 16.2524153,12.5021 16.3053258,12.4096445 C16.5882821,12.5107924 16.8996107,12.5605761 17.0084991,12.3503782 C17.1633965,12.0477249 16.0852487,11.9457869 16.0714459,11.564902 C16.0591768,11.183227 17.6848336,11.0686455 18.1901675,10.2728965 C18.2200735,10.2270639 18.3304954,10.2642041 18.3304954,10.2642041 C18.3304954,10.2642041 19.0144982,10.4214574 19.2744499,10.5739693 Z\"\n              id=\"Combined-Shape\"></path>\n          </g>\n        </g>\n      </svg>\n    </div>\n  </div>\n</div>\n\n\n\n<!-- MOBILE SIDEBAR -->\n<div id=\"icon-bar\" class=\"icon-bar hide-desktop\" [ngStyle]=\"{'background-color': options && options.backgroundColor}\">\n  <div class=\"icon-bar__top\">\n    <div class=\"icon-bar__top-btn\" *ngIf=\"!options.hideTopButton\">\n        <sc-icon [icon]=\"options.icon ? options.icon : 'close'\" (click)=\"handleClick($event)\" class=\"icon-bar__top-btn--icon\" [ngClass]=\"options.iconColor ? 'sc-color-' + options.iconColor : 'sc-color-white'\"></sc-icon>\n    </div>\n  </div>\n  <div class=\"icon-bar__bottom\">\n    <div class=\"icon-bar__bottom-img\" *ngIf=\"options && options.displayImage && options.src\">\n      <img [src]=\"options.src\" alt=\"bottom_img\">\n    </div>\n    <span class=\"icon-bar-label\">{{options?.closeBarTitle}}</span>\n  </div>\n</div>\n",
                    styles: [".icon-bar{align-items:center;background-color:#424f66;display:flex;height:54px;justify-content:center;padding:1.7rem 1rem;width:100%}.icon-bar-label{color:#fff;padding:0 15px}.icon-bar__top{position:absolute;left:18px}@media only screen and (min-width:1152px){.icon-bar{width:64px;height:100%;justify-content:space-between;flex-direction:column}.icon-bar__top{position:inherit}}.icon-bar__top-btn{cursor:pointer;color:inherit}.icon-bar__top-btn--icon{transition:.1s ease-in}.icon-bar__top-btn--icon:hover{opacity:.5}.icon-bar__bottom-img{width:100%;height:40px;display:flex;align-items:flex-end}.icon-bar__bottom-img img{max-width:100%;max-height:100%}.sticky{background:#fff;box-shadow:0 3px 12px 0 rgba(0,0,0,.08);position:fixed;top:0;height:120px;width:100%}@media (max-width:1152px){.icon-bar__bottom{width:100%;text-align:center}.hide-mobile{display:none!important}.close-bar.hide-desktop{height:0}}@media (min-width:1152px){.hide-desktop{display:none!important}}"]
                }] }
    ];
    /** @nocollapse */
    IconBarComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    IconBarComponent.propDecorators = {
        options: [{ type: Input }],
        iconClicked: [{ type: Output }]
    };
    return IconBarComponent;
}());
if (false) {
    /** @type {?} */
    IconBarComponent.prototype.options;
    /** @type {?} */
    IconBarComponent.prototype.iconClicked;
    /** @type {?} */
    IconBarComponent.prototype.domElem;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/icon-bar/icon-bar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconBarModule = /** @class */ (function () {
    function IconBarModule() {
    }
    IconBarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule
                    ],
                    declarations: [IconBarComponent],
                    exports: [IconBarComponent]
                },] }
    ];
    return IconBarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/pending-changes-warning-modal/pending-changes-warning-modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PendingChangesWarningModalComponent = /** @class */ (function () {
    function PendingChangesWarningModalComponent() {
        this.defaultSettings = {
            title: '¿Estás seguro de salir?',
            description: 'Algunos datos podrían perderse',
            labelContinue: 'Continuar',
            labelCancel: 'Cancelar'
        };
        this.cancel = new EventEmitter();
        this.continue = new EventEmitter();
    }
    /**
     * @return {?}
     */
    PendingChangesWarningModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.id) {
            this.idPrefix = this.id + '-';
        }
        this.settings = Object.assign({}, this.defaultSettings, this.settings);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    PendingChangesWarningModalComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.settings.currentValue) {
            this.settings = Object.assign({}, this.defaultSettings, changes.settings.currentValue);
        }
    };
    /**
     * @return {?}
     */
    PendingChangesWarningModalComponent.prototype.open = /**
     * @return {?}
     */
    function () {
        this.modal.open();
    };
    /**
     * @return {?}
     */
    PendingChangesWarningModalComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.modal.close();
    };
    PendingChangesWarningModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-pending-changes-warning-modal',
                    template: "<sc-modal #modal [closeButton]=\"false\" id=\"{{idPrefix}}pending-changes-warning-modal\" class=\"pending-changes-warning-modal\">\n    <div class=\"modal-content\">\n        <sc-title [content]=\"settings.title\" type=\"h2\"></sc-title>\n        <p>\n            {{settings.description}}\n        </p>\n        <div class=\"row\">\n            <sc-button type=\"primary\" (onClick)=\"continue.emit()\" class=\"col-6\" id=\"{{idPrefix}}pending-changes-warning-modal-continuar\">\n                {{settings.labelContinue}}\n            </sc-button>\n            <sc-button type=\"secondary\" (onClick)=\"cancel.emit()\" class=\"col-6\" id=\"{{idPrefix}}pending-changes-warning-modal-cancelar\">\n                {{settings.labelCancel}}\n            </sc-button>\n        </div>\n    </div>\n</sc-modal>",
                    styles: [".pending-changes-warning-modal .modal-content{display:flex;flex-direction:column;justify-content:center;align-items:center;margin:20% 0}@media (max-width:768px){.pending-changes-warning-modal .modal-content{justify-content:space-evenly}}"]
                }] }
    ];
    /** @nocollapse */
    PendingChangesWarningModalComponent.ctorParameters = function () { return []; };
    PendingChangesWarningModalComponent.propDecorators = {
        id: [{ type: Input }],
        settings: [{ type: Input }],
        cancel: [{ type: Output }],
        continue: [{ type: Output }],
        modal: [{ type: ViewChild, args: ['modal', { static: false },] }]
    };
    return PendingChangesWarningModalComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PendingChangesWarningModalComponent.prototype.defaultSettings;
    /** @type {?} */
    PendingChangesWarningModalComponent.prototype.id;
    /** @type {?} */
    PendingChangesWarningModalComponent.prototype.settings;
    /** @type {?} */
    PendingChangesWarningModalComponent.prototype.cancel;
    /** @type {?} */
    PendingChangesWarningModalComponent.prototype.continue;
    /** @type {?} */
    PendingChangesWarningModalComponent.prototype.modal;
    /** @type {?} */
    PendingChangesWarningModalComponent.prototype.idPrefix;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/modal/modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ModalComponent = /** @class */ (function () {
    function ModalComponent() {
        this.isCloseOutside = false;
        this.tabbingTagNames = [
            'BUTTON',
            'INPUT',
            'A',
            'TEXTAREA',
            'SELECT'
        ];
        this.closeButton = true;
        this.closeDisabled = false;
        this.isOpen = false;
        this.whenClose = new EventEmitter();
        this.whenOpen = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ModalComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        if (!this.closeButton) {
            /** @type {?} */
            var firstElement = this.findFirstTabbingElement(Array.from(this.content.nativeElement.children));
            if (firstElement) {
                firstElement.setAttribute('tabindex', '0');
            }
        }
    };
    /**
     * @return {?}
     */
    ModalComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.isOpen = false;
        this.whenClose.emit();
    };
    /**
     * @return {?}
     */
    ModalComponent.prototype.open = /**
     * @return {?}
     */
    function () {
        this.isOpen = true;
        this.whenOpen.emit();
    };
    /**
     * @return {?}
     */
    ModalComponent.prototype.handleEndAnchorTrapFocus = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var firstElement = this.findFirstTabbingElement(Array.from(this.content.nativeElement.children));
        if (!this.closeButton || this.closeDisabled) {
            firstElement.focus();
        }
        else {
            this.closeButtonElement.nativeElement.focus();
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    ModalComponent.prototype.handleModalClick = /**
     * @param {?} e
     * @return {?}
     */
    function (e) { };
    /**
     * @private
     * @param {?} children
     * @return {?}
     */
    ModalComponent.prototype.findFirstTabbingElement = /**
     * @private
     * @param {?} children
     * @return {?}
     */
    function (children) {
        var e_1, _a;
        var _this = this;
        /** @type {?} */
        var firstChild = (/** @type {?} */ (children.find((/**
         * @param {?} child
         * @return {?}
         */
        function (child) { return _this.tabbingTagNames.some((/**
         * @param {?} name
         * @return {?}
         */
        function (name) { return name.toLowerCase() === child.tagName.toLowerCase(); })); }))));
        if (firstChild == null) {
            try {
                for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                    var child = children_1_1.value;
                    firstChild = this.findFirstTabbingElement(Array.from(child.children));
                    if (firstChild) {
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return firstChild;
    };
    /**
     * @return {?}
     */
    ModalComponent.prototype.onEscape = /**
     * @return {?}
     */
    function () {
        if (this.isCloseOutside) {
            this.close();
        }
    };
    ModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-modal',
                    template: "<div [hidden]=\"!isOpen\">\n    <div class=\"sc-modal__overlay\" (click)=\"isCloseOutside && close()\">\n        <div class=\"sc-modal sc-scroll-bar\"\n            [class.sc-modal--small]=\"size==='small'\"\n            (click)=\"handleModalClick($event)\">\n            <div class=\"sc-modal__header-wrapper\">\n                <ng-content select=\".sc-modal__header\"></ng-content>\n                <button\n                    *ngIf=\"closeButton\"\n                    #closeButtonElement\n                    class=\"sc-modal__close\"\n                    aria-label=\"Close\"\n                    tabindex=\"0\"\n                    [disabled]=\"closeDisabled\"\n                    (click)=\"close()\"\n                >\n                    <span class=\"sc-modal__close-icon icon-close-elipse\"></span>\n                </button>\n            </div>\n            <div class=\"sc-modal__body\" #content>\n                <ng-content></ng-content>\n            </div>\n        </div>\n    </div>\n    <div tabindex=\"0\" class=\"sc-modal__focus-trap-anchor\" (focus)=\"handleEndAnchorTrapFocus()\"></div>\n</div>\n",
                    styles: [".sc-modal{display:flex;flex-direction:column;position:relative;margin:auto;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,28,51,.15);opacity:1;overflow-y:auto;transition:.5s;z-index:1100;max-height:95%;width:auto;min-height:312px;min-width:448px;max-width:1016px}.sc-modal--small{max-width:448px}.sc-modal__overlay{background-color:rgba(0,0,0,.4);bottom:0;left:0;position:fixed;right:0;top:0;z-index:1050;display:flex}.sc-modal__header-wrapper{display:flex;justify-content:space-between;align-items:center;padding:1rem}.sc-modal__close{background:0 0;border:0;color:#0070cc;cursor:pointer;outline:0;padding:0 0 0 1rem;margin-left:auto;text-align:right;z-index:1}.sc-modal__close:disabled{color:#e0e5ed;cursor:default}.sc-modal__close-icon{display:flex}.sc-modal__body{height:100%;padding:1rem}.sc-modal__focus-trap-anchor{-moz-appearance:none;-webkit-appearance:none;border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;outline:0;overflow:hidden;padding:0;position:absolute;width:1px}@media (max-width:768px){.sc-modal{min-width:100%;min-height:100%;position:fixed;top:0;left:0}.sc-modal__overlay{position:initial}.closed .modal{height:0;opacity:0}}"]
                }] }
    ];
    /** @nocollapse */
    ModalComponent.ctorParameters = function () { return []; };
    ModalComponent.propDecorators = {
        closeButton: [{ type: Input }],
        closeDisabled: [{ type: Input }],
        isOpen: [{ type: Input }],
        size: [{ type: Input }],
        isCloseOutside: [{ type: Input }],
        whenClose: [{ type: Output }],
        whenOpen: [{ type: Output }],
        content: [{ type: ViewChild, args: ['content', { static: true },] }],
        closeButtonElement: [{ type: ViewChild, args: ['closeButtonElement', { static: false },] }],
        onEscape: [{ type: HostListener, args: ['document:keydown.escape',] }]
    };
    return ModalComponent;
}());
if (false) {
    /** @type {?} */
    ModalComponent.prototype.closeButton;
    /** @type {?} */
    ModalComponent.prototype.closeDisabled;
    /** @type {?} */
    ModalComponent.prototype.isOpen;
    /** @type {?} */
    ModalComponent.prototype.size;
    /** @type {?} */
    ModalComponent.prototype.isCloseOutside;
    /** @type {?} */
    ModalComponent.prototype.whenClose;
    /** @type {?} */
    ModalComponent.prototype.whenOpen;
    /** @type {?} */
    ModalComponent.prototype.content;
    /** @type {?} */
    ModalComponent.prototype.closeButtonElement;
    /**
     * @type {?}
     * @private
     */
    ModalComponent.prototype.tabbingTagNames;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/modal/modal.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ModalModule = /** @class */ (function () {
    function ModalModule() {
    }
    ModalModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [ModalComponent],
                    exports: [ModalComponent]
                },] }
    ];
    return ModalModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/pending-changes-warning-modal/pending-changes-warning-modal.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PendingChangesWarningModalModule = /** @class */ (function () {
    function PendingChangesWarningModalModule() {
    }
    PendingChangesWarningModalModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        TitleModule,
                        ButtonModule,
                        ModalModule
                    ],
                    declarations: [
                        PendingChangesWarningModalComponent
                    ],
                    exports: [
                        PendingChangesWarningModalComponent
                    ]
                },] }
    ];
    return PendingChangesWarningModalModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/context-menu/context-menu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ContextMenuComponent = /** @class */ (function () {
    function ContextMenuComponent(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.icon = 'icon-more-dots';
        this.listener = (/**
         * @return {?}
         */
        function () { }); // Initialize with noop
    }
    /**
     * @param {?} event
     * @return {?}
     */
    ContextMenuComponent.prototype.onClickedOutsideMenu = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.isShowContextMenu = false;
            this.listener();
        }
    };
    /**
     * @return {?}
     */
    ContextMenuComponent.prototype.showContextMenu = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.isShowContextMenu = !this.isShowContextMenu;
        if (this.isShowContextMenu) {
            this.listener = this.renderer.listen('document', 'click', (/**
             * @param {?} event
             * @return {?}
             */
            function (event) { return _this.onClickedOutsideMenu(event); }));
        }
        else {
            this.listener();
        }
    };
    /**
     * @param {?} action
     * @return {?}
     */
    ContextMenuComponent.prototype.onActionClicked = /**
     * @param {?} action
     * @return {?}
     */
    function (action) {
        // Using a call here so we can use either an ArrowFunction or any other object that implements call as an action.
        action.action.call(null, this.row);
        this.listener();
        this.isShowContextMenu = false;
    };
    ContextMenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-context-menu',
                    template: "<button\n  type=\"button\"\n  class=\"cell__dot-button\"\n  [class.cell__dot-button--pressed]=\"isShowContextMenu\"\n  (click)=\"showContextMenu()\">\n    <span class=\"cell__icon\" [ngClass]=\"icon\"></span>\n</button>\n<sc-action-menu\n  *ngIf=\"isShowContextMenu\"\n  class=\"sc-context-menu\"\n  [items]=\"items\"\n  (actionClicked)=\"onActionClicked($event)\">\n</sc-action-menu>\n",
                    styles: [":host{display:inline-block;position:relative}:host(.selectedRow) .cell__dot-button:active+.actions-panel__panel{display:block}:host(.bottom-menu) .sc-context-menu{top:unset;right:.5rem}:host(.bottom-menu) .cell__dot-button{padding:9px 14px}:host(.bottom-menu) .cell__icon{vertical-align:middle}.sc-context-menu{position:absolute;min-width:240px;right:2rem;top:10px;z-index:10}.cell__dot-button{font-size:17px;background-color:transparent;border:none;border-radius:26px;padding:11px 14px}.cell__dot-button:active,.cell__dot-button:focus,.cell__dot-button:hover{outline:0}.cell__dot-button--pressed{background-color:#ccd2dd}"]
                }] }
    ];
    /** @nocollapse */
    ContextMenuComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    ContextMenuComponent.propDecorators = {
        items: [{ type: Input }],
        row: [{ type: Input }],
        icon: [{ type: Input }],
        hideContextMenu: [{ type: Output }]
    };
    return ContextMenuComponent;
}());
if (false) {
    /** @type {?} */
    ContextMenuComponent.prototype.items;
    /** @type {?} */
    ContextMenuComponent.prototype.row;
    /** @type {?} */
    ContextMenuComponent.prototype.icon;
    /** @type {?} */
    ContextMenuComponent.prototype.hideContextMenu;
    /** @type {?} */
    ContextMenuComponent.prototype.isShowContextMenu;
    /**
     * @type {?}
     * @private
     */
    ContextMenuComponent.prototype.listener;
    /**
     * @type {?}
     * @private
     */
    ContextMenuComponent.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    ContextMenuComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/context-menu/context-menu.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ContextMenuModule = /** @class */ (function () {
    function ContextMenuModule() {
    }
    ContextMenuModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ContextMenuComponent],
                    imports: [
                        ActionMenuModule,
                        CommonModule
                    ],
                    exports: [ContextMenuComponent]
                },] }
    ];
    return ContextMenuModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/date-picker/date-picker-view-mode.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DatePickerViewMode = {
    day: "day",
    month: "month",
    year: "year",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/date-picker/date-picker.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CONTROL_VALUE_ACCESSOR$1 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return DatePickerComponent; })),
    multi: true
};
var DatePickerComponent = /** @class */ (function () {
    function DatePickerComponent(localeService, datePipe, titleCasePipe) {
        this.localeService = localeService;
        this.datePipe = datePipe;
        this.titleCasePipe = titleCasePipe;
        this.dateFormat = 'dd/MM/yyyy';
        this.placement = 'bottom';
        this.debounceTime = 0; // [ms]
        this.container = 'body';
        this.adaptivePosition = false;
        this.onChange = (/**
         * @return {?}
         */
        function () { });
        this.auxFormControl = new FormControl();
        this.classes = 'theme-sc';
        defineLocale('es', esLocale);
        this.localeService.use('es');
    }
    /**
     * @return {?}
     */
    DatePickerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.datePickerConfig = {
            showWeekNumbers: false,
            adaptivePosition: this.adaptivePosition
        };
        this.calculateDateLimits();
        if (this.mode) {
            this.datePickerConfig.minMode = this.mode;
        }
        if (this.hideError) {
            this.classes += ' hide-errors';
        }
        this.datePickerConfig.containerClass = this.classes;
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    DatePickerComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.maxLimitDate || changes.minLimitDate || changes.maxLimitDateFromNow || changes.minLimitDateFromNow) {
            this.calculateDateLimits();
        }
    };
    /**
     * @param {?} date
     * @param {?} dateFromNow
     * @return {?}
     */
    DatePickerComponent.prototype.getEdgeDate = /**
     * @param {?} date
     * @param {?} dateFromNow
     * @return {?}
     */
    function (date, dateFromNow) {
        /** @type {?} */
        var edgeDate;
        if (date) {
            edgeDate = date;
        }
        else if (typeof dateFromNow === 'number') {
            edgeDate = new Date();
            edgeDate.setDate(edgeDate.getDate() + dateFromNow);
        }
        return edgeDate;
    };
    /**
     * @return {?}
     */
    DatePickerComponent.prototype.calculateDateLimits = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var negativeMinLimitDateFromNow = null;
        if (typeof this.minLimitDateFromNow === 'number') {
            negativeMinLimitDateFromNow = this.minLimitDateFromNow > 0 ? this.minLimitDateFromNow * (-1) : 0;
        }
        this.minDate = this.getEdgeDate(this.minLimitDate, negativeMinLimitDateFromNow);
        this.maxDate = this.getEdgeDate(this.maxLimitDate, this.maxLimitDateFromNow);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    DatePickerComponent.prototype.handleValueChange = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        /** @type {?} */
        var _date = null;
        if (date instanceof Date) {
            _date = date.toISOString();
        }
        else if (typeof date === 'string') {
            _date = date;
        }
        this.onChange(_date);
        this.auxFormControl.setValue(date);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    DatePickerComponent.prototype.writeValue = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        this.auxFormControl.setValue(date);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DatePickerComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DatePickerComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
    };
    DatePickerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-date-picker',
                    template: "<div class=\"sc-date-picker\" [class.readonly]=\"readOnly\" [class.disabled]=\"disabled\">\n    <sc-input\n        bsDatepicker\n        [bsValue]=\"auxFormControl.value\"\n        [bsConfig]=\"datePickerConfig\"\n        (bsValueChange)=\"handleValueChange($event)\"\n        [maxDate]=\"maxDate\"\n        [minDate]=\"minDate\"\n        [hideError]=\"hideError\"\n        [pipes]=\"[{pipe: datePipe, pipeParams: dateFormat}, {pipe: titleCasePipe }]\"\n        [label]=\"label\"\n        [readonly]=\"true\"\n        [isDisabled]=\"disabled\"\n        [formControl]=\"auxFormControl\"\n        [debounceTime]=\"debounceTime\"\n        [placement]=\"placement\"\n        [placeholder]=\"placeholder\"\n        [container]=\"container\"\n        type=\"text\"\n        icon=\"calendar\"\n    ></sc-input>\n</div>",
                    providers: [CONTROL_VALUE_ACCESSOR$1],
                    encapsulation: ViewEncapsulation.None,
                    styles: [".theme-sc{margin-top:-2rem}.theme-sc.hide-errors{margin-top:-.2rem}.theme-sc .bs-datepicker-body .selected,.theme-sc .bs-datepicker-head{background-color:#0070cc}.sc-date-picker.disabled,.sc-date-picker.readonly{pointer-events:none}.sc-date-picker:not(.readonly):not(.disabled) .sc-input input[type=text][readonly]{background-color:#fff;border-color:#ccd2dd}.sc-date-picker .icon-calendar{color:#0070cc}.sc-date-picker.disabled .icon-calendar,.sc-date-picker.readonly .icon-calendar{color:#aeb7c8}"]
                }] }
    ];
    /** @nocollapse */
    DatePickerComponent.ctorParameters = function () { return [
        { type: BsLocaleService },
        { type: DatePipe },
        { type: TitleCasePipe }
    ]; };
    DatePickerComponent.propDecorators = {
        dateFormat: [{ type: Input }],
        maxLimitDate: [{ type: Input }],
        minLimitDate: [{ type: Input }],
        maxLimitDateFromNow: [{ type: Input }],
        minLimitDateFromNow: [{ type: Input }],
        label: [{ type: Input }],
        disabled: [{ type: Input }],
        readOnly: [{ type: Input }],
        hideError: [{ type: Input }],
        placement: [{ type: Input }],
        debounceTime: [{ type: Input }],
        mode: [{ type: Input }],
        placeholder: [{ type: Input }],
        container: [{ type: Input }],
        adaptivePosition: [{ type: Input }]
    };
    return DatePickerComponent;
}());
if (false) {
    /** @type {?} */
    DatePickerComponent.prototype.dateFormat;
    /** @type {?} */
    DatePickerComponent.prototype.maxLimitDate;
    /** @type {?} */
    DatePickerComponent.prototype.minLimitDate;
    /** @type {?} */
    DatePickerComponent.prototype.maxLimitDateFromNow;
    /** @type {?} */
    DatePickerComponent.prototype.minLimitDateFromNow;
    /** @type {?} */
    DatePickerComponent.prototype.label;
    /** @type {?} */
    DatePickerComponent.prototype.disabled;
    /** @type {?} */
    DatePickerComponent.prototype.readOnly;
    /** @type {?} */
    DatePickerComponent.prototype.hideError;
    /** @type {?} */
    DatePickerComponent.prototype.placement;
    /** @type {?} */
    DatePickerComponent.prototype.debounceTime;
    /** @type {?} */
    DatePickerComponent.prototype.mode;
    /** @type {?} */
    DatePickerComponent.prototype.placeholder;
    /** @type {?} */
    DatePickerComponent.prototype.container;
    /** @type {?} */
    DatePickerComponent.prototype.adaptivePosition;
    /** @type {?} */
    DatePickerComponent.prototype.auxFormControl;
    /** @type {?} */
    DatePickerComponent.prototype.datePickerConfig;
    /** @type {?} */
    DatePickerComponent.prototype.maxDate;
    /** @type {?} */
    DatePickerComponent.prototype.minDate;
    /** @type {?} */
    DatePickerComponent.prototype.classes;
    /** @type {?} */
    DatePickerComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    DatePickerComponent.prototype.localeService;
    /** @type {?} */
    DatePickerComponent.prototype.datePipe;
    /** @type {?} */
    DatePickerComponent.prototype.titleCasePipe;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/inputmodes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var InputModes = {
    none: "none",
    text: "text",
    decimal: "decimal",
    numeric: "numeric",
    tel: "tel",
    search: "search",
    email: "email",
    url: "url",
    default: "",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/base-text-input/base-text-input.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var BaseTextInputComponent = /** @class */ (function () {
    function BaseTextInputComponent() {
        this.inputmode = null;
        this.debounceTime = 0; // [ms]
        this.hasFocus = false;
        this.subs = [];
        this.onChange = (/**
         * @return {?}
         */
        function () { });
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
        this.autocomplete = 'on';
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.hideError = false;
        this.readonly = false;
    }
    /**
     * @return {?}
     */
    BaseTextInputComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.control = this.formControl ? this.formControl : this.getControlContainer().control.get(this.formControlName);
        this.initControl();
        // Agrega un id siempre para poder usar con TGM
        if (this.formControlName && !this.id) {
            this.id = "field_" + this.formControlName;
        }
    };
    /**
     * @return {?}
     */
    BaseTextInputComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subs.forEach((/**
         * @param {?} sub
         * @return {?}
         */
        function (sub) { return sub.unsubscribe(); }));
    };
    /**
     * @param {?} event
     * @return {?}
     */
    BaseTextInputComponent.prototype.onInput = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _a = this.applyPipes(event.target.value), transformedValue = _a.transformedValue, originalValue = _a.originalValue;
        this.value = transformedValue;
        this.onChange(originalValue);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    BaseTextInputComponent.prototype.onBlur = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.blur.emit(event);
        this.onTouched(event);
        this.hasFocus = false;
        this.setControlValidity();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    BaseTextInputComponent.prototype.onFocus = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.focus.emit(event);
        this.hasFocus = true;
    };
    /**
     * @param {?} valueToTransform
     * @return {?}
     */
    BaseTextInputComponent.prototype.applyPipes = /**
     * @param {?} valueToTransform
     * @return {?}
     */
    function (valueToTransform) {
        /** @type {?} */
        var transformedValue = valueToTransform;
        /** @type {?} */
        var originalValue = valueToTransform;
        if (this.pipes && this.pipes.length) {
            this.pipes.forEach((/**
             * @param {?} pipe
             * @return {?}
             */
            function (pipe) {
                if (pipe['pipeParams']) {
                    transformedValue = pipe['pipe'].transform(transformedValue, pipe['pipeParams']);
                }
                else {
                    transformedValue = pipe['pipe'].transform(transformedValue);
                }
                originalValue = (pipe['pipe'].parse && pipe['pipe'].parse(transformedValue)) || transformedValue;
            }));
        }
        return { 'transformedValue': transformedValue, 'originalValue': originalValue };
    };
    // Control Value Accessor methods
    // Control Value Accessor methods
    /**
     * @param {?} value
     * @return {?}
     */
    BaseTextInputComponent.prototype.writeValue = 
    // Control Value Accessor methods
    /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var transformedValue = this.applyPipes(value).transformedValue;
        this.value = transformedValue;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    BaseTextInputComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    BaseTextInputComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} disabled
     * @return {?}
     */
    BaseTextInputComponent.prototype.setDisabledState = /**
     * @param {?} disabled
     * @return {?}
     */
    function (disabled) {
        this.isDisabled = disabled;
    };
    /**
     * @return {?}
     */
    BaseTextInputComponent.prototype.setFocus = /**
     * @return {?}
     */
    function () {
        if (this.elementRef && this.elementRef.nativeElement) {
            this.elementRef.nativeElement.focus();
            this.hasFocus = true;
        }
    };
    // ------------------------------
    // ------------------------------
    /**
     * @protected
     * @return {?}
     */
    BaseTextInputComponent.prototype.initControl = 
    // ------------------------------
    /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.control) {
            setTimeout((/**
             * @return {?}
             */
            function () { return _this.setControlValidity(); }));
            /** @type {?} */
            var obs1$ = this.control.valueChanges.pipe(debounceTime(this.debounceTime || 0), tap((/**
             * @return {?}
             */
            function () { return _this.setControlValidity(); })));
            this.subs.push(obs1$.subscribe());
        }
    };
    /**
     * @private
     * @return {?}
     */
    BaseTextInputComponent.prototype.setControlValidity = /**
     * @private
     * @return {?}
     */
    function () {
        this.hasError = this.control.invalid && (this.control.dirty || this.control.touched || this.control.value);
    };
    BaseTextInputComponent.propDecorators = {
        autocomplete: [{ type: Input }],
        errorMessages: [{ type: Input }],
        formControl: [{ type: Input }],
        formControlName: [{ type: Input }],
        hideError: [{ type: Input }],
        icon: [{ type: Input }],
        iconClickHandler: [{ type: Input }],
        id: [{ type: Input }],
        inputmode: [{ type: Input }],
        isDisabled: [{ type: Input }],
        label: [{ type: Input }],
        pipes: [{ type: Input }],
        placeholder: [{ type: Input }],
        readonly: [{ type: Input }],
        value: [{ type: Input }],
        maxlength: [{ type: Input }],
        debounceTime: [{ type: Input }],
        blur: [{ type: Output }],
        focus: [{ type: Output }],
        elementRef: [{ type: ViewChild, args: ['elementRef', { static: true },] }]
    };
    return BaseTextInputComponent;
}());
if (false) {
    /** @type {?} */
    BaseTextInputComponent.prototype.autocomplete;
    /** @type {?} */
    BaseTextInputComponent.prototype.errorMessages;
    /** @type {?} */
    BaseTextInputComponent.prototype.formControl;
    /** @type {?} */
    BaseTextInputComponent.prototype.formControlName;
    /** @type {?} */
    BaseTextInputComponent.prototype.hideError;
    /** @type {?} */
    BaseTextInputComponent.prototype.icon;
    /** @type {?} */
    BaseTextInputComponent.prototype.iconClickHandler;
    /** @type {?} */
    BaseTextInputComponent.prototype.id;
    /** @type {?} */
    BaseTextInputComponent.prototype.inputmode;
    /** @type {?} */
    BaseTextInputComponent.prototype.isDisabled;
    /** @type {?} */
    BaseTextInputComponent.prototype.label;
    /** @type {?} */
    BaseTextInputComponent.prototype.pipes;
    /** @type {?} */
    BaseTextInputComponent.prototype.placeholder;
    /** @type {?} */
    BaseTextInputComponent.prototype.readonly;
    /** @type {?} */
    BaseTextInputComponent.prototype.value;
    /** @type {?} */
    BaseTextInputComponent.prototype.maxlength;
    /** @type {?} */
    BaseTextInputComponent.prototype.debounceTime;
    /** @type {?} */
    BaseTextInputComponent.prototype.blur;
    /** @type {?} */
    BaseTextInputComponent.prototype.focus;
    /** @type {?} */
    BaseTextInputComponent.prototype.elementRef;
    /** @type {?} */
    BaseTextInputComponent.prototype.control;
    /** @type {?} */
    BaseTextInputComponent.prototype.hasError;
    /** @type {?} */
    BaseTextInputComponent.prototype.hasFocus;
    /**
     * @type {?}
     * @protected
     */
    BaseTextInputComponent.prototype.subs;
    /** @type {?} */
    BaseTextInputComponent.prototype.onChange;
    /** @type {?} */
    BaseTextInputComponent.prototype.onTouched;
    /**
     * @abstract
     * @return {?}
     */
    BaseTextInputComponent.prototype.getControlContainer = function () { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/input/input.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CONTROL_VALUE_ACCESSOR$2 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return InputComponent; })),
    multi: true
};
var InputComponent = /** @class */ (function (_super) {
    __extends(InputComponent, _super);
    function InputComponent(controlContainer) {
        var _this = _super.call(this) || this;
        _this.controlContainer = controlContainer;
        _this.hasPasswordToggle = false;
        _this.type = 'text';
        return _this;
    }
    /**
     * @return {?}
     */
    InputComponent.prototype.getControlContainer = /**
     * @return {?}
     */
    function () {
        return this.controlContainer;
    };
    /**
     * @return {?}
     */
    InputComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        _super.prototype.ngOnInit.call(this);
        if (this.type === 'password' && !this.icon) {
            this.icon = 'eye';
            this.hasPasswordToggle = true;
        }
    };
    /**
     * @return {?}
     */
    InputComponent.prototype.hidePassword = /**
     * @return {?}
     */
    function () {
        this.icon = 'eye';
        this.type = 'password';
    };
    /**
     * @return {?}
     */
    InputComponent.prototype.showPassword = /**
     * @return {?}
     */
    function () {
        this.icon = 'eye-hidden';
        this.type = 'text';
    };
    InputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-input',
                    template: "<div class=\"sc-input\" [class.sc-input--with-icon]=\"!!icon\">\n    <label\n      *ngIf=\"label\" [attr.for]=\"id ? id+'__input' : null\"\n      class=\"sc-input__label\"\n      [class.sc-input__label--floating]=\"!!value\"\n      [class.label--focus]=\"hasFocus\"\n      [class.sc-input__label--floating-has-error]=\"hasError\"\n    >{{ label }}</label>\n    <div class=\"sc-input__input-group\" >\n        <span\n          *ngIf=\"addOnPrefix\"\n          class=\"sc-input__input-group--prefix\"\n          [class.has-error]=\"hasError\"\n          [class.disabled-adon]=\"isDisabled\"\n          >{{addOnPrefix}}</span>\n\n        <span\n          *ngIf=\"addOnSubfix\"\n          class=\"sc-input__input-group--subfix\"\n          [class.has-error]=\"hasError\"\n          [class.disabled-adon]=\"isDisabled\"\n          >{{addOnSubfix}}</span>\n      <input\n            #elementRef\n            [autocomplete]=\"autocomplete\"\n            [class.has-error]=\"hasError\"\n            class=\"sc-input__input-group__control\"\n            [disabled]=\"isDisabled\"\n            [attr.id]=\"id ? id+'__input' : null\"\n            [attr.inputmode]=\"inputmode\"\n            [placeholder]=\"(placeholder ? placeholder : '')\"\n            [readonly]=\"readonly\"\n            [type]=\"type\"\n            [value]=\"value\"\n            (blur)=\"onBlur($event)\"\n            (focus)=\"onFocus($event)\"\n            (input)=\"onInput($event)\"\n            [attr.maxLength]=\"maxlength\"\n             />\n\n\n\n\n        <ng-container *ngIf=\"!!icon\">\n          <sc-icon class=\"sc-input__icon\" [icon]=\"icon\" *ngIf=\"!hasPasswordToggle && !iconClickHandler\" [disabled]=\"isDisabled || readonly\"></sc-icon>\n          <sc-icon class=\"sc-input__icon\" [icon]=\"icon\" *ngIf=\"!hasPasswordToggle && iconClickHandler\" [disabled]=\"isDisabled\" (click)=\"iconClickHandler.subscribe()\"></sc-icon>\n          <sc-icon class=\"sc-input__icon\" [icon]=\"icon\"\n           *ngIf=\"hasPasswordToggle\"\n           (mousedown)=\"showPassword()\"\n           (mouseup)=\"hidePassword()\"\n           (mouseleave)=\"hidePassword()\"\n           (press)=\"showPassword()\"\n           (pressup)=\"hidePassword()\"\n           [disabled]=\"isDisabled\">\n          </sc-icon>\n        </ng-container>\n    </div>\n    <sc-form-control-error\n      [errorMessages]=\"errorMessages\"\n      [control]=\"control\"\n      [hasError]=\"hasError\"\n      [hidden]=\"hideError\"\n      [debounceTime]=\"debounceTime\">\n    </sc-form-control-error>\n</div>\n",
                    providers: [CONTROL_VALUE_ACCESSOR$2],
                    styles: [".base-text-input__label,:host(.floating-label) .sc-input__label{pointer-events:none;position:absolute;top:13px;left:15px;transition:.1s ease-in-out;z-index:2;font-size:1rem;opacity:0}.base-text-input__label--floating,:host(.floating-label) .sc-input__label--floating{top:-8px;left:15px;font-size:.875rem;background-color:#fff;padding:0 5px;display:block;opacity:1}:host(.fluid-input){display:inline-block;width:100%}.sc-input{margin-bottom:.25rem}.sc-input--with-icon input{padding-right:3rem}.sc-input--with-icon input:focus{padding-right:3rem!important}.sc-input__input-group{position:relative;display:flex}.sc-input__input-group--focus{border-color:#0070cc}.sc-input__input-group--prefix{padding:4px 7px 5px;background-color:#eef0f7;border-radius:3px 0 0 3px;border:1px solid #ccd2dd;border-right:none;line-height:2.1;font-size:14px}.sc-input__input-group--prefix.has-error{border-color:#dc3545;background-color:#f1dcde;color:#dc3545}.sc-input__input-group--prefix+input{overflow:hidden;border:1px solid #ccd2dd;border-radius:0 3px 3px 0;padding-left:6px!important;width:100%}.sc-input__input-group--prefix+input.has-error{border-color:#dc3545}.sc-input__input-group--prefix+input:focus{padding-left:6px;border-color:#0070cc}.sc-input__input-group--subfix{padding:4px 7px 5px;background-color:#eef0f7;border-radius:0 3px 3px 0;border:1px solid #ccd2dd;line-height:2.1;font-size:14px;order:2}.sc-input__input-group--subfix.has-error{border-color:#dc3545;background-color:#e4606d;color:#dc3545}.sc-input__input-group--subfix+input{border:1px solid #ccd2dd;border-radius:3px 0 0 3px;padding-left:6px!important;padding-right:6px!important;width:100%;order:1}.sc-input__input-group--subfix+input.has-error{border-color:#dc3545}.sc-input__input-group--subfix+input:focus{padding-left:6px!important;padding-right:6px!important;border-color:#0070cc}.sc-input__input-group__control{padding:11px 15px;font-size:16px}@media (min-width:768px){.sc-input__input-group__control{font-size:14px}}.sc-input__input-group__control:focus{padding:11px 15px}.sc-input input[type=number]::-webkit-inner-spin-button,.sc-input input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.sc-input input[type=number]{-moz-appearance:textfield}.sc-input [readonly]:not(.has-error){background-color:#e0e5ed;border-color:#ccd2dd}.sc-input__icon{display:flex;position:absolute;right:0;top:0;padding:.5rem 1rem 1rem 0}.disabled-adon{opacity:.3}:host(.floating-label) .sc-input{position:relative;margin-top:.5rem}:host(.floating-label) .sc-input__label--floating-has-error{color:#dc3545}:host(.floating-label) .sc-input__label--floating-has-error.label--focus{color:#dc3545}:host(.floating-label) .label--focus{color:#0070cc}:host(.display-only) .sc-input__input-group__control,:host(.display-only) .sc-input__input-group__control:disabled{border:0;background-color:transparent;padding-left:5px}:host(.display-only) .sc-input{position:relative;margin-top:.5rem}:host(.display-only) .sc-input__label{left:0}"]
                }] }
    ];
    /** @nocollapse */
    InputComponent.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: Host }, { type: SkipSelf }, { type: Optional }] }
    ]; };
    InputComponent.propDecorators = {
        type: [{ type: Input }],
        addOnPrefix: [{ type: Input }],
        addOnSubfix: [{ type: Input }]
    };
    return InputComponent;
}(BaseTextInputComponent));
if (false) {
    /** @type {?} */
    InputComponent.prototype.type;
    /** @type {?} */
    InputComponent.prototype.addOnPrefix;
    /** @type {?} */
    InputComponent.prototype.addOnSubfix;
    /** @type {?} */
    InputComponent.prototype.hasPasswordToggle;
    /**
     * @type {?}
     * @private
     */
    InputComponent.prototype.controlContainer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/errorMessages.constant.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0 = /**
 * @return {?}
 */
function () { return 'Este campo es requerido'; }, ɵ1 = /**
 * @param {?} params
 * @return {?}
 */
function (params) { return "Ingres\u00E1 " + params.requiredLength + " caracteres como m\u00EDnimo"; }, ɵ2 = /**
 * @param {?} params
 * @return {?}
 */
function (params) { return "Se permiten hasta " + params.requiredLength + " caracteres"; }, ɵ3 = /**
 * @param {?} params
 * @return {?}
 */
function (params) { return 'El patrón requerido es: ' + params.requiredPattern; }, ɵ4 = /**
 * @param {?} params
 * @return {?}
 */
function (params) { return params.message; };
/** @type {?} */
var errorMessages = {
    'required': (ɵ0),
    'minlength': (ɵ1),
    'maxlength': (ɵ2),
    'pattern': (ɵ3),
    'years': (ɵ4)
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/form-control-error/form-control-error.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormControlErrorComponent = /** @class */ (function () {
    function FormControlErrorComponent() {
        this.debounceTime = 0; // [ms]
        this.errorsList = [];
        this._errorMessages = {};
    }
    Object.defineProperty(FormControlErrorComponent.prototype, "errorMessages", {
        get: /**
         * @return {?}
         */
        function () { return this._errorMessages; },
        set: 
        // [ms]
        /**
         * @param {?} errorMessages
         * @return {?}
         */
        function (errorMessages$1) {
            this._errorMessages = errorMessages$1;
            this.allErrorMessages = Object.assign({}, errorMessages, this._errorMessages);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormControlErrorComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initControl();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlErrorComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this.setControlValidity();
    };
    /**
     * @return {?}
     */
    FormControlErrorComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    FormControlErrorComponent.prototype.shouldShowErrors = /**
     * @return {?}
     */
    function () {
        return this.control && this.hasError;
    };
    /**
     * @param {?} type
     * @param {?} params
     * @return {?}
     */
    FormControlErrorComponent.prototype.getMessage = /**
     * @param {?} type
     * @param {?} params
     * @return {?}
     */
    function (type, params) {
        return type && params &&
            (typeof this.allErrorMessages[type] === 'function' ? this.allErrorMessages[type](params) : this.allErrorMessages[type])
            || '';
    };
    /**
     * @private
     * @return {?}
     */
    FormControlErrorComponent.prototype.initControl = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.control) {
            setTimeout((/**
             * @return {?}
             */
            function () { return _this.setControlValidity(); }));
            this.subs = this.control.valueChanges.pipe(debounceTime(this.debounceTime || 0), tap((/**
             * @return {?}
             */
            function () { return _this.setControlValidity(); }))).subscribe();
        }
    };
    /**
     * @private
     * @return {?}
     */
    FormControlErrorComponent.prototype.setControlValidity = /**
     * @private
     * @return {?}
     */
    function () {
        this.hasError = this.control.invalid && (this.control.dirty || this.control.touched || this.control.value);
        this.errorsList = this.getErrorsList();
    };
    /**
     * @private
     * @return {?}
     */
    FormControlErrorComponent.prototype.getErrorsList = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var errors = this.control && this.control.errors;
        /** @type {?} */
        var errorsToShow = errors ? Object.keys(errors) : [];
        return errorsToShow.map((/**
         * @param {?} field
         * @return {?}
         */
        function (field) { return _this.getMessage(field, errors[field]); }));
    };
    FormControlErrorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-form-control-error',
                    template: "<div class=\"sc-form-control-error form-control-error\">\n    <ul class=\"sc-form-control-error__list\" *ngIf=\"shouldShowErrors()\">\n        <li class=\"sc-form-control-error__list-item\" *ngFor=\"let error of errorsList\">{{ error }}</li>\n    </ul>\n</div>",
                    styles: [".sc-form-control-error{min-height:1.5rem}.sc-form-control-error__list{list-style:none;padding:0;margin:0}"]
                }] }
    ];
    /** @nocollapse */
    FormControlErrorComponent.ctorParameters = function () { return []; };
    FormControlErrorComponent.propDecorators = {
        control: [{ type: Input }],
        debounceTime: [{ type: Input }],
        errorMessages: [{ type: Input }],
        hasError: [{ type: Input }]
    };
    return FormControlErrorComponent;
}());
if (false) {
    /** @type {?} */
    FormControlErrorComponent.prototype.allErrorMessages;
    /** @type {?} */
    FormControlErrorComponent.prototype.control;
    /** @type {?} */
    FormControlErrorComponent.prototype.debounceTime;
    /** @type {?} */
    FormControlErrorComponent.prototype.hasError;
    /** @type {?} */
    FormControlErrorComponent.prototype.errorsList;
    /**
     * @type {?}
     * @private
     */
    FormControlErrorComponent.prototype._errorMessages;
    /**
     * @type {?}
     * @private
     */
    FormControlErrorComponent.prototype.subs;
}
/**
 * @record
 */
function KeyValue() { }

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/form-control-error/form-control-error.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormControlErrorModule = /** @class */ (function () {
    function FormControlErrorModule() {
    }
    FormControlErrorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [FormControlErrorComponent],
                    exports: [FormControlErrorComponent]
                },] }
    ];
    return FormControlErrorModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/input/input.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InputModule = /** @class */ (function () {
    function InputModule() {
    }
    InputModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        IconModule,
                        FormControlErrorModule
                    ],
                    declarations: [InputComponent],
                    exports: [InputComponent]
                },] }
    ];
    return InputModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/date-picker/date-picker.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
defineLocale('es', esLocale);
var DatePickerModule = /** @class */ (function () {
    function DatePickerModule() {
    }
    DatePickerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        BsDatepickerModule.forRoot(),
                        InputModule,
                        ReactiveFormsModule
                    ],
                    declarations: [DatePickerComponent],
                    exports: [DatePickerComponent],
                    providers: [DatePipe, TitleCasePipe]
                },] }
    ];
    return DatePickerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/filter-box/filter-box.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FilterBoxComponent = /** @class */ (function () {
    function FilterBoxComponent() {
        this.showLateralMenu = false;
        this.apply = new EventEmitter();
        this.delete = new EventEmitter();
        this.closeUnapplied = new EventEmitter();
        this.opened = new EventEmitter();
        this.count = 0;
        this.disabledApply = false;
        this.disabledDelete = false;
        this.buttonId = 'abrir-filtros';
        this.disabledButton = false;
        this.applyId = 'aplicar-filtros';
        this.deleteId = 'eliminar-filtros';
    }
    /**
     * @return {?}
     */
    FilterBoxComponent.prototype.open = /**
     * @return {?}
     */
    function () {
        if (!this.disabledButton) {
            this.opened.emit();
            this.showLateralMenu = true;
        }
    };
    /**
     * @return {?}
     */
    FilterBoxComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.closeUnapplied.emit();
        this.showLateralMenu = false;
    };
    /**
     * @return {?}
     */
    FilterBoxComponent.prototype.deleteFilters = /**
     * @return {?}
     */
    function () {
        if (!this.disabledDelete) {
            this.showLateralMenu = false;
            this.delete.emit();
        }
    };
    /**
     * @return {?}
     */
    FilterBoxComponent.prototype.applyFilters = /**
     * @return {?}
     */
    function () {
        if (!this.disabledApply) {
            this.showLateralMenu = false;
            this.apply.emit();
        }
    };
    FilterBoxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-filter-box',
                    template: "<!--DESKTOP-->\n<sc-button [disabled]=\"disabledButton\" [id]=\"buttonId\" type=\"secondary\" class=\"filter-button-desktop  d-none d-md-block\" (onClick)=\"open()\">\n  <span>\n    <sc-icon icon=\"list-filter\" size=\"0_75\" [class]=\"'mr-1'\" *ngIf=\"count == 0\"></sc-icon>\n\n    <span \n    [ngClass]=\"disabledButton? 'filter-button-desktop--count-disabled' : 'filter-button-desktop--count'\"\n    *ngIf=\"count > 0\">\n      <span class=\"filter-button-desktop--count__number\">\n        {{count}}\n      </span>\n    </span>\n      Filtros\n  </span>\n</sc-button>\n\n<!--MOBILE-->\n<div class=\"filter-button-mobile mobile-container d-md-none\" (click)=\"open()\" [id]=\"buttonId\">\n  <div>\n    <span\n    [ngClass]=\"disabledButton? 'filter-button-mobile--count-disabled' : 'filter-button-mobile--count'\"\n    *ngIf=\"count > 0\">\n      <span class=\"filter-button-mobile--count__number\">\n        {{count}}\n      </span>\n    </span>\n    <sc-icon [ngClass]=\"disabledButton? 'filter-button-mobile--icon-disabled' : 'filter-button-mobile--icon'\" icon=\"list-filter\" size=\"1\"></sc-icon>\n  </div>\n</div>\n\n<!-- LATERAL PANEL -->\n<sc-lateral-drawer-light-box \n  [class.show]=\"showLateralMenu\"\n  (close)=\"close()\">\n  <sc-lateral-drawer\n    class=\"filter-container white-lateral-panel hide-close-on-mobile\" \n    (close)=\"close()\"\n    [backArrowForMobile]=\"true\"\n    [isOpen]=\"showLateralMenu\">\n    <div class=\"filter-container__header\">\n      <span class=\"filter-container__header--title subtitle\">\n        Filtros\n      </span>\n    </div>\n    <div class=\"filter-container__body\">\n      <ng-content></ng-content>\n    </div>\n    <div class=\"filter-container__footer d-flex\">\n      <div class=\"col-md-6\">\n        <sc-button type=\"primary\" [id]=\"applyId\" [disabled]=\"disabledApply\" class=\"full-width\" (onClick)=\"applyFilters()\">Aplicar</sc-button>\n      </div>\n      <div class=\"col-md-6\">\n        <sc-button type=\"secondary\" [id]=\"deleteId\" [disabled]=\"disabledDelete\" class=\"full-width\" (onClick)=\"deleteFilters()\">Borrar filtros</sc-button>\n      </div>\n    </div>\n  </sc-lateral-drawer>\n</sc-lateral-drawer-light-box >",
                    styles: [".filter-container__header{border-bottom:1px solid #e0e5ed;padding:0 1.5rem 1.5rem;display:flex;align-items:center}@media only screen and (max-width:768px){.filter-container__header--title{margin-left:3rem;font-size:1.5rem}}.filter-container__footer{text-align:center;position:absolute;width:100%;bottom:0;padding:1.5rem 0;border-top:1px solid #e0e5ed;background-color:#fff}.filter-container__body{padding:1.5rem;height:calc(100vh - 10.5rem);overflow-y:auto}.filter-button-desktop--count{background-color:#0070cc;color:#fff;display:inline-block;vertical-align:text-bottom;height:17px;width:17px;border-radius:20px;font-size:11px;margin-right:10.41px!important}.filter-button-desktop--count__number{font-size:11px;display:flex;justify-content:center;align-items:center;width:17px;height:17px}.filter-button-desktop--count-disabled{background-color:#aeb7c8;color:#fff;display:inline-block;vertical-align:text-bottom;height:17px;width:17px;border-radius:20px;font-size:11px;margin-right:10.41px!important}.filter-button-desktop--count-disabled__number{font-size:11px;display:flex;justify-content:center;align-items:center;width:17px;height:17px}.filter-button-desktop:hover .filter-button__desktop--count{background-color:#fff!important;color:#0070cc!important}.filter-button-desktop:hover .filter-button__desktop--icon{color:#fff!important}.filter-button-mobile{display:flex;justify-content:center;align-items:center;height:40px}.filter-button-mobile--count{background-color:#3dcc98;color:#fff;border-radius:20px;position:absolute;margin-left:-8px;margin-top:-8px}.filter-button-mobile--count__number{font-size:11px;display:flex;justify-content:center;align-items:center;width:17px;height:17px}.filter-button-mobile--count-disabled{background-color:#aeb7c8;color:#fff;border-radius:20px;position:absolute;margin-left:-8px;margin-top:-8px}.filter-button-mobile--count-disabled__number{font-size:11px;display:flex;justify-content:center;align-items:center;width:17px;height:17px}.filter-button-mobile--icon{color:#0070cc}.filter-button-mobile--icon-disabled{color:#8993a4}"]
                }] }
    ];
    FilterBoxComponent.propDecorators = {
        apply: [{ type: Output }],
        delete: [{ type: Output }],
        closeUnapplied: [{ type: Output }],
        opened: [{ type: Output }],
        count: [{ type: Input }],
        disabledApply: [{ type: Input }],
        disabledDelete: [{ type: Input }],
        buttonId: [{ type: Input }],
        disabledButton: [{ type: Input }],
        applyId: [{ type: Input }],
        deleteId: [{ type: Input }]
    };
    return FilterBoxComponent;
}());
if (false) {
    /** @type {?} */
    FilterBoxComponent.prototype.showLateralMenu;
    /** @type {?} */
    FilterBoxComponent.prototype.apply;
    /** @type {?} */
    FilterBoxComponent.prototype.delete;
    /** @type {?} */
    FilterBoxComponent.prototype.closeUnapplied;
    /** @type {?} */
    FilterBoxComponent.prototype.opened;
    /** @type {?} */
    FilterBoxComponent.prototype.count;
    /** @type {?} */
    FilterBoxComponent.prototype.disabledApply;
    /** @type {?} */
    FilterBoxComponent.prototype.disabledDelete;
    /** @type {?} */
    FilterBoxComponent.prototype.buttonId;
    /** @type {?} */
    FilterBoxComponent.prototype.disabledButton;
    /** @type {?} */
    FilterBoxComponent.prototype.applyId;
    /** @type {?} */
    FilterBoxComponent.prototype.deleteId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-drawer/lateral-drawer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralDrawerComponent = /** @class */ (function () {
    function LateralDrawerComponent() {
        this.isOpen = false;
        this.backArrowForMobile = false;
        this.close = new EventEmitter();
        this.classes = {};
    }
    /**
     * @return {?}
     */
    LateralDrawerComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        this.setClass();
    };
    /**
     * @return {?}
     */
    LateralDrawerComponent.prototype.setClass = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var classes = {};
        classes['lateral-drawer'] = true;
        classes['lateral-drawer_open'] = this.isOpen;
        classes['lateral-drawer_close'] = !this.isOpen;
        this.classes = classes;
    };
    /**
     * @return {?}
     */
    LateralDrawerComponent.prototype.closeDrawer = /**
     * @return {?}
     */
    function () {
        this.close.emit();
    };
    LateralDrawerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-lateral-drawer',
                    template: "<div class=\"lateral-drawer\" [ngClass]=\"classes\">\n  <div class=\"lateral-menu--content\">\n    <span class=\"back-arrow\" (click)=\"closeDrawer()\"  [ngClass]=\"backArrowForMobile? 'd-md-none' : 'd-none'\">\n      <sc-icon icon=\"arrow-left-big\" size=\"1\"></sc-icon>\n    </span>\n    <span (click)=\"closeDrawer()\" class=\"close-button sc-icon sc-icon--2x icon-close\"\n    [ngClass]=\"backArrowForMobile? 'd-none d-md-block' : ''\"\n      ></span>\n    <ng-content></ng-content>\n  </div>\n</div>",
                    styles: ["@media (min-width:768px){:host(.wider) .lateral-drawer{width:512px}:host(.wider) .lateral-drawer_close{right:-512px}:host(.width-600) .lateral-drawer{width:600px}:host(.width-600) .lateral-drawer_close{right:-600px}:host(.width-900) .lateral-drawer{width:900px}:host(.width-900) .lateral-drawer_close{right:-900px}}.lateral-drawer{background-color:#fff;border-color:#ccd2dd;box-sizing:border-box;height:100%;position:absolute;width:457px;top:0;overflow:auto;box-shadow:0 2px 6px 0 rgba(0,0,0,.08);padding:0;transition:right .25s ease-out}.lateral-drawer .lateral-menu--content{margin:1.5rem 0 0}.lateral-drawer_open{right:0}.lateral-drawer_close{right:-457px}@media (max-width:768px){.lateral-drawer{width:100%;padding:0}.lateral-drawer_close{left:100%}}.close-button{color:#424f66;font-size:12px;position:absolute;cursor:pointer;right:12px;background-color:#e0e5ed;padding-top:5px;border-radius:3px;width:32px;height:32px;text-align:center;margin-right:1rem}.close-button:hover{background-color:#aeb7c8}.back-arrow{position:absolute;margin-left:1.5rem;line-height:2rem;cursor:pointer}"]
                }] }
    ];
    LateralDrawerComponent.propDecorators = {
        isOpen: [{ type: Input }],
        backArrowForMobile: [{ type: Input }],
        close: [{ type: Output }]
    };
    return LateralDrawerComponent;
}());
if (false) {
    /** @type {?} */
    LateralDrawerComponent.prototype.isOpen;
    /** @type {?} */
    LateralDrawerComponent.prototype.backArrowForMobile;
    /** @type {?} */
    LateralDrawerComponent.prototype.close;
    /** @type {?} */
    LateralDrawerComponent.prototype.classes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-drawer/lateral-drawer.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralDrawerModule = /** @class */ (function () {
    function LateralDrawerModule() {
    }
    LateralDrawerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ButtonModule,
                        IconModule
                    ],
                    declarations: [LateralDrawerComponent],
                    exports: [LateralDrawerComponent]
                },] }
    ];
    return LateralDrawerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-drawer-light-box/lateral-drawer-light-box.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralDrawerLightBoxComponent = /** @class */ (function () {
    function LateralDrawerLightBoxComponent() {
        this.close = new EventEmitter();
    }
    // When the escape key is pressed we simulate a click
    // When the escape key is pressed we simulate a click
    /**
     * @return {?}
     */
    LateralDrawerLightBoxComponent.prototype.onEscape = 
    // When the escape key is pressed we simulate a click
    /**
     * @return {?}
     */
    function () {
        this.close.emit();
    };
    /**
     * @return {?}
     */
    LateralDrawerLightBoxComponent.prototype.closeLightBox = /**
     * @return {?}
     */
    function () {
        this.close.emit();
    };
    LateralDrawerLightBoxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-lateral-drawer-light-box',
                    template: "<div class=\"sc-light-box\" (click)=\"closeLightBox()\">\n</div>\n<ng-content></ng-content>",
                    styles: [":host{background-color:rgba(0,0,0,0);bottom:0;height:100%;left:0;overflow-x:hidden;position:fixed;right:0;top:0;transition:background-color .3s ease-in-out,visibility .3s ease-in-out;visibility:hidden;width:100%;z-index:10}:host(.wider) .sc-light-box{width:calc(100% - 512px)}:host(.width-600) .sc-light-box{width:calc(100% - 600px)}:host(.width-900) .sc-light-box{width:calc(100% - 900px)}:host(.show){background-color:rgba(0,0,0,.6);visibility:visible}.sc-light-box{height:100%;width:calc(100% - 457px)}"]
                }] }
    ];
    LateralDrawerLightBoxComponent.propDecorators = {
        close: [{ type: Output }],
        onEscape: [{ type: HostListener, args: ['document:keydown.escape',] }]
    };
    return LateralDrawerLightBoxComponent;
}());
if (false) {
    /** @type {?} */
    LateralDrawerLightBoxComponent.prototype.close;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-drawer-light-box/lateral-drawer-light-box.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralDrawerLightBoxModule = /** @class */ (function () {
    function LateralDrawerLightBoxModule() {
    }
    LateralDrawerLightBoxModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [LateralDrawerLightBoxComponent],
                    exports: [LateralDrawerLightBoxComponent]
                },] }
    ];
    return LateralDrawerLightBoxModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/filter-box/filter-box.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FilterBoxModule = /** @class */ (function () {
    function FilterBoxModule() {
    }
    FilterBoxModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ButtonModule,
                        LateralDrawerModule,
                        IconModule,
                        LateralDrawerLightBoxModule
                    ],
                    declarations: [FilterBoxComponent],
                    exports: [FilterBoxComponent]
                },] }
    ];
    return FilterBoxModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/grid-settings.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GridSettings = /** @class */ (function () {
    function GridSettings() {
    }
    return GridSettings;
}());
if (false) {
    /** @type {?} */
    GridSettings.prototype.columns;
    /** @type {?} */
    GridSettings.prototype.rowCustomClass;
    /** @type {?} */
    GridSettings.prototype.mobileCardComponentClass;
    /** @type {?} */
    GridSettings.prototype.mobileCardFooterComponentClass;
    /** @type {?} */
    GridSettings.prototype.emptyState;
    /** @type {?} */
    GridSettings.prototype.error;
    /** @type {?} */
    GridSettings.prototype.footers;
    /** @type {?} */
    GridSettings.prototype.mobileCardFooterInitializer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/animations/tableList.animation.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var tableListAnimation = trigger('tableListAnimation', [
    transition(':enter', [
        query('tr', [
            style({ opacity: 0, overflow: 'hidden' }),
            stagger(100, [
                // animate('800ms cubic-bezier(0.35, 0, 0.25, 1)', style('*'))
                animate('600ms ease-in-out', style({ opacity: 1 }))
            ])
        ])
    ])
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/animations/timelineList.animation.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var timelineListAnimation = trigger('timelineListAnimation', [
    transition(':enter', [
        query('tr', [
            style({ opacity: 0, overflow: 'hidden' }),
            stagger(50, [
                // animate('800ms cubic-bezier(0.35, 0, 0.25, 1)', style('*'))
                animate('800ms ease-in-out', style({ opacity: 1 }))
            ])
        ])
    ]),
    transition(':leave', [
        query('tr', [
            style({ opacity: 1, overflow: 'hidden' }),
            stagger(10, [
                // animate('800ms cubic-bezier(0.35, 0, 0.25, 1)', style('*'))
                animate('50ms ease-in-out', style({ opacity: 0 }))
            ])
        ])
    ])
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/sort-criteria-types.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var sortCriteria = {
    ascendant: "ASC",
    descendant: "DESC",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/grid-sort-event.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GridSortEvent = /** @class */ (function () {
    function GridSortEvent(id) {
        if (id === void 0) { id = ''; }
        this.id = id;
        this.criteria = sortCriteria.ascendant;
    }
    return GridSortEvent;
}());
if (false) {
    /** @type {?} */
    GridSortEvent.prototype.id;
    /** @type {?} */
    GridSortEvent.prototype.criteria;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/breakpoints.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var Breakpoints = {
    SM: "320px",
    MD: "768px",
    LG: "1152px",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/grid.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GridComponent = /** @class */ (function () {
    function GridComponent(breakpointObserver) {
        var _this = this;
        this.breakpointObserver = breakpointObserver;
        this.summary = '';
        this.placeholderItems = new Array(6);
        this.rowClicked = new EventEmitter();
        this.columnSorted = new EventEmitter();
        this.actionColumns = [];
        this.otherColumns = [];
        this.checkboxColumns = [];
        this.loading = false;
        this.hasError = false;
        this.isMobile = true;
        this.breakpointObserver
            .observe(["(max-width: " + Breakpoints.MD + ")"])
            .subscribe((/**
         * @param {?} state
         * @return {?}
         */
        function (state) { return _this.isMobile = state.matches; }));
    }
    /**
     * @return {?}
     */
    GridComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.sortableColumnIconOption = {
            'ASC': 'arrow-up-dropdown',
            'DESC': 'arrow-down-dropdown'
        };
        this.sortedDefaultColumn = this.settings.columns.filter((/**
         * @param {?} column
         * @return {?}
         */
        function (column) { return column.defaultSortedColumn; })) || [];
        this.gridSortBy = new GridSortEvent(this.sortedDefaultColumn[0] && this.sortedDefaultColumn[0].id);
    };
    Object.defineProperty(GridComponent.prototype, "mobileCardFooterData", {
        get: /**
         * @return {?}
         */
        function () {
            return {
                componentClass: this.settings.mobileCardFooterComponentClass,
                items: this.items,
                initializer: this.settings.mobileCardFooterInitializer
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridComponent.prototype, "hasFooter", {
        get: /**
         * @return {?}
         */
        function () {
            return !!this.settings.footers;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    GridComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        var _this = this;
        if (changes.source) {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
            this.loading = true;
            this.hasError = false;
            this.subscription = this.source.subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                _this.updateSourceData(data);
            }), (/**
             * @return {?}
             */
            function () {
                _this.hasError = true;
                _this.items = null;
            }))
                .add((/**
             * @return {?}
             */
            function () { return _this.loading = false; }));
        }
        if (changes.settings) {
            this.actionColumns = this.settings.columns.filter((/**
             * @param {?} each
             * @return {?}
             */
            function (each) { return each.isActionColumn; }));
            this.otherColumns = this.settings.columns.filter((/**
             * @param {?} each
             * @return {?}
             */
            function (each) { return !each.isActionColumn && !each.isCheckbox; }));
            this.checkboxColumns = this.settings.columns.filter((/**
             * @param {?} each
             * @return {?}
             */
            function (each) { return each.isCheckbox; }));
        }
    };
    /**
     * @protected
     * @param {?} data
     * @return {?}
     */
    GridComponent.prototype.updateSourceData = /**
     * @protected
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.items = data;
        this.loading = false;
    };
    /**
     * @param {?} row
     * @param {?} index
     * @return {?}
     */
    GridComponent.prototype.onRowClicked = /**
     * @param {?} row
     * @param {?} index
     * @return {?}
     */
    function (row, index) {
        this.rowClicked.emit(row);
    };
    /**
     * @return {?}
     */
    GridComponent.prototype.onLoadError = /**
     * @return {?}
     */
    function () {
        this.settings.error.actionCallback.call(null, null);
    };
    /**
     * @param {?} config
     * @return {?}
     */
    GridComponent.prototype.getSortableColumnIcon = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var sortableColumnIcon;
        sortableColumnIcon = (config.id === this.gridSortBy.id)
            ? this.sortableColumnIconOption[this.gridSortBy.criteria]
            : this.sortableColumnIconOption[config.defaultSortCriteria];
        return sortableColumnIcon;
    };
    /**
     * @param {?} columnConfig
     * @return {?}
     */
    GridComponent.prototype.hanldeHeaderClick = /**
     * @param {?} columnConfig
     * @return {?}
     */
    function (columnConfig) {
        if (columnConfig.sortable) {
            /** @type {?} */
            var criteria = (this.gridSortBy.id !== columnConfig.id)
                ? columnConfig.defaultSortCriteria
                : (this.gridSortBy.criteria === sortCriteria.ascendant)
                    ? sortCriteria.descendant
                    : sortCriteria.ascendant;
            this.gridSortBy = {
                id: columnConfig.id,
                criteria: criteria
            };
            this.columnSorted.emit(this.gridSortBy);
        }
    };
    /**
     * @param {?} column
     * @return {?}
     */
    GridComponent.prototype.getFooter = /**
     * @param {?} column
     * @return {?}
     */
    function (column) {
        return this.settings.footers.find((/**
         * @param {?} f
         * @return {?}
         */
        function (f) { return f.columnId === column.id; }));
    };
    /**
     * @param {?} column
     * @param {?} row
     * @return {?}
     */
    GridComponent.prototype.shouldShowContextMenu = /**
     * @param {?} column
     * @param {?} row
     * @return {?}
     */
    function (column, row) {
        /** @type {?} */
        var actions = column.getActions(row);
        /** @type {?} */
        var firstActionIcon = actions && actions.length ? actions[0].icon : null;
        return actions && actions.length
            && (actions.length > 1 || !firstActionIcon);
    };
    /**
     * @param {?} column
     * @param {?} row
     * @return {?}
     */
    GridComponent.prototype.shouldshowIconContextMenu = /**
     * @param {?} column
     * @param {?} row
     * @return {?}
     */
    function (column, row) {
        /** @type {?} */
        var actions = column.getActions(row);
        /** @type {?} */
        var firstActionIcon = actions && actions.length ? actions[0].icon : null;
        return actions && actions.length
            && actions.length === 1 && firstActionIcon;
    };
    GridComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-grid',
                    template: "<div *ngIf=\"!isMobile\">\n  <table class=\"sc-grid__table\">\n    <caption hidden=\"true\">{{summary}}</caption>\n    <tr class=\"sc-grid__table__row-header\">\n      <th\n        *ngFor=\"let head of settings.columns\"\n        scope=\"col\"\n        (click)=\"hanldeHeaderClick(head)\"\n        [attr.id]=\"'grid-header-' + head.id\"\n        class=\"sc-grid__table__row-header__head\"\n        [class.sc-grid__table__row-header__head--clickable]=\"head.sortable\"\n        [class.sc-grid__table__row-header__head--sorted]=\"head.id===gridSortBy.id\"\n        [ngClass]=\"head.columnClass\"\n      >\n        {{head.header}}\n        <sc-icon\n          [icon]=\"getSortableColumnIcon(head)\"\n          class=\"sc-grid__table__row-header__head__arrow\"\n          *ngIf=\"head.sortable\"\n        ></sc-icon>\n        <sc-tooltip \n          class=\"small sc-grid__table__row-header__head--help\" \n          [description]=\"head.helpText\" \n          [position]=\"head.helpTextPositionToolTip\"\n          *ngIf=\"head.helpText\">\n          <sc-icon \n            icon=\"alert-elipse-copy\" \n            size=\"0_75\">\n          </sc-icon>\n        </sc-tooltip>\n      </th>\n    </tr>\n    <tbody *ngIf=\"!loading\">\n      <tr\n        (click)=\"onRowClicked(row, rowIndex)\"\n        *ngFor=\"let row of items; let rowIndex= index\"\n        class=\"sc-grid__table__row\"\n        [ngClass]=\"settings.rowCustomClass && settings.rowCustomClass.call(null, row)\">\n\n        <td\n          scope=\"row\"\n          *ngFor=\"let column of settings.columns;\"\n          [attr.id]=\"column.id + rowIndex\"\n          [class.sc-grid__table-cell--with-secondary]=\"column.hasSecondaryValue()\"\n          [ngClass]=\"column.columnClass\"\n          class=\"sc-grid__table-cell\">\n\n          <ng-container *ngIf=\"column.isValueColumn\">\n            <div class=\"cell__primary-text\" [innerHtml]=\"column.getPrimaryValue(row)\">\n            </div>\n            <div class=\"cell__secondary-text\" [innerHtml]=\"column.getSecondaryValue(row)\">\n            </div>\n          </ng-container>\n          <!--actions-->\n          <sc-context-menu\n            *ngIf=\"column.isActionColumn && shouldShowContextMenu(column, row)\"\n            [items]=\"column.getActions(row)\"\n            [row]=\"row\">\n          </sc-context-menu>\n          <sc-icon-context-menu *ngIf=\"column.isActionColumn && shouldshowIconContextMenu(column, row)\"\n          [row]=\"row\"\n          [icon]=\"column.getActions(row)[0]?.icon\"\n          [items]=\"column.getActions(row)\"\n          [tooltip]=\"column.getActions(row)[0]?.label\">\n          </sc-icon-context-menu>\n          <!--actions-->\n          <sc-cell-component-adapter\n            *ngIf=\"column.isComponentColumn\"\n            [componentClass]=\"column.componentClass\"\n            [initializer]=\"column.initializer\"\n            [row]=\"row\">\n          </sc-cell-component-adapter>\n        </td>\n      </tr>\n    </tbody>\n    <tbody *ngIf=\"loading\">\n      <tr class=\"sc-grid__table__row timeline animated-background\"\n        *ngFor=\"let item of placeholderItems; let index = index;\">\n        <ng-container *ngTemplateOutlet=\"placeholderDesktopTemplate, context: { item: item, index: index }\">\n        </ng-container>\n      </tr>\n    </tbody>\n    <tfoot *ngIf=\"hasFooter\">\n      <tr class=\"sc-grid__table__row\">\n        <td *ngFor=\"let column of settings.columns\"\n          [attr.id]=\"'grid-footer-' + column.id\"\n          class=\"sc-grid__table-cell sc-grid__table-cell__footer\"\n          [ngClass]=\"column.columnClass\">\n\n          <ng-container *ngIf=\"getFooter(column); let foot\">\n            <ng-container *ngIf=\"foot.isValueFooter\">\n              <div class=\"cell__primary-text\">{{foot.getValue(items)}}</div>\n            </ng-container>\n            <sc-footer-component-adapter\n              *ngIf=\"foot.isComponentFooter\"\n              [data]=\"foot.getValue(items)\">\n            </sc-footer-component-adapter>\n          </ng-container>\n        </td>\n      </tr>\n    </tfoot>\n  </table>\n</div>\n\n<!-- Mobile-->\n<div *ngIf=\"isMobile\"\n>\n  <div *ngIf=\"!loading\">\n    <div\n      class=\"sc-grid__card\"\n      *ngFor=\"let row of items; let rowIndex= index\"\n      [class.sc-grid__card--with-checkbox]=\"checkboxColumns.length > 0\"\n      [ngClass]=\"settings.rowCustomClass && settings.rowCustomClass.call(null, row)\">\n      <!-- Actions-->\n      <div\n        *ngIf=\"checkboxColumns.length > 0\"\n        class=\"sc-grid__card-checkboxes\">\n          <ng-container\n        *ngFor=\"let column of checkboxColumns\">\n        <sc-cell-component-adapter\n          class=\"sc-grid__card-checkbox\"\n          [componentClass]=\"column.componentClass\"\n          [initializer]=\"column.initializer\"\n          [row]=\"row\">\n        </sc-cell-component-adapter>\n      </ng-container>\n      </div>\n      <!-- Actions-->\n      <ng-container *ngFor=\"let column of actionColumns\">\n        <sc-context-menu\n          *ngIf=\"column.getActions(row)?.length\"\n          class=\"sc-grid__card-menu\"\n          [ngClass]=\"column.columnClass\"\n          [items]=\"column.getActions(row)\"\n          [row]=\"row\">\n        </sc-context-menu>\n      </ng-container>\n      <!-- Auto generated cards-->\n      <ng-container\n        *ngIf=\"!settings.mobileCardComponentClass\">\n        <!-- Auto generated card fields-->\n        <div class=\"sc-grid__card-fields\"\n             *ngFor=\"let column of otherColumns\">\n          <div\n            class=\"sc-grid__card-field\"\n            [ngClass]=\"column.columnClass\">\n            <ng-container *ngIf=\"column.isValueColumn\">\n              <div class=\"cell__primary-text\" [innerHtml]=\"column.getPrimaryValue(row)\">\n              </div>\n            </ng-container>\n            <sc-cell-component-adapter\n              *ngIf=\"column.isComponentColumn\"\n              [componentClass]=\"column.componentClass\"\n              [initializer]=\"column.initializer\"\n              [row]=\"row\"\n              [index]=\"rowIndex\" >\n            </sc-cell-component-adapter>\n          </div>\n        </div>\n      </ng-container>\n      <!-- Custom Cards-->\n      <ng-container\n        *ngIf=\"settings.mobileCardComponentClass\">\n        <!-- Auto generated card context menu-->\n        <sc-cell-component-adapter\n          class=\"sc-grid__card-custom\"\n          *ngIf=\"settings.mobileCardComponentClass\"\n          [componentClass]=\"settings.mobileCardComponentClass\"\n          [row]=\"row\">\n        </sc-cell-component-adapter>\n      </ng-container>\n    </div>\n    <div\n      *ngIf=\"!!settings.mobileCardFooterComponentClass\"\n      class=\"sc-grid__card sc-grid__card__footer\">\n      <sc-footer-component-adapter\n        *ngIf=\"settings.mobileCardFooterComponentClass\"\n        [data]=\"mobileCardFooterData\">\n      </sc-footer-component-adapter>\n    </div\n    >\n  </div>\n  <div *ngIf=\"loading\">\n    <!-- Auto generated loading -->\n    <div class=\"sc-grid__card sc-grid__card__footer timeline animated-background\"\n      *ngFor=\"let item of placeholderItems; let index = index;\">\n      <ng-container *ngTemplateOutlet=\"placeholderMobileTemplate, context: { item: item, index: index }\">\n      </ng-container>\n    </div>\n  </div>\n</div>\n\n<div class=\"container\">\n  <sc-empty-table-message\n    *ngIf=\"!loading && settings.emptyState && items && items.length === 0\"\n    [title]=\"settings.emptyState.title\"\n    [message]=\"settings.emptyState.message\"\n    [imageSrc]=\"settings.emptyState.imageSrc\"\n  >\n  </sc-empty-table-message>\n  <sc-empty-table-message\n    *ngIf=\"!loading && settings.error && !items && hasError\"\n    [title]=\"settings.error.title\"\n    [message]=\"settings.error.message\"\n    (retry)=\"onLoadError()\"\n    [showButton]=\"!!settings.error.actionCallback\"\n    [imageSrc]=\"settings.error.imageSrc\"\n  >\n  </sc-empty-table-message>\n</div>\n\n<ng-template #placeholderMobileTemplate>\n    <div class=\"timeline-item-space\"></div>\n    <div *ngFor=\"let column of actionColumns\">\n      <div>\n        <div class=\"timeline-item size-50\"></div>\n        <div class=\"timeline-item-space\"></div>\n      </div>\n    </div>\n    <div *ngFor=\"let column of otherColumns\">\n      <div class=\"timeline-item size-25\"></div>\n      <div class=\"timeline-item-space\"></div>\n    </div>\n</ng-template>\n\n<ng-template #placeholderDesktopTemplate>\n  <td *ngFor=\"let column of settings.columns\">\n    <div *ngIf=\"column.isValueColumn\">\n      <div class=\"timeline-item-start\"></div>\n      <div class=\"timeline-item size-25\"></div>\n      <div class=\"timeline-item-space\"></div>\n      <div class=\"timeline-item size-50\"></div>\n      <div class=\"timeline-item-space\"></div>\n      <div class=\"timeline-item-end\"></div>\n    </div>\n    <div *ngIf=\"column.isActionColumn\">\n      <div class=\"timeline-item-start\"></div>\n      <div class=\"timeline-item-space\"></div>\n      <div class=\"timeline-item size-25\"></div>\n      <div class=\"timeline-item size-25\"></div>\n      <div class=\"timeline-item-space\"></div>\n      <div class=\"timeline-item-end\"></div>\n    </div>\n    <div *ngIf=\"column.isComponentColumn\">\n      <div class=\"timeline-item-start\"></div>\n      <div class=\"timeline-item-space\"></div>\n      <div class=\"timeline-item size-25\"></div>\n      <div class=\"timeline-item size-25\"></div>\n      <div class=\"timeline-item-space\"></div>\n      <div class=\"timeline-item-end\"></div>\n    </div>\n  </td>\n</ng-template>\n",
                    animations: [tableListAnimation, timelineListAnimation],
                    styles: [".timeline{background:#fff;padding:0!important;margin:0 auto}.timeline td,.timeline-row{padding:0!important;height:64px}.timeline td.timeline-empty,.timeline-row.timeline-empty{background:#fff}.timeline-item{display:block;height:10px}.timeline-item::before{content:\"\";height:inherit;display:block;background:#fff;float:right}.timeline-item.f-l::before{float:left}.timeline-item.f-r::before{float:right}.timeline-item.size-0::before{width:0}.timeline-item.size-1::before{width:1rem}.timeline-item.size-2::before{width:2rem}.timeline-item.size-25::before{width:25%}.timeline-item.size-50::before{width:50%}.timeline-item.size-75::before{width:75%}.timeline-item.size-100::before{width:100%}.timeline-item-end,.timeline-item-start{height:12px}.timeline-item-end::before,.timeline-item-start::before{content:\"\";height:inherit;display:block;background:#fff;width:100%}.timeline-item-space{height:10px}.timeline-item-space::before{content:\"\";display:block;width:100%;height:inherit;background:#fff}.timeline.animated-background{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:placeHolderShimmer;animation-name:placeHolderShimmer;-webkit-animation-timing-function:linear;animation-timing-function:linear;background:#fff;background:linear-gradient(to right,#e0e5ed 8%,#edf0f5 18%,#e0e5ed 33%);background-size:1024px;width:100%;position:relative}@-webkit-keyframes placeHolderShimmer{0%{background-position:-468px 0}100%{background-position:468px 0}}@keyframes placeHolderShimmer{0%{background-position:-468px 0}100%{background-position:468px 0}}:host{display:block}.sc-grid__md{display:none}.sc-grid__table{width:100%}.sc-grid__table__row-header{background-color:#e0e5ed}.sc-grid__table__row-header__head{height:33px;padding:0 16px;text-transform:uppercase;font-weight:500;font-size:12px}.sc-grid__table__row-header__head--sorted{font-weight:700}.sc-grid__table__row-header__head--sorted .sc-grid__table__row-header__head__arrow{visibility:visible}.sc-grid__table__row-header__head--help{text-transform:none}.sc-grid__table__row-header__head--clickable{cursor:pointer}.sc-grid__table__row-header__head--clickable:hover .sc-grid__table__row-header__head__arrow{visibility:visible}.sc-grid__table__row-header__head__arrow{vertical-align:middle;visibility:hidden}.sc-grid__table__row{border-bottom:1px solid #ccd2dd;height:64px}.sc-grid__table-cell{padding:0 16px}.sc-grid__table-cell--with-secondary .cell__primary-text{font-size:13px;line-height:18px;font-weight:700}.sc-grid__card{padding:.5rem;border-bottom:1px solid #aeb7c8}.sc-grid__card:first-child{border-top:1px solid #aeb7c8}.sc-grid__card-menu{float:right}.sc-grid__card-field{padding:.25rem 0}.sc-grid__card--with-checkbox .sc-grid__card-field{margin-left:30px}.sc-grid__card-checkboxes{padding:.25rem 0;float:left;width:30px}.sc-grid__card-checkbox{margin:.25rem 0;float:left;width:30px}.cell__primary-text{font-size:13px;font-weight:700}.cell__secondary-text{line-height:18px;font-size:12px}.actions-panel{position:relative}.activeRow{box-shadow:0 2px 7px 0 rgba(0,0,0,.12);background-color:#fff}@media (min-width:768px){.sc-grid__xs{display:none}.sc-grid__md{display:block}}"]
                }] }
    ];
    /** @nocollapse */
    GridComponent.ctorParameters = function () { return [
        { type: BreakpointObserver }
    ]; };
    GridComponent.propDecorators = {
        settings: [{ type: Input }],
        source: [{ type: Input }],
        summary: [{ type: Input }],
        placeholderItems: [{ type: Input }],
        rowClicked: [{ type: Output }],
        columnSorted: [{ type: Output }]
    };
    return GridComponent;
}());
if (false) {
    /** @type {?} */
    GridComponent.prototype.settings;
    /** @type {?} */
    GridComponent.prototype.source;
    /** @type {?} */
    GridComponent.prototype.summary;
    /** @type {?} */
    GridComponent.prototype.placeholderItems;
    /** @type {?} */
    GridComponent.prototype.rowClicked;
    /** @type {?} */
    GridComponent.prototype.columnSorted;
    /** @type {?} */
    GridComponent.prototype.items;
    /**
     * @type {?}
     * @private
     */
    GridComponent.prototype.subscription;
    /** @type {?} */
    GridComponent.prototype.actionColumns;
    /** @type {?} */
    GridComponent.prototype.otherColumns;
    /** @type {?} */
    GridComponent.prototype.checkboxColumns;
    /** @type {?} */
    GridComponent.prototype.loading;
    /** @type {?} */
    GridComponent.prototype.hasError;
    /** @type {?} */
    GridComponent.prototype.gridSortBy;
    /** @type {?} */
    GridComponent.prototype.sortableColumnIconOption;
    /** @type {?} */
    GridComponent.prototype.isMobile;
    /**
     * @type {?}
     * @private
     */
    GridComponent.prototype.sortedDefaultColumn;
    /**
     * @type {?}
     * @private
     */
    GridComponent.prototype.breakpointObserver;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/cell-component-adapter/cell-component-adapter.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CellComponentAdapterComponent = /** @class */ (function () {
    function CellComponentAdapterComponent(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.initializer = (/**
         * @return {?}
         */
        function () { });
    }
    /**
     * @return {?}
     */
    CellComponentAdapterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.componentClass) {
            /** @type {?} */
            var componentInstance = this.componentClass;
            /** @type {?} */
            var componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentInstance);
            /** @type {?} */
            var componentRef = this.viewContainerRef.createComponent(componentFactory);
            /** @type {?} */
            var currentComponent = componentRef.instance;
            currentComponent.rowData = this.row;
            this.initializer.call(null, currentComponent);
        }
    };
    CellComponentAdapterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-cell-component-adapter',
                    template: "<ng-template #viewContainerRef >\n                                \n</ng-template> ",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    CellComponentAdapterComponent.ctorParameters = function () { return [
        { type: ComponentFactoryResolver }
    ]; };
    CellComponentAdapterComponent.propDecorators = {
        componentClass: [{ type: Input }],
        row: [{ type: Input }],
        index: [{ type: Input }],
        viewContainerRef: [{ type: ViewChild, args: ['viewContainerRef', { read: ViewContainerRef, static: true },] }],
        initializer: [{ type: Input }]
    };
    return CellComponentAdapterComponent;
}());
if (false) {
    /** @type {?} */
    CellComponentAdapterComponent.prototype.componentClass;
    /** @type {?} */
    CellComponentAdapterComponent.prototype.row;
    /** @type {?} */
    CellComponentAdapterComponent.prototype.index;
    /** @type {?} */
    CellComponentAdapterComponent.prototype.viewContainerRef;
    /** @type {?} */
    CellComponentAdapterComponent.prototype.initializer;
    /**
     * @type {?}
     * @private
     */
    CellComponentAdapterComponent.prototype.componentFactoryResolver;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/columns/column.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Column = /** @class */ (function () {
    function Column(column) {
        this.columnClass = column.columnClass ? column.columnClass : "sc-grid__column--" + column.id;
        this.header = column.header;
        this.id = column.id;
        this.primaryValueGetter = column.primaryValueGetter;
        this.helpText = column.helpText;
        this.helpTextPositionToolTip = column.helpTextPositionToolTip ? column.helpTextPositionToolTip : 'right';
    }
    Object.defineProperty(Column.prototype, "isValueColumn", {
        get: /**
         * @return {?}
         */
        function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "isActionColumn", {
        get: /**
         * @return {?}
         */
        function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "isComponentColumn", {
        get: /**
         * @return {?}
         */
        function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Column.prototype, "isCheckbox", {
        get: /**
         * @return {?}
         */
        function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    Column.prototype.hasSecondaryValue = /**
     * @return {?}
     */
    function () {
        return false;
    };
    /**
     * @param {?} row
     * @return {?}
     */
    Column.prototype.getPrimaryValue = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        return this.primaryValueGetter.call(null, row);
    };
    return Column;
}());
if (false) {
    /** @type {?} */
    Column.prototype.columnClass;
    /** @type {?} */
    Column.prototype.header;
    /** @type {?} */
    Column.prototype.id;
    /** @type {?} */
    Column.prototype.primaryValueGetter;
    /** @type {?} */
    Column.prototype.helpText;
    /** @type {?} */
    Column.prototype.helpTextPositionToolTip;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/columns/sortable-column.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SortableColumn = /** @class */ (function (_super) {
    __extends(SortableColumn, _super);
    function SortableColumn(column) {
        var _this = _super.call(this, column) || this;
        _this.defaultSortCriteria = column.defaultSortCriteria || sortCriteria.ascendant;
        _this.defaultSortedColumn = column.defaultSortedColumn;
        _this.sortable = column.sortable;
        return _this;
    }
    return SortableColumn;
}(Column));
if (false) {
    /** @type {?} */
    SortableColumn.prototype.defaultSortCriteria;
    /** @type {?} */
    SortableColumn.prototype.defaultSortedColumn;
    /** @type {?} */
    SortableColumn.prototype.sortable;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/columns/value-column.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ValueColumn = /** @class */ (function (_super) {
    __extends(ValueColumn, _super);
    function ValueColumn(column) {
        var _this = _super.call(this, column) || this;
        _this.secondaryValueGetter = column.secondaryValueGetter;
        return _this;
    }
    Object.defineProperty(ValueColumn.prototype, "isValueColumn", {
        get: /**
         * @return {?}
         */
        function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ValueColumn.prototype.hasSecondaryValue = /**
     * @return {?}
     */
    function () {
        return !!this.secondaryValueGetter;
    };
    /**
     * @param {?} row
     * @return {?}
     */
    ValueColumn.prototype.getSecondaryValue = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        return this.secondaryValueGetter ? this.secondaryValueGetter.call(null, row) : ' ';
    };
    return ValueColumn;
}(SortableColumn));
if (false) {
    /** @type {?} */
    ValueColumn.prototype.secondaryValueGetter;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/property-callback.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PropertyCallback = /** @class */ (function () {
    function PropertyCallback(property) {
        this.property = property;
    }
    return PropertyCallback;
}());
if (false) {
    /** @type {?} */
    PropertyCallback.prototype.property;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/property-accessor-callback.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PropertyAccessorCallback = /** @class */ (function (_super) {
    __extends(PropertyAccessorCallback, _super);
    function PropertyAccessorCallback() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} _
     * @param {?} receiver
     * @param {?=} value
     * @return {?}
     */
    PropertyAccessorCallback.prototype.call = /**
     * @param {?} _
     * @param {?} receiver
     * @param {?=} value
     * @return {?}
     */
    function (_, receiver, value) {
        return receiver[this.property];
    };
    return PropertyAccessorCallback;
}(PropertyCallback));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/columns/component-column.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ComponentColumn = /** @class */ (function (_super) {
    __extends(ComponentColumn, _super);
    function ComponentColumn(column) {
        var _this = _super.call(this, column) || this;
        _this.initializer = (/**
         * @return {?}
         */
        function () { });
        _this.componentClass = column.componentClass;
        _this.initializer = column.initializer ? column.initializer : (/**
         * @return {?}
         */
        function () { });
        return _this;
    }
    Object.defineProperty(ComponentColumn.prototype, "isComponentColumn", {
        get: /**
         * @return {?}
         */
        function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    return ComponentColumn;
}(SortableColumn));
if (false) {
    /** @type {?} */
    ComponentColumn.prototype.componentClass;
    /** @type {?} */
    ComponentColumn.prototype.initializer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/fixed-actions-callback.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FixedActionsCallback = /** @class */ (function () {
    function FixedActionsCallback(actions) {
        this.actions = actions.map((/**
         * @param {?} each
         * @return {?}
         */
        function (each) { return new ActionItem(each); }));
    }
    /**
     * @param {?} _
     * @param {?} row
     * @return {?}
     */
    FixedActionsCallback.prototype.call = /**
     * @param {?} _
     * @param {?} row
     * @return {?}
     */
    function (_, row) {
        return this.actions;
    };
    return FixedActionsCallback;
}());
if (false) {
    /** @type {?} */
    FixedActionsCallback.prototype.actions;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/columns/actions-column.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActionsColumn = /** @class */ (function (_super) {
    __extends(ActionsColumn, _super);
    function ActionsColumn(column) {
        var _this = _super.call(this, column) || this;
        _this.getActionsCallback = column.getActionsCallback;
        return _this;
    }
    Object.defineProperty(ActionsColumn.prototype, "isActionColumn", {
        get: /**
         * @return {?}
         */
        function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} row
     * @return {?}
     */
    ActionsColumn.prototype.getActions = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        /** @type {?} */
        var answer = this.getActionsCallback.call(null, row);
        return !answer ? answer : answer.map((/**
         * @param {?} each
         * @return {?}
         */
        function (each) { return new ActionItem(each); }));
    };
    return ActionsColumn;
}(Column));
if (false) {
    /** @type {?} */
    ActionsColumn.prototype.getActionsCallback;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/cell-checkbox/cell-checkbox.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CellCheckboxComponent = /** @class */ (function () {
    function CellCheckboxComponent() {
        this.onDestroy$ = new Subject();
        this.form = new FormGroup({
            checkbox: new FormControl()
        });
    }
    /**
     * @return {?}
     */
    CellCheckboxComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscription = this.form.controls.checkbox.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) { return _this.setValue(value); }));
    };
    /**
     * @param {?} aColumn
     * @return {?}
     */
    CellCheckboxComponent.prototype.setColumn = /**
     * @param {?} aColumn
     * @return {?}
     */
    function (aColumn) {
        this.column = aColumn;
        this.ngOnChanges();
    };
    Object.defineProperty(CellCheckboxComponent.prototype, "rowData", {
        get: /**
         * @return {?}
         */
        function () {
            return this.privateRowData;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var _this = this;
            this.privateRowData = value;
            this.ngOnChanges();
            if (this.privateRowData.changes) {
                this.privateRowData.changes.pipe(takeUntil(this.onDestroy$)).subscribe((/**
                 * @return {?}
                 */
                function () { return _this.ngOnChanges(); }));
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CellCheckboxComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        if (!this.column || !this.rowData) {
            return;
        }
        this.form.controls.checkbox.setValue(!!this.getValue(), { emitEvent: false });
    };
    /**
     * @private
     * @return {?}
     */
    CellCheckboxComponent.prototype.getValue = /**
     * @private
     * @return {?}
     */
    function () {
        return this.column.primaryValueGetter.call(null, this.rowData);
    };
    /**
     * @return {?}
     */
    CellCheckboxComponent.prototype.isDisabled = /**
     * @return {?}
     */
    function () {
        return this.column.isDisabledCallback.call(null, this.rowData);
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    CellCheckboxComponent.prototype.setValue = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.column.primaryValueSetter.call(null, this.rowData, value);
    };
    /**
     * @return {?}
     */
    CellCheckboxComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.onDestroy$.next();
    };
    CellCheckboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-cell-checkbox',
                    template: "<div [formGroup]=\"form\" *ngIf=\"column\">\n  <sc-checkbox formControlName=\"checkbox\" [isReadOnly]=\"isDisabled()\"> </sc-checkbox>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    CellCheckboxComponent.ctorParameters = function () { return []; };
    return CellCheckboxComponent;
}());
if (false) {
    /** @type {?} */
    CellCheckboxComponent.prototype.column;
    /** @type {?} */
    CellCheckboxComponent.prototype.privateRowData;
    /** @type {?} */
    CellCheckboxComponent.prototype.form;
    /**
     * @type {?}
     * @private
     */
    CellCheckboxComponent.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    CellCheckboxComponent.prototype.onDestroy$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/always-false-callback.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AlwaysFalseCallback = /** @class */ (function () {
    function AlwaysFalseCallback() {
    }
    /**
     * @param {...?} args
     * @return {?}
     */
    AlwaysFalseCallback.prototype.call = /**
     * @param {...?} args
     * @return {?}
     */
    function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return false;
    };
    return AlwaysFalseCallback;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/noop-callback.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NoopCallback = /** @class */ (function () {
    function NoopCallback() {
    }
    /**
     * @param {...?} args
     * @return {?}
     */
    NoopCallback.prototype.call = /**
     * @param {...?} args
     * @return {?}
     */
    function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return;
    };
    return NoopCallback;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/columns/checkbox-column.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CheckboxColumn = /** @class */ (function (_super) {
    __extends(CheckboxColumn, _super);
    function CheckboxColumn(column) {
        var _this = _super.call(this, column) || this;
        _this.isDisabledCallback = column.isDisabledCallback || new AlwaysFalseCallback();
        _this.primaryValueSetter = column.primaryValueSetter || new NoopCallback();
        return _this;
    }
    Object.defineProperty(CheckboxColumn.prototype, "initializer", {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            return (/**
             * @param {?} component
             * @return {?}
             */
            function (component) { return component.setColumn(_this); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckboxColumn.prototype, "componentClass", {
        get: /**
         * @return {?}
         */
        function () {
            return CellCheckboxComponent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckboxColumn.prototype, "isComponentColumn", {
        get: /**
         * @return {?}
         */
        function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckboxColumn.prototype, "isCheckbox", {
        get: /**
         * @return {?}
         */
        function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    return CheckboxColumn;
}(SortableColumn));
if (false) {
    /** @type {?} */
    CheckboxColumn.prototype.isDisabledCallback;
    /** @type {?} */
    CheckboxColumn.prototype.primaryValueSetter;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/property-setter-callback.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PropertySetterCallback = /** @class */ (function (_super) {
    __extends(PropertySetterCallback, _super);
    function PropertySetterCallback() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} _
     * @param {?} receiver
     * @param {?} value
     * @return {?}
     */
    PropertySetterCallback.prototype.call = /**
     * @param {?} _
     * @param {?} receiver
     * @param {?} value
     * @return {?}
     */
    function (_, receiver, value) {
        return receiver[this.property] = value;
    };
    return PropertySetterCallback;
}(PropertyCallback));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/grid-column-factory/grid-column-factory.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GridColumnFactoryService = /** @class */ (function () {
    function GridColumnFactoryService() {
    }
    /**
     * @param {?} columnSpec
     * @return {?}
     */
    GridColumnFactoryService.prototype.value = /**
     * @param {?} columnSpec
     * @return {?}
     */
    function (columnSpec) {
        /** @type {?} */
        var finalSpec = this.replacePropertyGetters(columnSpec);
        return new ValueColumn(finalSpec);
    };
    /**
     * @param {?} columnSpec
     * @return {?}
     */
    GridColumnFactoryService.prototype.component = /**
     * @param {?} columnSpec
     * @return {?}
     */
    function (columnSpec) {
        /** @type {?} */
        var finalSpec = this.replacePropertyGetters(columnSpec);
        return new ComponentColumn(finalSpec);
    };
    /**
     * @param {?} columnSpec
     * @return {?}
     */
    GridColumnFactoryService.prototype.checkbox = /**
     * @param {?} columnSpec
     * @return {?}
     */
    function (columnSpec) {
        /** @type {?} */
        var finalSpec = this.replacePropertySetter(this.replacePropertyGetters(columnSpec));
        return new CheckboxColumn(finalSpec);
    };
    /**
     * @param {?} columnSpec
     * @return {?}
     */
    GridColumnFactoryService.prototype.actions = /**
     * @param {?} columnSpec
     * @return {?}
     */
    function (columnSpec) {
        /** @type {?} */
        var finalSpec = this.replaceActionGetter(this.replacePropertyGetters(columnSpec));
        return new ActionsColumn(finalSpec);
    };
    /**
     * @private
     * @param {?} columnSpec
     * @return {?}
     */
    GridColumnFactoryService.prototype.replacePropertyGetters = /**
     * @private
     * @param {?} columnSpec
     * @return {?}
     */
    function (columnSpec) {
        return __assign({}, columnSpec, { primaryValueGetter: columnSpec.primaryProperty ?
                new PropertyAccessorCallback(columnSpec.primaryProperty) :
                columnSpec.primaryValueGetter, secondaryValueGetter: columnSpec.secondaryProperty ?
                new PropertyAccessorCallback(columnSpec.secondaryProperty) :
                columnSpec.secondaryValueGetter });
    };
    /**
     * @private
     * @param {?} columnSpec
     * @return {?}
     */
    GridColumnFactoryService.prototype.replaceActionGetter = /**
     * @private
     * @param {?} columnSpec
     * @return {?}
     */
    function (columnSpec) {
        return __assign({}, columnSpec, { getActionsCallback: columnSpec.actions ?
                new FixedActionsCallback(columnSpec.actions) :
                columnSpec.getActionsCallback });
    };
    /**
     * @private
     * @param {?} columnSpec
     * @return {?}
     */
    GridColumnFactoryService.prototype.replacePropertySetter = /**
     * @private
     * @param {?} columnSpec
     * @return {?}
     */
    function (columnSpec) {
        return __assign({}, columnSpec, { primaryValueSetter: columnSpec.primaryProperty ?
                new PropertySetterCallback(columnSpec.primaryProperty) :
                columnSpec.primaryValueSetter });
    };
    GridColumnFactoryService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    GridColumnFactoryService.ctorParameters = function () { return []; };
    /** @nocollapse */ GridColumnFactoryService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GridColumnFactoryService_Factory() { return new GridColumnFactoryService(); }, token: GridColumnFactoryService, providedIn: "root" });
    return GridColumnFactoryService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/table/table.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScTableComponent = /** @class */ (function () {
    function ScTableComponent() {
        this.tableAlternativeClass = false;
        this.rowSelected = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ScTableComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.placeholderItems = (this.placeholderItemsCount !== undefined) ? new Array(this.placeholderItemsCount) : new Array(10);
        if (this.rowSelectable === undefined) {
            this.rowSelectable = true;
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ScTableComponent.prototype.selectRow = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (this.rowSelectable) {
            this.rowSelected.emit(item);
        }
    };
    ScTableComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-table',
                    template: "<table [ngClass]=\"{'sc-table--selectable': rowSelectable, 'sc-table-alternative': tableAlternativeClass, 'sc-table': !tableAlternativeClass }\">\n  <thead class=\"sc-table__head hidden-sm\">\n    <tr class=\"sc-table__head-row\">\n      <ng-container *ngTemplateOutlet=\"rowHeaderTemplate\"></ng-container>\n    </tr>\n  </thead>\n  <tbody class=\"sc-table__body\" *ngIf=\"!loading && items && items.length\" [@tableListAnimation]=\"items.length\">\n    <tr [class]=\"(id) ? 'sc-table__body-row ' + id + '__row' : 'sc-table__body-row'\" *ngFor=\"let item of items; let index = index;\"\n      (click)=\"selectRow(item)\">\n      <ng-container *ngTemplateOutlet=\"rowItemTemplate, context: { item: item, index: index }\"></ng-container>\n    </tr>\n  </tbody>\n  <tbody class=\"sc-table__placeholder-body\" *ngIf=\"loading\" [@timelineListAnimation]=\"items.length\">\n    <tr class=\"sc-table__placeholder-body-row timeline animated-background\" *ngFor=\"let item of placeholderItems; let index = index;\">\n      <ng-container *ngTemplateOutlet=\"rowItemPlaceholderTemplate, context: { item: item, index: index }\"></ng-container>\n    </tr>\n  </tbody>\n</table>",
                    animations: [tableListAnimation, timelineListAnimation],
                    encapsulation: ViewEncapsulation.None,
                    styles: [".sc-table,.sc-table-alternative{width:100%}.sc-table__head-row{background-color:#fafbfc}.sc-table__body-row{border-bottom:1px solid #e0e5ed}.sc-table--selectable .sc-table__body-row:hover{background:#f4f9ff;cursor:pointer}.sc-list__main__table{display:block;margin-bottom:1rem;margin-top:1rem}.sc-list__main__table__cell{color:#424f66;font-size:.875rem;font-weight:400;height:4.3rem;line-height:1.5rem;padding:1rem}.sc-list__main__table__cell--email{word-wrap:break-word}.sc-list__main__table__cell--email a{color:#0070cc}.sc-list__main__table__cell--email a:hover{color:#4393d4}.sc-list__main__table__header-cell{color:#8993a4;font-size:.875rem;font-weight:400;line-height:1rem;padding:1rem;text-transform:uppercase}.sc-list__loading{align-items:center;color:#0070cc;display:flex;font-size:32px;height:100%;justify-content:center;width:100%}.timeline{background:#fff;padding:0!important;margin:0 auto}.timeline td{padding:0!important;height:auto!important}.timeline td.timeline-empty{background:#fff}.timeline-item{display:block;height:1rem}.timeline-item::before{content:\"\";height:inherit;display:block;background:#fff;float:right}.timeline-item.f-l::before{float:left}.timeline-item.f-r::before{float:right}.timeline-item.size-0::before{width:0}.timeline-item.size-1::before{width:1rem}.timeline-item.size-2::before{width:2rem}.timeline-item.size-25::before{width:25%}.timeline-item.size-50::before{width:50%}.timeline-item.size-75::before{width:75%}.timeline-item.size-100::before{width:100%}.timeline-item-end,.timeline-item-start{height:2rem}.timeline-item-end::before,.timeline-item-start::before{content:\"\";height:inherit;display:block;background:#fff;width:100%}.timeline-item-space{height:.5rem}.timeline-item-space::before{content:\"\";display:block;width:100%;height:inherit;background:#fff}.timeline.animated-background{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:placeHolderShimmer;animation-name:placeHolderShimmer;-webkit-animation-timing-function:linear;animation-timing-function:linear;background:#fff;background:linear-gradient(to right,#e0e5ed 8%,#edf0f5 18%,#e0e5ed 33%);background-size:1024px;width:100%;position:relative}@media (max-width:767.98px){.sc-table__body-row,.sc-table__head-row{padding:1rem 0}.sc-table__body-row:first-child{border-top:1px solid #e0e5ed}.sc-list__main__table__cell{font:400 .875rem/1.5rem Roboto,\"Open Sans\",sans-serif;padding:.25rem 1rem;height:auto;border:0}.sc-list__main__table__header-cell{padding:1rem}}@-webkit-keyframes placeHolderShimmer{0%{background-position:-468px 0}100%{background-position:468px 0}}@keyframes placeHolderShimmer{0%{background-position:-468px 0}100%{background-position:468px 0}}"]
                }] }
    ];
    /** @nocollapse */
    ScTableComponent.ctorParameters = function () { return []; };
    ScTableComponent.propDecorators = {
        id: [{ type: Input }],
        items: [{ type: Input }],
        loading: [{ type: Input }],
        placeholderItemsCount: [{ type: Input }],
        rowHeaderTemplate: [{ type: Input }],
        rowItemPlaceholderTemplate: [{ type: Input }],
        rowItemTemplate: [{ type: Input }],
        rowSelectable: [{ type: Input }],
        tableAlternativeClass: [{ type: Input }],
        rowSelected: [{ type: Output }]
    };
    return ScTableComponent;
}());
if (false) {
    /** @type {?} */
    ScTableComponent.prototype.placeholderItems;
    /** @type {?} */
    ScTableComponent.prototype.id;
    /** @type {?} */
    ScTableComponent.prototype.items;
    /** @type {?} */
    ScTableComponent.prototype.loading;
    /** @type {?} */
    ScTableComponent.prototype.placeholderItemsCount;
    /** @type {?} */
    ScTableComponent.prototype.rowHeaderTemplate;
    /** @type {?} */
    ScTableComponent.prototype.rowItemPlaceholderTemplate;
    /** @type {?} */
    ScTableComponent.prototype.rowItemTemplate;
    /** @type {?} */
    ScTableComponent.prototype.rowSelectable;
    /** @type {?} */
    ScTableComponent.prototype.tableAlternativeClass;
    /** @type {?} */
    ScTableComponent.prototype.rowSelected;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/table/sc-empty-table-message/sc-empty-table-message.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScEmptyTableMessageComponent = /** @class */ (function () {
    function ScEmptyTableMessageComponent() {
        this.imageSrc = '/assets/images/papers.svg';
        this.buttonText = 'Reintentar';
        this.showButton = false;
        this.retry = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ScEmptyTableMessageComponent.prototype.retryClicked = /**
     * @return {?}
     */
    function () {
        this.retry.emit();
    };
    ScEmptyTableMessageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-empty-table-message',
                    template: "<div class=\"row sc-empty-table-message\">\n  <div class=\"col-md-6 sc-empty-table-message__announcement\">\n    <p class=\"sc-empty-table-message__title\" [innerHTML]=\"title\"></p>\n    <p class=\"sc-empty-table-message__message mt-1\" [innerHTML]=\"message\"></p>\n    <sc-button\n      class=\"d-none d-md-block\"\n      *ngIf=\"showButton\"\n      (onClick)=\"retryClicked()\"\n      id=\"reload-error-button\"\n      [loading]=\"buttonLoading\"\n      [prefixIcon]=\"buttonIcon\"\n    >\n      {{ buttonText }}\n    </sc-button>\n  </div>\n  <div class=\"col-md-6\">\n    <div class=\"sc-empty-table-message__image-container\">\n      <img [src]=\"imageSrc ? imageSrc : '/assets/images/papers.svg'\" class=\"sc-empty-table-message__image img-fluid w-100\">\n    </div>\n    <sc-button\n      class=\"d-block d-md-none\"\n      *ngIf=\"showButton\"\n      (onClick)=\"retryClicked()\"\n      id=\"reload-error-button\"\n      [loading]=\"buttonLoading\"\n      [prefixIcon]=\"buttonIcon\"\n    >\n      {{ buttonText }}\n    </sc-button>\n  </div>\n</div>\n",
                    styles: [".sc-empty-table-message__title{color:#8993a4;font:400 1.25rem/2rem Roboto,\"Open Sans\",sans-serif}.sc-empty-table-message__message{color:#8993a4;font:400 1rem/1.5rem Roboto,\"Open Sans\",sans-serif}.sc-empty-table-message__announcement{align-self:center}.sc-empty-table-message__image-container{align-items:center;display:flex;height:100%}@media (min-width:768px){.sc-empty-table-message__image{height:313px;-o-object-fit:contain;object-fit:contain;width:317px}}"]
                }] }
    ];
    ScEmptyTableMessageComponent.propDecorators = {
        title: [{ type: Input }],
        message: [{ type: Input }],
        imageSrc: [{ type: Input }],
        buttonText: [{ type: Input }],
        buttonIcon: [{ type: Input }],
        buttonLoading: [{ type: Input }],
        showButton: [{ type: Input }],
        retry: [{ type: Output }]
    };
    return ScEmptyTableMessageComponent;
}());
if (false) {
    /** @type {?} */
    ScEmptyTableMessageComponent.prototype.title;
    /** @type {?} */
    ScEmptyTableMessageComponent.prototype.message;
    /** @type {?} */
    ScEmptyTableMessageComponent.prototype.imageSrc;
    /** @type {?} */
    ScEmptyTableMessageComponent.prototype.buttonText;
    /** @type {?} */
    ScEmptyTableMessageComponent.prototype.buttonIcon;
    /** @type {?} */
    ScEmptyTableMessageComponent.prototype.buttonLoading;
    /** @type {?} */
    ScEmptyTableMessageComponent.prototype.showButton;
    /** @type {?} */
    ScEmptyTableMessageComponent.prototype.retry;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/table/table.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScTableModule = /** @class */ (function () {
    function ScTableModule() {
    }
    ScTableModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ButtonModule
                    ],
                    exports: [
                        ScEmptyTableMessageComponent,
                        ScTableComponent
                    ],
                    declarations: [
                        ScEmptyTableMessageComponent,
                        ScTableComponent
                    ],
                    entryComponents: [ScTableComponent]
                },] }
    ];
    return ScTableModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/footers/footer.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
Footer = /** @class */ (function () {
    function Footer(footer) {
        this.columnId = footer.columnId;
    }
    Object.defineProperty(Footer.prototype, "isValueFooter", {
        get: /**
         * @return {?}
         */
        function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Footer.prototype, "isComponentFooter", {
        get: /**
         * @return {?}
         */
        function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    return Footer;
}());
if (false) {
    /** @type {?} */
    Footer.prototype.columnId;
    /**
     * @abstract
     * @param {?} items
     * @return {?}
     */
    Footer.prototype.getValue = function (items) { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/footers/component-footer.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ComponentFooter = /** @class */ (function (_super) {
    __extends(ComponentFooter, _super);
    function ComponentFooter(footer) {
        var _this = _super.call(this, footer) || this;
        _this.initializer = (/**
         * @return {?}
         */
        function () { });
        _this.componentClass = footer.componentClass;
        _this.initializer = footer.initializer ? footer.initializer : (/**
         * @return {?}
         */
        function () { });
        return _this;
    }
    Object.defineProperty(ComponentFooter.prototype, "isComponentFooter", {
        get: /**
         * @return {?}
         */
        function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} items
     * @return {?}
     */
    ComponentFooter.prototype.getValue = /**
     * @param {?} items
     * @return {?}
     */
    function (items) {
        return {
            componentClass: this.componentClass,
            initializer: this.initializer,
            items: items
        };
    };
    return ComponentFooter;
}(Footer));
if (false) {
    /** @type {?} */
    ComponentFooter.prototype.componentClass;
    /** @type {?} */
    ComponentFooter.prototype.initializer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/footers/value-footer.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ValueFooter = /** @class */ (function (_super) {
    __extends(ValueFooter, _super);
    function ValueFooter(footer) {
        var _this = _super.call(this, footer) || this;
        _this.valueGetter = footer.valueGetter;
        return _this;
    }
    Object.defineProperty(ValueFooter.prototype, "isValueFooter", {
        get: /**
         * @return {?}
         */
        function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} items
     * @return {?}
     */
    ValueFooter.prototype.getValue = /**
     * @param {?} items
     * @return {?}
     */
    function (items) {
        return this.valueGetter.call(this, items);
    };
    return ValueFooter;
}(Footer));
if (false) {
    /** @type {?} */
    ValueFooter.prototype.valueGetter;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/footers/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/grid-footer-factory/grid-footer-factory.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GridFooterFactoryService = /** @class */ (function () {
    function GridFooterFactoryService() {
    }
    /**
     * @param {?} footerSpec
     * @return {?}
     */
    GridFooterFactoryService.prototype.value = /**
     * @param {?} footerSpec
     * @return {?}
     */
    function (footerSpec) {
        return new ValueFooter(footerSpec);
    };
    /**
     * @param {?} footerSpec
     * @return {?}
     */
    GridFooterFactoryService.prototype.component = /**
     * @param {?} footerSpec
     * @return {?}
     */
    function (footerSpec) {
        return new ComponentFooter(footerSpec);
    };
    GridFooterFactoryService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    GridFooterFactoryService.ctorParameters = function () { return []; };
    /** @nocollapse */ GridFooterFactoryService.ngInjectableDef = ɵɵdefineInjectable({ factory: function GridFooterFactoryService_Factory() { return new GridFooterFactoryService(); }, token: GridFooterFactoryService, providedIn: "root" });
    return GridFooterFactoryService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/footer-component-adapter/footer-component-adapter.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FooterComponentAdapterComponent = /** @class */ (function () {
    function FooterComponentAdapterComponent(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
    }
    /**
     * @return {?}
     */
    FooterComponentAdapterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.data && this.data.componentClass) {
            /** @type {?} */
            var componentInstance = this.data.componentClass;
            /** @type {?} */
            var componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentInstance);
            /** @type {?} */
            var componentRef = this.viewContainerRef.createComponent(componentFactory);
            /** @type {?} */
            var currentComponent = componentRef.instance;
            currentComponent.items = this.data.items;
            if (this.data.initializer) {
                this.data.initializer.call(null, currentComponent);
            }
        }
    };
    FooterComponentAdapterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-footer-component-adapter',
                    template: "<ng-template #viewContainerRef>\n</ng-template> ",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    FooterComponentAdapterComponent.ctorParameters = function () { return [
        { type: ComponentFactoryResolver }
    ]; };
    FooterComponentAdapterComponent.propDecorators = {
        data: [{ type: Input }],
        viewContainerRef: [{ type: ViewChild, args: ['viewContainerRef', {
                        read: ViewContainerRef,
                        static: true
                    },] }]
    };
    return FooterComponentAdapterComponent;
}());
if (false) {
    /** @type {?} */
    FooterComponentAdapterComponent.prototype.data;
    /** @type {?} */
    FooterComponentAdapterComponent.prototype.viewContainerRef;
    /**
     * @type {?}
     * @private
     */
    FooterComponentAdapterComponent.prototype.componentFactoryResolver;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/icon-context-menu/icon-context-menu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconContextMenuComponent = /** @class */ (function () {
    function IconContextMenuComponent() {
        this.listener = (/**
         * @return {?}
         */
        function () { }); // Initialize with noop
    }
    // Initialize with noop
    /**
     * @param {?} action
     * @return {?}
     */
    IconContextMenuComponent.prototype.onIconClicked = 
    // Initialize with noop
    /**
     * @param {?} action
     * @return {?}
     */
    function (action) {
        // Using a call here so we can use either an ArrowFunction or any other object that implements call as an action.
        action.action.call(null, this.row);
        this.listener();
    };
    IconContextMenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-icon-context-menu',
                    template: "<a *ngIf=\"items && items[0]\" class=\"icon-container\" (click)=\"onIconClicked(items[0])\" id=\"{{items[0].id}}\">\n    <sc-icon [icon]=\"icon\" size=\"1\"></sc-icon>\n</a>\n<span class=\"tooltip-container\" *ngIf=\"tooltip\">\n    {{tooltip}}\n</span>\n",
                    styles: [":host{display:block;position:relative}.tooltip-container{position:absolute;top:0;font-size:12px;background-color:#fff;padding:.2rem;word-wrap:none;display:none;border:1px solid #edf0f5;box-shadow:0 0 5px 0 rgba(0,0,0,.2);border-radius:3px;text-align:center;width:-webkit-max-content;width:-moz-max-content;width:max-content;transform:translate(0,-110%)}.icon-container{cursor:pointer;padding:11px 14px}.icon-container:hover{color:#0070cc}.icon-container:hover+.tooltip-container{display:block!important}"]
                }] }
    ];
    IconContextMenuComponent.propDecorators = {
        items: [{ type: Input }],
        icon: [{ type: Input }],
        tooltip: [{ type: Input }],
        row: [{ type: Input }]
    };
    return IconContextMenuComponent;
}());
if (false) {
    /** @type {?} */
    IconContextMenuComponent.prototype.items;
    /** @type {?} */
    IconContextMenuComponent.prototype.icon;
    /** @type {?} */
    IconContextMenuComponent.prototype.tooltip;
    /** @type {?} */
    IconContextMenuComponent.prototype.row;
    /**
     * @type {?}
     * @private
     */
    IconContextMenuComponent.prototype.listener;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/icon-context-menu/icon-context-menu.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconContextMenuModule = /** @class */ (function () {
    function IconContextMenuModule() {
    }
    IconContextMenuModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [IconContextMenuComponent],
                    imports: [
                        ActionMenuModule,
                        CommonModule,
                        ButtonModule,
                        IconModule
                    ],
                    exports: [IconContextMenuComponent]
                },] }
    ];
    return IconContextMenuModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/grid.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GridModule = /** @class */ (function () {
    function GridModule() {
    }
    GridModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule,
                        ContextMenuModule,
                        IconContextMenuModule,
                        ScTableModule,
                        FormsModule,
                        ReactiveFormsModule,
                        CheckboxModule,
                        TooltipCustomModule
                    ],
                    declarations: [
                        GridComponent,
                        CellComponentAdapterComponent,
                        FooterComponentAdapterComponent,
                        CellCheckboxComponent
                    ],
                    providers: [
                        GridColumnFactoryService,
                        GridFooterFactoryService
                    ],
                    entryComponents: [CellCheckboxComponent],
                    exports: [GridComponent]
                },] }
    ];
    return GridModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/observable-wrapper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ObservableWrapper = /** @class */ (function () {
    function ObservableWrapper(observed) {
        this.changes = new EventEmitter();
        this.observed = observed;
        this.createProperties();
    }
    /**
     * @private
     * @return {?}
     */
    ObservableWrapper.prototype.createProperties = /**
     * @private
     * @return {?}
     */
    function () {
        for (var key in this.observed) {
            if (typeof this.observed[key] !== 'function') {
                this.wrapProperty(key);
            }
        }
    };
    /**
     * @private
     * @param {?} key
     * @return {?}
     */
    ObservableWrapper.prototype.wrapProperty = /**
     * @private
     * @param {?} key
     * @return {?}
     */
    function (key) {
        var _this = this;
        Object.defineProperty(this, key, {
            get: (/**
             * @return {?}
             */
            function () { return _this.observed[key]; }),
            set: (/**
             * @param {?} value
             * @return {?}
             */
            function (value) {
                _this.observed[key] = value;
                _this.notifyChanges(key, value);
            })
        });
    };
    /**
     * @private
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    ObservableWrapper.prototype.notifyChanges = /**
     * @private
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        this.changes.emit({ key: key, value: value });
    };
    return ObservableWrapper;
}());
if (false) {
    /** @type {?} */
    ObservableWrapper.prototype.observed;
    /** @type {?} */
    ObservableWrapper.prototype.changes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/observable-row-data.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ObservableRowData() { }
if (false) {
    /** @type {?|undefined} */
    ObservableRowData.prototype.changes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/columns/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/model/grid-footer-component.interface.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function GridFooterComponent() { }
if (false) {
    /** @type {?} */
    GridFooterComponent.prototype.items;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/grid/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/info-box/info-box.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InfoBoxComponent = /** @class */ (function () {
    function InfoBoxComponent() {
        this.icon = 'alert-elipse-copy';
    }
    InfoBoxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-info-box',
                    template: "<div class=\"sc-info-box\">\n  <sc-icon class=\"sc-info-box__icon\" [icon]=\"icon\"></sc-icon>\n  <div class=\"sc-info-box__content\">\n    <div class=\"sc-info-box__content__title\" *ngIf=\"!!title\">{{title}}</div>\n    <div class=\"sc-info-box__content__external\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n",
                    styles: [":host{font-family:Roboto,sans-serif;font-size:14px;background-color:#edf0f5;padding:14px;border-radius:2px;display:flex}:host(.info){background-color:rgba(103,187,244,.2)}:host(.warning){background-color:rgba(251,163,68,.2);color:#de350b}:host(.warning) .sc-info-box__icon{color:#de350b}:host(.error){background-color:rgba(222,53,11,.2);color:#de350b}:host(.error) .sc-info-box__icon{color:#de350b}:host(.under-writing){background-color:rgba(251,172,87,.4)}:host(.under-writing) .sc-info-box__icon{color:#fba344}:host(.small){font-size:small;padding:6px}.sc-info-box{display:flex}.sc-info-box__icon{color:#4393d4;vertical-align:top;margin-right:10px;font-size:16px}.sc-info-box__content__title{font-weight:700;margin-bottom:10px}"]
                }] }
    ];
    InfoBoxComponent.propDecorators = {
        title: [{ type: Input }],
        icon: [{ type: Input }]
    };
    return InfoBoxComponent;
}());
if (false) {
    /** @type {?} */
    InfoBoxComponent.prototype.title;
    /** @type {?} */
    InfoBoxComponent.prototype.icon;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/info-box/info-box.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InfoBoxModule = /** @class */ (function () {
    function InfoBoxModule() {
    }
    InfoBoxModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule,
                    ],
                    declarations: [
                        InfoBoxComponent
                    ],
                    exports: [
                        InfoBoxComponent
                    ],
                    providers: []
                },] }
    ];
    return InfoBoxModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-menu/lateral-menu-content.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralMenuContentComponent = /** @class */ (function () {
    function LateralMenuContentComponent() {
    }
    return LateralMenuContentComponent;
}());
if (false) {
    /** @type {?} */
    LateralMenuContentComponent.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-menu/lateral-menu-service-stub.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralMenuServiceStub = /** @class */ (function () {
    function LateralMenuServiceStub() {
        this.content$ = new BehaviorSubject(null);
        this.isOpen$ = new BehaviorSubject(false);
        this.result$ = new Subject$1();
    }
    /**
     * @param {?=} result
     * @return {?}
     */
    LateralMenuServiceStub.prototype.close = /**
     * @param {?=} result
     * @return {?}
     */
    function (result) { };
    /**
     * @template T
     * @param {?} component
     * @param {?=} data
     * @return {?}
     */
    LateralMenuServiceStub.prototype.open = /**
     * @template T
     * @param {?} component
     * @param {?=} data
     * @return {?}
     */
    function (component, data) {
        return EMPTY;
    };
    return LateralMenuServiceStub;
}());
if (false) {
    /** @type {?} */
    LateralMenuServiceStub.prototype.content$;
    /** @type {?} */
    LateralMenuServiceStub.prototype.isOpen$;
    /** @type {?} */
    LateralMenuServiceStub.prototype.result$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-menu/lateral-menu-content.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralMenuContent = /** @class */ (function () {
    function LateralMenuContent(data) {
        this.componentFactory = data.componentFactory;
        if (data.data) {
            this.data = data.data;
        }
    }
    return LateralMenuContent;
}());
if (false) {
    /** @type {?} */
    LateralMenuContent.prototype.componentFactory;
    /** @type {?} */
    LateralMenuContent.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/scroll.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScrollService = /** @class */ (function () {
    function ScrollService(document) {
        this.document = document;
    }
    /**
     * @return {?}
     */
    ScrollService.prototype.disableViewportScroll = /**
     * @return {?}
     */
    function () {
        this.document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    };
    /**
     * @return {?}
     */
    ScrollService.prototype.enableViewportScroll = /**
     * @return {?}
     */
    function () {
        this.document.getElementsByTagName('body')[0].style.overflow = 'auto';
    };
    ScrollService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ScrollService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
    ]; };
    /** @nocollapse */ ScrollService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ScrollService_Factory() { return new ScrollService(ɵɵinject(DOCUMENT)); }, token: ScrollService, providedIn: "root" });
    return ScrollService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ScrollService.prototype.document;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-menu/lateral-menu.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralMenuService = /** @class */ (function () {
    function LateralMenuService(scrollService, componentFactoryResolver) {
        this.scrollService = scrollService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.contentEmitter$ = new BehaviorSubject(null);
        this.content$ = this.contentEmitter$.asObservable();
        this.isOpen$ = this.content$.pipe(map((/**
         * @param {?} content
         * @return {?}
         */
        function (content) { return !!content; })));
        this.resultEmitter$ = new Subject$1();
        this.result$ = this.resultEmitter$.asObservable();
    }
    /**
     * @param {?=} result
     * @return {?}
     */
    LateralMenuService.prototype.close = /**
     * @param {?=} result
     * @return {?}
     */
    function (result) {
        if (!isNullOrUndefined(result)) {
            this.resultEmitter$.next(result);
        }
        this.contentEmitter$.next(null);
        this.scrollService.enableViewportScroll();
    };
    /**
     * @template T
     * @param {?} component
     * @param {?=} data
     * @return {?}
     */
    LateralMenuService.prototype.open = /**
     * @template T
     * @param {?} component
     * @param {?=} data
     * @return {?}
     */
    function (component, data) {
        this.scrollService.disableViewportScroll();
        /** @type {?} */
        var componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        /** @type {?} */
        var content = new LateralMenuContent({ componentFactory: componentFactory, data: data });
        this.contentEmitter$.next(content);
        return this.result$
            .pipe(
        // When the menu is closed, complete this observable
        takeUntil(this.isOpen$.pipe(filter((/**
         * @param {?} isOpen
         * @return {?}
         */
        function (isOpen) { return !isOpen; })))));
    };
    LateralMenuService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    LateralMenuService.ctorParameters = function () { return [
        { type: ScrollService },
        { type: ComponentFactoryResolver }
    ]; };
    return LateralMenuService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    LateralMenuService.prototype.contentEmitter$;
    /** @type {?} */
    LateralMenuService.prototype.content$;
    /** @type {?} */
    LateralMenuService.prototype.isOpen$;
    /**
     * @type {?}
     * @private
     */
    LateralMenuService.prototype.resultEmitter$;
    /** @type {?} */
    LateralMenuService.prototype.result$;
    /**
     * @type {?}
     * @private
     */
    LateralMenuService.prototype.scrollService;
    /**
     * @type {?}
     * @private
     */
    LateralMenuService.prototype.componentFactoryResolver;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-menu/lateral-menu-content.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralMenuContentDirective = /** @class */ (function () {
    function LateralMenuContentDirective(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    LateralMenuContentDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[scLateralMenuContent]'
                },] }
    ];
    /** @nocollapse */
    LateralMenuContentDirective.ctorParameters = function () { return [
        { type: ViewContainerRef }
    ]; };
    return LateralMenuContentDirective;
}());
if (false) {
    /** @type {?} */
    LateralMenuContentDirective.prototype.viewContainerRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-menu/lateral-menu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralMenuComponent = /** @class */ (function () {
    function LateralMenuComponent(lateralMenuService) {
        var _this = this;
        this.lateralMenuService = lateralMenuService;
        this.onDestroy$ = new Subject$1();
        this.lateralMenuService
            .content$
            .pipe(filter((/**
         * @param {?} content
         * @return {?}
         */
        function (content) { return !!content; })), takeUntil(this.onDestroy$))
            .subscribe((/**
         * @param {?} content
         * @return {?}
         */
        function (content) { return _this.initContent(content); }));
        this.isOpen$ = this.lateralMenuService
            .isOpen$
            .pipe(tap((/**
         * @param {?} isOpen
         * @return {?}
         */
        function (isOpen) { return !isOpen && _this.removeContent(); })), takeUntil(this.onDestroy$));
    }
    /**
     * @return {?}
     */
    LateralMenuComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.onDestroy$.next();
    };
    /**
     * @return {?}
     */
    LateralMenuComponent.prototype.onClose = /**
     * @return {?}
     */
    function () {
        this.lateralMenuService.close();
    };
    /**
     * @private
     * @param {?} content
     * @return {?}
     */
    LateralMenuComponent.prototype.initContent = /**
     * @private
     * @param {?} content
     * @return {?}
     */
    function (content) {
        /** @type {?} */
        var componentRef = this.contentRef.createComponent(content.componentFactory);
        if (content.data) {
            (componentRef.instance).data = content.data;
        }
    };
    /**
     * @private
     * @return {?}
     */
    LateralMenuComponent.prototype.removeContent = /**
     * @private
     * @return {?}
     */
    function () {
        this.contentRef.remove(0);
    };
    LateralMenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-lateral-menu',
                    template: "<sc-lateral-drawer-light-box\n  class=\"overlay\"\n  [class.show]=\"isOpen$ | async\"\n  (close)=\"onClose()\">\n  <sc-lateral-drawer (close)=\"onClose()\" [isOpen]=\"isOpen$ | async\">\n    <ng-template scLateralMenuContent></ng-template>\n  </sc-lateral-drawer>\n</sc-lateral-drawer-light-box>"
                }] }
    ];
    /** @nocollapse */
    LateralMenuComponent.ctorParameters = function () { return [
        { type: LateralMenuService }
    ]; };
    LateralMenuComponent.propDecorators = {
        contentRef: [{ type: ViewChild, args: [LateralMenuContentDirective, { read: ViewContainerRef, static: true },] }]
    };
    return LateralMenuComponent;
}());
if (false) {
    /** @type {?} */
    LateralMenuComponent.prototype.isOpen$;
    /**
     * @type {?}
     * @private
     */
    LateralMenuComponent.prototype.onDestroy$;
    /** @type {?} */
    LateralMenuComponent.prototype.contentRef;
    /**
     * @type {?}
     * @private
     */
    LateralMenuComponent.prototype.lateralMenuService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-menu/lateral-menu.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralMenuModule = /** @class */ (function () {
    function LateralMenuModule() {
    }
    LateralMenuModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        LateralMenuComponent,
                        LateralMenuContentDirective
                    ],
                    imports: [
                        CommonModule,
                        LateralDrawerModule,
                        LateralDrawerLightBoxModule
                    ],
                    exports: [LateralMenuComponent],
                    providers: [LateralMenuService]
                },] }
    ];
    return LateralMenuModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/loading/loading.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadingComponent = /** @class */ (function () {
    function LoadingComponent() {
    }
    LoadingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-loading',
                    template: "<div class=\"loading-spinner\"></div>",
                    styles: [":host{align-items:center;display:flex;height:100%;justify-content:center;position:relative;width:100%}:host(.small) .loading-spinner{width:30px;height:30px}.loading-spinner{-webkit-animation:1s linear infinite spin;animation:1s linear infinite spin;border:3px solid rgba(137,147,164,.3);border-radius:50%;border-top-color:#8993a4;height:75px;width:75px}@-webkit-keyframes spin{to{transform:rotate(360deg)}}@keyframes spin{to{transform:rotate(360deg)}}"]
                }] }
    ];
    return LoadingComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/loading/loading.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoadingModule = /** @class */ (function () {
    function LoadingModule() {
    }
    LoadingModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [LoadingComponent],
                    imports: [
                        CommonModule
                    ],
                    exports: [LoadingComponent]
                },] }
    ];
    return LoadingModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/model/abstract-menu-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
AbstractMenuItem = /** @class */ (function () {
    function AbstractMenuItem(spec) {
        this.id = spec.id;
        this.label = spec.label;
        this.icon = spec.icon;
        this.selected = spec.selected || false;
        this.canHighlight = spec.canHighlight;
    }
    /**
     * @return {?}
     */
    AbstractMenuItem.prototype.isMenu = /**
     * @return {?}
     */
    function () {
        return false;
    };
    return AbstractMenuItem;
}());
if (false) {
    /** @type {?} */
    AbstractMenuItem.prototype.id;
    /** @type {?} */
    AbstractMenuItem.prototype.label;
    /** @type {?} */
    AbstractMenuItem.prototype.icon;
    /** @type {?} */
    AbstractMenuItem.prototype.selected;
    /** @type {?} */
    AbstractMenuItem.prototype.canHighlight;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/model/section.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Section = /** @class */ (function (_super) {
    __extends(Section, _super);
    function Section(spec) {
        var _this = _super.call(this, spec) || this;
        _this.items = spec.items;
        return _this;
    }
    return Section;
}(AbstractMenuItem));
if (false) {
    /** @type {?} */
    Section.prototype.items;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/model/menu-section.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuSection = /** @class */ (function (_super) {
    __extends(MenuSection, _super);
    function MenuSection(spec) {
        return _super.call(this, spec) || this;
    }
    return MenuSection;
}(Section));
if (false) {
    /** @type {?} */
    MenuSection.prototype.items;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/model/menu.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(spec) {
        var _this = _super.call(this, spec) || this;
        _this.isOpen = false;
        return _this;
    }
    /**
     * @return {?}
     */
    Menu.prototype.isMenu = /**
     * @return {?}
     */
    function () {
        return true;
    };
    return Menu;
}(MenuSection));
if (false) {
    /** @type {?} */
    Menu.prototype.isOpen;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/model/menu-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MenuItem = /** @class */ (function (_super) {
    __extends(MenuItem, _super);
    function MenuItem(spec) {
        var _this = _super.call(this, spec) || this;
        _this.action = spec.action;
        return _this;
    }
    return MenuItem;
}(AbstractMenuItem));
if (false) {
    /** @type {?} */
    MenuItem.prototype.action;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/model/panel-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PanelItem = /** @class */ (function (_super) {
    __extends(PanelItem, _super);
    function PanelItem(spec) {
        var _this = _super.call(this, spec) || this;
        _this.tooltip = spec.tooltip;
        _this.size = spec.size;
        return _this;
    }
    return PanelItem;
}(MenuItem));
if (false) {
    /** @type {?} */
    PanelItem.prototype.tooltip;
    /** @type {?} */
    PanelItem.prototype.size;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/model/panel-section.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PanelSection = /** @class */ (function (_super) {
    __extends(PanelSection, _super);
    function PanelSection(spec) {
        var _this = _super.call(this, spec) || this;
        _this.size = spec.size;
        _this.icon = spec.icon;
        _this.action = spec.action;
        return _this;
    }
    return PanelSection;
}(Section));
if (false) {
    /** @type {?} */
    PanelSection.prototype.items;
    /** @type {?} */
    PanelSection.prototype.size;
    /** @type {?} */
    PanelSection.prototype.icon;
    /** @type {?} */
    PanelSection.prototype.action;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/model/panel.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Panel = /** @class */ (function (_super) {
    __extends(Panel, _super);
    function Panel(spec) {
        var _this = _super.call(this, spec) || this;
        _this.isOpen = false;
        _this.tooltip = spec.tooltip;
        return _this;
    }
    /**
     * @return {?}
     */
    Panel.prototype.isMenu = /**
     * @return {?}
     */
    function () {
        return true;
    };
    return Panel;
}(PanelSection));
if (false) {
    /** @type {?} */
    Panel.prototype.tooltip;
    /** @type {?} */
    Panel.prototype.isOpen;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/model/navbar-setting.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function NavbarSetting() { }
if (false) {
    /** @type {?} */
    NavbarSetting.prototype.highlightActive;
    /** @type {?} */
    NavbarSetting.prototype.showTooltip;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/model/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/navbar-menu-factory.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavbarMenuFactoryService = /** @class */ (function () {
    function NavbarMenuFactoryService(router) {
        this.router = router;
    }
    /**
     * @param {?} panelSpec
     * @return {?}
     */
    NavbarMenuFactoryService.prototype.panel = /**
     * @param {?} panelSpec
     * @return {?}
     */
    function (panelSpec) {
        return new Panel({
            id: panelSpec.id ? panelSpec.id : "navbar-panel-" + this.convertToId(panelSpec.label),
            label: panelSpec.label,
            items: panelSpec.items,
            icon: panelSpec.icon,
            size: panelSpec.size,
            action: panelSpec.action,
            tooltip: panelSpec.tooltip
        });
    };
    /**
     * @param {?} itemSpec
     * @return {?}
     */
    NavbarMenuFactoryService.prototype.itemPanel = /**
     * @param {?} itemSpec
     * @return {?}
     */
    function (itemSpec) {
        return new PanelItem({
            id: itemSpec.id ? itemSpec.id : "navbar-panel-item-" + this.convertToId(itemSpec.label),
            label: itemSpec.label,
            icon: itemSpec.icon,
            action: itemSpec.action,
            size: itemSpec.size,
            selected: itemSpec.selected,
            tooltip: itemSpec.tooltip,
            canHighlight: this.setCanHighlight(itemSpec)
        });
    };
    /**
     * @param {?} menuSpec
     * @return {?}
     */
    NavbarMenuFactoryService.prototype.menu = /**
     * @param {?} menuSpec
     * @return {?}
     */
    function (menuSpec) {
        return new Menu({
            id: menuSpec.id ? menuSpec.id : "navbar-menu-" + this.convertToId(menuSpec.label),
            label: menuSpec.label,
            items: menuSpec.items,
            icon: menuSpec.icon
        });
    };
    /**
     * @param {?} menuSpec
     * @return {?}
     */
    NavbarMenuFactoryService.prototype.item = /**
     * @param {?} menuSpec
     * @return {?}
     */
    function (menuSpec) {
        return new MenuItem({
            id: menuSpec.id ? menuSpec.id : "navbar-menu-item-" + this.convertToId(menuSpec.label),
            label: menuSpec.label,
            icon: menuSpec.icon,
            action: menuSpec.action,
            selected: menuSpec.selected,
            canHighlight: this.setCanHighlight(menuSpec)
        });
    };
    /**
     * @param {?} menuSpec
     * @return {?}
     */
    NavbarMenuFactoryService.prototype.route = /**
     * @param {?} menuSpec
     * @return {?}
     */
    function (menuSpec) {
        var _this = this;
        return new MenuItem({
            id: menuSpec.id ? menuSpec.id : "navbar-menu-item-route-" + this.convertToId(menuSpec.route),
            label: menuSpec.label,
            icon: menuSpec.icon,
            action: (/**
             * @return {?}
             */
            function () { return _this.router.navigate([menuSpec.route]); }),
            selected: menuSpec.selected,
            canHighlight: this.setCanHighlight(menuSpec)
        });
    };
    /**
     * @param {?} menuSpec
     * @return {?}
     */
    NavbarMenuFactoryService.prototype.routePanelItem = /**
     * @param {?} menuSpec
     * @return {?}
     */
    function (menuSpec) {
        var _this = this;
        return new PanelItem({
            id: menuSpec.id ? menuSpec.id : "navbar-panel-item-route-" + this.convertToId(menuSpec.route),
            label: menuSpec.label,
            icon: menuSpec.icon,
            action: (/**
             * @return {?}
             */
            function () { return _this.router.navigate([menuSpec.route]); }),
            size: menuSpec.size,
            selected: menuSpec.selected,
            canHighlight: this.setCanHighlight(menuSpec)
        });
    };
    /**
     * @private
     * @param {?} label
     * @return {?}
     */
    NavbarMenuFactoryService.prototype.convertToId = /**
     * @private
     * @param {?} label
     * @return {?}
     */
    function (label) {
        return label.toLowerCase().trim().replace(/( |-|\+|\*|\(|\)|\$|_)+/g, '-');
    };
    /**
     * @private
     * @param {?} itemSpec
     * @return {?}
     */
    NavbarMenuFactoryService.prototype.setCanHighlight = /**
     * @private
     * @param {?} itemSpec
     * @return {?}
     */
    function (itemSpec) {
        return itemSpec.hasOwnProperty('canHighlight') ? itemSpec.canHighlight : true;
    };
    NavbarMenuFactoryService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    NavbarMenuFactoryService.ctorParameters = function () { return [
        { type: Router }
    ]; };
    /** @nocollapse */ NavbarMenuFactoryService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NavbarMenuFactoryService_Factory() { return new NavbarMenuFactoryService(ɵɵinject(Router)); }, token: NavbarMenuFactoryService, providedIn: "root" });
    return NavbarMenuFactoryService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    NavbarMenuFactoryService.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/navbar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavbarComponent = /** @class */ (function () {
    function NavbarComponent() {
        this.settings = {
            highlightActive: false,
            showTooltip: false
        };
        this.itemClicked = new EventEmitter();
        this.isMobileMenuOpen = new EventEmitter();
        this.isMobileOpen = false;
        this.isCollapsed = false;
        this.panelOptionSelected = null;
    }
    /**
     * @return {?}
     */
    NavbarComponent.prototype.toggleMobileMenu = /**
     * @return {?}
     */
    function () {
        this.isMobileOpen = !this.isMobileOpen;
        this.isMobileMenuOpen.next(this.isMobileOpen);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    NavbarComponent.prototype.onItemClicked = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (item.action) {
            item.action.call(null, item);
        }
        this.itemClicked.emit(item);
        this.isMobileOpen = item.isMenu();
        this.panelOptionSelected = this.isMobileOpen ? item : null;
        if (this.settings.highlightActive && item.canHighlight) {
            this.selectItem(item);
        }
    };
    /**
     * @return {?}
     */
    NavbarComponent.prototype.onPanelSubMenuClose = /**
     * @return {?}
     */
    function () {
        this.panelOptionSelected = null;
    };
    /**
     * @private
     * @param {?} item
     * @return {?}
     */
    NavbarComponent.prototype.selectItem = /**
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (!item.isMenu()) {
            item.selected = true;
            if (this.mainMenu && this.mainMenu.items && this.mainMenu.items.length) {
                this.unselectItems(item.id, this.mainMenu.items);
            }
            if (this.panelOptions && this.panelOptions.items && this.panelOptions.items.length) {
                this.unselectItems(item.id, this.panelOptions.items);
            }
        }
    };
    /**
     * @private
     * @param {?} selected
     * @param {?} itemList
     * @return {?}
     */
    NavbarComponent.prototype.unselectItems = /**
     * @private
     * @param {?} selected
     * @param {?} itemList
     * @return {?}
     */
    function (selected, itemList) {
        var _this = this;
        itemList.forEach((/**
         * @param {?} element
         * @return {?}
         */
        function (element) {
            if (element.isMenu()) {
                /** @type {?} */
                var section = (/** @type {?} */ (element));
                _this.unselectItems(selected, section.items);
            }
            else {
                if (element.id !== selected) {
                    element.selected = false;
                }
            }
        }));
    };
    NavbarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-navbar',
                    template: "<div class=\"navbar__header-mobile\">\n  <div class=\"navbar__header-mobile-logo-wrapper\">\n    <img *ngIf=\"mobileLogo\" [src]=\"mobileLogo\" alt=\"logo\" class=\"navbar__logo--mobile\">\n  </div>\n  <ng-container >\n    <sc-icon id=\"hamburguer-button\" icon=\"burger-menu\" (click)=\"toggleMobileMenu()\" *ngIf=\"!isMobileOpen\"></sc-icon>\n    <sc-icon id=\"close-menu-button\" icon=\"close\" (click)=\"toggleMobileMenu()\" *ngIf=\"isMobileOpen\"></sc-icon>\n  </ng-container>\n</div>\n<div class=\"navbar__body-mobile\" *ngIf=\"isMobileOpen\">\n  <sc-nav-items\n    [highlightActive]=\"settings.highlightActive\"\n    [menu]=\"mainMenu\"\n    (itemClicked)=\"onItemClicked($event)\"\n  >\n  </sc-nav-items>\n  <div *ngIf=\"panelOptions\" class=\"navbar-panel-container\">\n    <hr class=\"navbar__separator\" [hidden]=\"!mainMenu\">\n    <sc-nav-panel-items\n      *ngIf=\"panelOptions\"\n      [panel]=\"panelOptions\"\n      [showTooltip]=\"settings.showTooltip\"\n      (itemClicked)=\"onItemClicked($event)\"\n    >\n    </sc-nav-panel-items>\n  </div>\n  <sc-nav-panel-submenu\n   [panel]=\"panelOptionSelected\"\n   [highlightActive]=\"settings.highlightActive\"\n   (closeClicked)=\"onPanelSubMenuClose()\"\n   (itemClicked)=\"onItemClicked($event)\"\n  >\n  </sc-nav-panel-submenu>\n</div>\n<div class=\"navbar__desktop-wrapper\">\n  <div class=\"navbar__aside\">\n    <img class=\"navbar__logo\" *ngIf=\"logo\" [src]=\"logo\" alt=\"logo\">\n\n    <sc-nav-panel-items\n      *ngIf=\"panelOptions\"\n      [panel]=\"panelOptions\"\n      [showTooltip]=\"settings.showTooltip\"\n      (itemClicked)=\"onItemClicked($event)\"\n    >\n    </sc-nav-panel-items>\n  </div>\n  <sc-nav-panel-submenu\n   [panel]=\"panelOptionSelected\"\n   [highlightActive]=\"settings.highlightActive\"\n   [firstLevel]=\"true\"\n   (closeClicked)=\"onPanelSubMenuClose()\"\n   (itemClicked)=\"onItemClicked($event)\"\n  >\n  </sc-nav-panel-submenu>\n  <div *ngIf=\"mainMenu\" class=\"navbar__main\" [class.navbar__main--collapsed]=\"isCollapsed\">\n    <sc-nav-items\n      class=\"navbar__main-items\"\n      [highlightActive]=\"settings.highlightActive\"\n      [firstLevel]=\"true\"\n      [menu]=\"mainMenu\"\n      (itemClicked)=\"onItemClicked($event)\"\n    >\n    </sc-nav-items>\n    <div class=\"navbar__collapse-button\" (click)=\"isCollapsed = !isCollapsed\">\n      <sc-icon\n        [icon]=\"isCollapsed ? 'burger-menu': 'arrow-left' \"\n        size=\"0_5\"\n        class=\"navbar__collapse-button-icon\"\n      ></sc-icon>\n    </div>\n  </div>\n</div>\n",
                    styles: [".navbar__logo{margin:2rem auto 0;display:block;max-width:3rem}.navbar__logo--mobile{max-height:2rem}.navbar__header-mobile{height:54px;background-color:#025499;color:#fff;padding:1rem;display:flex;flex-direction:row;align-items:center}.navbar__header-mobile-logo-wrapper{text-align:center;flex-grow:1}.navbar__body-mobile{padding:1.75rem 0;height:calc(100vh - 54px);background-color:#e0e5ed;overflow:auto;position:absolute;width:100%;z-index:10}@media (min-width:768px){.navbar__body-mobile,.navbar__header-mobile{display:none}}.navbar__aside,.navbar__main{min-height:100vh}.navbar__aside{background-color:#025499;width:4rem;display:flex;flex-direction:column}.navbar__aside__option{display:flex;justify-content:flex-end}@media (max-width:768px){.navbar__aside__option{display:none}}.navbar__main{background-color:#edf0f5;width:14rem;position:relative;border-right:1px solid #ccd2dd;transition:width .3s ease-out}.navbar__main .navbar__main-items{padding-top:1.75rem;transition:opacity .5s ease-in-out;opacity:1}.navbar__main--collapsed{width:1rem}.navbar__main--collapsed .navbar__main-items{opacity:0;transition:opacity .1s ease-in-out;pointer-events:none}.navbar__desktop-wrapper{display:flex;flex-direction:row}@media (max-width:768px){.navbar__desktop-wrapper{display:none}}.navbar__collapse-button{position:absolute;right:-.5rem;top:2.625rem;width:1.25rem;height:1.25rem;background-color:#fff;border-radius:1rem;border:1px solid #ccd2dd;box-shadow:0 2px 7px 0 rgba(0,0,0,.12)}.navbar__collapse-button-icon{position:absolute;top:-.325rem;left:.35rem;height:1rem}.navbar__separator{border:2px;height:1px;border-top:1px solid rgba(103,103,103,.1);border-bottom:1px solid rgba(226,224,224,.3)}"]
                }] }
    ];
    NavbarComponent.propDecorators = {
        panelOptions: [{ type: Input }],
        mainMenu: [{ type: Input }],
        logo: [{ type: Input }],
        mobileLogo: [{ type: Input }],
        settings: [{ type: Input }],
        itemClicked: [{ type: Output }],
        isMobileMenuOpen: [{ type: Output }]
    };
    return NavbarComponent;
}());
if (false) {
    /** @type {?} */
    NavbarComponent.prototype.panelOptions;
    /** @type {?} */
    NavbarComponent.prototype.mainMenu;
    /** @type {?} */
    NavbarComponent.prototype.logo;
    /** @type {?} */
    NavbarComponent.prototype.mobileLogo;
    /** @type {?} */
    NavbarComponent.prototype.settings;
    /** @type {?} */
    NavbarComponent.prototype.itemClicked;
    /** @type {?} */
    NavbarComponent.prototype.isMobileMenuOpen;
    /** @type {?} */
    NavbarComponent.prototype.isMobileOpen;
    /** @type {?} */
    NavbarComponent.prototype.isCollapsed;
    /** @type {?} */
    NavbarComponent.prototype.panelOptionSelected;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/nav-items/nav-items.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavItemsComponent = /** @class */ (function () {
    function NavItemsComponent() {
        this.highlightActive = false;
        this.firstLevel = false;
        this.itemClicked = new EventEmitter();
    }
    NavItemsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-nav-items',
                    template: "<ul class=\"sc-nav-items__list\" *ngIf=\"menu\">\n  <li *ngFor=\"let item of menu.items\" class=\"sc-nav-items__list-item\">\n    <a\n      *ngIf=\"!item.isMenu()\"\n      (click)=\"itemClicked.emit(item)\"\n      class=\"sc-nav-items__list-item-link\"\n      [ngClass]=\"{'sc-nav-items__list-item-link--selected': highlightActive && item.selected}\"\n      [attr.id]=\"item.id\"\n    >\n      <sc-icon\n        *ngIf=\"item.icon\"\n        class=\"sc-nav-items__list-item-icon\"\n        [icon]=\"item.icon\" size=\"0_75\"></sc-icon>\n      <span\n        *ngIf=\"!item.icon\"\n        class=\"sc-nav-items__list-item-icon-placeholder\">\n      </span>\n      {{item.label}}\n    </a>\n    <sc-nav-submenu\n      [ngClass]=\"{'internal-sub-menu': !firstLevel}\"\n      *ngIf=\"item.isMenu()\"\n      [highlightActive]=\"highlightActive\"\n      [firstLevel]=\"firstLevel\"\n      [menu]=\"item\"\n      (itemClicked)=\"itemClicked.emit($event)\"\n    >\n    </sc-nav-submenu>\n  </li>\n</ul>\n",
                    styles: [".sc-nav-items__list{margin:0;padding:0;list-style-type:none}.sc-nav-items__list-item{position:relative}.sc-nav-items__list-item-link:hover{color:#025499!important;padding-left:.75rem;transition:padding-left .1s ease-in;background-color:#ccd2dd}.sc-nav-items__list-item-link:active{color:#024680!important}.sc-nav-items__list-item-link{display:flex;flex-direction:row;width:100%;text-align:left;padding:.75rem 1rem;cursor:pointer;font-size:16px;transition:padding-left .1s ease-in;color:inherit;text-decoration:none}@media (min-width:768px){.sc-nav-items__list-item-link{font-size:14px}}.sc-nav-items__list-item-link--selected{color:#0070cc;font-weight:700}.sc-nav-items__list-item-icon{margin-right:.5rem}.sc-nav-items__list-item-icon-placeholder{width:.75rem;margin-right:.5rem}:host{display:block}:host(.sub-item) .sc-nav-items__list-item-icon{margin-left:1rem}:host(.sub-item) .sc-nav-items__list-item-icon-placeholder{margin-left:1rem}:host(.sub-item-nested) .sc-nav-items__list-item-icon{margin-left:2rem}:host(.sub-item-nested) .sc-nav-items__list-item-icon-placeholder{margin-left:2rem}"]
                }] }
    ];
    NavItemsComponent.propDecorators = {
        highlightActive: [{ type: Input }],
        firstLevel: [{ type: Input }],
        menu: [{ type: Input }],
        itemClicked: [{ type: Output }]
    };
    return NavItemsComponent;
}());
if (false) {
    /** @type {?} */
    NavItemsComponent.prototype.highlightActive;
    /** @type {?} */
    NavItemsComponent.prototype.firstLevel;
    /** @type {?} */
    NavItemsComponent.prototype.menu;
    /** @type {?} */
    NavItemsComponent.prototype.itemClicked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/nav-submenu/nav-submenu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavSubmenuComponent = /** @class */ (function (_super) {
    __extends(NavSubmenuComponent, _super);
    function NavSubmenuComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.highlightActive = false;
        _this.firstLevel = false;
        _this.itemClicked = new EventEmitter();
        return _this;
    }
    NavSubmenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-nav-submenu',
                    template: "<a\n  (click)=\"menu.isOpen = !menu.isOpen\"\n  [class.sc-nav-items__list-item-link--open]=\"menu.isOpen\"\n  class=\"sc-nav-items__list-item-link\"\n>\n  <sc-icon\n    *ngIf=\"menu.icon\"\n    class=\"sc-nav-items__list-item-icon\"\n    [icon]=\"menu.icon\" size=\"0_75\"></sc-icon>\n  <span\n    *ngIf=\"!menu.icon\"\n    class=\"sc-nav-items__list-item-icon-placeholder\">\n      </span>\n  <div class=\"sc-nav-items__list-item-label\">\n    {{menu.label}}\n  </div>\n  <sc-icon\n    class=\"sc-nav-items__list-item-icon-open\"\n    [icon]=\"menu.isOpen ? 'arrow-down' : 'arrow-right'\" size=\"0_5\"></sc-icon>\n</a>\n<sc-nav-items\n  [ngClass]=\"{'sub-item-nested': !firstLevel}\"\n  class=\"sc-nav-items__submenu sub-item\"\n  [class.sc-nav-items__submenu--open]=\"menu.isOpen\"\n  *ngIf=\"menu.isOpen\"\n  [highlightActive]=\"highlightActive\"\n  [menu]=\"menu\"\n  (itemClicked)=\"itemClicked.emit($event)\"\n>\n</sc-nav-items>\n",
                    styles: [".sc-nav-items__list{margin:0;padding:0;list-style-type:none}.sc-nav-items__list-item{position:relative}.sc-nav-items__list-item-link:hover{color:#025499!important;padding-left:.75rem;transition:padding-left .1s ease-in;background-color:#ccd2dd}.sc-nav-items__list-item-link:active{color:#024680!important}.sc-nav-items__list-item-link{display:flex;flex-direction:row;width:100%;text-align:left;padding:.75rem 1rem;cursor:pointer;font-size:16px;transition:padding-left .1s ease-in;color:inherit;text-decoration:none}@media (min-width:768px){.sc-nav-items__list-item-link{font-size:14px}}.sc-nav-items__list-item-link--selected{color:#0070cc;font-weight:700}.sc-nav-items__list-item-icon{margin-right:.5rem}.sc-nav-items__list-item-icon-placeholder{width:.75rem;margin-right:.5rem}:host(.internal-sub-menu) .sc-nav-items__list-item-icon{padding-left:1rem}:host(.internal-sub-menu) .sc-nav-items__list-item-icon-placeholder{padding-left:2rem;margin-right:.3rem}.sc-nav-items__list-item-label{flex-grow:1}.sc-nav-items__list-item-icon-open{margin-right:.5rem}.sc-nav-items__list-item-link--open,.sc-nav-items__submenu--open{background-color:#e0e5ed}"]
                }] }
    ];
    NavSubmenuComponent.propDecorators = {
        highlightActive: [{ type: Input }],
        firstLevel: [{ type: Input }],
        itemClicked: [{ type: Output }]
    };
    return NavSubmenuComponent;
}(NavItemsComponent));
if (false) {
    /** @type {?} */
    NavSubmenuComponent.prototype.highlightActive;
    /** @type {?} */
    NavSubmenuComponent.prototype.firstLevel;
    /** @type {?} */
    NavSubmenuComponent.prototype.itemClicked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/nav-panel-items/nav-panel-items.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavPanelItemsComponent = /** @class */ (function () {
    function NavPanelItemsComponent() {
        this.showTooltip = false;
        this.itemClicked = new EventEmitter();
    }
    NavPanelItemsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-nav-panel-items',
                    template: "<div class=\"sc-nav-panel-mobile\">\n  <div *ngFor=\"let item of panel.items\" class=\"sc-nav-panel-item\" [attr.title]=\"item.label\" (click)=\"itemClicked.emit(item)\">\n    <a\n      (click)=\"item.isOpen = !item.isOpen\"\n      class=\"sc-nav-panel-item__link\"\n    >\n      <sc-icon\n        *ngIf=\"item.icon\"\n        class=\"sc-nav-panel-item__icon\"\n        [icon]=\"item.icon\" size=\"0_75\"></sc-icon>\n      <span\n        *ngIf=\"!item.icon\"\n        class=\"sc-nav-panel-item__icon-placeholder\">\n      </span>\n      <div class=\"sc-nav-items__list-item-label\">\n        {{item.label}}\n      </div>\n    </a>\n  </div>\n</div>\n<div class=\"sc-nav-panel-desktop\">\n  <div class=\"sc-nav-panel__list\">\n    <div *ngFor=\"let item of panel.items\" class=\"sc-nav-panel__list-item\" [attr.title]=\"!showTooltip ? item.label : ''\" >\n      <a\n      (click)=\"itemClicked.emit(item)\"\n        class=\"sc-nav-panel__list-item-link\"\n        [attr.id]=\"item.id\"\n        [tooltip]=\"showTooltip ? item.tooltip : null\"\n        [delay]=\"60\"\n        placement=\"right\"\n        container=\"body\"\n        triggers=\"hover click\"\n      >\n        <sc-icon\n          *ngIf=\"item.icon\"\n          class=\"sc-nav-panel__list-item-icon\"\n          [icon]=\"item.icon\"\n          [size]=\"item.size\"></sc-icon>\n      </a>\n    </div>\n  </div>\n</div>\n",
                    styles: [".sc-nav-items__list{margin:0;padding:0;list-style-type:none}.sc-nav-items__list-item{position:relative}.sc-nav-items__list-item-link:hover{color:#025499!important;padding-left:.75rem;transition:padding-left .1s ease-in;background-color:#ccd2dd}.sc-nav-items__list-item-link:active{color:#024680!important}.sc-nav-items__list-item-link{display:flex;flex-direction:row;width:100%;text-align:left;padding:.75rem 1rem;cursor:pointer;font-size:16px;transition:padding-left .1s ease-in;color:inherit;text-decoration:none}.sc-nav-items__list-item-link--selected{color:#0070cc;font-weight:700}.sc-nav-items__list-item-icon{margin-right:.5rem}.sc-nav-items__list-item-icon-placeholder{width:.75rem;margin-right:.5rem}:host{margin-top:auto;margin-bottom:1rem}@media (max-width:768px){.sc-nav-panel-desktop{display:none}}.sc-nav-panel__list{margin:0;padding:0;list-style-type:none}.sc-nav-panel__list-item{position:relative;cursor:pointer}.sc-nav-panel__list-item-link:hover{color:#025499!important;background-color:rgba(0,0,0,.1);transition:background-color .1s ease-in;border-radius:50%}.sc-nav-panel__list-item-link{display:flex;flex-direction:row;padding:.75rem .5rem;color:#fff;cursor:pointer;justify-content:center;height:3rem;width:3rem;align-items:center;margin:0 auto}.sc-nav-panel__list-item-icon{color:#76c1f5;line-height:0}.sc-nav-panel-mobile{display:flex;flex-direction:column}@media (min-width:768px){.sc-nav-items__list-item-link{font-size:14px}.sc-nav-panel-mobile{display:none}}.sc-nav-panel-mobile .sc-nav-panel-item__link{display:flex;flex-direction:row;width:100%;text-align:left;padding:.75rem .5rem;cursor:pointer;font-size:16px;transition:padding-left .1s ease-in;align-items:center}.sc-nav-panel-mobile .sc-nav-panel-item__icon{margin-right:.5rem}.sc-nav-panel-mobile .sc-nav-panel-item__icon-placeholder{width:.75rem;margin-right:.5rem}"]
                }] }
    ];
    NavPanelItemsComponent.propDecorators = {
        panel: [{ type: Input }],
        showTooltip: [{ type: Input }],
        itemClicked: [{ type: Output }]
    };
    return NavPanelItemsComponent;
}());
if (false) {
    /** @type {?} */
    NavPanelItemsComponent.prototype.panel;
    /** @type {?} */
    NavPanelItemsComponent.prototype.showTooltip;
    /** @type {?} */
    NavPanelItemsComponent.prototype.itemClicked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/animations/slideInOut.animation.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var slideInOut = trigger('slideInOut', [
    transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' }))
    ]),
    transition(':leave', [
        animate('200ms ease-out', style({ transform: 'translateX(-100%)' }))
    ])
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/nav-panel-submenu/nav-panel-submenu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavPanelSubmenuComponent = /** @class */ (function () {
    function NavPanelSubmenuComponent() {
        this.panel = null;
        this.highlightActive = false;
        this.firstLevel = false;
        this.itemClicked = new EventEmitter();
        this.closeClicked = new EventEmitter();
        this.showLateralMenu = false;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NavPanelSubmenuComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this.showLateralMenu = changes && changes.panel && changes.panel.currentValue;
    };
    /**
     * @return {?}
     */
    NavPanelSubmenuComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.closeClicked.emit();
        this.showLateralMenu = false;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    NavPanelSubmenuComponent.prototype.onItemClicked = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.itemClicked.emit($event);
    };
    NavPanelSubmenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-nav-panel-submenu',
                    template: "<sc-lateral-drawer-light-box [class.show]=\"showLateralMenu\" (close)=\"close()\">\n  <div class=\"sc-nav-panel-submenu\" [class.open]=\"showLateralMenu\" @slideInOut *ngIf=\"panel\">\n    <div class=\"sc-nav-panel-submenu__content\">\n      <div class=\"sc-nav-panel-submenu__content__header\">\n        <span (click)=\"close()\" class=\"sc-nav-panel-submenu__content__header__close icon-arrow-left-big\"></span>\n        <p class=\"sc-nav-panel-submenu__content__header__title\">{{panel.label}}</p>\n      </div>\n      <div class=\"sc-nav-panel-submenu__content__items\">\n        <sc-nav-items\n          [firstLevel]=\"firstLevel\"\n          [highlightActive]=\"highlightActive\"\n          [menu]=\"panel\"\n          (itemClicked)=\"onItemClicked($event)\"\n        >\n        </sc-nav-items>\n      </div>\n    </div>\n  </div>\n</sc-lateral-drawer-light-box>\n",
                    animations: [slideInOut],
                    styles: [".sc-nav-items__list{margin:0;padding:0;list-style-type:none}.sc-nav-items__list-item{position:relative}.sc-nav-items__list-item-link:hover{color:#025499!important;padding-left:.75rem;transition:padding-left .1s ease-in;background-color:#ccd2dd}.sc-nav-items__list-item-link:active{color:#024680!important}.sc-nav-items__list-item-link{display:flex;flex-direction:row;width:100%;text-align:left;padding:.75rem 1rem;cursor:pointer;font-size:16px;transition:padding-left .1s ease-in;color:inherit;text-decoration:none}.sc-nav-items__list-item-link--selected{color:#0070cc;font-weight:700}.sc-nav-items__list-item-icon{margin-right:.5rem}.sc-nav-items__list-item-icon-placeholder{width:.75rem;margin-right:.5rem}:host{margin-top:auto}.sc-nav-panel-submenu{top:0;position:absolute;background-color:#fff;border-color:#fff;width:100%;height:100%;box-sizing:border-box;overflow:auto;box-shadow:0 2px 6px 0 rgba(0,0,0,.08);padding:0;transition:left .25s ease-out;left:-18rem}@media (min-width:768px){.sc-nav-items__list-item-link{font-size:14px}.sc-nav-panel-submenu{width:18rem}}.sc-nav-panel-submenu.open{left:0}.sc-nav-panel-submenu__content{margin:1.5rem 0 0}.sc-nav-panel-submenu__content__header{display:flex;align-items:baseline}.sc-nav-panel-submenu__content__header__title{font-size:17px;font-weight:bolder}@media (min-width:768px){.sc-nav-panel-submenu__content__header__title{font-size:15px;font-weight:400}}.sc-nav-panel-submenu__content__header__close{color:#424f66;font-size:.85rem;cursor:pointer;left:12px;padding-top:5px;text-align:center;margin-right:2rem;margin-left:1.2rem}.sc-nav-panel-submenu__content__items{margin-left:3rem}"]
                }] }
    ];
    NavPanelSubmenuComponent.propDecorators = {
        panel: [{ type: Input }],
        highlightActive: [{ type: Input }],
        firstLevel: [{ type: Input }],
        itemClicked: [{ type: Output }],
        closeClicked: [{ type: Output }]
    };
    return NavPanelSubmenuComponent;
}());
if (false) {
    /** @type {?} */
    NavPanelSubmenuComponent.prototype.panel;
    /** @type {?} */
    NavPanelSubmenuComponent.prototype.highlightActive;
    /** @type {?} */
    NavPanelSubmenuComponent.prototype.firstLevel;
    /** @type {?} */
    NavPanelSubmenuComponent.prototype.itemClicked;
    /** @type {?} */
    NavPanelSubmenuComponent.prototype.closeClicked;
    /** @type {?} */
    NavPanelSubmenuComponent.prototype.showLateralMenu;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/navbar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavbarModule = /** @class */ (function () {
    function NavbarModule() {
    }
    NavbarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        BrowserAnimationsModule, CommonModule, IconModule, RouterModule,
                        LateralMenuModule, LateralDrawerLightBoxModule, TooltipModule.forRoot()
                    ],
                    declarations: [
                        NavbarComponent,
                        NavItemsComponent,
                        NavSubmenuComponent,
                        NavPanelItemsComponent,
                        NavPanelSubmenuComponent,
                    ],
                    exports: [NavbarComponent],
                    providers: [NavbarMenuFactoryService]
                },] }
    ];
    return NavbarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/navbar/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/pagination/pagination-info.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationInfo = /** @class */ (function () {
    function PaginationInfo(data) {
        this.actualPage = data.actualPage;
        this.itemsPage = data.itemsPage;
        this.totalPages = data.totalPages;
    }
    return PaginationInfo;
}());
if (false) {
    /** @type {?} */
    PaginationInfo.prototype.actualPage;
    /** @type {?} */
    PaginationInfo.prototype.itemsPage;
    /** @type {?} */
    PaginationInfo.prototype.totalPages;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/pagination/pagination-options.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationOptions = /** @class */ (function () {
    function PaginationOptions(data) {
        this.key = data.key;
        this.value = data.value;
    }
    return PaginationOptions;
}());
if (false) {
    /** @type {?} */
    PaginationOptions.prototype.key;
    /** @type {?} */
    PaginationOptions.prototype.value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/pagination/pagination-initial-config.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationInitialConfig = /** @class */ (function () {
    function PaginationInitialConfig() {
    }
    return PaginationInitialConfig;
}());
if (false) {
    /** @type {?} */
    PaginationInitialConfig.prototype.startingPage;
    /** @type {?} */
    PaginationInitialConfig.prototype.startingPageLength;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/pagination/pagination.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationComponent = /** @class */ (function () {
    function PaginationComponent(fb) {
        this.fb = fb;
        this.itemsPageOptions = [
            new PaginationOptions({
                key: 20,
                value: 20
            }),
            new PaginationOptions({
                key: 50,
                value: 50
            }),
            new PaginationOptions({
                key: 100,
                value: 100
            })
        ];
        this.data = new PaginationInfo({
            totalPages: 0,
            itemsPage: 0,
            actualPage: 0
        });
        this.paginationInfo = new EventEmitter();
        this.paginationForm = this.fb.group({
            pageItem: this.itemsPageOptions[0]
        });
        this.changeItemForPage(this.itemsPageOptions[0]);
    }
    /**
     * @private
     * @param {?} initialConfig
     * @return {?}
     */
    PaginationComponent.prototype.findStartingLengthOption = /**
     * @private
     * @param {?} initialConfig
     * @return {?}
     */
    function (initialConfig) {
        /** @type {?} */
        var startingPageLength;
        if (initialConfig && initialConfig.startingPageLength) {
            startingPageLength = this.itemsPageOptions.find((/**
             * @param {?} x
             * @return {?}
             */
            function (x) { return x.value === initialConfig.startingPageLength; }));
        }
        if (isNullOrUndefined(startingPageLength)) {
            startingPageLength = this.itemsPageOptions[0];
        }
        return startingPageLength;
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    PaginationComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if ((changes.itemsPageOptions && changes.itemsPageOptions.currentValue)) {
            this.paginationForm.setValue({ pageItem: changes.itemsPageOptions.currentValue[0] });
        }
        if (changes.initialConfig) {
            this.paginationForm.setValue({
                pageItem: this.findStartingLengthOption(changes.initialConfig.currentValue)
            });
        }
        this.count = this.rowsLength / this.paginationForm.value.pageItem.value;
        this.data.totalPages = Math.ceil(this.count);
        this.data.itemsPage = this.paginationForm.value.pageItem.value;
        this.data.actualPage = this.initialConfig && this.initialConfig.startingPage ? this.initialConfig.startingPage : 1;
        this.paginationInfo.emit(this.data);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    PaginationComponent.prototype.changeItemForPage = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.count = this.rowsLength / item.value;
        this.data.totalPages = Math.ceil(this.count);
        this.data.itemsPage = item.value;
        this.data.actualPage = 1;
        this.paginationInfo.emit(this.data);
    };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.next = /**
     * @return {?}
     */
    function () {
        if (this.data.actualPage < this.data.totalPages) {
            this.data.actualPage++;
            this.paginationInfo.emit(this.data);
        }
    };
    /**
     * @return {?}
     */
    PaginationComponent.prototype.back = /**
     * @return {?}
     */
    function () {
        if (this.data.actualPage > 1) {
            this.data.actualPage--;
            this.paginationInfo.emit(this.data);
        }
    };
    PaginationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-pagination',
                    template: "<form [formGroup]=\"paginationForm\">\n  <div class=\"pagination\">\n    <div class=\"page-text-items-page\" *ngIf=\"itemsPageOptions.length > 1\">Items por P\u00E1gina</div>\n    <sc-select class=\"page-select\" placeholder=\"\" formControlName=\"pageItem\" [items]=\"itemsPageOptions\" [enableSearch]=\"false\"\n      (optionSelected)=\"changeItemForPage($event)\" *ngIf=\"itemsPageOptions.length > 1\"></sc-select>\n    <div class=\"page-text ml-auto\">P\u00E1gina {{data.actualPage}} de {{data.totalPages}}</div>\n    <a class=\"page-link page-link_left\" (click)=\"back()\">\n      <sc-icon icon=\"arrow-left\" size=\"1\"></sc-icon>\n    </a>\n    <a class=\"page-link page-link_right\" (click)=\"next()\">\n      <sc-icon icon=\"arrow-right\" size=\"1\"></sc-icon>\n    </a>\n  </div>\n</form>\n",
                    styles: [".pagination a:active,.pagination a:focus,.pagination a:hover{color:#0070cc!important}.pagination{display:flex;padding-left:0;list-style:none;border-radius:.25rem;flex-direction:row;justify-content:flex-start;height:40px}.page-link{display:block;padding:.45rem .75rem;margin-left:-1px;height:auto;color:#8993a4!important;font-size:1.25rem;border:1px solid #ccd2dd;cursor:pointer;text-decoration:none}.page-link_left{border-radius:3px 0 0 3px}.page-link_right{border-radius:0 3px 3px 0}.page-text{font-weight:500;padding:.5rem 1.375rem;height:1rem;font-size:.875rem;color:#8993a4}.page-text-items-page{font-weight:500;padding-top:.5rem;padding-bottom:.5rem;padding-right:.875rem;height:1rem;font-size:.875rem;color:#8993a4}@media (max-width:768px){.page-text{width:100%;padding-left:0}.page-text-items-page{display:none}}.page-select{display:block;width:5.675rem}@media (max-width:768px){.page-select{display:none}}"]
                }] }
    ];
    /** @nocollapse */
    PaginationComponent.ctorParameters = function () { return [
        { type: FormBuilder }
    ]; };
    PaginationComponent.propDecorators = {
        itemsPageOptions: [{ type: Input }],
        rowsLength: [{ type: Input }],
        initialConfig: [{ type: Input }],
        paginationInfo: [{ type: Output }]
    };
    return PaginationComponent;
}());
if (false) {
    /** @type {?} */
    PaginationComponent.prototype.itemsPageOptions;
    /** @type {?} */
    PaginationComponent.prototype.rowsLength;
    /** @type {?} */
    PaginationComponent.prototype.initialConfig;
    /** @type {?} */
    PaginationComponent.prototype.paginationInfo;
    /** @type {?} */
    PaginationComponent.prototype.paginationForm;
    /** @type {?} */
    PaginationComponent.prototype.actualPage;
    /** @type {?} */
    PaginationComponent.prototype.count;
    /** @type {?} */
    PaginationComponent.prototype.data;
    /** @type {?} */
    PaginationComponent.prototype.fb;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/select/select.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CONTROL_VALUE_ACCESSOR$3 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return SelectComponent; })),
    multi: true
};
var SelectComponent = /** @class */ (function () {
    function SelectComponent(controlContainer, document) {
        var _this = this;
        this.controlContainer = controlContainer;
        this.document = document;
        this.debounceTime = 0;
        this.autocomplete = 'off';
        this.showItemsBelow = true;
        this.items = [];
        this.filteredItems = [];
        this.inputField = new FormControl();
        this.hideError = false;
        this.isDisabled = false;
        this.isReadonly = false;
        this.lastSelected = null;
        this.objectKey = 'key';
        this.objectValue = 'value';
        this.selectedItemIndex = -1;
        this.showItems = false;
        this.onChange = (/**
         * @param {?} val
         * @return {?}
         */
        function (val) { });
        this.onTouchedCallback = (/**
         * @return {?}
         */
        function () { });
        this.optionSelected = new EventEmitter();
        this.iconClickObservable = new Observable((/**
         * @return {?}
         */
        function () {
            _this.calculateShowItemsBelow();
            if (_this.shouldShowItems()) {
                _this.showItems = !_this.showItems;
            }
        }));
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    SelectComponent.prototype.eventScroll = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.onClickOutside();
    };
    /**
     * @return {?}
     */
    SelectComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.control = this.formControl ? this.formControl : this.controlContainer.control.get(this.formControlName);
        // We need to set validator and value to the input
        // this.inputField.setValue(this.control.value ? this.control.value[this.objectValue] : null);
        this.inputField.setValidators(this.control.validator);
        if (this.itemsAsync$) {
            this.items = [];
            this.loading = true;
            this.itemsAsync$.subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                if (data) {
                    _this.items = data;
                    _this.setInitialItems();
                }
                else {
                    _this.items = [];
                    _this.setSelected(null);
                    _this.loading = true;
                }
            }));
        }
        else {
            this.setInitialItems();
        }
        if (this.maxlength) {
            this.initialMaxLength = this.maxlength;
        }
    };
    /**
     * @private
     * @return {?}
     */
    SelectComponent.prototype.setInitialItems = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.filteredItems = this.getFilteredItems(this.items);
        this.loading = false;
        /** @type {?} */
        var value = (this.control && this.control.value) || this.itemToSelect;
        if (!!value) {
            if (this.maxlength) {
                this.maxlength = 9999999999;
            }
            this.selectedItemIndex = this.filteredItems.findIndex((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return item[_this.objectKey] === value[_this.objectKey]; }));
            this.setWritedValue(this.filteredItems[this.selectedItemIndex]);
        }
        this.itemToSelect = null;
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    SelectComponent.prototype.onControlValueChanged = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        if (value === null || value === undefined) {
            this.selectedItemIndex = -1;
            this.setSelected(value);
            return;
        }
        /** @type {?} */
        var itemToSelect = this.filteredItems.find((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item[_this.objectKey] === value[_this.objectKey]; }));
        if (!!itemToSelect) {
            this.setSelected(itemToSelect);
            this.selectedItemIndex = this.filteredItems.findIndex((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return item[_this.objectKey] === value[_this.objectKey]; }));
        }
        else {
            this.itemToSelect = value;
        }
    };
    /**
     * @param {?} rawData
     * @return {?}
     */
    SelectComponent.prototype.getFilteredItems = /**
     * @param {?} rawData
     * @return {?}
     */
    function (rawData) {
        var _this = this;
        /** @type {?} */
        var filteredItems = [];
        if (this.hasGroupedItems) {
            rawData.forEach((/**
             * @param {?} element
             * @return {?}
             */
            function (element) {
                filteredItems.push(element.groupType);
                element.items.forEach((/**
                 * @param {?} item
                 * @return {?}
                 */
                function (item) {
                    item.groupType = element.groupType.groupTypeValue;
                    item.groupTypeName = element.groupType[_this.objectValue];
                    filteredItems.push(item);
                }));
            }));
        }
        else {
            filteredItems = rawData;
        }
        return filteredItems;
    };
    /**
     * @return {?}
     */
    SelectComponent.prototype.applyFilter = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var filterString;
        if (this.enableSearch && this.inputField.value) {
            filterString = this.inputField.value.toLowerCase();
            this.filteredItems = this.items.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return item[_this.objectValue].toLowerCase().indexOf(filterString) > -1; }));
        }
        else {
            this.filteredItems = this.hasGroupedItems ? this.getFilteredItems(this.items) : this.items;
        }
        switch (this.filteredItems.length) {
            case 0:
                this.selectedItemIndex = -1;
                break;
            case 1:
                if (this.filteredItems[0][this.objectValue].toLowerCase() === filterString) {
                    this.selectedItemIndex = 0;
                    this.setSelected(this.filteredItems[0]);
                }
                break;
        }
    };
    /**
     * @return {?}
     */
    SelectComponent.prototype.setInputIcon = /**
     * @return {?}
     */
    function () {
        if (this.loading) {
            return 'loading';
        }
        else {
            return this.showItems ? 'arrow-up-dropdown arrow-up-dropdown-blue' : 'arrow-down-dropdown arrow-down-dropdown-blue';
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    SelectComponent.prototype.setSelected = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (this.maxlength) {
            this.maxlength = 9999999999;
        }
        if (!this.lastSelected
            || (this.lastSelected && item === null)
            || (this.lastSelected && item && this.lastSelected[this.objectKey] !== item[this.objectKey])) {
            this.optionSelected.emit(item);
            this.onChange(item);
        }
        this.setWritedValue(item);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    SelectComponent.prototype.setWritedValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var writeValue = null;
        if (value) {
            writeValue = this.hasGroupedItems ? value.groupTypeName + " - " + value[this.objectValue] : value[this.objectValue];
        }
        this.inputField.setValue(writeValue);
        this.lastSelected = value;
    };
    /**
     * @return {?}
     */
    SelectComponent.prototype.scrollItems = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var liList = this.itemsElement.nativeElement.querySelectorAll('.sc-select__scroll');
        /** @type {?} */
        var currentItem = liList[this.selectedItemIndex];
        /** @type {?} */
        var currentItemContainer = currentItem.parentElement;
        currentItemContainer.scrollTo(0, currentItem['offsetTop'] + -144);
    };
    /**
     * @param {?=} newVal
     * @return {?}
     */
    SelectComponent.prototype.shouldShowItems = /**
     * @param {?=} newVal
     * @return {?}
     */
    function (newVal) {
        if (this.isDisabled || this.isReadonly) {
            return false;
        }
        else if (!this.filteredItems.length && !this.inputField.value) {
            return false;
        }
        else {
            return newVal || true;
        }
    };
    /**
     * @param {?} tagName
     * @return {?}
     */
    SelectComponent.prototype.onClickInput = /**
     * @param {?} tagName
     * @return {?}
     */
    function (tagName) {
        if (tagName.toLowerCase() === 'input' && !(this.isDisabled || this.isReadonly)) {
            if (this.enableSearch) {
                this.inputField.setValue('');
            }
            this.filteredItems = this.hasGroupedItems ? this.getFilteredItems(this.items) : this.items;
            this.calculateShowItemsBelow();
            this.showItems = this.shouldShowItems(!this.showItems);
        }
    };
    /**
     * @return {?}
     */
    SelectComponent.prototype.onClickOutside = /**
     * @return {?}
     */
    function () {
        this.setSelected(this.lastSelected);
        this.showItems = false;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectComponent.prototype.onKeydown = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.maxlength) {
            this.maxlength = this.initialMaxLength;
        }
        switch (event.keyCode) {
            // backspace
            case 8:
                this.showItems = this.shouldShowItems(this.enableSearch);
                break;
            // tab, esc
            case 9:
            case 27:
                this.blurKeysHandler();
                break;
            // enter
            case 13:
                event.preventDefault();
                event.stopPropagation();
                /** @type {?} */
                var item = this.filteredItems[this.selectedItemIndex];
                if (!item || !this.showItems) {
                    this.showItems = this.shouldShowItems(true);
                }
                else {
                    this.setSelected(item);
                    this.showItems = false;
                }
                break;
            // shift
            case 16:
                // ...do nothing
                break;
            // arrowup
            case 38:
                this.upDownKeysHandler('up', event);
                break;
            // arrowdown
            case 40:
                this.upDownKeysHandler('down', event);
                break;
            // repag, inicio
            case 33:
            case 36:
                // Set the first item of list as selected
                this.firstLastKeysHandler('first', event);
                break;
            // avpag, fin
            case 34:
            case 35:
                // Set the last item of list as selected
                this.firstLastKeysHandler('last', event);
                break;
            default:
                this.showItems = this.shouldShowItems(this.enableSearch);
                break;
        }
    };
    /**
     * @param {?} key
     * @return {?}
     */
    SelectComponent.prototype.onSelectItem = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this.selectedItemIndex = key;
        this.setSelected(this.filteredItems[key]);
        // this.optionSelected.emit(this.filteredItems[key]);
        this.showItems = false;
        this.applyFilter();
    };
    /**
     * @private
     * @return {?}
     */
    SelectComponent.prototype.calculateShowItemsBelow = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var clientHeight = this.document.documentElement.clientHeight;
        /** @type {?} */
        var yPosition = this.scInput.elementRef.nativeElement.getBoundingClientRect().top;
        /** @type {?} */
        var itemsHeight = this.filteredItems.length > 3 ? 194 : (this.filteredItems.length * 48);
        this.showItemsBelow = clientHeight - yPosition > (itemsHeight + 30);
    };
    // Used when a key blurs the input
    // Hide items and set input value with latest selected item
    // Used when a key blurs the input
    // Hide items and set input value with latest selected item
    /**
     * @private
     * @return {?}
     */
    SelectComponent.prototype.blurKeysHandler = 
    // Used when a key blurs the input
    // Hide items and set input value with latest selected item
    /**
     * @private
     * @return {?}
     */
    function () {
        this.showItems = false;
        this.setSelected(this.lastSelected);
        this.inputField.setValue(this.lastSelected ? this.lastSelected[this.objectValue] : null);
    };
    // Used for up/down keys
    // Used for up/down keys
    /**
     * @private
     * @param {?} direction
     * @param {?} event
     * @return {?}
     */
    SelectComponent.prototype.upDownKeysHandler = 
    // Used for up/down keys
    /**
     * @private
     * @param {?} direction
     * @param {?} event
     * @return {?}
     */
    function (direction, event) {
        event.preventDefault();
        this.showItems = this.shouldShowItems(true);
        /** @type {?} */
        var condition = direction === 'up' ? this.selectedItemIndex > 0 : this.selectedItemIndex < this.filteredItems.length - 1;
        if (condition) {
            if (this.hasGroupedItems) {
                if (direction === 'up') {
                    if (!(this.filteredItems[this.selectedItemIndex - 1].groupType)) {
                        if (this.selectedItemIndex - 1 > 0) {
                            this.selectedItemIndex = this.selectedItemIndex - 2;
                            return;
                        }
                        else {
                            return;
                        }
                    }
                }
                else {
                    if (!(this.filteredItems[this.selectedItemIndex + 1].groupType)) {
                        if (this.selectedItemIndex + 1 < this.filteredItems.length - 1) {
                            this.selectedItemIndex = this.selectedItemIndex + 2;
                            return;
                        }
                        else {
                            return;
                        }
                    }
                }
            }
            direction === 'up' ? --this.selectedItemIndex : ++this.selectedItemIndex;
            this.scrollItems();
        }
    };
    // Used for init/end and [up|down]Page keys
    // Used for init/end and [up|down]Page keys
    /**
     * @private
     * @param {?} position
     * @param {?} event
     * @return {?}
     */
    SelectComponent.prototype.firstLastKeysHandler = 
    // Used for init/end and [up|down]Page keys
    /**
     * @private
     * @param {?} position
     * @param {?} event
     * @return {?}
     */
    function (position, event) {
        event.preventDefault();
        this.selectedItemIndex = position === 'first' ? 0 : this.filteredItems.length - 1;
        this.scrollItems();
    };
    // Control Value Accessor methods
    // Control Value Accessor methods
    /**
     * @param {?} value
     * @return {?}
     */
    SelectComponent.prototype.writeValue = 
    // Control Value Accessor methods
    /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.onControlValueChanged(value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouchedCallback = fn;
    };
    /**
     * @param {?} disabled
     * @return {?}
     */
    SelectComponent.prototype.setDisabledState = /**
     * @param {?} disabled
     * @return {?}
     */
    function (disabled) {
        this.isDisabled = disabled;
    };
    SelectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-select',
                    template: "<div\n    class=\"sc-select\"\n    scClickOutside\n    [class.sc-select--with-label]=\"!!label\"\n    [class.sc-select--readonly]=\"isReadonly\"\n    [class.sc-select--disabled]=\"isDisabled\"\n    (onClickOutSide)=\"onClickOutside()\"\n    (keydown)=\"onKeydown($event)\"\n>\n    <sc-input #scInput\n        [autocomplete]=\"autocomplete\"\n        [formControl]=\"inputField\"\n        [icon]=\"setInputIcon()\"\n        [id]=\"formControlName ? (id ? formControlName + '-' + id : formControlName) : null\"\n        [isDisabled]=\"isDisabled\"\n        [readonly]=\"isReadonly || !enableSearch\"\n        [errorMessages]=\"errorMessages\"\n        [hideError]=\"hideError\"\n        [label]=\"label\"\n        [placeholder]=\"placeholder\"\n        (click)=\"onClickInput($event.target.tagName)\"\n        (keyup)=\"applyFilter()\"\n        [iconClickHandler]=\"!(isDisabled || isReadonly || loading) && iconClickObservable\"\n        [maxlength]=\"maxlength\"\n        [debounceTime]=\"debounceTime\"\n    ></sc-input>\n    <div class=\"sc-select__items sc-scroll-bar\" [hidden]=\"!showItems || loading\" [class.sc-select__items__down]=\"showItemsBelow\"\n    [class.sc-select__items__up]=\"!showItemsBelow && !label\" [class.sc-select__items__up--with-label]=\"!showItemsBelow && label\" #itemsElement>\n        <ng-container *ngIf=\"filteredItems.length; else sinResultados\">\n            <div\n                *ngFor=\"let item of filteredItems; let index = index\"\n                class=\"sc-select__scroll\"\n                [class.sc-select__item]=\"item.groupType || !hasGroupedItems\"\n                [class.sc-select__item--grouped]=\"hasGroupedItems && item.groupType\"\n                [class.sc-select__title]=\"hasGroupedItems && !item.groupType\"\n                [class.sc-select__item--selected]=\"index === selectedItemIndex\"\n                (click)=\"onSelectItem(index)\"\n            >{{ item[objectValue] }}</div>\n        </ng-container>\n        <ng-template #sinResultados>\n            <div class=\"sc-select__item\" disabled>No hay resultados</div>\n        </ng-template>\n    </div>\n</div>\n",
                    providers: [CONTROL_VALUE_ACCESSOR$3],
                    styles: [".sc-select{position:relative}.sc-select__items{border-radius:3px;border:1px solid #ccd2dd;background-color:#fff;position:absolute;width:100%;max-height:194px;z-index:3;overflow-y:scroll}.sc-select__items__down{top:40px}.sc-select__items__up{bottom:100%}.sc-select__items__up--with-label{bottom:calc(100% - 22px)}.sc-select__item{padding:.75rem 1rem;font-size:.875rem;cursor:pointer}.sc-select__item--grouped{padding:.75rem 1rem .75rem 2rem;color:#8993a4;font-family:Roboto;font-size:14px}.sc-select__item--selected{background-color:#0070cc;color:#fff}.sc-select__item:hover:not(.sc-select__item--selected){background-color:#4393d4;color:#fff}.sc-select__item[disabled]{color:#aeb7c8;cursor:default}.sc-select__item[disabled]:hover{color:#aeb7c8;background-color:#fff}.sc-select__item.loading sc-icon{float:right}.sc-select__title{pointer-events:none;padding:.75rem 1rem;color:#424f66;font-family:Roboto;font-size:14px;font-weight:700;line-height:24px}.sc-select--with-label .sc-select__items.sc-select__items__down{top:62px}.sc-select ::ng-deep input:-moz-read-only{cursor:pointer}.sc-select ::ng-deep input:read-only{cursor:pointer}.sc-select:not(.sc-select--readonly):not(.sc-select--disabled) ::ng-deep .sc-input input[type=text][readonly]:not(.has-error){background-color:#fff;border-color:#ccd2dd}.sc-select--disabled ::ng-deep input:-moz-read-only,.sc-select--readonly ::ng-deep input:-moz-read-only{cursor:default}.sc-select--disabled ::ng-deep input:read-only,.sc-select--readonly ::ng-deep input:read-only{cursor:default}@media (max-width:768px){.sc-select__items{max-height:170px}}"]
                }] }
    ];
    /** @nocollapse */
    SelectComponent.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: Host }, { type: SkipSelf }, { type: Optional }] },
        { type: undefined, decorators: [{ type: Inject, args: ['Document',] }] }
    ]; };
    SelectComponent.propDecorators = {
        enableSearch: [{ type: Input }],
        errorMessages: [{ type: Input }],
        formControl: [{ type: Input }],
        formControlName: [{ type: Input }],
        hideError: [{ type: Input }],
        id: [{ type: Input }],
        isDisabled: [{ type: Input }],
        isReadonly: [{ type: Input }],
        items: [{ type: Input }],
        itemsAsync$: [{ type: Input }],
        label: [{ type: Input }],
        loading: [{ type: Input }],
        objectKey: [{ type: Input }],
        objectValue: [{ type: Input }],
        placeholder: [{ type: Input }],
        maxlength: [{ type: Input }],
        hasGroupedItems: [{ type: Input }],
        debounceTime: [{ type: Input }],
        optionSelected: [{ type: Output }],
        itemsElement: [{ type: ViewChild, args: ['itemsElement', { static: true },] }],
        scInput: [{ type: ViewChild, args: ['scInput', { static: true },] }],
        eventScroll: [{ type: HostListener, args: ['window:scroll', ['$event'],] }]
    };
    return SelectComponent;
}());
if (false) {
    /** @type {?} */
    SelectComponent.prototype.enableSearch;
    /** @type {?} */
    SelectComponent.prototype.errorMessages;
    /** @type {?} */
    SelectComponent.prototype.formControl;
    /** @type {?} */
    SelectComponent.prototype.formControlName;
    /** @type {?} */
    SelectComponent.prototype.hideError;
    /** @type {?} */
    SelectComponent.prototype.id;
    /** @type {?} */
    SelectComponent.prototype.isDisabled;
    /** @type {?} */
    SelectComponent.prototype.isReadonly;
    /** @type {?} */
    SelectComponent.prototype.items;
    /** @type {?} */
    SelectComponent.prototype.itemsAsync$;
    /** @type {?} */
    SelectComponent.prototype.label;
    /** @type {?} */
    SelectComponent.prototype.loading;
    /** @type {?} */
    SelectComponent.prototype.objectKey;
    /** @type {?} */
    SelectComponent.prototype.objectValue;
    /** @type {?} */
    SelectComponent.prototype.placeholder;
    /** @type {?} */
    SelectComponent.prototype.maxlength;
    /** @type {?} */
    SelectComponent.prototype.hasGroupedItems;
    /** @type {?} */
    SelectComponent.prototype.debounceTime;
    /** @type {?} */
    SelectComponent.prototype.optionSelected;
    /** @type {?} */
    SelectComponent.prototype.itemsElement;
    /** @type {?} */
    SelectComponent.prototype.scInput;
    /** @type {?} */
    SelectComponent.prototype.autocomplete;
    /** @type {?} */
    SelectComponent.prototype.control;
    /** @type {?} */
    SelectComponent.prototype.filteredItems;
    /** @type {?} */
    SelectComponent.prototype.inputField;
    /** @type {?} */
    SelectComponent.prototype.iconClickObservable;
    /** @type {?} */
    SelectComponent.prototype.selectedItemIndex;
    /** @type {?} */
    SelectComponent.prototype.showItems;
    /** @type {?} */
    SelectComponent.prototype.showItemsBelow;
    /**
     * @type {?}
     * @private
     */
    SelectComponent.prototype.lastSelected;
    /**
     * @type {?}
     * @private
     */
    SelectComponent.prototype.itemToSelect;
    /**
     * @type {?}
     * @private
     */
    SelectComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    SelectComponent.prototype.onTouchedCallback;
    /**
     * @type {?}
     * @private
     */
    SelectComponent.prototype.initialMaxLength;
    /**
     * @type {?}
     * @private
     */
    SelectComponent.prototype.controlContainer;
    /** @type {?} */
    SelectComponent.prototype.document;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/on-enter.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OnEnterDirective = /** @class */ (function () {
    function OnEnterDirective() {
        // Set key as Enter key by default
        if (!this.key || this.key === '') {
            this.key = 'Enter';
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    OnEnterDirective.prototype.onKeyPressHandler = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.key === 'Enter') {
            this.action();
        }
    };
    OnEnterDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[scOnEnter]'
                },] }
    ];
    /** @nocollapse */
    OnEnterDirective.ctorParameters = function () { return []; };
    OnEnterDirective.propDecorators = {
        action: [{ type: Input }],
        key: [{ type: Input }],
        onKeyPressHandler: [{ type: HostListener, args: ['keypress', ['$event'],] }]
    };
    return OnEnterDirective;
}());
if (false) {
    /** @type {?} */
    OnEnterDirective.prototype.action;
    /** @type {?} */
    OnEnterDirective.prototype.key;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/helpers/dom.helper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DomHelper = /** @class */ (function () {
    function DomHelper() {
    }
    /**
     * @param {?} element
     * @param {?} classString
     * @return {?}
     */
    DomHelper.prototype.setClass = /**
     * @param {?} element
     * @param {?} classString
     * @return {?}
     */
    function (element, classString) {
        if (element) {
            element.className = classString;
        }
    };
    /**
     * @param {?} element
     * @param {?} classString
     * @return {?}
     */
    DomHelper.prototype.addClass = /**
     * @param {?} element
     * @param {?} classString
     * @return {?}
     */
    function (element, classString) {
        if (element) {
            element.className = element
                .className
                .split(' ')
                .filter((/**
             * @param {?} name
             * @return {?}
             */
            function (name) {
                return name !== classString;
            }))
                .concat(classString)
                .join(' ');
        }
    };
    /**
     * @param {?} element
     * @param {?} classString
     * @return {?}
     */
    DomHelper.prototype.removeClass = /**
     * @param {?} element
     * @param {?} classString
     * @return {?}
     */
    function (element, classString) {
        if (element) {
            element.className = element
                .className
                .split(' ')
                .filter((/**
             * @param {?} name
             * @return {?}
             */
            function (name) {
                return name !== classString;
            }))
                .join(' ');
        }
    };
    /**
     * @param {?} el
     * @param {?} cls
     * @return {?}
     */
    DomHelper.prototype.findAncestor = /**
     * @param {?} el
     * @param {?} cls
     * @return {?}
     */
    function (el, cls) {
        do {
            el = el.parentElement;
        } while (!el.classList.contains(cls));
        return el;
    };
    /**
     * @return {?}
     */
    DomHelper.prototype.isSmallViewport = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var SMALL_SCREEN_BREAKPOINT = 768;
        return window.innerWidth < SMALL_SCREEN_BREAKPOINT;
    };
    /**
     * @return {?}
     */
    DomHelper.prototype.isLargeViewport = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var SMALL_SCREEN_BREAKPOINT = 768;
        return window.innerWidth >= SMALL_SCREEN_BREAKPOINT;
    };
    /**
     * @return {?}
     */
    DomHelper.prototype.isMobile = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var SMALL_SCREEN_BREAKPOINT = 768;
        return window.screen.width < SMALL_SCREEN_BREAKPOINT;
    };
    /**
     * @param {?} parent
     * @param {?} child
     * @param {?} distance
     * @return {?}
     */
    DomHelper.prototype.scrollFrom = /**
     * @param {?} parent
     * @param {?} child
     * @param {?} distance
     * @return {?}
     */
    function (parent, child, distance) {
        parent.scrollTo(0, child['offsetTop'] + distance);
    };
    /**
     * @param {?} offSetElement
     * @param {?=} desktop
     * @param {?=} mobile
     * @return {?}
     */
    DomHelper.prototype.scrollTo = /**
     * @param {?} offSetElement
     * @param {?=} desktop
     * @param {?=} mobile
     * @return {?}
     */
    function (offSetElement, desktop, mobile) {
        if (desktop === void 0) { desktop = 200; }
        if (mobile === void 0) { mobile = 200; }
        /** @type {?} */
        var content = document.body;
        if (content && offSetElement) {
            /** @type {?} */
            var height_1 = window.screen.width >= 768 ? desktop : mobile;
            setTimeout((/**
             * @return {?}
             */
            function () {
                window.scrollTo(0, offSetElement['offsetTop'] + height_1);
                // if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
                //     window.scrollTo(0, offSetElement['offsetTop'] + height)
                // } else {
                //     content.scrollTop = offSetElement['offsetTop'] + height;
                // }
                // this.scrollToSlow(content, offSetElement['offsetTop'] + height, 200)
            }), 500);
        }
    };
    /**
     * @param {?} element
     * @param {?} to
     * @param {?} duration
     * @return {?}
     */
    DomHelper.prototype.scrollToSlow = /**
     * @param {?} element
     * @param {?} to
     * @param {?} duration
     * @return {?}
     */
    function (element, to, duration) {
        var _this = this;
        if (duration <= 0) {
            window.scrollTo(0, to);
            // if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
            //     window.scrollTo(0, to)
            // } else {
            //     element.scrollTop = to;
            // }
            return;
        }
        /** @type {?} */
        var difference = to - element.scrollTop;
        /** @type {?} */
        var perTick = difference / duration * 10;
        setTimeout((/**
         * @return {?}
         */
        function () {
            // if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
            //     window.scrollTo(0, element.scrollTop + perTick)
            // } else {
            //     element.scrollTop = element.scrollTop + perTick;
            // }
            window.scrollTo(0, element.scrollTop + perTick);
            if (element.scrollTop === to) {
                return;
            }
            _this.scrollToSlow(element, to, duration - 5);
        }), 5);
    };
    /**
     * @param {?} parent
     * @param {?} elToFix
     * @param {?} height
     * @return {?}
     */
    DomHelper.prototype.scrollFixed = /**
     * @param {?} parent
     * @param {?} elToFix
     * @param {?} height
     * @return {?}
     */
    function (parent, elToFix, height) {
        if (elToFix) {
            /** @type {?} */
            var h = parent.querySelector('html').scrollTop;
            /** @type {?} */
            var hasFixed = elToFix.className.includes('fixedAtTop');
            if (h >= parseInt(height, 10)) {
                if (!hasFixed) {
                    this.addClass(elToFix, 'fixedAtTop');
                }
            }
            else {
                this.removeClass(elToFix, 'fixedAtTop');
            }
        }
    };
    /**
     * @return {?}
     */
    DomHelper.prototype.windowSize = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var w = window;
        /** @type {?} */
        var d = document;
        /** @type {?} */
        var e = d.documentElement;
        /** @type {?} */
        var g = d.getElementsByTagName('body')[0];
        /** @type {?} */
        var x = w.innerWidth || e.clientWidth || g.clientWidth;
        /** @type {?} */
        var y = w.innerHeight || e.clientHeight || g.clientHeight;
        return { x: x, y: y };
    };
    DomHelper.decorators = [
        { type: Injectable }
    ];
    return DomHelper;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/hour-mask.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HourMaskDirective = /** @class */ (function () {
    function HourMaskDirective(eRef, model, dom) {
        this.eRef = eRef;
        this.model = model;
        this.dom = dom;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    HourMaskDirective.prototype.onKeypress = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        return this.keypressEvent(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    HourMaskDirective.prototype.onInput = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        return this.inputEvent(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    HourMaskDirective.prototype.onKeydown = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        return this.keydownEvent(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    HourMaskDirective.prototype.onPaste = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        return this.pasteEvent(e);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    HourMaskDirective.prototype.onDrop = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        return this.dropEvent(e);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    HourMaskDirective.prototype.clickout = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.model.value) {
            if (this.model.value.length === 1) {
                this.model.control.setValue("0" + this.model.value + ":00");
            }
            if (this.model.value.length === 2) {
                this.model.control.setValue(this.model.value + ":00");
            }
            if (this.model.value.length === 3 && !(/^[0-9]:[0-5]$/.test(this.model.value))) {
                this.model.control.setValue(this.model.value + "00");
            }
            if (this.model.value.length === 3 && (/^[0-9]:[0-5]$/.test(this.model.value))) {
                this.model.control.setValue("0" + this.model.value + "0");
            }
            if (this.model.value.length === 4) {
                this.model.control.setValue(this.model.value + "0");
            }
            if (!(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(this.model.control.value)) && this.model.control.value) {
                this.model.control.setValue(null);
                this.model.control.setErrors({ invalidFormat: true });
            }
        }
    };
    /**
     * @param {?} time
     * @return {?}
     */
    HourMaskDirective.prototype.keypressEvent = /**
     * @param {?} time
     * @return {?}
     */
    function (time) {
        /** @type {?} */
        var valueLength = time.target.value.length + 1;
        return this.validateNumbers(time, time.key || time.char, valueLength);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    HourMaskDirective.prototype.inputEvent = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (this.dom.isMobile()) {
            /** @type {?} */
            var valueLength = e.target.value.length;
            if (!this.validateNumbers(e, e.data, valueLength) && e.inputType !== 'deleteContentBackward') {
                e.target.value = this.timeSaved || null;
            }
            if (e.inputType === 'deleteContentBackward' && valueLength === 2) {
                e.target.value = e.target.value.slice(0, 1) || null;
            }
        }
        this.timeSaved = e.target.value;
        if (e.target.value.length === 2) {
            e.target.value += ':';
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    HourMaskDirective.prototype.keydownEvent = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (e.key === 'Backspace' && e.target.value.length === 3) {
            e.target.value = e.target.value.substring(e.target.value.length - 1, 0);
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    HourMaskDirective.prototype.pasteEvent = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var data = e.clipboardData.getData('text/plain');
        return /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/.test(data);
    };
    /**
     * @param {?} e
     * @return {?}
     */
    HourMaskDirective.prototype.dropEvent = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        /** @type {?} */
        var data = e.dataTransfer.getData('text/plain');
        return /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/.test(data);
    };
    /**
     * @private
     * @param {?} event
     * @param {?} keyChar
     * @param {?} valueLength
     * @return {?}
     */
    HourMaskDirective.prototype.validateNumbers = /**
     * @private
     * @param {?} event
     * @param {?} keyChar
     * @param {?} valueLength
     * @return {?}
     */
    function (event, keyChar, valueLength) {
        if (valueLength === 1) {
            return /^[0-9]$/.test(keyChar);
        }
        if (valueLength === 2) {
            return this.validateSecondNumber(event, keyChar);
        }
        if (valueLength === 4) {
            return this.validateFourthNumber(keyChar);
        }
        if (valueLength === 5) {
            return this.validateFifthNumber(keyChar);
        }
    };
    /**
     * @private
     * @param {?} time
     * @param {?} keyChar
     * @return {?}
     */
    HourMaskDirective.prototype.validateSecondNumber = /**
     * @private
     * @param {?} time
     * @param {?} keyChar
     * @return {?}
     */
    function (time, keyChar) {
        if (time.target.value.charAt(0) === '2') {
            if (/[^0-3]/gi.test(keyChar) && keyChar) {
                return false;
            }
        }
        else {
            if (/[^0-9]/gi.test(keyChar) && keyChar) {
                return false;
            }
        }
        return true;
    };
    /**
     * @private
     * @param {?} keyChar
     * @return {?}
     */
    HourMaskDirective.prototype.validateFourthNumber = /**
     * @private
     * @param {?} keyChar
     * @return {?}
     */
    function (keyChar) {
        if (/[^0-5]/gi.test(keyChar) && keyChar) {
            return false;
        }
        return true;
    };
    /**
     * @private
     * @param {?} keyChar
     * @return {?}
     */
    HourMaskDirective.prototype.validateFifthNumber = /**
     * @private
     * @param {?} keyChar
     * @return {?}
     */
    function (keyChar) {
        if (/[^0-9]/gi.test(keyChar) && keyChar) {
            return false;
        }
        return true;
    };
    HourMaskDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[hourMask]',
                    providers: [DomHelper]
                },] }
    ];
    /** @nocollapse */
    HourMaskDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: NgControl },
        { type: DomHelper }
    ]; };
    HourMaskDirective.propDecorators = {
        onKeypress: [{ type: HostListener, args: ['keypress', ['$event'],] }],
        onInput: [{ type: HostListener, args: ['input', ['$event'],] }],
        onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
        onPaste: [{ type: HostListener, args: ['paste', ['$event'],] }],
        onDrop: [{ type: HostListener, args: ['drop', ['$event'],] }],
        clickout: [{ type: HostListener, args: ['focusout', ['$event'],] }]
    };
    return HourMaskDirective;
}());
if (false) {
    /** @type {?} */
    HourMaskDirective.prototype.timeSaved;
    /**
     * @type {?}
     * @private
     */
    HourMaskDirective.prototype.eRef;
    /**
     * @type {?}
     * @private
     */
    HourMaskDirective.prototype.model;
    /**
     * @type {?}
     * @private
     */
    HourMaskDirective.prototype.dom;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/hide-header.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HideHeaderDirective = /** @class */ (function () {
    function HideHeaderDirective() {
        this.initialX = null;
        this.initialY = null;
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    HideHeaderDirective.prototype.onMousewheel = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if (window.screen.width <= 1151) {
            /** @type {?} */
            var closeBarElement = this.hideElement.domElem.nativeElement;
            /** @type {?} */
            var delta = void 0;
            if ($event.wheelDelta) {
                delta = $event.wheelDelta;
            }
            else {
                delta = -1 * $event.deltaY;
            }
            if (delta < 0) {
                // up
                closeBarElement.classList.remove('show');
                closeBarElement.classList.add('hide');
            }
            else if (delta > 0) {
                // down
                closeBarElement.classList.remove('hide');
                closeBarElement.classList.add('show');
            }
        }
    };
    /**
     * @private
     * @param {?} $event
     * @return {?}
     */
    HideHeaderDirective.prototype.onTouchStart = /**
     * @private
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.initialX = $event.touches[0].clientX;
        this.initialY = $event.touches[0].clientY;
    };
    /**
     * @private
     * @param {?} $event
     * @return {?}
     */
    HideHeaderDirective.prototype.onTouchMove = /**
     * @private
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if (window.screen.width <= 1151) {
            /** @type {?} */
            var closeBarElement = this.hideElement.domElem.nativeElement;
            if (this.initialX === null) {
                return;
            }
            if (this.initialY === null) {
                return;
            }
            /** @type {?} */
            var currentY = $event.touches[0].clientY;
            /** @type {?} */
            var diffY = this.initialY - currentY;
            if (diffY > 0) {
                // swiped up
                closeBarElement.classList.remove('show');
                closeBarElement.classList.add('hide');
            }
            else {
                // swiped down
                closeBarElement.classList.remove('hide');
                closeBarElement.classList.add('show');
            }
            this.initialX = null;
            this.initialY = null;
        }
    };
    HideHeaderDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[hide-on-scroll]'
                },] }
    ];
    /** @nocollapse */
    HideHeaderDirective.ctorParameters = function () { return []; };
    HideHeaderDirective.propDecorators = {
        hideElement: [{ type: Input, args: ['hideElement',] }],
        onMousewheel: [{ type: HostListener, args: ['mousewheel', ['$event'],] }],
        onTouchStart: [{ type: HostListener, args: ['touchstart', ['$event'],] }],
        onTouchMove: [{ type: HostListener, args: ['touchmove', ['$event'],] }]
    };
    return HideHeaderDirective;
}());
if (false) {
    /** @type {?} */
    HideHeaderDirective.prototype.hideElement;
    /** @type {?} */
    HideHeaderDirective.prototype.initialX;
    /** @type {?} */
    HideHeaderDirective.prototype.initialY;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/scroll-to-top.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function WindowXY() { }
if (false) {
    /** @type {?} */
    WindowXY.prototype.currentXY;
}
var ScrollToTopDirective = /** @class */ (function () {
    function ScrollToTopDirective(elementRef, router) {
        this.elementRef = elementRef;
        this.router = router;
        this.source = interval(10);
        this.routerEventsSubscription = null;
    }
    /**
     * @return {?}
     */
    ScrollToTopDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.routerEventsSubscription) {
            this.routerEventsSubscription.unsubscribe();
        }
        this.windowCoordinates = this.currentXY;
    };
    /**
     * @return {?}
     */
    ScrollToTopDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.currentXY = this.windowCoordinates;
        this.windowScroll = (/** @type {?} */ ({ currentXY: [0, 0] }));
        this.routerEventsSubscription = this.router.events.pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        function (event) { return event instanceof NavigationEnd; })), distinctUntilChanged((/**
         * @param {?} prev
         * @param {?} next
         * @return {?}
         */
        function (prev, next) { return next && next.url === prev.url; })))
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            /** @type {?} */
            var node = _this.elementRef.nativeElement.parentNode;
            /** @type {?} */
            var subscription = _this.source.subscribe((/**
             * @param {?} step
             * @return {?}
             */
            function (step) {
                node.scrollTop = (node.scrollTop - (10 * step));
                if (node.scrollTop <= 0) {
                    node.scrollTop = 0;
                    subscription.unsubscribe();
                }
            }));
        }));
    };
    Object.defineProperty(ScrollToTopDirective.prototype, "windowCoordinates", {
        get: /**
         * @private
         * @return {?}
         */
        function () {
            return (/** @type {?} */ ({ currentXY: [window.scrollX, window.scrollY] }));
        },
        set: /**
         * @private
         * @param {?} xy
         * @return {?}
         */
        function (xy) {
            /** @type {?} */
            var x = xy[0] || 0;
            /** @type {?} */
            var y = xy[1] || 0;
            window.scrollTo(x, y);
        },
        enumerable: true,
        configurable: true
    });
    ScrollToTopDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[scroll-to-top-navigation-end]'
                },] }
    ];
    /** @nocollapse */
    ScrollToTopDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Router }
    ]; };
    return ScrollToTopDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ScrollToTopDirective.prototype.routerEventsSubscription;
    /**
     * @type {?}
     * @private
     */
    ScrollToTopDirective.prototype.currentXY;
    /** @type {?} */
    ScrollToTopDirective.prototype.windowScroll;
    /** @type {?} */
    ScrollToTopDirective.prototype.source;
    /**
     * @type {?}
     * @private
     */
    ScrollToTopDirective.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    ScrollToTopDirective.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/alpha-numeric.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AlphaNumericDirective = /** @class */ (function () {
    function AlphaNumericDirective(el) {
        this.el = el;
        this.ALPHA_NUMERIC = /^[a-zA-Z0-9]*$/;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    AlphaNumericDirective.prototype.onKeyPress = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        if (!this.ALPHA_NUMERIC.test(e.key)) {
            e.preventDefault();
        }
    };
    AlphaNumericDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[scAlphaNumeric]'
                },] }
    ];
    /** @nocollapse */
    AlphaNumericDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    AlphaNumericDirective.propDecorators = {
        OnlyNumber: [{ type: Input }],
        onKeyPress: [{ type: HostListener, args: ['keypress', ['$event'],] }]
    };
    return AlphaNumericDirective;
}());
if (false) {
    /** @type {?} */
    AlphaNumericDirective.prototype.ALPHA_NUMERIC;
    /** @type {?} */
    AlphaNumericDirective.prototype.OnlyNumber;
    /**
     * @type {?}
     * @private
     */
    AlphaNumericDirective.prototype.el;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/click-out-side.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ClickOutsideDirective = /** @class */ (function () {
    function ClickOutsideDirective(_elementRef) {
        this._elementRef = _elementRef;
        this.onClickOutSide = new EventEmitter();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    ClickOutsideDirective.prototype.onClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!event.target) {
            return;
        }
        /** @type {?} */
        var clickedInside = this._elementRef.nativeElement.contains(event.target);
        if (!clickedInside) {
            this.onClickOutSide.emit(event);
        }
    };
    ClickOutsideDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[scClickOutside]'
                },] }
    ];
    /** @nocollapse */
    ClickOutsideDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    ClickOutsideDirective.propDecorators = {
        onClickOutSide: [{ type: Output }],
        onClick: [{ type: HostListener, args: ['document:click', ['$event'],] }]
    };
    return ClickOutsideDirective;
}());
if (false) {
    /** @type {?} */
    ClickOutsideDirective.prototype.onClickOutSide;
    /**
     * @type {?}
     * @private
     */
    ClickOutsideDirective.prototype._elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/numeric.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScNumericDirective = /** @class */ (function () {
    function ScNumericDirective(model) {
        this.model = model;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    ScNumericDirective.prototype.inputChange = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var newValue = event.target.value.replace(/\D/g, '');
        this.model.control.setValue(newValue);
    };
    ScNumericDirective.decorators = [
        { type: Injectable },
        { type: Directive, args: [{ selector: '[scNumeric]' },] }
    ];
    /** @nocollapse */
    ScNumericDirective.ctorParameters = function () { return [
        { type: NgControl }
    ]; };
    ScNumericDirective.propDecorators = {
        inputChange: [{ type: HostListener, args: ['input', ['$event'],] }]
    };
    return ScNumericDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ScNumericDirective.prototype.model;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/upper-input.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UpperInputDirective = /** @class */ (function () {
    function UpperInputDirective(elementRef) {
        this.elementRef = elementRef;
        this.el = this.elementRef.nativeElement;
        this.el.value = this.el.value && this.el.value.toUpperCase();
    }
    /**
     * @return {?}
     */
    UpperInputDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.el.value = this.el.value && this.el.value.toUpperCase();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    UpperInputDirective.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this.el.value = this.el.value && this.el.value.toUpperCase();
    };
    /**
     * @param {?} value
     * @return {?}
     */
    UpperInputDirective.prototype.onKeyup = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.el.value = value && value.toUpperCase();
    };
    /**
     * @param {?} value
     * @return {?}
     */
    UpperInputDirective.prototype.onChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.el.value = value && value.toUpperCase();
    };
    UpperInputDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[scUpperInput]',
                },] }
    ];
    /** @nocollapse */
    UpperInputDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    UpperInputDirective.propDecorators = {
        onKeyup: [{ type: HostListener, args: ['keyup', ['$event.target.value'],] }],
        onChange: [{ type: HostListener, args: ['ngModelChange', ['$event'],] }]
    };
    return UpperInputDirective;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    UpperInputDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    UpperInputDirective.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/directives.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var directives = [
    AlphaNumericDirective,
    ClickOutsideDirective,
    HideHeaderDirective,
    HourMaskDirective,
    ScNumericDirective,
    OnEnterDirective,
    ScrollToTopDirective,
    UpperInputDirective,
];
var DirectivesModule = /** @class */ (function () {
    function DirectivesModule() {
    }
    DirectivesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: directives,
                    exports: directives,
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                },] }
    ];
    return DirectivesModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/select/select.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function documentFactory() {
    return document;
}
var SelectModule = /** @class */ (function () {
    function SelectModule() {
    }
    SelectModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        InputModule,
                        IconModule,
                        FormControlErrorModule,
                        DirectivesModule
                    ],
                    declarations: [SelectComponent],
                    exports: [SelectComponent],
                    providers: [
                        { provide: 'Document', useFactory: documentFactory }
                    ]
                },] }
    ];
    return SelectModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/pagination/pagination.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaginationModule = /** @class */ (function () {
    function PaginationModule() {
    }
    PaginationModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        SelectModule,
                        IconModule
                    ],
                    declarations: [PaginationComponent],
                    exports: [PaginationComponent]
                },] }
    ];
    return PaginationModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/password.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$1 = /**
 * @param {?} each
 * @return {?}
 */
function (each) { return (__assign({}, each, { ruleRegExp: new RegExp(each.rule) })); };
/** @type {?} */
var passwordRules = ([
    { description: 'Al menos 8 caracteres', rule: '.{8,}' },
    { description: 'Al menos 1 mayúscula', rule: '.*[A-Z].*' },
    { description: 'Al menos 1 minúscula', rule: '.*[a-z].*' },
    { description: 'Al menos 1 número', rule: '.*[0-9].*' },
]).map((ɵ0$1));
/**
 * @param {?} control
 * @return {?}
 */
function ValidatePassword(control) {
    /** @type {?} */
    var value = control.value;
    if (!passwordRules.every((/**
     * @param {?} each
     * @return {?}
     */
    function (each) { return value.match(each.ruleRegExp); }))) {
        return { invalidPassword: true };
    }
    return null;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/password-rules/password-rules.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PasswordRulesComponent = /** @class */ (function () {
    function PasswordRulesComponent() {
        this.rules = passwordRules;
    }
    PasswordRulesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-password-rules',
                    template: "<div class=\"password-rules__title\">La contrase\u00F1a debe poseer:</div>\n<ul class=\"password-rules__list\">\n  <li class=\"password-rules__item\" *ngFor=\"let rule of rules\"\n    [class.restriction-fullfilled]=\"value && value.match(rule.ruleRegExp)\">{{rule.description}}</li>\n</ul>",
                    styles: ["@charset \"UTF-8\";:host{display:block;text-align:left;font-size:.75rem}.password-rules__list{-moz-columns:2;columns:2;color:#424f66;list-style:none;padding:initial}.password-rules__title{font-family:Montserrat,sans-serif}.password-rules__item::before{content:\"\u2022\";color:#0070cc;font-weight:700;font-size:1.3rem;margin-right:.2rem;vertical-align:bottom}.password-rules__item.restriction-fullfilled::before,.restriction-fullfilled{color:#aeb7c8}"]
                }] }
    ];
    PasswordRulesComponent.propDecorators = {
        value: [{ type: Input }]
    };
    return PasswordRulesComponent;
}());
if (false) {
    /** @type {?} */
    PasswordRulesComponent.prototype.value;
    /** @type {?} */
    PasswordRulesComponent.prototype.rules;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/password-rules/password-rules.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PasswordRulesModule = /** @class */ (function () {
    function PasswordRulesModule() {
    }
    PasswordRulesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [PasswordRulesComponent],
                    imports: [
                        CommonModule
                    ],
                    exports: [PasswordRulesComponent]
                },] }
    ];
    return PasswordRulesModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/phone/phone.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CONTROL_VALUE_ACCESSOR$4 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return PhoneComponent; })),
    multi: true
};
var PhoneComponent = /** @class */ (function () {
    function PhoneComponent(controlContainer) {
        this.controlContainer = controlContainer;
        this.errorsList = [];
        this.subs = [];
        this.onChange = (/**
         * @return {?}
         */
        function () { });
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.areaCodePrefix = '54';
        this.phoneNumberPrefix = '15';
        this.maxlength = 10;
    }
    /**
     * @return {?}
     */
    PhoneComponent.prototype.getControlContainer = /**
     * @return {?}
     */
    function () {
        return this.controlContainer;
    };
    /**
     * @return {?}
     */
    PhoneComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var containerControl = this.getControlContainer().control;
        this.formControlAreaCode = this.formControlAreaCode ?
            this.formControlAreaCode :
            (/** @type {?} */ (containerControl.get(this.formControlNameAreaCode)));
        this.formControlPhoneNumber = this.formControlPhoneNumber ?
            this.formControlPhoneNumber :
            (/** @type {?} */ (containerControl.get(this.formControlNamePhoneNumber)));
        if (this.formControlAreaCode) {
            this.idAreaCode = "field_" + this.formControlNameAreaCode;
            this.formControlAreaCode.setValidators(Validators.compose([this.formControlAreaCode.validator, this.validateTotalMaxLength.bind(this)]));
        }
        if (this.formControlPhoneNumber) {
            this.idPhoneNumber = "field_" + this.formControlNamePhoneNumber;
            this.formControlPhoneNumber.setValidators(Validators.compose([this.formControlPhoneNumber.validator, this.validateTotalMaxLength.bind(this)]));
        }
        this.initControl();
    };
    /**
     * @return {?}
     */
    PhoneComponent.prototype.validateMaxLength = /**
     * @return {?}
     */
    function () {
        return this.getLengthControlValue(this.formControlAreaCode) + this.getLengthControlValue(this.formControlPhoneNumber) > this.maxlength;
    };
    /**
     * @param {?} control
     * @return {?}
     */
    PhoneComponent.prototype.getLengthControlValue = /**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        return control && control.value ? control.value.length : 0;
    };
    /**
     * @return {?}
     */
    PhoneComponent.prototype.validateTotalMaxLength = /**
     * @return {?}
     */
    function () {
        return !this.validateMaxLength() ? null : {
            totalmaxlength: {
                totalmaxlength: true
            }
        };
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PhoneComponent.prototype.onBlur = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.blur.emit(event);
        this.setControlValidity();
    };
    /**
     * @param {?} event
     * @param {?} control
     * @return {?}
     */
    PhoneComponent.prototype.onFocus = /**
     * @param {?} event
     * @param {?} control
     * @return {?}
     */
    function (event, control) {
        this.focus.emit(event);
        control.markAsTouched();
    };
    /**
     * @return {?}
     */
    PhoneComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subs.forEach((/**
         * @param {?} sub
         * @return {?}
         */
        function (sub) { return sub.unsubscribe(); }));
    };
    /**
     * @protected
     * @return {?}
     */
    PhoneComponent.prototype.initControl = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.formControlAreaCode) {
            setTimeout((/**
             * @return {?}
             */
            function () { return _this.setControlValidity(); }));
            /** @type {?} */
            var obs1$ = this.formControlAreaCode.valueChanges.pipe(tap((/**
             * @return {?}
             */
            function () { return _this.setControlValidity(); })));
            /** @type {?} */
            var obs2$ = this.formControlPhoneNumber.valueChanges.pipe(tap((/**
             * @return {?}
             */
            function () { return _this.setControlValidity(); })));
            this.subs.push(obs1$.subscribe());
            this.subs.push(obs2$.subscribe());
        }
    };
    /**
     * @private
     * @return {?}
     */
    PhoneComponent.prototype.setControlValidity = /**
     * @private
     * @return {?}
     */
    function () {
        this.errorsList = [];
        if (this.formControlAreaCode && this.formControlPhoneNumber) {
            this.hasErrorAreaCode = this.formControlAreaCode.invalid &&
                (this.formControlAreaCode.dirty || this.formControlAreaCode.touched || this.formControlAreaCode.value || this.validateMaxLength());
            this.hasErrorPhoneNumber = this.formControlPhoneNumber.invalid &&
                (this.formControlPhoneNumber.dirty || this.formControlPhoneNumber.touched || this.formControlPhoneNumber.value
                    || this.validateMaxLength());
        }
        if (this.hasErrorPhoneNumber || this.hasErrorAreaCode) {
            this.errorsList = this.getErrorsList();
        }
    };
    /**
     * @private
     * @return {?}
     */
    PhoneComponent.prototype.getErrorsList = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var errors = (this.formControlAreaCode && this.formControlAreaCode.errors) ||
            (this.formControlPhoneNumber && this.formControlPhoneNumber.errors);
        /** @type {?} */
        var errorsToShow = errors ? Object.keys(errors) : [];
        return errorsToShow.map((/**
         * @param {?} field
         * @return {?}
         */
        function (field) {
            return _this.getMessage(field, errors[field]);
        }));
    };
    /**
     * @param {?} type
     * @param {?} params
     * @return {?}
     */
    PhoneComponent.prototype.getMessage = /**
     * @param {?} type
     * @param {?} params
     * @return {?}
     */
    function (type, params) {
        return type && params &&
            (typeof this.errorMessages[type] === 'function' ? this.errorMessages[type](params) : this.errorMessages[type])
            || '';
    };
    PhoneComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-phone',
                    template: "<div class=\"sc-phone\" [class.has-error]=\"hasErrorAreaCode || hasErrorPhoneNumber\">\n  <label *ngIf=\"label\" [attr.for]=\"idAreaCode\" class=\"sc-phone__label\">{{ label }}</label>\n  <div class=\"sc-phone__input-group d-flex\">\n    <div class=\"d-flex sc-phone__code-area\">\n      <sc-input [id]=\"idAreaCode\" [formControl]=\"formControlAreaCode\" type=\"number\" [placeholder]=\"placeholderAreaCode\" [value]=\"valueAreaCode\" [isDisabled]=\"isDisabledAreaCode\"  [addOnPrefix]=\"areaCodePrefix\" class=\"fluid-input\"\n        [hideError]=\"true\" [errorMessages]=\"errorMessages\" (focus)=\"onFocus($event,formControlAreaCode)\"\n        (blur)=\"onBlur($event)\"></sc-input>\n    </div>\n    <div class=\"d-flex sc-phone__phone-number\">\n      <sc-input [id]=\"idPhoneNumber\" [formControl]=\"formControlPhoneNumber\" type=\"number\" [placeholder]=\"placeholderPhoneNumber\" [value]=\"valuePhoneNumber\"  [isDisabled]=\"isDisabledPhoneNumber\" [addOnPrefix]=\"phoneNumberPrefix\" class=\"fluid-input\"\n        [hideError]=\"true\" [errorMessages]=\"errorMessages\" (focus)=\"onFocus($event,formControlPhoneNumber)\"  \n        (blur)=\"onBlur($event)\"></sc-input>\n    </div>\n  </div>\n  <div class=\"sc-phone__error-list\" *ngIf=\"errorsList\">\n    <ul class=\"sc-phone__error-list has-error\" >\n      <li class=\"sc-phone__error-list__item\" *ngFor=\"let error of errorsList\">{{error}}</li>\n    </ul>\n  </div>\n\n</div>",
                    providers: [CONTROL_VALUE_ACCESSOR$4],
                    styles: [":host{display:inline-block;width:100%;min-width:260px}.sc-phone__code-area{width:30%;margin-right:3%}.sc-phone__phone-number{width:67%}.sc-phone__error-list{margin:.25rem 0 0;padding:0;list-style-type:none;display:block;font-size:.875rem;line-height:1.5rem;color:#de350b;text-align:right;min-height:1.5rem}"]
                }] }
    ];
    /** @nocollapse */
    PhoneComponent.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: Host }, { type: SkipSelf }, { type: Optional }] }
    ]; };
    PhoneComponent.propDecorators = {
        areaCodePrefix: [{ type: Input }],
        phoneNumberPrefix: [{ type: Input }],
        formControlNameAreaCode: [{ type: Input }],
        formControlNamePhoneNumber: [{ type: Input }],
        formControlAreaCode: [{ type: Input }],
        formControlPhoneNumber: [{ type: Input }],
        readonlyAreaCode: [{ type: Input }],
        readonlyPhoneNumber: [{ type: Input }],
        placeholderAreaCode: [{ type: Input }],
        placeholderPhoneNumber: [{ type: Input }],
        isDisabledAreaCode: [{ type: Input }],
        isDisabledPhoneNumber: [{ type: Input }],
        valuePhoneNumber: [{ type: Input }],
        valueAreaCode: [{ type: Input }],
        label: [{ type: Input }],
        errorMessages: [{ type: Input }],
        maxlength: [{ type: Input }],
        blur: [{ type: Output }],
        focus: [{ type: Output }]
    };
    return PhoneComponent;
}());
if (false) {
    /** @type {?} */
    PhoneComponent.prototype.areaCodePrefix;
    /** @type {?} */
    PhoneComponent.prototype.phoneNumberPrefix;
    /** @type {?} */
    PhoneComponent.prototype.formControlNameAreaCode;
    /** @type {?} */
    PhoneComponent.prototype.formControlNamePhoneNumber;
    /** @type {?} */
    PhoneComponent.prototype.formControlAreaCode;
    /** @type {?} */
    PhoneComponent.prototype.formControlPhoneNumber;
    /** @type {?} */
    PhoneComponent.prototype.readonlyAreaCode;
    /** @type {?} */
    PhoneComponent.prototype.readonlyPhoneNumber;
    /** @type {?} */
    PhoneComponent.prototype.placeholderAreaCode;
    /** @type {?} */
    PhoneComponent.prototype.placeholderPhoneNumber;
    /** @type {?} */
    PhoneComponent.prototype.isDisabledAreaCode;
    /** @type {?} */
    PhoneComponent.prototype.isDisabledPhoneNumber;
    /** @type {?} */
    PhoneComponent.prototype.valuePhoneNumber;
    /** @type {?} */
    PhoneComponent.prototype.valueAreaCode;
    /** @type {?} */
    PhoneComponent.prototype.label;
    /** @type {?} */
    PhoneComponent.prototype.errorMessages;
    /** @type {?} */
    PhoneComponent.prototype.maxlength;
    /** @type {?} */
    PhoneComponent.prototype.idAreaCode;
    /** @type {?} */
    PhoneComponent.prototype.idPhoneNumber;
    /** @type {?} */
    PhoneComponent.prototype.hasErrorAreaCode;
    /** @type {?} */
    PhoneComponent.prototype.hasErrorPhoneNumber;
    /** @type {?} */
    PhoneComponent.prototype.errorsList;
    /**
     * @type {?}
     * @protected
     */
    PhoneComponent.prototype.subs;
    /** @type {?} */
    PhoneComponent.prototype.blur;
    /** @type {?} */
    PhoneComponent.prototype.focus;
    /** @type {?} */
    PhoneComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    PhoneComponent.prototype.controlContainer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/phone/phone.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PhoneModule = /** @class */ (function () {
    function PhoneModule() {
    }
    PhoneModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        IconModule,
                        InputModule,
                        ReactiveFormsModule,
                        FormControlErrorModule
                    ],
                    declarations: [PhoneComponent],
                    exports: [PhoneComponent]
                },] }
    ];
    return PhoneModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/radio-button/radio-group/radio-group.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RadioGroupComponent = /** @class */ (function () {
    function RadioGroupComponent() {
        this.isDisabled = false;
        this.isReadOnly = false;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    RadioGroupComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioGroupComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @return {?}
     */
    RadioGroupComponent.prototype.registerOnTouched = /**
     * @return {?}
     */
    function () {
    };
    RadioGroupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-radio-group',
                    template: "<div class=\"sc-radio-group\"><ng-content></ng-content></div>",
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return RadioGroupComponent; })),
                            multi: true
                        }
                    ]
                }] }
    ];
    /** @nocollapse */
    RadioGroupComponent.ctorParameters = function () { return []; };
    RadioGroupComponent.propDecorators = {
        isDisabled: [{ type: Input }],
        isReadOnly: [{ type: Input }],
        formControlName: [{ type: Input }]
    };
    return RadioGroupComponent;
}());
if (false) {
    /** @type {?} */
    RadioGroupComponent.prototype.isDisabled;
    /** @type {?} */
    RadioGroupComponent.prototype.isReadOnly;
    /** @type {?} */
    RadioGroupComponent.prototype.formControlName;
    /** @type {?} */
    RadioGroupComponent.prototype.onChange;
    /** @type {?} */
    RadioGroupComponent.prototype.value;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/radio-button/radio-item/radio-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RadioItemComponent = /** @class */ (function () {
    function RadioItemComponent(radioGroup) {
        this.radioGroup = radioGroup;
        this.check = new EventEmitter();
        this.isDisabled = false;
        this.isReadOnly = false;
        this.type = 'default';
    }
    /**
     * @return {?}
     */
    RadioItemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.radioGroup && this.radioGroup.formControlName) {
            this.id = this.radioGroup.formControlName.toLowerCase();
            if (this.value && this.value.toLowerCase) {
                this.id += '-' + this.value.toLowerCase();
            }
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    RadioItemComponent.prototype.onClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.isReadOnly
            || this.radioGroup.isReadOnly
            || this.isDisabled
            || this.radioGroup.isDisabled) {
            return;
        }
        this.radioGroup.value = this.value;
        this.radioGroup.onChange(this.value);
        this.check.emit({ event: event });
    };
    /**
     * @return {?}
     */
    RadioItemComponent.prototype.isChecked = /**
     * @return {?}
     */
    function () {
        if (!this.radioGroup.value) {
            return false;
        }
        if (typeof this.value === 'object') {
            return (JSON.stringify(this.radioGroup.value) === JSON.stringify(this.value));
        }
        else {
            return (this.radioGroup.value.toString() === this.value.toString());
        }
    };
    RadioItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-radio-item',
                    template: "<div class=\"sc-radio-item\"\n  [id]=\"id\"\n  (click)=\"onClick($event)\"\n  [ngClass]=\"{\n    'sc-radio-item--disabled': isDisabled || radioGroup.isDisabled,\n    'sc-radio-item--readonly': isReadOnly || radioGroup.isReadOnly,\n    'sc-radio-item--boxed': type == 'boxed',\n    'sc-radio-item--boxed_checked': type == 'boxed' && isChecked(),\n    'sc-radio-item--boxed_unselected': type == 'boxed' && !isChecked() && radioGroup && radioGroup.value\n  }\"\n>\n  <div class=\"sc-radio-item__circle\">\n    <div [ngClass]=\"{\n      'sc-radio-item__circle-outer': type == 'default',\n      'sc-radio-item__circle-outer--checked': type == 'default' && isChecked(),\n      'sc-radio-item__circle-boxed': type == 'boxed',\n      'sc-radio-item__circle-boxed--checked': type == 'boxed' && isChecked()\n    }\">\n    </div>\n    <div [ngClass]=\"{\n        'sc-radio-item__circle-inner--checked': isChecked() && (type == 'default'),\n        'sc-radio-item__circle-inner': type == 'default',\n        'sc-radio-item__circle-inner-boxed': type == 'boxed' && isChecked()\n      }\">\n    </div>\n  </div>\n  <input class=\"sc-radio-item__input\" type=\"radio\" [checked]=\"isChecked()\" [disabled]=\"isDisabled || radioGroup.isDisabled\"/>\n  <label class=\"sc-radio-item__label\" [ngClass]=\"{'sc-radio-item__label-boxed': type == 'boxed'}\">\n    <ng-content></ng-content>\n  </label>\n</div>",
                    styles: [":host(.vertical-align-center) .sc-radio-item{align-items:center}:host(.margin-bottom) .sc-radio-item{margin-bottom:1rem}.sc-radio-item{align-items:flex-start;cursor:pointer;display:flex;position:relative;margin-bottom:8px;width:100%}.sc-radio-item__circle{height:22px;position:relative;width:22px}.sc-radio-item__circle-outer{border-radius:50%;border:2px solid;box-sizing:border-box;color:#424f66;height:22px;position:absolute;width:22px}.sc-radio-item__circle-outer--checked{color:#3dcc98}.sc-radio-item__circle-boxed{border-radius:50%;border:1px solid #8993a4;box-sizing:border-box;height:16px;left:3px;top:3px;transition:border-color 280ms;width:16px;position:relative}.sc-radio-item__circle-boxed--checked{border-color:#4393d4}.sc-radio-item__circle-inner{border-radius:50%;transform:scale(.001);transition:transform 280ms}.sc-radio-item__circle-inner--checked{border:11px solid #3dcc98;transform:scale(.5)}.sc-radio-item__circle-inner-boxed{border-right:1px solid #4393d4;border-bottom:1px solid #4393d4;left:9.5px;position:absolute;top:8px;height:6px;width:3px;transform:rotate(45deg)}.sc-radio-item--disabled,.sc-radio-item--readonly{pointer-events:none}.sc-radio-item--disabled .sc-radio-item__circle-outer,.sc-radio-item--readonly .sc-radio-item__circle-outer{color:#aeb7c8}.sc-radio-item--disabled .sc-radio-item__circle-inner,.sc-radio-item--readonly .sc-radio-item__circle-inner{border-color:#aeb7c8}.sc-radio-item--disabled .sc-radio-item__label,.sc-radio-item--readonly .sc-radio-item__label{cursor:not-allowed;color:#aeb7c8}.sc-radio-item--disabled .sc-radio-item__circle-inner{display:none}.sc-radio-item--boxed{flex:1;border:1px solid #8993a4;border-radius:3px;margin-bottom:16px;padding-top:6px;padding-bottom:6px;padding-left:10px;transition:border-color 280ms}.sc-radio-item--boxed_checked{border-color:#4393d4}.sc-radio-item--boxed_unselected{opacity:.5}.sc-radio-item--boxed:hover{border-color:#424f66}.sc-radio-item__label{color:#424f66;cursor:pointer;font-size:1rem;flex:1;line-height:22px;margin-bottom:0;margin-left:10px}.sc-radio-item__label-boxed{font-size:.875rem}.sc-radio-item__input{visibility:hidden;position:absolute;left:-9999px}.sc-radio-item--disabled.sc-radio-item--boxed{border-color:#ccd2dd}"]
                }] }
    ];
    /** @nocollapse */
    RadioItemComponent.ctorParameters = function () { return [
        { type: RadioGroupComponent, decorators: [{ type: Host }, { type: Inject, args: [forwardRef((/**
                         * @return {?}
                         */
                        function () { return RadioGroupComponent; })),] }] }
    ]; };
    RadioItemComponent.propDecorators = {
        isDisabled: [{ type: Input }],
        isReadOnly: [{ type: Input }],
        type: [{ type: Input }],
        value: [{ type: Input }],
        check: [{ type: Output }]
    };
    return RadioItemComponent;
}());
if (false) {
    /** @type {?} */
    RadioItemComponent.prototype.isDisabled;
    /** @type {?} */
    RadioItemComponent.prototype.isReadOnly;
    /** @type {?} */
    RadioItemComponent.prototype.type;
    /** @type {?} */
    RadioItemComponent.prototype.value;
    /** @type {?} */
    RadioItemComponent.prototype.check;
    /** @type {?} */
    RadioItemComponent.prototype.id;
    /** @type {?} */
    RadioItemComponent.prototype.radioGroup;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/radio-button/radio-button.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RadioModule = /** @class */ (function () {
    function RadioModule() {
    }
    RadioModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    exports: [RadioGroupComponent, RadioItemComponent],
                    declarations: [RadioGroupComponent, RadioItemComponent]
                },] }
    ];
    return RadioModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/search-field/search-field.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchFieldComponent = /** @class */ (function () {
    function SearchFieldComponent() {
        this.buttonId = '';
        this.inputId = '';
        this.isDirty = false;
        this.hasActiveSearch = false;
        this.id = this.id ? this.id : 'search-field';
        this.placeholder = '';
        this.search = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SearchFieldComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.buttonId = this.id + "-button";
        this.inputId = this.id + "-input";
        this.searchInputFieldText = '';
        if (this.initialValue) {
            this.hasActiveSearch = true;
            this.searchInputFieldText = this.initialValue;
        }
    };
    /**
     * @return {?}
     */
    SearchFieldComponent.prototype.textChanged = /**
     * @return {?}
     */
    function () {
        this.isDirty = true;
        this.hasActiveSearch = false;
    };
    /**
     * @return {?}
     */
    SearchFieldComponent.prototype.showClear = /**
     * @return {?}
     */
    function () {
        return !this.isDirty && this.hasActiveSearch;
    };
    /**
     * @return {?}
     */
    SearchFieldComponent.prototype.buttonClicked = /**
     * @return {?}
     */
    function () {
        if (this.showClear()) {
            this.doClear();
        }
        else {
            this.doSearch();
        }
    };
    /**
     * @return {?}
     */
    SearchFieldComponent.prototype.doSearch = /**
     * @return {?}
     */
    function () {
        this.hasActiveSearch = true;
        this.isDirty = false;
        this.search.emit(this.searchInputFieldText);
    };
    /**
     * @return {?}
     */
    SearchFieldComponent.prototype.doClear = /**
     * @return {?}
     */
    function () {
        this.searchInputFieldText = '';
        this.hasActiveSearch = false;
        this.isDirty = false;
        this.search.emit(this.searchInputFieldText);
    };
    SearchFieldComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-search-field',
                    template: "<div class=\"input-group search-field\" [class.disabled]=\"disabled\">\n  <input type=\"text\" class=\"form-control\" [placeholder]=\"placeholder\" [(ngModel)]=\"searchInputFieldText\"\n    autocomplete=\"off\" (keydown)=\"textChanged()\" (keydown.enter)=\"doSearch()\" [id]=\"inputId\" [disabled]=\"disabled\">\n  <div class=\"input-group-append\">\n    <sc-button\n      type=\"primary\"\n      [prefixIcon]=\"showClear() ? 'close' : 'white-magnifier'\"\n      [iconOnly]=\"true\"\n      [id]=\"buttonId\"\n      (onClick)=\"buttonClicked()\"\n      [disabled]=\"disabled\"\n    ></sc-button>\n  </div>\n</div>",
                    styles: [".input-group.search-field{border-radius:3px;border:2px solid #0070cc}.input-group.search-field input{border:0;color:#424f66;font-size:14px;font-family:Roboto,sans-serif;font-weight:400;line-height:20px}.input-group.search-field input:disabled{background-color:#edf0f5}.input-group.search-field ::ng-deep .sc-button{border-radius:0}.input-group.search-field ::ng-deep .sc-button.sc-button--icon-only{width:48px}.input-group.search-field ::ng-deep .sc-button.sc-button--icon-only[disabled]{color:#fff;background-color:#ccd2dd}.input-group.search-field:focus-within,.input-group.search-field:hover{border-color:#4393d4}.input-group.search-field:active,.input-group.search-field:focus{border-color:#4393d4}.input-group.search-field.disabled{border-color:#ccd2dd}.input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control{position:relative;flex:1 1 auto;width:1%;margin-bottom:0}.input-group>.form-control:focus{z-index:3}.input-group>.form-control+.form-control{margin-left:-1px}.input-group>.form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group-append{display:flex}.input-group-append .btn{position:relative;z-index:2}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text{margin-left:-1px}"]
                }] }
    ];
    /** @nocollapse */
    SearchFieldComponent.ctorParameters = function () { return []; };
    SearchFieldComponent.propDecorators = {
        id: [{ type: Input }],
        initialValue: [{ type: Input }],
        placeholder: [{ type: Input }],
        disabled: [{ type: Input }],
        search: [{ type: Output }]
    };
    return SearchFieldComponent;
}());
if (false) {
    /** @type {?} */
    SearchFieldComponent.prototype.id;
    /** @type {?} */
    SearchFieldComponent.prototype.initialValue;
    /** @type {?} */
    SearchFieldComponent.prototype.placeholder;
    /** @type {?} */
    SearchFieldComponent.prototype.disabled;
    /** @type {?} */
    SearchFieldComponent.prototype.search;
    /** @type {?} */
    SearchFieldComponent.prototype.searchInputFieldText;
    /** @type {?} */
    SearchFieldComponent.prototype.buttonId;
    /** @type {?} */
    SearchFieldComponent.prototype.inputId;
    /** @type {?} */
    SearchFieldComponent.prototype.isDirty;
    /** @type {?} */
    SearchFieldComponent.prototype.hasActiveSearch;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/search-field/search-field.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchFieldModule = /** @class */ (function () {
    function SearchFieldModule() {
    }
    SearchFieldModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        IconModule,
                        InputModule,
                        ButtonModule,
                        ReactiveFormsModule,
                        FormControlErrorModule
                    ],
                    declarations: [SearchFieldComponent],
                    exports: [SearchFieldComponent]
                },] }
    ];
    return SearchFieldModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/stepper/stepper.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StepperComponent = /** @class */ (function () {
    function StepperComponent() {
        this.steps = [];
        this.stepSelected = new EventEmitter();
    }
    /**
     * @return {?}
     */
    StepperComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        this.setNextStepsDisabled();
        if (this.steps.length > 0) {
            this.steps[this.steps.length - 1].final = true;
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    StepperComponent.prototype.handleClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        if (!this.disableClicks && !item.disabled && !this.disabled) {
            this.setCurrentStep(item);
        }
    };
    /**
     * @param {?} step
     * @return {?}
     */
    StepperComponent.prototype.setCurrentStep = /**
     * @param {?} step
     * @return {?}
     */
    function (step) {
        this.currentStepId = step.id;
        this.stepSelected.emit(step);
        this.setNextStepsDisabled();
    };
    /**
     * @return {?}
     */
    StepperComponent.prototype.setNextStepsDisabled = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.currentStepId) {
            if (this.nextStepsDisabled) {
                /** @type {?} */
                var currentStepIndex_1 = this.steps.findIndex((/**
                 * @param {?} s
                 * @return {?}
                 */
                function (s) { return s.id === _this.currentStepId; }));
                this.steps.forEach((/**
                 * @param {?} item
                 * @param {?} index
                 * @return {?}
                 */
                function (item, index) {
                    if (index > currentStepIndex_1) {
                        if (!item.completed) {
                            item.disabled = true;
                        }
                    }
                }));
            }
        }
    };
    /**
     * @param {?} step
     * @return {?}
     */
    StepperComponent.prototype.setCompletedStep = /**
     * @param {?} step
     * @return {?}
     */
    function (step) {
        /** @type {?} */
        var completedStepIndex = this.steps.findIndex((/**
         * @param {?} s
         * @return {?}
         */
        function (s) { return s.id === step; }));
        this.steps[completedStepIndex].completed = true;
        if (completedStepIndex + 1 !== this.steps.length) {
            this.steps[completedStepIndex + 1].disabled = false;
            this.currentStepId = this.steps[completedStepIndex + 1].id;
        }
    };
    /**
     * @param {?} step
     * @return {?}
     */
    StepperComponent.prototype.completePreviousSteps = /**
     * @param {?} step
     * @return {?}
     */
    function (step) {
        /** @type {?} */
        var stepIndex = this.steps.findIndex((/**
         * @param {?} s
         * @return {?}
         */
        function (s) { return s.id === step; }));
        /** @type {?} */
        var index = 0;
        for (; index < stepIndex; index++) {
            this.steps[index].completed = true;
        }
        this.currentStepId = this.steps[index].id;
    };
    /**
     * @param {?} step
     * @return {?}
     */
    StepperComponent.prototype.setWarningStep = /**
     * @param {?} step
     * @return {?}
     */
    function (step) {
        /** @type {?} */
        var stepIndex = this.steps.findIndex((/**
         * @param {?} s
         * @return {?}
         */
        function (s) { return s.id === step; }));
        this.steps[stepIndex].warning = true;
    };
    StepperComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-stepper',
                    template: "<ul class=\"sc-stepper__list\">\n  <li class=\"sc-stepper__list-item\"\n    *ngFor=\"let step of steps; let i = index;\"\n    [class.no-clickable]=\"disableClicks || step.id === currentStepId || disabled\"\n    [class.disabled]=\"step.disabled || disabled\"\n    [class.warning]=\"step.warning\"\n    [class.completed]=\"step.completed\"\n    [class.final]=\"step.final\"\n    [class.current]=\"step.id === currentStepId\"\n    (click)=\"handleClick(step)\">\n    <div class=\"sc-stepper__list-item-status\">\n      <sc-icon \n        *ngIf=\"step.warning || step.completed || (step.final && step.id === currentStepId); else number\"\n        class=\"sc-stepper__list-item-status-icon\"\n        [icon]=\"step.warning ? 'alert-elipse-copy':'done-rounded-flat'\">\n      </sc-icon>\n      <ng-template #number>\n        <span>{{ i + 1 }}</span>\n      </ng-template>\n    </div>\n    <div class=\"sc-stepper__list-item-title\">{{ step.label }}</div>\n  </li>\n</ul>\n",
                    styles: [".sc-stepper__list{padding:0;list-style:none}.sc-stepper__list-item{align-items:center;border-top:1px solid #d7deed;color:#8993a4;cursor:pointer;display:flex;font-size:16px;font-weight:500;height:48px;line-height:20px;padding:0 16px}.sc-stepper__list-item.no-clickable{cursor:default}.sc-stepper__list-item-status{padding-right:10px;text-align:center;width:40px}.sc-stepper__list-item-status-icon{color:#3dcc98}.sc-stepper__list-item.current{background-color:#fff;border-left:5px solid #3dcc98;padding:0 11px}.sc-stepper__list-item.current.warning{border-left:5px solid #fba344;padding:0 11px}.sc-stepper__list-item.disabled{cursor:default;color:#aeb7c8}.sc-stepper__list-item.warning [class*=-icon]{color:#fba344}.sc-stepper__list-item.final.current [class*=-icon]{color:#fff}.sc-stepper__list-item.final.current.current{color:#fff;background-color:#3dcc98}.sc-stepper__list-item.final.current.current.warning{background-color:#fba344}.sc-stepper__list-item-title{font-size:14px;line-height:24px}"]
                }] }
    ];
    /** @nocollapse */
    StepperComponent.ctorParameters = function () { return []; };
    StepperComponent.propDecorators = {
        steps: [{ type: Input }],
        currentStepId: [{ type: Input }],
        disableClicks: [{ type: Input }],
        nextStepsDisabled: [{ type: Input }],
        disabled: [{ type: Input }],
        stepSelected: [{ type: Output }]
    };
    return StepperComponent;
}());
if (false) {
    /** @type {?} */
    StepperComponent.prototype.steps;
    /** @type {?} */
    StepperComponent.prototype.currentStepId;
    /** @type {?} */
    StepperComponent.prototype.disableClicks;
    /** @type {?} */
    StepperComponent.prototype.nextStepsDisabled;
    /** @type {?} */
    StepperComponent.prototype.disabled;
    /** @type {?} */
    StepperComponent.prototype.stepSelected;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/stepper/stepper.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StepperModule = /** @class */ (function () {
    function StepperModule() {
    }
    StepperModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule
                    ],
                    exports: [StepperComponent],
                    declarations: [StepperComponent]
                },] }
    ];
    return StepperModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/stepper/stepper-step.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function StepperStep() { }
if (false) {
    /** @type {?} */
    StepperStep.prototype.id;
    /** @type {?} */
    StepperStep.prototype.label;
    /** @type {?|undefined} */
    StepperStep.prototype.warning;
    /** @type {?|undefined} */
    StepperStep.prototype.final;
    /** @type {?|undefined} */
    StepperStep.prototype.disabled;
    /** @type {?|undefined} */
    StepperStep.prototype.completed;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/tab/tab.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScTabComponent = /** @class */ (function () {
    function ScTabComponent() {
        this.selectedTabToEmit = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ScTabComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.selectedTab = this.selectedItem ? this.selectedItem : this.items[0];
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ScTabComponent.prototype.handleTabClick = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.selectedTab = item;
        this.selectedTabToEmit.emit(item);
    };
    ScTabComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-tab',
                    template: "<div class=\"col-md-12\">\n  <ul class=\"sc__tab-selector\">\n    <li class=\"sc__tab\" *ngFor=\"let item of items\" [ngClass]=\"{ 'sc__tab--selected': selectedTab.id === item.id }\">\n      <button class=\"sc__tab-button\" (click)=\"handleTabClick(item)\" [disabled]=\"item.disabled\">{{ item.label }}</button>\n    </li>\n  </ul>\n</div>",
                    styles: [".sc__tab{display:inline-block;position:relative}.sc__tab::after{content:\"\";background-color:#025499;width:0%;height:4px;position:absolute;bottom:0;left:0}.sc__tab--selected::after{transition:.3s ease-in;width:100%}.sc__tab-selector{border-bottom:1px solid #e8e8e8;list-style:none;padding:0}.sc__tab-button{color:#424f66;cursor:pointer;font-family:Roboto;font-size:14px;line-height:24px;background:0 0;border:0;overflow:visible;padding:.5rem 1.5rem;text-transform:uppercase;outline:0}.sc__tab-button:disabled{color:#ccd2dd;cursor:default}@media (max-width:767.98px){.sc__tab{display:flex}.sc__tab-selector{display:flex;overflow-y:scroll}}"]
                }] }
    ];
    /** @nocollapse */
    ScTabComponent.ctorParameters = function () { return []; };
    ScTabComponent.propDecorators = {
        items: [{ type: Input }],
        selectedItem: [{ type: Input }],
        selectedTabToEmit: [{ type: Output }]
    };
    return ScTabComponent;
}());
if (false) {
    /** @type {?} */
    ScTabComponent.prototype.items;
    /** @type {?} */
    ScTabComponent.prototype.selectedItem;
    /** @type {?} */
    ScTabComponent.prototype.selectedTabToEmit;
    /** @type {?} */
    ScTabComponent.prototype.selectedTab;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/tab/tab.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScTabModule = /** @class */ (function () {
    function ScTabModule() {
    }
    ScTabModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        ScTabComponent
                    ],
                    declarations: [
                        ScTabComponent
                    ]
                },] }
    ];
    return ScTabModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/textarea/textarea.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CONTROL_VALUE_ACCESSOR$5 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return TextareaComponent; })),
    multi: true
};
var TextareaComponent = /** @class */ (function (_super) {
    __extends(TextareaComponent, _super);
    function TextareaComponent(controlContainer, renderer) {
        var _this = _super.call(this) || this;
        _this.controlContainer = controlContainer;
        _this.renderer = renderer;
        _this.warningText = '';
        _this.characterCounter = 0;
        _this._charCounterMaxLength = undefined;
        _this.latestMaxLengthErrorMessage = '';
        _this.errorMessages = {};
        return _this;
    }
    Object.defineProperty(TextareaComponent.prototype, "charCounterMaxLength", {
        get: /**
         * @return {?}
         */
        function () { return this._charCounterMaxLength; },
        set: /**
         * @param {?} maxLength
         * @return {?}
         */
        function (maxLength) {
            this._charCounterMaxLength = maxLength;
            this.showHideMaxLengthErrorMessage();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TextareaComponent.prototype.getControlContainer = /**
     * @return {?}
     */
    function () {
        return this.controlContainer;
    };
    /**
     * @return {?}
     */
    TextareaComponent.prototype.isCharacterCounterExceeded = /**
     * @return {?}
     */
    function () {
        return this.characterCounter > this.charCounterMaxLength;
    };
    // Control Value Accessor methods
    // Control Value Accessor methods
    /**
     * @param {?} value
     * @return {?}
     */
    TextareaComponent.prototype.writeValue = 
    // Control Value Accessor methods
    /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        _super.prototype.writeValue.call(this, value);
        this.elementRef.nativeElement.value = this.value; // we use this.value, since it has applied all pipes
    };
    /**
     * @protected
     * @return {?}
     */
    TextareaComponent.prototype.initControl = /**
     * @protected
     * @return {?}
     */
    function () {
        _super.prototype.initControl.call(this);
        this.initCharacterCounter();
    };
    /**
     * @private
     * @return {?}
     */
    TextareaComponent.prototype.initCharacterCounter = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.control.value) {
            this.countCharacters(this.control.value);
        }
        /** @type {?} */
        var obs1$ = this.control.valueChanges.pipe(tap((/**
         * @param {?} value
         * @return {?}
         */
        function (value) { return _this.countCharacters(value || ''); })));
        this.subs.push(obs1$.subscribe());
    };
    /**
     * @private
     * @param {?} text
     * @return {?}
     */
    TextareaComponent.prototype.countCharacters = /**
     * @private
     * @param {?} text
     * @return {?}
     */
    function (text) {
        this.characterCounter = text.length;
    };
    /**
     * @private
     * @return {?}
     */
    TextareaComponent.prototype.showHideMaxLengthErrorMessage = /**
     * @private
     * @return {?}
     */
    function () {
        if (this._charCounterMaxLength) {
            this.latestMaxLengthErrorMessage = this.errorMessages['maxlength'] || this.latestMaxLengthErrorMessage;
            this.errorMessages['maxlength'] = '';
        }
        else {
            this.errorMessages['maxlength'] = this.latestMaxLengthErrorMessage || errorMessages.maxlength;
        }
        this.errorMessages = __assign({}, this.errorMessages);
    };
    TextareaComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-textarea',
                    template: "<div class=\"sc-textarea\" [class.sc-textarea--with-icon]=\"!!icon\">\n    <label\n      class=\"sc-textarea__label\"\n      *ngIf=\"label\" [attr.for]=\"id ? id+'__textarea' : null\"\n      [class.sc-textarea__label--floating]=\"!!value\"\n      [class.label--focus]=\"hasFocus\"\n      [class.sc-text-area__label--floating-has-error]=\"hasError\"\n    >{{ label }}</label>\n    <div class=\"sc-textarea__textarea-group\">\n        <textarea\n            #elementRef\n            class=\"sc-textarea__native-textarea\"\n            [class.has-error]=\"hasError\"\n            [disabled]=\"isDisabled\"\n            [attr.id]=\"id ? id+'__textarea' : null\"\n            [attr.inputmode]=\"inputmode\"\n            [placeholder]=\"(placeholder ? placeholder : '')\"\n            [readonly]=\"readonly\"\n            (blur)=\"onBlur($event)\"\n            (focus)=\"onFocus($event)\"\n            (input)=\"onInput($event)\"\n            [attr.maxLength]=\"maxlength\"\n            [rows]=\"rows\"\n            [cols]=\"cols\"\n        >{{value}}</textarea>\n\n        <ng-container *ngIf=\"!!icon\">\n            <sc-icon [icon]=\"icon\" *ngIf=\"!iconClickHandler\"></sc-icon>\n            <sc-icon [icon]=\"icon\" *ngIf=\"iconClickHandler\" (click)=\"iconClickHandler.subscribe()\"></sc-icon>\n        </ng-container>\n    </div>\n    <div class=\"sc-textarea__messages\">\n      <div *ngIf=\"!!charCounterMaxLength && !warningText\"\n           class=\"sc-textarea__char-counter\"\n           [ngClass]=\"{ 'sc-textarea__char-counter_error': isCharacterCounterExceeded() }\">\n        {{ characterCounter }}/{{ charCounterMaxLength }} caracteres\n      </div>\n      <div *ngIf=\"!!warningText\" [innerHTML]=\"warningText\"></div>\n    </div>\n    <sc-form-control-error\n      [errorMessages]=\"errorMessages\"\n      [control]=\"control\"\n      [hasError]=\"hasError\"\n      [hidden]=\"hideError\"\n      [debounceTime]=\"debounceTime\">\n    </sc-form-control-error>\n</div>\n",
                    providers: [CONTROL_VALUE_ACCESSOR$5],
                    styles: [".base-text-input__label,:host(.floating-label) .sc-textarea__label{pointer-events:none;position:absolute;top:13px;left:15px;transition:.1s ease-in-out;z-index:2;font-size:1rem;opacity:0}.base-text-input__label--floating,:host(.floating-label) .sc-textarea__label--floating{top:-8px;left:15px;font-size:.875rem;background-color:#fff;padding:0 5px;display:block;opacity:1}.sc-textarea{margin-bottom:.25rem}.sc-textarea--with-icon textarea{padding-right:3rem}.sc-textarea__native-textarea{width:100%;font-family:Roboto,sans-serif;font-size:16px;border-radius:3px;border-color:#ccd2dd}.sc-textarea__native-textarea:focus{border-color:#0070cc;outline:0}.sc-textarea__native-textarea.has-error{border:1px solid #dc3545}.sc-textarea__textarea-group{position:relative;display:inline-block;width:100%}.sc-textarea__textarea-group sc-icon{position:absolute;right:1rem;top:.5rem}.sc-textarea__messages{text-align:right;font-size:.875rem;color:#8993a4}.sc-textarea__char-counter_error{color:#dc3545}.sc-textarea [readonly]{background-color:#e0e5ed;border-color:#ccd2dd}.sc-textarea .texts,.sc-textarea :-ms-input-placeholder,.sc-textarea ::-ms-input-placeholder,.sc-textarea ::-webkit-input-placeholder{color:#aeb7c8!important;font-family:Roboto,sans-serif!important;font-size:14px!important;line-height:24px!important}.sc-textarea .texts,.sc-textarea :-ms-input-placeholder,.sc-textarea ::-webkit-input-placeholder,.sc-textarea ::placeholder{color:#aeb7c8!important;font-family:Roboto,sans-serif!important;font-size:14px!important;line-height:24px!important}@media (min-width:768px){.sc-textarea__native-textarea{font-size:14px}}:host(.floating-label) .sc-textarea{position:relative;margin-top:.5rem}:host(.floating-label) .sc-textarea__label--floating-has-error{color:#dc3545}:host(.floating-label) .sc-textarea__label--floating-has-error.label--focus{color:#dc3545}:host(.floating-label) .label--focus{color:#0070cc}"]
                }] }
    ];
    /** @nocollapse */
    TextareaComponent.ctorParameters = function () { return [
        { type: ControlContainer, decorators: [{ type: Host }, { type: SkipSelf }, { type: Optional }] },
        { type: Renderer2 }
    ]; };
    TextareaComponent.propDecorators = {
        cols: [{ type: Input }],
        charCounterMaxLength: [{ type: Input }],
        rows: [{ type: Input }],
        warningText: [{ type: Input }]
    };
    return TextareaComponent;
}(BaseTextInputComponent));
if (false) {
    /** @type {?} */
    TextareaComponent.prototype.cols;
    /** @type {?} */
    TextareaComponent.prototype.rows;
    /** @type {?} */
    TextareaComponent.prototype.warningText;
    /** @type {?} */
    TextareaComponent.prototype.characterCounter;
    /**
     * @type {?}
     * @private
     */
    TextareaComponent.prototype._charCounterMaxLength;
    /**
     * @type {?}
     * @private
     */
    TextareaComponent.prototype.latestMaxLengthErrorMessage;
    /**
     * @type {?}
     * @private
     */
    TextareaComponent.prototype.controlContainer;
    /**
     * @type {?}
     * @private
     */
    TextareaComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/textarea/textarea.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TextareaModule = /** @class */ (function () {
    function TextareaModule() {
    }
    TextareaModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        IconModule,
                        FormControlErrorModule
                    ],
                    declarations: [TextareaComponent],
                    exports: [TextareaComponent]
                },] }
    ];
    return TextareaModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/tooltip-input-decorator/tooltip-input-decorator.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TooltipInputDecoratorComponent = /** @class */ (function () {
    function TooltipInputDecoratorComponent() {
        this.placement = 'auto';
        this.openOnFocus = false;
        this.binding = true;
        this.forceOpen = false;
    }
    /**
     * @return {?}
     */
    TooltipInputDecoratorComponent.prototype.onFocusIn = /**
     * @return {?}
     */
    function () {
        this.forceOpen = this.openOnFocus;
    };
    /**
     * @return {?}
     */
    TooltipInputDecoratorComponent.prototype.onFocusOut = /**
     * @return {?}
     */
    function () {
        this.forceOpen = this.openOnFocus && false;
    };
    TooltipInputDecoratorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-tooltip-input-decorator',
                    template: "<ng-content>\n</ng-content>\n\n<div class=\"tooltip-icon-placeholder\"\n     [tooltip]=\"tooltipText || tooltipTemplate\"\n     [isOpen]=\"forceOpen\"\n     [placement]=\"placement\">\n</div>\n",
                    encapsulation: ViewEncapsulation.None,
                    styles: [".tooltip-input-decorator{position:relative;display:block}.tooltip-input-decorator .tooltip-inner{background-color:#fff;border:1px solid #aeb7c8;border-radius:2px;box-shadow:0 2px 4px 0 rgba(0,28,51,.06);color:#424f66;font-size:.875rem;max-width:350px;padding:1rem 1.5rem;text-align:center}.tooltip-input-decorator .tooltip.show{opacity:1}.tooltip-input-decorator .tooltip.bottom .tooltip-arrow::before,.tooltip-input-decorator .tooltip.top .tooltip-arrow::before{border-width:.5rem .75rem}.tooltip-input-decorator .tooltip.left .tooltip-arrow::before,.tooltip-input-decorator .tooltip.right .tooltip-arrow::before{border-width:.75rem .5rem}.tooltip-input-decorator .tooltip.top .tooltip-arrow::before{border-top-color:#aeb7c8}.tooltip-input-decorator .tooltip.left .tooltip-arrow::before{border-left-color:#aeb7c8}.tooltip-input-decorator .tooltip.bottom .tooltip-arrow::before{border-bottom-color:#aeb7c8}.tooltip-input-decorator .tooltip.right .tooltip-arrow::before{border-right-color:#aeb7c8}.tooltip-icon-placeholder{height:2.5rem;position:absolute;right:0;top:0;width:3rem}.tooltip-icon-placeholder:hover{cursor:pointer}@media (max-width:768px){.tooltip-input-decorator .tooltip-inner{max-width:200px;padding:.25rem}}"]
                }] }
    ];
    TooltipInputDecoratorComponent.propDecorators = {
        tooltipText: [{ type: Input }],
        tooltipTemplate: [{ type: Input }],
        placement: [{ type: Input }],
        openOnFocus: [{ type: Input }],
        binding: [{ type: HostBinding, args: ['class.tooltip-input-decorator',] }],
        onFocusIn: [{ type: HostListener, args: ['focusin',] }],
        onFocusOut: [{ type: HostListener, args: ['focusout',] }]
    };
    return TooltipInputDecoratorComponent;
}());
if (false) {
    /** @type {?} */
    TooltipInputDecoratorComponent.prototype.tooltipText;
    /** @type {?} */
    TooltipInputDecoratorComponent.prototype.tooltipTemplate;
    /** @type {?} */
    TooltipInputDecoratorComponent.prototype.placement;
    /** @type {?} */
    TooltipInputDecoratorComponent.prototype.openOnFocus;
    /** @type {?} */
    TooltipInputDecoratorComponent.prototype.binding;
    /** @type {?} */
    TooltipInputDecoratorComponent.prototype.forceOpen;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/tooltip-input-decorator/tooltip-input-decorator.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TooltipInputDecoratorModule = /** @class */ (function () {
    function TooltipInputDecoratorModule() {
    }
    TooltipInputDecoratorModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [TooltipInputDecoratorComponent],
                    imports: [
                        CommonModule,
                        TooltipModule.forRoot()
                    ],
                    exports: [TooltipInputDecoratorComponent]
                },] }
    ];
    return TooltipInputDecoratorModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/box/box.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BoxComponent = /** @class */ (function () {
    function BoxComponent() {
        this.type = 'info';
    }
    BoxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-box',
                    template: "<div class=\"sc-box\" [ngClass]=\"{'sc-box_error': type=='error'}\">\n    <ng-container [ngSwitch]=\"type\">\n        <sc-icon *ngSwitchCase=\"'info'\" class=\"sc-box__icon\" icon=\"alert-elipse-copy\"></sc-icon>\n        <sc-icon *ngSwitchCase=\"'error'\" class=\"sc-box__icon sc-box__icon_error\" icon=\"close-elipse\"></sc-icon>\n    </ng-container>\n    <div class=\"sc-box__text\" [innerHtml]=\"content\"></div>\n</div>\n",
                    styles: [".sc-box{display:flex;flex-direction:row;border-radius:3px;background-color:#e0e5ed;padding:1rem}.sc-box__icon{color:#0070cc;margin:0 .5rem}.sc-box__icon_error{color:#de350b}.sc-box__text{font-family:Roboto,\"Open Sans\",sans-serif;font-size:.875rem}.sc-box_error__icon{color:#de350b}"]
                }] }
    ];
    /** @nocollapse */
    BoxComponent.ctorParameters = function () { return []; };
    BoxComponent.propDecorators = {
        content: [{ type: Input }],
        type: [{ type: Input }]
    };
    return BoxComponent;
}());
if (false) {
    /** @type {?} */
    BoxComponent.prototype.content;
    /** @type {?} */
    BoxComponent.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/box/box.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BoxModule = /** @class */ (function () {
    function BoxModule() {
    }
    BoxModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule
                    ],
                    declarations: [
                        BoxComponent
                    ],
                    exports: [BoxComponent]
                },] }
    ];
    return BoxModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/uploader/file-size-pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScFileSizePipe = /** @class */ (function () {
    function ScFileSizePipe() {
        this.units = [
            'bytes',
            'KB',
            'MB',
            'GB',
            'TB',
            'PB'
        ];
    }
    /**
     * @param {?=} bytes
     * @param {?=} precision
     * @return {?}
     */
    ScFileSizePipe.prototype.transform = /**
     * @param {?=} bytes
     * @param {?=} precision
     * @return {?}
     */
    function (bytes, precision) {
        if (bytes === void 0) { bytes = 0; }
        if (precision === void 0) { precision = 2; }
        if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
            return '?';
        }
        /** @type {?} */
        var unit = 0;
        while (bytes >= 1024) {
            bytes /= 1024;
            unit++;
        }
        return bytes.toFixed(+precision) + ' ' + this.units[unit];
    };
    ScFileSizePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'fileSize',
                    pure: false
                },] }
    ];
    return ScFileSizePipe;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ScFileSizePipe.prototype.units;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/uploader/uploader.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UploaderService = /** @class */ (function () {
    function UploaderService(api) {
        this.api = api;
        this.destination = '';
        this.cancel$ = new Subject$1();
    }
    /**
     * @param {?} file
     * @param {?=} owner
     * @return {?}
     */
    UploaderService.prototype.uploadFile = /**
     * @param {?} file
     * @param {?=} owner
     * @return {?}
     */
    function (file, owner) {
        /** @type {?} */
        var fileName = file.name;
        /** @type {?} */
        var input = new FormData();
        input.append('file', file, fileName);
        return this.api.post(this.destination, input).pipe(takeUntil(this.cancel$.pipe(filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item === fileName; })))));
    };
    /**
     * @param {?} fileName
     * @param {?=} owner
     * @return {?}
     */
    UploaderService.prototype.deleteFile = /**
     * @param {?} fileName
     * @param {?=} owner
     * @return {?}
     */
    function (fileName, owner) {
        return this.api.delete(this.destination + fileName);
    };
    /**
     * @param {?} item
     * @param {?=} owner
     * @return {?}
     */
    UploaderService.prototype.cancelFile = /**
     * @param {?} item
     * @param {?=} owner
     * @return {?}
     */
    function (item, owner) {
        this.cancel$.next(item.name);
    };
    /**
     * @param {?} fileName
     * @return {?}
     */
    UploaderService.prototype.getImageEncodedURI = /**
     * @param {?} fileName
     * @return {?}
     */
    function (fileName) {
        return encodeURI(this.destination + fileName);
    };
    UploaderService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    UploaderService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    return UploaderService;
}());
if (false) {
    /** @type {?} */
    UploaderService.prototype.destination;
    /**
     * @type {?}
     * @private
     */
    UploaderService.prototype.cancel$;
    /**
     * @type {?}
     * @private
     */
    UploaderService.prototype.api;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/uploader/uploader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UploaderComponent = /** @class */ (function () {
    function UploaderComponent(uploaderService) {
        this.uploaderService = uploaderService;
        this.initialFiles = [];
        this.maxFiles = 1;
        // any extra data can be used here
        this.placeholder = '';
        this.subtitle = '';
        this.title = 'Subir archivos';
        this.itemsChanged = new EventEmitter(true);
        this.hasCancel = false;
        this.isLoading = false;
        this.errorMessage = null;
        this.multiple = true;
        this.errorInfoDisappearsTimeOut = 4000;
        this.addButtonText = 'Seleccionar archivo';
        this.extensionAllowed = 'image/x-png,image/jpg,image/jpeg';
        this.extensionErrorMessage = 'Formato no válido';
        this.fileMaxSizeErrorMessage = '';
        this.items = this.items || [];
        this.loadingText = 'Cargando...';
        this.shouldShowImageThumbnail = true;
        this.showLabel = true;
        this.uploadErrorMessage = 'Error al subir';
        this.view = 'thumbnail'; // thumbnail | list | simple
    }
    /**
     * @return {?}
     */
    UploaderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.hasCancel = !!this.uploaderService.cancelFile;
        this.items = this.initialFiles.filter((/**
         * @param {?} file
         * @return {?}
         */
        function (file) { return _this.isFileExtensionAllowed(file); })).map((/**
         * @param {?} file
         * @return {?}
         */
        function (file) {
            /** @type {?} */
            var imageUrl = file.url || _this.uploaderService.getImageEncodedURI(file.name);
            /** @type {?} */
            var isImage = _this.isImage(file);
            return {
                size: file.size,
                errorMessage: '',
                loading: false,
                name: file.name,
                retry: false,
                thumbnail: file.thumbnail || _this.getThumbnail(file, imageUrl),
                thumbnailLoading: _this.shouldShowImageThumbnail && isImage,
                type: file.type,
                typeImage: isImage
            };
        }));
        this.itemsChanged.emit(this.items);
    };
    /**
     * @param {?} change
     * @return {?}
     */
    UploaderComponent.prototype.ngOnChanges = /**
     * @param {?} change
     * @return {?}
     */
    function (change) {
        if (change.maxFiles) {
            if (change.maxFiles.currentValue === undefined || change.maxFiles.currentValue == null) {
                this.multiple = true;
            }
            else {
                this.multiple = change.maxFiles.currentValue > 1;
            }
        }
    };
    /**
     * @param {?} list
     * @param {?} loading
     * @return {?}
     */
    UploaderComponent.prototype.loadingList = /**
     * @param {?} list
     * @param {?} loading
     * @return {?}
     */
    function (list, loading) {
        return list ? list.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.loading === loading; })) : [];
    };
    /**
     * @param {?} fileInput
     * @return {?}
     */
    UploaderComponent.prototype.fileEvent = /**
     * @param {?} fileInput
     * @return {?}
     */
    function (fileInput) {
        this.loadingText = 'Cargando...';
        /** @type {?} */
        var files = fileInput.target.files;
        if (files && files[0]) {
            if (this.multiple && this.items.length + files.length > this.maxFiles) {
                this.setErrorMaxUpload();
                return;
            }
            /** @type {?} */
            var limit = Math.min(files.length, this.maxFiles - this.items.length);
            for (var i = 0; i < limit; i++) {
                /** @type {?} */
                var file = files[i];
                /** @type {?} */
                var fileName = this.getFileName(file.name);
                /** @type {?} */
                var newFile = (file.name === fileName) ? file : new File([file], fileName, { type: file.type });
                this.loadFile(newFile);
            }
        }
        this.fileInput.nativeElement.value = '';
    };
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    UploaderComponent.prototype.loadFile = /**
     * @private
     * @param {?} file
     * @return {?}
     */
    function (file) {
        var _this = this;
        /** @type {?} */
        var reader = new FileReader();
        reader.onload = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.isLoading = true;
            /** @type {?} */
            var fileSource = event.target['result'];
            /** @type {?} */
            var item = {
                errorMessage: _this.getErrorMessage(file),
                file: file,
                loading: true,
                name: file.name,
                retry: false,
                size: file.size,
                thumbnail: _this.getThumbnail(file, fileSource),
                thumbnailLoading: false,
                type: file.type,
                typeImage: _this.isImage(file)
            };
            _this.items.push(item);
            if (!item.errorMessage) {
                _this.uploadFile(item);
            }
            else {
                item.loading = false;
                _this.hasError = true;
                _this.setLoading(false);
                _this.itemsChanged.emit(_this.items);
            }
        });
        if (typeof file === 'object') {
            reader.readAsDataURL(file);
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    UploaderComponent.prototype.uploadFile = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var _this = this;
        this.resetErrorStatus();
        this.uploaderService.uploadFile(item.file, this)
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            item.loading = false;
            item.retry = false;
            item.name = response.name || item.file.name;
            item.size = response.size || item.size;
            _this.itemsChanged.emit(_this.items);
            _this.setLoading(false);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            item.loading = false;
            item.retry = true;
            item.errorMessage = _this.uploadErrorMessage;
            _this.itemsChanged.emit(_this.items);
            _this.hasError = true;
            _this.setLoading(false);
            console.error(err);
        }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    UploaderComponent.prototype.retryUploadFile = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        item.errorMessage = '';
        item.loading = true;
        item.retry = false;
        this.uploadFile(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    UploaderComponent.prototype.deleteFile = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var _this = this;
        this.loadingText = 'Eliminando...';
        /** @type {?} */
        var itemPosition = this.items.indexOf(item);
        item.loading = true;
        item.isDelete = true;
        this.resetErrorStatus();
        if (!item.errorMessage && !item.retry) {
            this.uploaderService.deleteFile(item.name, this).subscribe((/**
             * @return {?}
             */
            function () {
                _this.items.splice(itemPosition, 1);
                _this.resetErrorStatus();
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                item.errorMessage = 'Error al eliminar';
                _this.hasError = true;
                console.error(err);
            })).add((/**
             * @return {?}
             */
            function () {
                item.loading = false;
                _this.itemsChanged.emit(_this.items);
            }));
        }
        else {
            item.loading = false;
            this.items.splice(itemPosition, 1);
            this.itemsChanged.emit(this.items);
            this.resetErrorStatus();
        }
    };
    /**
     * @param {?} item
     * @return {?}
     */
    UploaderComponent.prototype.cancelFile = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.uploaderService.cancelFile(item, this);
        this.deleteFile(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    UploaderComponent.prototype.handleThumbnailLoad = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        item.thumbnailLoading = false;
    };
    /**
     * @private
     * @param {?} file
     * @param {?} fileSource
     * @return {?}
     */
    UploaderComponent.prototype.getThumbnail = /**
     * @private
     * @param {?} file
     * @param {?} fileSource
     * @return {?}
     */
    function (file, fileSource) {
        return (this.isImage(file)) ? fileSource : this.fileTypeDocThumbnailImageUrl;
    };
    /**
     * @private
     * @param {?} fileName
     * @return {?}
     */
    UploaderComponent.prototype.getFileName = /**
     * @private
     * @param {?} fileName
     * @return {?}
     */
    function (fileName) {
        /** @type {?} */
        var counter = 0;
        /** @type {?} */
        var newFileName = fileName;
        /** @type {?} */
        var suffix = '';
        /** @type {?} */
        var fileExtension = '.' + this.getFileExtension(fileName);
        /** @type {?} */
        var name = fileName.slice(0, fileName.indexOf(fileExtension));
        /** @type {?} */
        var exist = this.items.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.name === fileName; })).length;
        while (exist) {
            counter++;
            suffix = '(' + counter + ')';
            newFileName = name + ' ' + suffix + fileExtension;
            exist = this.items.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return item.name === newFileName; })).length;
        }
        return newFileName;
    };
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    UploaderComponent.prototype.getErrorMessage = /**
     * @private
     * @param {?} file
     * @return {?}
     */
    function (file) {
        /** @type {?} */
        var errorMessage = '';
        if (this.fileMaxSizeBytes && this.fileMaxSizeBytes < file.size) {
            errorMessage = this.fileMaxSizeErrorMessage;
        }
        if (this.extensionErrorMessage && !this.isFileExtensionAllowed(file)) {
            errorMessage = this.extensionErrorMessage;
        }
        return errorMessage;
    };
    /**
     * @param {?} fileName
     * @return {?}
     */
    UploaderComponent.prototype.getFileExtension = /**
     * @param {?} fileName
     * @return {?}
     */
    function (fileName) {
        return fileName.substr(fileName.lastIndexOf('.') + 1);
    };
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    UploaderComponent.prototype.isImage = /**
     * @private
     * @param {?} file
     * @return {?}
     */
    function (file) {
        /** @type {?} */
        var supportedImageTypes = [
            'image/gif',
            'image/png',
            'image/x-png',
            'image/jpg',
            'image/jpeg'
        ].join();
        /** @type {?} */
        var supportedImageExtensions = [
            '.gif',
            '.png',
            '.jpg',
            '.jpeg'
        ].join();
        /** @type {?} */
        var fileExtension = this.getFileExtension(file.name.toLowerCase());
        return file.type && ((supportedImageTypes.indexOf(file.type) !== -1) || (supportedImageExtensions.indexOf(fileExtension) !== -1));
    };
    /**
     * @return {?}
     */
    UploaderComponent.prototype.getAcceptType = /**
     * @return {?}
     */
    function () {
        return !this.isAnyTypeAllowed() ? this.extensionAllowed : '';
    };
    /**
     * @private
     * @param {?} file
     * @return {?}
     */
    UploaderComponent.prototype.isFileExtensionAllowed = /**
     * @private
     * @param {?} file
     * @return {?}
     */
    function (file) {
        return this.isAnyTypeAllowed() || (file.type && this.extensionAllowed.toLowerCase().indexOf(file.type.toLowerCase()) !== -1);
    };
    /**
     * @private
     * @return {?}
     */
    UploaderComponent.prototype.isAnyTypeAllowed = /**
     * @private
     * @return {?}
     */
    function () {
        return this.extensionAllowed === '*/*';
    };
    /**
     * @param {?} fileName
     * @return {?}
     */
    UploaderComponent.prototype.getFileNameWithoutExt = /**
     * @param {?} fileName
     * @return {?}
     */
    function (fileName) {
        return fileName.substr(0, fileName.lastIndexOf('.'));
    };
    /**
     * @return {?}
     */
    UploaderComponent.prototype.browseFileInput = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var element = (/** @type {?} */ (document.querySelector('#sc-uploader-' + this.id)));
        element.click();
    };
    /**
     * @private
     * @return {?}
     */
    UploaderComponent.prototype.resetErrorStatus = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.items.some((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return !!item.errorMessage; }))) {
            return;
        }
        this.hasError = false;
    };
    /**
     * @private
     * @return {?}
     */
    UploaderComponent.prototype.setErrorMaxUpload = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.hasError = this.hasErrorMessage = true;
        this.errorMessage = "No podemos procesar tantos archivos, "
            + ("por favor seleccion\u00E1 hasta " + this.maxFiles + " archivos.");
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.hasErrorMessage = false;
            _this.resetErrorStatus();
        }), this.errorInfoDisappearsTimeOut);
    };
    /**
     * @private
     * @param {?} isLoading
     * @return {?}
     */
    UploaderComponent.prototype.setLoading = /**
     * @private
     * @param {?} isLoading
     * @return {?}
     */
    function (isLoading) {
        if (this.items.some((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.loading; }))) {
            return;
        }
        this.isLoading = isLoading;
    };
    UploaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-uploader',
                    template: "<div class=\"sc-uploader\" [ngClass]=\"{\n        'sc-uploader_status': view == 'list',\n        'sc-uploader_status_valid': items.length > 0,\n        'sc-uploader_status_invalid': hasError\n        }\">\n    <div *ngIf=\"showLabel\" class=\"sc-uploader__images-loaded-label\">\n        <span *ngIf=\"maxFiles > 1 && loadingList(items,false).length\">\n            {{loadingList(items,false).length}} foto{{loadingList(items,false).length > 1 ? 's' : ''}} cargada{{loadingList(items,false).length > 1 ? 's' : ''}}:\n        </span>\n    </div>\n    <div class=\"sc-uploader__thumbnail-container\" *ngIf=\"view=='thumbnail'\">\n        <div *ngFor=\"let item of items; let i = index;\" class=\"sc-uploader__image-item\">\n            <div class=\"sc-uploader__image-container\">\n                <div class=\"sc-uploader__thumbnail-loading\" *ngIf=\"!item.errorMessage && (item.loading || item.thumbnailLoading)\"></div>\n                <sc-icon class=\"sc-uploader__thumbnail-loading-icon\" icon=\"loading\" *ngIf=\"!item.errorMessage && (item.loading || item.thumbnailLoading)\"></sc-icon>\n                <div class=\"sc-uploader__thumbnail-error\" *ngIf=\"item.errorMessage\">\n                    <span class=\"sc-uploader__thumbnail-error-message text-truncate\">{{item.errorMessage}}</span>\n                </div>\n                <sc-icon class=\"sc-uploader__thumbnail-error-icon\" icon=\"close-elipse\" *ngIf=\"item.errorMessage\"></sc-icon>\n                <img alt=\"Imagen subida\" class=\"sc-uploader__thumbnail-image\" *ngIf=\"!item.errorMessage\" [src]=\"item.thumbnail\" (load)=\"handleThumbnailLoad(item)\">\n            </div>\n            <div class=\"sc-uploader__image-name text-truncate\">{{item.name}}</div>\n            <div class=\"sc-uploader__image-detail\">\n                <div class=\"sc-uploader__image-size text-truncate\">\n                    <span *ngIf=\"item.size\">{{item.size | fileSize}}</span>\n                </div>\n                <sc-icon *ngIf=\"!item.loading && item.retry\" class=\"sc-uploader__retry-icon\" icon=\"refresh\" (click)=\"retryUploadFile(item)\"></sc-icon>\n                <sc-icon *ngIf=\"!item.loading\" class=\"sc-uploader__delete-icon\" icon=\"trash\" (click)=\"deleteFile(item)\"></sc-icon>\n            </div>\n        </div>\n    </div>\n    <div class=\"sc-uploader__header header-box\" *ngIf=\"view=='list'\">\n        <div class=\"header-box__title\">{{title}}</div>\n        <div class=\"header-box__subtitle\">{{subtitle}}</div>\n        <div class=\"header-box__button\">\n            <button\n                id=\"btn-upload-{{id}}\"\n                class=\"sc-upload-button\"\n                (click)=\"fileInput.click() && $event.stopPropagation()\"\n                [disabled]=\"disabled || items.length >= maxFiles\">\n                {{addButtonText}}\n            </button>\n        </div>\n    </div>\n\n    <div class=\"sc-uploader__info\" *ngIf=\"view=='list' && info\">\n        <sc-box type='info' [content]=\"info\"></sc-box>\n    </div>\n\n    <div class=\"sc-uploader__list-container\" *ngIf=\"view=='list'\">\n        <div *ngFor=\"let item of items.slice().reverse(); let i = index;\" class=\"sc-uploader__item d-flex\" [ngClass]=\"{'sc-uploader__item--document': !item.typeImage, 'sc-uploader__item--errored': item.errorMessage, 'sc-uploader__item--multiple': multiple}\">\n            <div class=\"sc-uploader__item-left d-flex align-items-center justify-content-center\">\n                <div class=\"sc-uploader__thumbnail-loading\" *ngIf=\"!item.errorMessage && (item.loading || item.thumbnailLoading)\"></div>\n                <sc-icon class=\"sc-uploader__thumbnail-loading-icon\" icon=\"loading\" *ngIf=\"!item.errorMessage && (item.loading || item.thumbnailLoading)\"></sc-icon>\n                <div class=\"sc-uploader__thumbnail-error\" *ngIf=\"item.errorMessage\">\n                    <sc-icon class=\"sc-uploader__thumbnail-error-icon\" icon=\"close-elipse\"></sc-icon>\n                </div>\n                <div class=\"sc-uploader__thumbnail-file\" *ngIf=\"!item.typeImage\">\n                    <sc-icon [icon]=\"item.type === 'application/pdf' ? 'pdf-document' : 'uniE91D'\" size=\"1_5\"></sc-icon>\n                </div>\n                <img alt=\"Imagen Subida\" class=\"sc-uploader__thumbnail-image\" *ngIf=\"shouldShowImageThumbnail && item.typeImage\" [src]=\"item.thumbnail\" (load)=\"handleThumbnailLoad(item)\">\n            </div>\n            <div class=\"sc-uploader__item-center text-truncate\">\n                <div class=\"align-self-center text-truncate\">\n                    <p class=\"sc-uploader__item-center-title m-0\">\n                        <span class=\"text-truncate\">{{getFileNameWithoutExt(item.name)}}</span>.{{getFileExtension(item.name)}}\n                    </p>\n                    <p class=\"sc-uploader__item-center-size m-0 text-truncate\" *ngIf=\"!item.errorMessage\">\n                        <span *ngIf=\"item.size && !item.loading\">{{item.size | fileSize}}</span>\n                        <span *ngIf=\"item.loading\">{{loadingText}}</span>\n                    </p>\n                    <p class=\"sc-uploader__item-center-error-message m-0 text-truncate\" *ngIf=\"item.errorMessage\">\n                        <span class=\"sc-uploader__item-center-error-message-info\">{{item.size | fileSize}} -</span> {{item.errorMessage}}\n                    </p>\n                </div>\n            </div>\n            <div class=\"sc-uploader__item-right\">\n                <div class=\"sc-uploader__image-detail\" [ngClass]=\"{ 'sc-uploader__image-detail_disabled': disabled }\">\n                    <sc-icon *ngIf=\"!item.loading && item.retry\" class=\"sc-uploader__retry-icon\" icon=\"refresh\" (click)=\"retryUploadFile(item)\"></sc-icon>\n                    <sc-icon *ngIf=\"!item.loading\" class=\"sc-uploader__delete-icon\" icon=\"trash\" (click)=\"deleteFile(item)\"></sc-icon>\n                    <sc-icon *ngIf=\"hasCancel && item.loading && !item.isDelete\" class=\"sc-uploader__cancel-icon\" icon=\"close\" (click)=\"cancelFile(item)\"></sc-icon>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"sc-uploader__simple\" *ngIf=\"view=='simple'\">\n        <sc-button\n            class=\"mt-1\"\n            type=\"link-secondary\"\n            [id]=\"'sc-button-upload-'+id\"\n            (onClick)=\"fileInput.click() && $event.stopPropagation()\"\n            [disabled]=\"disabled\"\n            [loading]=\"isLoading\">\n            {{addButtonText}}\n        </sc-button>\n    </div>\n\n    <div class=\"sc-uploader__error\" [ngClass]=\"{ 'sc-uploader__error_show': hasErrorMessage }\" *ngIf=\"multiple\">\n        <sc-box type=\"error\" content=\"{{errorMessage}}\"></sc-box>\n    </div>\n    <sc-button class=\"mt-1\" [id]=\"'sc-button-upload-'+id\" type=\"secondary\" (onClick)=\"fileInput.click() && $event.stopPropagation()\" *ngIf=\"(!maxFiles || items && items.length < maxFiles) && view === 'thumbnail'\">\n        {{addButtonText}}\n    </sc-button>\n    <input id=\"sc-uploader-{{id}}\" hidden tabindex=\"-1\" [disabled]=\"disabled\" #fileInput [accept]=\"getAcceptType()\" type=\"file\" [placeholder]=\"placeholder\" (change)=\"fileEvent($event)\" [multiple]=\"multiple\"/>\n</div>\n",
                    styles: [".sc-uploader__thumbnail-error,.sc-uploader__thumbnail-loading{height:100%;position:absolute;width:100%;left:0;top:0}.sc-uploader__thumbnail-error-icon,.sc-uploader__thumbnail-loading-icon{font-size:30px}.sc-uploader__thumbnail-loading{background-color:#fff;opacity:.7}.sc-uploader__thumbnail-loading-icon{color:#0070cc;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.sc-uploader__thumbnail-error{background-color:#edf0f5;border-radius:2px;border:1.5px solid #de350b;text-align:center}.sc-uploader__thumbnail-error-icon{color:#de350b;left:49px;position:relative;top:18px}.sc-uploader__thumbnail-error-message{color:#424f66;display:inline-block;position:relative;top:58px;width:100%}.sc-uploader__images-loaded-Label{color:#424f66;font:400 1rem/1.5rem Roboto,\"Open Sans\",sans-serif}.sc-uploader__cancel-icon,.sc-uploader__delete-icon,.sc-uploader__retry-icon{cursor:pointer}.sc-uploader__thumbnail-container{display:flex;flex-basis:33px;flex-flow:row;flex-wrap:wrap;list-style:none;margin-left:-8px;margin-right:-8px;padding:0}.sc-uploader__thumbnail-container .sc-uploader__image-item{font-size:14px;height:160px;margin:0 8px 16px;position:relative;white-space:nowrap;width:128px}.sc-uploader__thumbnail-container .sc-uploader__image-name{color:#424f66;font:400 .875rem/1 Roboto,\"Open Sans\",sans-serif;height:24px;margin-top:16px;padding-right:10px}.sc-uploader__thumbnail-container .sc-uploader__image-detail{align-items:center;color:#0070cc;display:flex;font-size:16px;height:24px;justify-content:space-between;padding-right:10px}.sc-uploader__thumbnail-container .sc-uploader__image-size{color:#8993a4;display:inline-flex;font:400 .75rem/1 Roboto,\"Open Sans\",sans-serif}.sc-uploader__thumbnail-container .sc-uploader__image-container{display:flex;height:96px;position:relative;width:100%;text-align:center;background:#e0e5ed;overflow:hidden}.sc-uploader__thumbnail-container .sc-uploader__thumbnail-image{-o-object-fit:contain;object-fit:contain;height:auto;max-height:100%;width:auto;max-width:100%;margin:auto}.sc-uploader_status{border-left:4px solid #aeb7c8}.sc-uploader_status_valid{border-color:#3dcc98}.sc-uploader_status_invalid{border-color:#de350b}.sc-uploader__list-container{display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;max-width:704px;margin-left:1.825rem}.sc-uploader__list-container .sc-uploader__item{width:312px;align-items:center;margin:.5rem 1rem;padding:.5rem;transition:.5s;border-radius:2px}.sc-uploader__list-container .sc-uploader__item:hover{background-color:#edf0f5;transition:.3s}.sc-uploader__list-container .sc-uploader__item-left{position:relative;border-radius:3px;box-shadow:0 2px 9px 0 rgba(0,0,0,.03);height:48px;width:68px}.sc-uploader__list-container .sc-uploader__item-left-icon{width:68px;font-size:40px;text-align:center}.sc-uploader__list-container .sc-uploader__item-center{flex:1 auto;padding:0 1rem}.sc-uploader__list-container .sc-uploader__item-center-title{font:400 .875rem/1.5rem Roboto,\"Open Sans\",sans-serif;color:#424f66;display:flex}.sc-uploader__list-container .sc-uploader__item-center-size{font:400 .75rem/1.5rem Roboto,\"Open Sans\",sans-serif;color:#8993a4}.sc-uploader__list-container .sc-uploader__item-center-error-message{font:400 .75rem/1.5rem Roboto,\"Open Sans\",sans-serif;color:#de350b}.sc-uploader__list-container .sc-uploader__item-center-error-message-info{color:#8993a4}.sc-uploader__list-container .sc-uploader__item-right{flex:0 auto;padding:0 .5rem;min-width:32px;display:flex;justify-content:flex-end;text-align:right}.sc-uploader__list-container .sc-uploader__item-right-retry-button{padding-right:16px}.sc-uploader__list-container .sc-uploader__item-right:hover{color:#0070cc}.sc-uploader__list-container .sc-uploader__item--placeholder{display:flex}.sc-uploader__list-container .sc-uploader__item--placeholder .sc-uploader__item-left{background-color:#e0e5ed}.sc-uploader__list-container .sc-uploader__item--document .sc-uploader__item-left{background-color:#3dcc98}.sc-uploader__list-container .sc-uploader__item--document .sc-uploader__thumbnail-loading{background-color:#e0e5ed;opacity:1}.sc-uploader__list-container .sc-uploader__item--errored .sc-uploader__thumbnail-error{background:#ffd5cb;border-radius:2px;border:0}.sc-uploader__list-container .sc-uploader__item--errored .sc-uploader__thumbnail-error-icon{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.sc-uploader__list-container .sc-uploader__thumbnail-file{display:flex;align-items:center;justify-content:center;color:#fff;margin-top:3px;-o-object-fit:cover;object-fit:cover;height:48px;width:68px}.sc-uploader__list-container .sc-uploader__thumbnail-image{border-radius:3px;-o-object-fit:cover;object-fit:cover;height:48px;max-height:100%;width:68px;margin:auto;background-color:#aeb7c8}.sc-uploader__list-container .sc-uploader__thumbnail-loading{border-radius:3px;background-color:#aeb7c8;opacity:1}.sc-uploader__list-container .sc-uploader__image-detail_disabled{pointer-events:none;color:#aeb7c8}.sc-uploader__info{max-width:665px;margin-left:2rem;margin-bottom:1px}.sc-uploader__error{max-width:665px;margin-left:2rem;margin-bottom:1px;transition:max-height .6s ease-in-out;max-height:0;overflow:hidden}.sc-uploader__error_show{max-height:500px;margin-bottom:1rem}.header-box{display:flex;flex-direction:row;align-items:center}.header-box__title{font-family:Roboto,\"Open Sans\",sans-serif;font-size:1rem;font-weight:700;margin-left:2rem;margin-right:1rem}.header-box__subtitle{font-family:Roboto,\"Open Sans\",sans-serif;font-size:1rem;color:#aeb7c8}.sc-upload-button{border:0;color:#0070cc;font-family:Roboto,\"Open Sans\",sans-serif;font-size:1rem;background-color:transparent;height:32px;padding:0 .75rem;transition:.3s;width:-webkit-max-content;width:-moz-max-content;width:max-content}.sc-upload-button:hover{border-radius:3px;background-color:#e0e5ed;transition:.3s}.sc-upload-button:focus{outline:0}.sc-upload-button:disabled{cursor:default;color:#aeb7c8;background-color:transparent}@media (max-width:767.98px){.sc-uploader_status{border-left:0}.sc-uploader__list-container{border-radius:3px;flex-direction:column;margin-left:0}.sc-uploader__list-container .sc-uploader__item{width:100%;margin:.75rem 0;padding:0}.sc-uploader__list-container .sc-uploader__item:hover{background:0 0}.sc-uploader__list-container .sc-uploader__item-center-retry-button,.sc-uploader__list-container .sc-uploader__item-left-retry-button,.sc-uploader__list-container .sc-uploader__item-right-retry-button{padding-right:8px}.sc-uploader__error,.sc-uploader__info{margin-left:0}.header-box{flex-direction:column;align-items:baseline}.header-box__title{margin-left:0;margin-right:0;word-break:break-word}.sc-upload-button{padding:0}.sc-upload-button:hover{background-color:transparent}}@media (max-width:768px){.sc-uploader-image-item{background-color:#fff;font-size:14px;height:63px;margin:32px 0;position:relative;white-space:nowrap;width:100%}.sc-uploader__list-container .sc-uploader__item-right{min-width:52px}.sc-uploader__list-container .sc-uploader__item-right .sc-uploader__image-detail{display:block}.sc-uploader__retry-icon{margin-right:8px}.imagePic{display:flex;height:64px;width:48px}.imgLoading{height:64px;width:48px}.imgLoading .sc-icon{margin-top:8px}.imageName{position:absolute;top:0;left:60px;margin-top:0;width:calc(100% - 80px)}.imageDetail .sc-icon{top:0!important}.imageSize{position:absolute;top:25px;left:60px}}"]
                }] }
    ];
    /** @nocollapse */
    UploaderComponent.ctorParameters = function () { return [
        { type: UploaderService }
    ]; };
    UploaderComponent.propDecorators = {
        addButtonText: [{ type: Input }],
        disabled: [{ type: Input }],
        extensionAllowed: [{ type: Input }],
        extensionErrorMessage: [{ type: Input }],
        fileMaxSizeBytes: [{ type: Input }],
        fileMaxSizeErrorMessage: [{ type: Input }],
        fileTypeDocThumbnailImageUrl: [{ type: Input }],
        initialFiles: [{ type: Input }],
        id: [{ type: Input }],
        info: [{ type: Input }],
        items: [{ type: Input }],
        loadingText: [{ type: Input }],
        maxFiles: [{ type: Input }],
        optionalData: [{ type: Input }],
        placeholder: [{ type: Input }],
        placeholderDescription: [{ type: Input }],
        shouldShowImageThumbnail: [{ type: Input }],
        showLabel: [{ type: Input }],
        subtitle: [{ type: Input }],
        title: [{ type: Input }],
        uploadErrorMessage: [{ type: Input }],
        view: [{ type: Input }],
        itemsChanged: [{ type: Output }],
        fileInput: [{ type: ViewChild, args: ['fileInput', { static: true },] }],
        uploadButton: [{ type: ViewChild, args: ['uploadButton', { static: false },] }]
    };
    return UploaderComponent;
}());
if (false) {
    /** @type {?} */
    UploaderComponent.prototype.addButtonText;
    /** @type {?} */
    UploaderComponent.prototype.disabled;
    /** @type {?} */
    UploaderComponent.prototype.extensionAllowed;
    /** @type {?} */
    UploaderComponent.prototype.extensionErrorMessage;
    /** @type {?} */
    UploaderComponent.prototype.fileMaxSizeBytes;
    /** @type {?} */
    UploaderComponent.prototype.fileMaxSizeErrorMessage;
    /** @type {?} */
    UploaderComponent.prototype.fileTypeDocThumbnailImageUrl;
    /** @type {?} */
    UploaderComponent.prototype.initialFiles;
    /** @type {?} */
    UploaderComponent.prototype.id;
    /** @type {?} */
    UploaderComponent.prototype.info;
    /** @type {?} */
    UploaderComponent.prototype.items;
    /** @type {?} */
    UploaderComponent.prototype.loadingText;
    /** @type {?} */
    UploaderComponent.prototype.maxFiles;
    /** @type {?} */
    UploaderComponent.prototype.optionalData;
    /** @type {?} */
    UploaderComponent.prototype.placeholder;
    /** @type {?} */
    UploaderComponent.prototype.placeholderDescription;
    /** @type {?} */
    UploaderComponent.prototype.shouldShowImageThumbnail;
    /** @type {?} */
    UploaderComponent.prototype.showLabel;
    /** @type {?} */
    UploaderComponent.prototype.subtitle;
    /** @type {?} */
    UploaderComponent.prototype.title;
    /** @type {?} */
    UploaderComponent.prototype.uploadErrorMessage;
    /** @type {?} */
    UploaderComponent.prototype.view;
    /** @type {?} */
    UploaderComponent.prototype.itemsChanged;
    /** @type {?} */
    UploaderComponent.prototype.fileInput;
    /** @type {?} */
    UploaderComponent.prototype.uploadButton;
    /** @type {?} */
    UploaderComponent.prototype.hasCancel;
    /** @type {?} */
    UploaderComponent.prototype.hasError;
    /** @type {?} */
    UploaderComponent.prototype.hasErrorMessage;
    /** @type {?} */
    UploaderComponent.prototype.isLoading;
    /** @type {?} */
    UploaderComponent.prototype.errorMessage;
    /** @type {?} */
    UploaderComponent.prototype.loading;
    /** @type {?} */
    UploaderComponent.prototype.multiple;
    /**
     * @type {?}
     * @private
     */
    UploaderComponent.prototype.errorInfoDisappearsTimeOut;
    /**
     * @type {?}
     * @private
     */
    UploaderComponent.prototype.uploaderService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/uploader/uploader.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UploaderModule = /** @class */ (function () {
    function UploaderModule() {
    }
    /**
     * @param {?} service
     * @return {?}
     */
    UploaderModule.setUploader = /**
     * @param {?} service
     * @return {?}
     */
    function (service) {
        return {
            ngModule: UploaderModule,
            providers: [
                {
                    provide: UploaderService,
                    useClass: service
                }
            ]
        };
    };
    UploaderModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        BoxModule,
                        ButtonModule,
                        CommonModule,
                        IconModule
                    ],
                    exports: [
                        UploaderComponent, ScFileSizePipe
                    ],
                    declarations: [
                        UploaderComponent, ScFileSizePipe
                    ],
                    providers: [
                        UploaderService, ScFileSizePipe
                    ]
                },] }
    ];
    return UploaderModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/uploader/uploader-service-base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function UploaderServiceBase() { }
if (false) {
    /**
     * @param {?} item
     * @param {?=} owner
     * @return {?}
     */
    UploaderServiceBase.prototype.cancelFile = function (item, owner) { };
    /**
     * @param {?} fileName
     * @param {?=} owner
     * @return {?}
     */
    UploaderServiceBase.prototype.deleteFile = function (fileName, owner) { };
    /**
     * @param {?} folder
     * @param {?} fileName
     * @return {?}
     */
    UploaderServiceBase.prototype.getImageEncodedURI = function (folder, fileName) { };
    /**
     * @param {?} file
     * @param {?=} owner
     * @return {?}
     */
    UploaderServiceBase.prototype.uploadFile = function (file, owner) { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/uploader/uploader-item.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function UploaderItem() { }
if (false) {
    /** @type {?} */
    UploaderItem.prototype.size;
    /** @type {?} */
    UploaderItem.prototype.errorMessage;
    /** @type {?} */
    UploaderItem.prototype.loading;
    /** @type {?} */
    UploaderItem.prototype.name;
    /** @type {?} */
    UploaderItem.prototype.retry;
    /** @type {?} */
    UploaderItem.prototype.thumbnail;
    /** @type {?} */
    UploaderItem.prototype.thumbnailLoading;
    /** @type {?} */
    UploaderItem.prototype.type;
    /** @type {?} */
    UploaderItem.prototype.typeImage;
    /** @type {?|undefined} */
    UploaderItem.prototype.file;
    /** @type {?|undefined} */
    UploaderItem.prototype.isDelete;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/uploader/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/helpers/sc-array.helper.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScArrayHelper = /** @class */ (function () {
    function ScArrayHelper() {
    }
    /**
     * @param {?} from
     * @param {?} comparedWith
     * @return {?}
     */
    ScArrayHelper.prototype.diff = /**
     * @param {?} from
     * @param {?} comparedWith
     * @return {?}
     */
    function (from, comparedWith) {
        return from.filter((/**
         * @param {?} i
         * @return {?}
         */
        function (i) {
            return comparedWith.indexOf(i) < 0;
        }));
    };
    /**
     * @param {?=} old
     * @param {?=} newValue
     * @param {?=} addNewKeys
     * @return {?}
     */
    ScArrayHelper.prototype.updateObject = /**
     * @param {?=} old
     * @param {?=} newValue
     * @param {?=} addNewKeys
     * @return {?}
     */
    function (old, newValue, addNewKeys) {
        if (old === void 0) { old = {}; }
        if (newValue === void 0) { newValue = {}; }
        if (addNewKeys === void 0) { addNewKeys = false; }
        /** @type {?} */
        var value = newValue || {};
        for (var i in old) {
            if (value.hasOwnProperty(i)) {
                old[i] = value[i];
            }
        }
        if (addNewKeys) {
            /** @type {?} */
            var newKeys = this.diff(Object.keys(value), Object.keys(old));
            for (var i in newKeys) {
                if (value.hasOwnProperty(newKeys[i])) {
                    old[newKeys[i]] = value[newKeys[i]];
                }
            }
        }
        return old;
    };
    /**
     * @template T
     * @param {?} array
     * @param {?} orderField
     * @param {?=} orderDesc
     * @return {?}
     */
    ScArrayHelper.prototype.orderBy = /**
     * @template T
     * @param {?} array
     * @param {?} orderField
     * @param {?=} orderDesc
     * @return {?}
     */
    function (array, orderField, orderDesc) {
        if (orderDesc === void 0) { orderDesc = false; }
        array.sort((/**
         * @param {?} itemA
         * @param {?} itemB
         * @return {?}
         */
        function (itemA, itemB) {
            /** @type {?} */
            var valueA = itemA[orderField];
            /** @type {?} */
            var valueB = itemB[orderField];
            return orderDesc
                ? valueA > valueB ? -1 : 1
                : valueB > valueA ? -1 : 1;
        }));
        return array;
    };
    ScArrayHelper.decorators = [
        { type: Injectable }
    ];
    return ScArrayHelper;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/helpers/sc-helpers.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScHelpersModule = /** @class */ (function () {
    function ScHelpersModule() {
    }
    /**
     * @return {?}
     */
    ScHelpersModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: ScHelpersModule,
            providers: [
                ScArrayHelper
            ]
        };
    };
    ScHelpersModule.decorators = [
        { type: NgModule }
    ];
    return ScHelpersModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/helpers/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/sc-currency.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScCurrencyPipe = /** @class */ (function () {
    function ScCurrencyPipe() {
    }
    /**
     * @param {?} val
     * @param {?=} currency
     * @return {?}
     */
    ScCurrencyPipe.prototype.transform = /**
     * @param {?} val
     * @param {?=} currency
     * @return {?}
     */
    function (val, currency) {
        return this.setCurrencyFormat(val, currency);
    };
    /**
     * @param {?} value
     * @param {?=} currency
     * @return {?}
     */
    ScCurrencyPipe.prototype.setCurrencyFormat = /**
     * @param {?} value
     * @param {?=} currency
     * @return {?}
     */
    function (value, currency) {
        /** @type {?} */
        var text = typeof value === 'number' ? value.toFixed(0) : this.parse(value);
        /** @type {?} */
        var newVal = parseInt(text, 10).toString();
        /** @type {?} */
        var symbol = currency === 'usd' ? '$USD ' : '$ ';
        return symbol + this.addThousandsSeparator(newVal, '.');
    };
    /**
     * @param {?} value
     * @return {?}
     */
    ScCurrencyPipe.prototype.parse = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var parsed = this.parseForNegativeValue(value && value.toString() || '');
        return parsed.length ? parsed : '0';
    };
    /**
     * @param {?} number
     * @param {?} thousandsSeparatorSymbol
     * @return {?}
     */
    ScCurrencyPipe.prototype.addThousandsSeparator = /**
     * @param {?} number
     * @param {?} thousandsSeparatorSymbol
     * @return {?}
     */
    function (number, thousandsSeparatorSymbol) {
        return number.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparatorSymbol);
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    ScCurrencyPipe.prototype.parseForNegativeValue = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (parseInt(value) < 0) {
            return value;
        }
        /** @type {?} */
        var withTemporalMinusSymbol = value.replace(/([\D]+ \-)/g, '~');
        return withTemporalMinusSymbol.replace(/[^\d~]/g, '').replace('~', '-');
    };
    ScCurrencyPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'scCurrency'
                },] }
    ];
    return ScCurrencyPipe;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/sc-cuit.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var separator = '-';
var ScCuitPipe = /** @class */ (function () {
    function ScCuitPipe() {
    }
    /**
     * @param {?} val
     * @return {?}
     */
    ScCuitPipe.prototype.transform = /**
     * @param {?} val
     * @return {?}
     */
    function (val) {
        /** @type {?} */
        var cuitString = this.toString(val).replace(new RegExp(separator, 'g'), '');
        /** @type {?} */
        var firstPart = cuitString.substr(0, 2);
        /** @type {?} */
        var middlePart = cuitString.substr(2, 8);
        /** @type {?} */
        var lastPart = cuitString.substr(10, 1);
        return this.transfromCuit(firstPart, middlePart, lastPart);
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    ScCuitPipe.prototype.toString = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return value ? value.toString() : '';
    };
    /**
     * @private
     * @param {?} firstPart
     * @param {?} middlePart
     * @param {?} lastPart
     * @return {?}
     */
    ScCuitPipe.prototype.transfromCuit = /**
     * @private
     * @param {?} firstPart
     * @param {?} middlePart
     * @param {?} lastPart
     * @return {?}
     */
    function (firstPart, middlePart, lastPart) {
        /** @type {?} */
        var cuitTransformed = firstPart;
        if (firstPart.length === 2) {
            cuitTransformed += separator;
        }
        cuitTransformed += middlePart;
        if (middlePart.length === 8) {
            cuitTransformed += separator;
        }
        cuitTransformed += lastPart;
        return cuitTransformed;
    };
    ScCuitPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'scCuit'
                },] }
    ];
    return ScCuitPipe;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/sc-sanitizer-html.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScSanitizerHtmlPipe = /** @class */ (function () {
    function ScSanitizerHtmlPipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    ScSanitizerHtmlPipe.prototype.transform = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    };
    ScSanitizerHtmlPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'scSanitizerHtml'
                },] }
    ];
    /** @nocollapse */
    ScSanitizerHtmlPipe.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    return ScSanitizerHtmlPipe;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ScSanitizerHtmlPipe.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/sc-pipes.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var pipes = [
    ScCurrencyPipe,
    ScCuitPipe,
    ScSanitizerHtmlPipe
];
var ScPipesModule = /** @class */ (function () {
    function ScPipesModule() {
    }
    ScPipesModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    exports: pipes,
                    declarations: pipes,
                    providers: pipes
                },] }
    ];
    return ScPipesModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/cdk-directives/platform-class.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PlatformClassDirective = /** @class */ (function () {
    function PlatformClassDirective(renderer, hostElement, platform) {
        this.renderer = renderer;
        this.hostElement = hostElement;
        this.platform = platform;
        /* An object with keys as the Platform class values in upper case ie:
            ANDROID, IOS, EDGE, etc and a value with a string with the class to be applied
           */
        this.scPlatformClass = null;
        if (!this.scPlatformClass) {
            this.scPlatformClass = Object.keys(platform).reduce((/**
             * @param {?} platformClass
             * @param {?} each
             * @return {?}
             */
            function (platformClass, each) {
                platformClass[each] = '';
                return platformClass;
            }), {});
        }
    }
    /**
     * @return {?}
     */
    PlatformClassDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        Object.keys(this.platform)
            .filter((/**
         * @param {?} each
         * @return {?}
         */
        function (each) { return _this.platform[each] && _this.scPlatformClass[each]; }))
            .forEach((/**
         * @param {?} each
         * @return {?}
         */
        function (each) {
            return _this.addClass(each);
        }));
    };
    /**
     * @private
     * @param {?} each
     * @return {?}
     */
    PlatformClassDirective.prototype.addClass = /**
     * @private
     * @param {?} each
     * @return {?}
     */
    function (each) {
        this.renderer.addClass(this.hostElement.nativeElement, this.scPlatformClass[each]);
    };
    PlatformClassDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[scPlatformClass]',
                },] }
    ];
    /** @nocollapse */
    PlatformClassDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: Platform }
    ]; };
    PlatformClassDirective.propDecorators = {
        scPlatformClass: [{ type: Input }]
    };
    return PlatformClassDirective;
}());
if (false) {
    /** @type {?} */
    PlatformClassDirective.prototype.scPlatformClass;
    /**
     * @type {?}
     * @private
     */
    PlatformClassDirective.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    PlatformClassDirective.prototype.hostElement;
    /**
     * @type {?}
     * @private
     */
    PlatformClassDirective.prototype.platform;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directives/cdk-directives/cdk-directives.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var directives$1 = [PlatformClassDirective];
var CdkDirectivesModule = /** @class */ (function () {
    function CdkDirectivesModule() {
    }
    CdkDirectivesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: directives$1,
                    exports: directives$1,
                    imports: [
                        CommonModule
                    ]
                },] }
    ];
    return CdkDirectivesModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/tags-list/tags-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TagsListComponent = /** @class */ (function () {
    function TagsListComponent() {
        this.canCloseTag = false;
        this.closeTagOnLeft = false;
        this.closedTag = new EventEmitter();
        this.showTitle = true;
        this.title = 'Filtros aplicados:';
        this.tags = [];
    }
    /**
     * @param {?} tag
     * @return {?}
     */
    TagsListComponent.prototype.close = /**
     * @param {?} tag
     * @return {?}
     */
    function (tag) {
        this.tags = this.tags.filter((/**
         * @param {?} tagElement
         * @return {?}
         */
        function (tagElement) { return tagElement !== tag; }));
        this.closedTag.emit(tag);
    };
    TagsListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-tags-list',
                    template: "<div class=\"tag-list-container\">\n    <ng-container *ngIf=\"showTitle\">\n        <div class=\"tag-list-container--title\">{{ title }}</div>\n    </ng-container>\n    <ng-template ngFor let-item [ngForOf]=\"tags\">\n        <div class=\"tag-list-container--tag\" *ngIf=\"!closeTagOnLeft\">\n          {{item}}\n          <sc-icon *ngIf=\"canCloseTag\"\n            id=\"close-tag\"\n            class=\"tag-list-container__close\"\n            [icon]=\"'close'\"\n            [size]=\"'0_5'\"\n            (click)=\"close(item)\"></sc-icon>\n        </div>\n        <div class=\"d-inline-flex\" *ngIf=\"closeTagOnLeft\">\n            <div class=\"tag-list-container__left-close\" *ngIf=\"canCloseTag\" \n            (click)=\"close(item)\">\n                <sc-icon \n                id=\"close-tag\"\n                [icon]=\"'close'\"\n                [size]=\"'0_5'\"></sc-icon>\n            </div>\n            <div [ngClass]=\"{'tag-list-container--tag-with-close': canCloseTag, 'tag-list-container--tag': !canCloseTag}\">\n            {{item}}\n            </div>\n        </div>\n    </ng-template>\n</div>\n",
                    styles: [":host .tag-list-container{padding:1px 16px;font-family:Roboto,\"Open Sans\",sans-serif;align-items:center;display:flex;flex-wrap:wrap;background-color:#edf0f5;min-height:40px;font-size:.8rem}:host .tag-list-container--title{margin-right:5px}:host .tag-list-container--tag{border-radius:4px;margin:.3rem;padding:2px 16px;color:#fff;background-color:#82d4b7}:host .tag-list-container--tag-with-close{border-radius:0 4px 4px 0;margin:.3rem .3rem .3rem 0;padding:2px 16px;color:#fff;background-color:#82d4b7}:host .tag-list-container__close{margin-left:5px}:host .tag-list-container__close:hover{cursor:pointer;opacity:.5}:host .tag-list-container__left-close{border-radius:4px 0 0 4px;margin:.3rem 0;padding:1px 8px;color:#fff;background-color:#82d4b7;border-right:1px solid #78c9ac}:host .tag-list-container__left-close:hover{cursor:pointer;opacity:.5}"]
                }] }
    ];
    /** @nocollapse */
    TagsListComponent.ctorParameters = function () { return []; };
    TagsListComponent.propDecorators = {
        showTitle: [{ type: Input }],
        title: [{ type: Input }],
        tags: [{ type: Input }],
        canCloseTag: [{ type: Input }],
        closeTagOnLeft: [{ type: Input }],
        closedTag: [{ type: Output }]
    };
    return TagsListComponent;
}());
if (false) {
    /** @type {?} */
    TagsListComponent.prototype.showTitle;
    /** @type {?} */
    TagsListComponent.prototype.title;
    /** @type {?} */
    TagsListComponent.prototype.tags;
    /** @type {?} */
    TagsListComponent.prototype.canCloseTag;
    /** @type {?} */
    TagsListComponent.prototype.closeTagOnLeft;
    /** @type {?} */
    TagsListComponent.prototype.closedTag;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/tags-list/tags-list.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TagsListModule = /** @class */ (function () {
    function TagsListModule() {
    }
    TagsListModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule
                    ],
                    exports: [TagsListComponent],
                    declarations: [TagsListComponent]
                },] }
    ];
    return TagsListModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/banner/banner.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Banner = /** @class */ (function () {
    function Banner(data) {
        this.title = data.title;
        this.subtitle = data.subtitle;
        this.image = data.image;
        this.mobileImage = data.mobileImage;
        this.buttonText = data.buttonText;
        this.buttonId = data.buttonId;
        this.route = data.route;
    }
    return Banner;
}());
if (false) {
    /** @type {?} */
    Banner.prototype.title;
    /** @type {?} */
    Banner.prototype.subtitle;
    /** @type {?} */
    Banner.prototype.image;
    /** @type {?} */
    Banner.prototype.mobileImage;
    /** @type {?} */
    Banner.prototype.buttonText;
    /** @type {?} */
    Banner.prototype.buttonId;
    /** @type {?} */
    Banner.prototype.route;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/banner/banner.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BannerComponent = /** @class */ (function () {
    function BannerComponent(router) {
        this.router = router;
        this.buttonClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    BannerComponent.prototype.onClick = /**
     * @return {?}
     */
    function () {
        if (this.config.route) {
            if (this.config.route[0].startsWith('http')) {
                window.open(this.config.route[0]);
            }
            else {
                this.router.navigate(this.config.route);
            }
        }
        else {
            this.buttonClick.emit();
        }
    };
    BannerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-banner',
                    template: "<div class=\"banner button-banner\">\n    <div>\n        <sc-title type=\"h2\" [content]=\"config.title\"></sc-title>\n        <p class=\"button-banner__text\" [innerHTML]=\"config.subtitle\">\n        </p>\n        <ng-content></ng-content>\n        <div class=\"button-banner__button-container\" *ngIf=\"config.buttonText && config.buttonId\">\n            <sc-button (onClick)=\"onClick()\" type=\"secondary\" [loading]=\"loading\" [id]=\"config.buttonId\">\n                {{config.buttonText}}\n            </sc-button>\n        </div>\n    </div>\n    <img [src]=\"config.mobileImage\" [alt]=\"config.title\" class=\"d-block d-lg-none button-banner__image\">\n    <img [src]=\"config.image\" [alt]=\"config.title\" class=\"d-none d-lg-block button-banner__image\">\n</div>",
                    styles: [":host{display:block}:host(.smaller) .banner{background-color:#e0e5ed;min-height:auto}@media (min-width:768px){:host(.smaller) .banner{min-height:auto}:host(.smaller) .button-banner__image{height:110px}}@media (max-width:768px){:host(.smaller) .button-banner__image{height:100px;padding-left:2rem}}.banner{background-color:#edf0f5;min-height:200px;padding:1.5rem 1rem 1rem}@media (min-width:768px){.banner{padding:1.5rem 2rem 1rem;min-height:220px}}.banner__button{width:initial}.button-banner{display:flex;flex-direction:row;justify-content:space-between}.button-banner__button-container{min-width:100px}.button-banner__text{font-size:14px}.button-banner__link{margin-right:.5rem}"]
                }] }
    ];
    /** @nocollapse */
    BannerComponent.ctorParameters = function () { return [
        { type: Router }
    ]; };
    BannerComponent.propDecorators = {
        config: [{ type: Input }],
        loading: [{ type: Input }],
        buttonClick: [{ type: Output }]
    };
    return BannerComponent;
}());
if (false) {
    /** @type {?} */
    BannerComponent.prototype.config;
    /** @type {?} */
    BannerComponent.prototype.loading;
    /** @type {?} */
    BannerComponent.prototype.buttonClick;
    /**
     * @type {?}
     * @private
     */
    BannerComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/banner/banner.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BannerModule = /** @class */ (function () {
    function BannerModule() {
    }
    BannerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [BannerComponent],
                    imports: [
                        CommonModule,
                        ButtonModule,
                        TitleModule
                    ],
                    exports: [BannerComponent]
                },] }
    ];
    return BannerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/providers/window.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function getWindow() {
    return (typeof window !== 'undefined') ? window : null;
}
var WindowRef = /** @class */ (function (_super) {
    __extends(WindowRef, _super);
    function WindowRef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WindowRef;
}(Window));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/help-desk-error-modal/help-desk-error-modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var HelpDeskErrorModalComponent = /** @class */ (function () {
    function HelpDeskErrorModalComponent(window) {
        this.window = window;
        this.backHome = new EventEmitter();
        this.titleDefault = 'Ocurrió un problema';
        this.helpDeskUrlDefault = 'https://serviciospas.sancristobal.com.ar/';
        this.linkLabelDefault = 'Volver al inicio';
    }
    /**
     * @return {?}
     */
    HelpDeskErrorModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.title) {
            this.title = this.titleDefault;
        }
        if (!this.helpDeskUrl) {
            this.helpDeskUrl = this.helpDeskUrlDefault;
        }
        if (!this.linkLabel) {
            this.linkLabel = this.linkLabelDefault;
        }
    };
    /**
     * @return {?}
     */
    HelpDeskErrorModalComponent.prototype.open = /**
     * @return {?}
     */
    function () {
        this.helpDeskModal.open();
    };
    /**
     * @return {?}
     */
    HelpDeskErrorModalComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.helpDeskModal.close();
    };
    /**
     * @return {?}
     */
    HelpDeskErrorModalComponent.prototype.emitBackToHome = /**
     * @return {?}
     */
    function () {
        this.backHome.emit();
    };
    /**
     * @return {?}
     */
    HelpDeskErrorModalComponent.prototype.openHelpDesk = /**
     * @return {?}
     */
    function () {
        this.window.open(this.helpDeskUrl, '_blank');
    };
    /**
     * @return {?}
     */
    HelpDeskErrorModalComponent.prototype.copyToClipboard = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var range = document.createRange();
        range.selectNode(document.getElementsByClassName('error-detail__message')[0]);
        this.window.getSelection().removeAllRanges();
        this.window.getSelection().addRange(range);
        document.execCommand('copy');
        this.window.getSelection().removeAllRanges();
    };
    HelpDeskErrorModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-help-desk-error-modal',
                    template: "<sc-modal [title]=\"title\" #helpDeskModal [closeButton]=\"false\">\n    <div class=\"help-desk__content\">\n        <img *ngIf=\"imageSrc\" class=\"mb-1\" [src]=\"imageSrc\" alt=\"\">\n        <sc-title [content]=\"title\" type=\"h2\"></sc-title>\n        <div class=\"my-1\">\n            <p class=\"mb-0\">\n                Copi\u00E1 el error e informalo a la <strong>Mesa de Ayuda</strong>\n            </p>\n            <p class=\"mb-0\">\n                para que podamos solucionarlo cuanto antes.\n            </p>\n        </div>\n        <div class=\"error-detail\">\n            <div id=\"error-message\" class=\"pl-1 pt-1 pb-1 pr-sm-1 pr-md-0\">\n                <sc-button type=\"secondary\" class=\"error-detail__floating-copy-button d-sm-none d-md-block\"\n                    (onClick)=\"copyToClipboard()\">Copiar error</sc-button>\n                <p class=\"error-detail__message mb-0 sc-scroll-bar\">\n                    {{ errorMessage }}\n                </p>\n                <div class=\"w-50\">\n                    <sc-button type=\"secondary\" class=\"error-detail__floating-copy-button d-md-none\"\n                        (onClick)=\"copyToClipboard()\">\n                        Copiar error</sc-button>\n                </div>\n            </div>\n        </div>\n        <div class=\"py-1\">\n            <sc-button type=\"primary\" (onClick)=\"openHelpDesk()\">Informar a la mesa de ayuda</sc-button>\n        </div>\n        <div class=\"back-home\">\n            <sc-button type=\"link\" (onClick)=\"emitBackToHome()\">{{ linkLabel }}</sc-button>\n        </div>\n    </div>\n</sc-modal>",
                    styles: [".help-desk__content{text-align:center;max-width:480px}.error-detail{background-color:#edf0f5}.error-detail__message{overflow:auto;font-size:12px;line-height:21px;overflow-wrap:anywhere;text-align:left}@media only screen and (min-width:768px){.error-detail__message{width:100%;padding-right:165px;height:64px}.error-detail__floating-copy-button{position:absolute;right:40px;padding-top:10px}}@media only screen and (max-width:768px){.error-detail__message{padding-right:10px;max-height:150px}}.back-home{border-top:1px solid #e0e5ed;padding-top:.5rem}.sc-scroll-bar::-webkit-scrollbar-thumb{height:40px}"]
                }] }
    ];
    /** @nocollapse */
    HelpDeskErrorModalComponent.ctorParameters = function () { return [
        { type: WindowRef }
    ]; };
    HelpDeskErrorModalComponent.propDecorators = {
        helpDeskModal: [{ type: ViewChild, args: ['helpDeskModal', { static: true },] }],
        title: [{ type: Input }],
        errorMessage: [{ type: Input }],
        imageSrc: [{ type: Input }],
        helpDeskUrl: [{ type: Input }],
        linkLabel: [{ type: Input }],
        backHome: [{ type: Output }]
    };
    return HelpDeskErrorModalComponent;
}());
if (false) {
    /** @type {?} */
    HelpDeskErrorModalComponent.prototype.helpDeskModal;
    /** @type {?} */
    HelpDeskErrorModalComponent.prototype.title;
    /** @type {?} */
    HelpDeskErrorModalComponent.prototype.errorMessage;
    /** @type {?} */
    HelpDeskErrorModalComponent.prototype.imageSrc;
    /** @type {?} */
    HelpDeskErrorModalComponent.prototype.helpDeskUrl;
    /** @type {?} */
    HelpDeskErrorModalComponent.prototype.linkLabel;
    /** @type {?} */
    HelpDeskErrorModalComponent.prototype.backHome;
    /** @type {?} */
    HelpDeskErrorModalComponent.prototype.titleDefault;
    /** @type {?} */
    HelpDeskErrorModalComponent.prototype.helpDeskUrlDefault;
    /** @type {?} */
    HelpDeskErrorModalComponent.prototype.linkLabelDefault;
    /**
     * @type {?}
     * @private
     */
    HelpDeskErrorModalComponent.prototype.window;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/help-desk-error-modal/help-desk-error-modal.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$2 = getWindow;
var HelpDeskErrorModalModule = /** @class */ (function () {
    function HelpDeskErrorModalModule() {
    }
    HelpDeskErrorModalModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [HelpDeskErrorModalComponent],
                    imports: [
                        CommonModule,
                        ModalModule,
                        TitleModule,
                        ButtonModule
                    ],
                    exports: [HelpDeskErrorModalComponent],
                    providers: [{ provide: WindowRef, useFactory: ɵ0$2 }]
                },] }
    ];
    return HelpDeskErrorModalModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/error-screen/error-screen.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ErrorScreenComponent = /** @class */ (function () {
    function ErrorScreenComponent() {
        this.buttonAction = new EventEmitter();
        this.secondaryButtonAction = new EventEmitter();
        this.defaultTitle = 'Ocurrió un error inesperado';
        this.defaultMessage = 'Disculpá las molestias ocasionadas, por favor, volvé a intentarlo nuevamente más tarde.';
        this.defaultButtonLabel = 'Volver';
    }
    /**
     * @return {?}
     */
    ErrorScreenComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.title) {
            this.title = this.defaultTitle;
        }
        if (!this.message) {
            this.message = this.defaultMessage;
        }
        if (!this.buttonLabel) {
            this.buttonLabel = this.defaultButtonLabel;
        }
    };
    /**
     * @return {?}
     */
    ErrorScreenComponent.prototype.handleButtonClicked = /**
     * @return {?}
     */
    function () {
        this.buttonAction.emit();
    };
    /**
     * @return {?}
     */
    ErrorScreenComponent.prototype.handleSecondaryButtonClicked = /**
     * @return {?}
     */
    function () {
        this.secondaryButtonAction.emit();
    };
    ErrorScreenComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-error-screen',
                    template: "<img\n  class=\"error-screen__image\"\n  src=\"/assets/images/emision-error.png\"\n  alt=\"Icono error\"\n/>\n<sc-title class=\"error-screen__title\" [content]=\"title\" type=\"h2\"></sc-title>\n<p class=\"error-screen__message\" [innerHTML]=\"message\"></p>\n<div class=\"error-screen__buttons\">\n  <sc-button\n    id=\"error-screen-button\"\n    class=\"error-screen__button\"\n    [loading]=\"buttonLoading\"\n    (onClick)=\"handleButtonClicked()\"\n  >\n    {{ buttonLabel }}\n  </sc-button>\n  <sc-button\n    *ngIf=\"secondaryButtonLabel\"\n    id=\"error-screen-secondary-button\"\n    class=\"error-screen__button\"\n    type=\"secondary\"\n    [loading]=\"secondaryButtonLoading\"\n    (onClick)=\"handleSecondaryButtonClicked()\"\n  >\n    {{ secondaryButtonLabel }}\n  </sc-button>\n</div>\n",
                    styles: [":host{position:relative;display:flex;flex-direction:column;justify-content:center;padding:1rem;text-align:center;margin:auto;max-width:440px}:host .error-screen__image{margin:0 auto 1.5rem;max-width:86px}:host .error-screen__message{font-weight:400;font-size:1rem;line-height:1.5rem;margin:2rem auto 3rem}:host .error-screen__button{margin:0 1rem}:host .error-screen__buttons{display:flex;align-items:center;justify-content:center}"]
                }] }
    ];
    ErrorScreenComponent.propDecorators = {
        title: [{ type: Input }],
        message: [{ type: Input }],
        buttonLabel: [{ type: Input }],
        secondaryButtonLabel: [{ type: Input }],
        buttonLoading: [{ type: Input }],
        secondaryButtonLoading: [{ type: Input }],
        buttonAction: [{ type: Output }],
        secondaryButtonAction: [{ type: Output }]
    };
    return ErrorScreenComponent;
}());
if (false) {
    /** @type {?} */
    ErrorScreenComponent.prototype.title;
    /** @type {?} */
    ErrorScreenComponent.prototype.message;
    /** @type {?} */
    ErrorScreenComponent.prototype.buttonLabel;
    /** @type {?} */
    ErrorScreenComponent.prototype.secondaryButtonLabel;
    /** @type {?} */
    ErrorScreenComponent.prototype.buttonLoading;
    /** @type {?} */
    ErrorScreenComponent.prototype.secondaryButtonLoading;
    /** @type {?} */
    ErrorScreenComponent.prototype.buttonAction;
    /** @type {?} */
    ErrorScreenComponent.prototype.secondaryButtonAction;
    /** @type {?} */
    ErrorScreenComponent.prototype.defaultTitle;
    /** @type {?} */
    ErrorScreenComponent.prototype.defaultMessage;
    /** @type {?} */
    ErrorScreenComponent.prototype.defaultButtonLabel;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/error-screen/error-screen.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ErrorScreenModule = /** @class */ (function () {
    function ErrorScreenModule() {
    }
    ErrorScreenModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        TitleModule,
                        ButtonModule
                    ],
                    declarations: [ErrorScreenComponent],
                    exports: [ErrorScreenComponent]
                },] }
    ];
    return ErrorScreenModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/chip/chip.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ChipComponent = /** @class */ (function () {
    function ChipComponent() {
        this.color = 1;
        this.number = null;
        this.enableClose = false;
        this.close = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ChipComponent.prototype.onClose = /**
     * @return {?}
     */
    function () {
        this.close.emit();
    };
    ChipComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-chip',
                    template: "<div [class]=\"'sc-chip sc-chip--color' + color\">\n  <div class=\"sc-chip__number\" *ngIf=\"number\">{{number}}</div>\n  <div class=\"sc-chip__text\">\n    <ng-content></ng-content>\n  </div>\n  <div class=\"sc-chip__close\" *ngIf=\"enableClose\">\n    <sc-icon icon=\"close1\" size=\"0_5\" (click)=\"onClose()\"></sc-icon>\n  </div>\n</div>\n",
                    styles: [".sc-chip{border-radius:4px;background-color:#dadcfb;padding:.25rem .5rem;outline:0;display:flex;align-items:center;justify-content:center}.sc-chip__number{background-color:#5f67ec;border-radius:50%;font-size:.75rem;color:#fff;padding:0 .25rem;width:20px;height:20px;margin-right:.5rem;display:flex;align-items:center;justify-content:center}.sc-chip__text{font-size:.875rem;margin-right:.5rem}.sc-chip__close{width:18px;height:19px;display:flex;align-items:center;justify-content:center;cursor:pointer}.sc-chip--color1{background-color:#dadcfb}.sc-chip--color1 .sc-chip__number{background-color:#5f67ec}.sc-chip--color2{background-color:#fae6d1}.sc-chip--color2 .sc-chip__number{background-color:#fbac57}.sc-chip--color3{background-color:#d3f4e8}.sc-chip--color3 .sc-chip__number{background-color:#82d4b7}"]
                }] }
    ];
    ChipComponent.propDecorators = {
        color: [{ type: Input }],
        number: [{ type: Input }],
        enableClose: [{ type: Input }],
        close: [{ type: Output }]
    };
    return ChipComponent;
}());
if (false) {
    /** @type {?} */
    ChipComponent.prototype.color;
    /** @type {?} */
    ChipComponent.prototype.number;
    /** @type {?} */
    ChipComponent.prototype.enableClose;
    /** @type {?} */
    ChipComponent.prototype.close;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/chip/chip.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ChipModule = /** @class */ (function () {
    function ChipModule() {
    }
    ChipModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule
                    ],
                    declarations: [
                        ChipComponent
                    ],
                    exports: [
                        ChipComponent
                    ]
                },] }
    ];
    return ChipModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ui-core-components.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var componentsModules = [
    AccordionModule,
    ActionMenuModule,
    AlertModule,
    ButtonModule,
    CheckboxModule,
    ContextMenuModule,
    IconContextMenuModule,
    DatePickerModule,
    FilterBoxModule,
    FormControlErrorModule,
    GridModule,
    IconBarModule,
    IconModule,
    InfoBoxModule,
    InputModule,
    LateralDrawerModule,
    LateralMenuModule,
    LoadingModule,
    ModalModule,
    NavbarModule,
    PaginationModule,
    PendingChangesWarningModalModule,
    PhoneModule,
    RadioModule,
    ScTableModule,
    ScTabModule,
    SearchFieldModule,
    SelectModule,
    StepperModule,
    TextareaModule,
    TitleModule,
    TooltipModule,
    TooltipInputDecoratorModule,
    BannerModule,
    TagsListModule,
    TooltipCustomModule,
    HelpDeskErrorModalModule,
    ErrorScreenModule,
    ChipModule
];
var UiCoreComponentsModule = /** @class */ (function () {
    function UiCoreComponentsModule() {
    }
    UiCoreComponentsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        componentsModules
                    ],
                    exports: [componentsModules]
                },] }
    ];
    return UiCoreComponentsModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/scroll-service-stub.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScrollServiceStub = /** @class */ (function () {
    function ScrollServiceStub() {
    }
    /**
     * @return {?}
     */
    ScrollServiceStub.prototype.disableViewportScroll = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    ScrollServiceStub.prototype.enableViewportScroll = /**
     * @return {?}
     */
    function () { };
    return ScrollServiceStub;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/whatsapp/whatsapp.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var linkMobile = 'https://wa.me/';
/** @type {?} */
var linkDesktop = 'https://web.whatsapp.com/send?phone=';
var WhatsAppService = /** @class */ (function () {
    function WhatsAppService(platform) {
        this.platform = platform;
    }
    /**
     * @param {?} phoneNumber
     * @param {?=} message
     * @return {?}
     */
    WhatsAppService.prototype.getWhatsAppLink = /**
     * @param {?} phoneNumber
     * @param {?=} message
     * @return {?}
     */
    function (phoneNumber, message) {
        if (message === void 0) { message = ''; }
        /** @type {?} */
        var paramToSelectContact = !phoneNumber ? '&app_absent=' : '';
        return this.isMobile()
            ? "" + linkMobile + phoneNumber + "?text=" + message
            : "" + linkDesktop + phoneNumber + "&text=" + message + paramToSelectContact;
    };
    /**
     * @private
     * @return {?}
     */
    WhatsAppService.prototype.isMobile = /**
     * @private
     * @return {?}
     */
    function () {
        return this.platform.ANDROID || this.platform.IOS;
    };
    WhatsAppService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    WhatsAppService.ctorParameters = function () { return [
        { type: Platform }
    ]; };
    /** @nocollapse */ WhatsAppService.ngInjectableDef = ɵɵdefineInjectable({ factory: function WhatsAppService_Factory() { return new WhatsAppService(ɵɵinject(Platform)); }, token: WhatsAppService, providedIn: "root" });
    return WhatsAppService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    WhatsAppService.prototype.platform;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/cuit.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var inValidLengthErrorKey = 'length';
/** @type {?} */
var inValidErrorKey = 'invalid';
/** @type {?} */
var cuitValidator = (/**
 * @param {?} control
 * @return {?}
 */
function (control) {
    var _a, _b;
    /** @type {?} */
    var inValidLengthResult = (_a = {}, _a[inValidLengthErrorKey] = true, _a);
    /** @type {?} */
    var inValidResult = (_b = {}, _b[inValidErrorKey] = true, _b);
    if (!control.value) {
        return null;
    }
    if (isNaN(control.value)) {
        return inValidResult;
    }
    /** @type {?} */
    var cuitString = control.value.toString();
    if (cuitString.length !== 11) {
        return inValidLengthResult;
    }
    return validateCuit(cuitString) ? null : inValidResult;
});
/**
 * @param {?} cuitString
 * @return {?}
 */
function validateCuit(cuitString) {
    /** @type {?} */
    var accumulated = 0;
    /** @type {?} */
    var digits = cuitString.split('');
    /** @type {?} */
    var digit = digits.pop();
    for (var i = 0; i < digits.length; i++) {
        accumulated += Number(digits[9 - i]) * (2 + (i % 6));
    }
    /** @type {?} */
    var verif = 11 - (accumulated % 11);
    if (verif === 11) {
        verif = 0;
    }
    return Number(digit) === verif;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/email.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var emailValidator = (/**
 * @param {?} c
 * @return {?}
 */
function (c) {
    // tslint:disable-next-line:max-line-length
    /** @type {?} */
    var EMAIL = /^[\w!#$%&'*+/=?`{|}~^-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
    /** @type {?} */
    var err = {
        'email': {
            'message': 'Ingrese un email válido'
        }
    };
    /** @type {?} */
    var isError = c.value && c.value.length > 0 && !EMAIL.test(c.value);
    return isError ? err : null;
});

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/phone-number.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
var  
// @dynamic
PhoneNumberValidator = /** @class */ (function () {
    function PhoneNumberValidator() {
    }
    /**
     * @param {?} prefix
     * @param {?} phoneNumber
     * @return {?}
     */
    PhoneNumberValidator.matchingPhoneNumber = /**
     * @param {?} prefix
     * @param {?} phoneNumber
     * @return {?}
     */
    function (prefix, phoneNumber) {
        return (/**
         * @param {?} group
         * @return {?}
         */
        function (group) {
            /** @type {?} */
            var prefixInput = group.controls[prefix];
            /** @type {?} */
            var phoneNumberInput = group.controls[phoneNumber];
            if (!prefixInput.value || !phoneNumberInput.value) {
                return { phoneNumberInvalid: true };
            }
            /** @type {?} */
            var totalDigits = (phoneNumberInput.value).toString().length + (prefixInput.value).toString().length;
            if (prefixInput.value && phoneNumberInput.value && totalDigits !== 10) {
                return { phoneTotalDigitsInvalid: true };
            }
            return null;
        });
    };
    return PhoneNumberValidator;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/testing/dom-testing.functions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var selectElement = (/**
 * @param {?} fixture
 * @param {?} selector
 * @return {?}
 */
function (fixture, selector) {
    return fixture.debugElement.query(By.css(selector)).nativeElement;
});
var ɵ0$3 = selectElement;
/** @type {?} */
var selectAllElements = (/**
 * @param {?} fixture
 * @param {?} selector
 * @return {?}
 */
function (fixture, selector) {
    return fixture.debugElement.queryAll(By.css(selector));
});
var ɵ1$1 = selectAllElements;
/** @type {?} */
var clickElement = (/**
 * @param {?} fixture
 * @param {?} selector
 * @return {?}
 */
function (fixture, selector) {
    /** @type {?} */
    var element = selectElement(fixture, selector);
    element.click();
});
var ɵ2$1 = clickElement;
/** @type {?} */
var focusElement = (/**
 * @param {?} fixture
 * @param {?} selector
 * @return {?}
 */
function (fixture, selector) {
    /** @type {?} */
    var element = selectElement(fixture, selector);
    element.focus();
});
var ɵ3$1 = focusElement;
/** @type {?} */
var blurElement = (/**
 * @param {?} fixture
 * @param {?} selector
 * @return {?}
 */
function (fixture, selector) {
    /** @type {?} */
    var element = selectElement(fixture, selector);
    element.blur();
});
var ɵ4$1 = blurElement;
/** @type {?} */
var getInnerHTML = (/**
 * @param {?} fixture
 * @param {?} selector
 * @return {?}
 */
function (fixture, selector) {
    /** @type {?} */
    var element = selectElement(fixture, selector);
    return element.innerHTML;
});
var ɵ5 = getInnerHTML;
/** @type {?} */
var getTextContent = (/**
 * @param {?} fixture
 * @param {?} selector
 * @return {?}
 */
function (fixture, selector) {
    /** @type {?} */
    var element = selectElement(fixture, selector);
    return element.textContent;
});
var ɵ6 = getTextContent;
/** @type {?} */
var getInnerText = (/**
 * @param {?} fixture
 * @param {?} selector
 * @return {?}
 */
function (fixture, selector) {
    /** @type {?} */
    var element = selectElement(fixture, selector);
    return element.innerText;
});
var ɵ7 = getInnerText;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/simple-date-picker/simple-date-picker.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CONTROL_VALUE_ACCESSOR$6 = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return SimpleDatePickerComponent; })),
    multi: true
};
var SimpleDatePickerComponent = /** @class */ (function () {
    function SimpleDatePickerComponent(localeService) {
        this.localeService = localeService;
        this.onChange = (/**
         * @return {?}
         */
        function () { });
        this.dateFormControl = new FormControl(null);
        esLocale.invalidDate = 'Fecha incorrecta';
        defineLocale('es', esLocale);
        this.localeService.use('es');
        this.datePickerConfig = {
            showWeekNumbers: false,
            containerClass: 'theme-sc'
        };
    }
    /**
     * @return {?}
     */
    SimpleDatePickerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.calculateDateLimits();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    SimpleDatePickerComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.maxLimitDate || changes.minLimitDate || changes.maxLimitDateFromNow || changes.minLimitDateFromNow) {
            this.calculateDateLimits();
        }
    };
    /**
     * @param {?} date
     * @param {?} dateFromNow
     * @return {?}
     */
    SimpleDatePickerComponent.prototype.getEdgeDate = /**
     * @param {?} date
     * @param {?} dateFromNow
     * @return {?}
     */
    function (date, dateFromNow) {
        /** @type {?} */
        var edgeDate;
        if (date) {
            edgeDate = date;
        }
        else if (typeof dateFromNow === 'number') {
            edgeDate = new Date();
            edgeDate.setDate(edgeDate.getDate() + dateFromNow);
        }
        return edgeDate;
    };
    /**
     * @return {?}
     */
    SimpleDatePickerComponent.prototype.calculateDateLimits = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var negativeMinLimitDateFromNow = null;
        if (typeof this.minLimitDateFromNow === 'number') {
            negativeMinLimitDateFromNow = this.minLimitDateFromNow > 0 ? this.minLimitDateFromNow * (-1) : 0;
        }
        this.minDate = this.getEdgeDate(this.minLimitDate, negativeMinLimitDateFromNow);
        this.maxDate = this.getEdgeDate(this.maxLimitDate, this.maxLimitDateFromNow);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    SimpleDatePickerComponent.prototype.handleValueChange = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        this.onChange(date);
    };
    /**
     * @param {?} date
     * @return {?}
     */
    SimpleDatePickerComponent.prototype.writeValue = /**
     * @param {?} date
     * @return {?}
     */
    function (date) {
        if (this.dateFormControl && date) {
            this.dateFormControl.setValue(date && date['value'] || date);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SimpleDatePickerComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SimpleDatePickerComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { };
    SimpleDatePickerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-simple-date-picker',
                    template: "<div class=\"sc-simple-date-picker\" [class.readonly]=\"readonly\">\n    <label\n        *ngIf=\"!!label\"\n        [attr.for]=\"!readonly ? 'date-picker_' + formControlName : null\">{{ label }}</label>\n    <div class=\"sc-simple-date-picker__input-wrapper\">\n        <input\n            id=\"date-picker_{{formControlName}}\"\n            type=\"text\"\n            bsDatepicker\n            [bsValue]=\"dateFormControl.value\"\n            [formControl]=\"dateFormControl\"\n            [minDate]=\"minDate\"\n            [maxDate]=\"maxDate\"\n            [bsConfig]=\"datePickerConfig\"\n            (bsValueChange)=\"handleValueChange($event)\"\n        >\n        <sc-icon class=\"icon\" icon=\"calendar\"></sc-icon>\n    </div>\n</div>",
                    providers: [CONTROL_VALUE_ACCESSOR$6],
                    styles: ["::ng-deep .theme-sc .bs-datepicker-head{background-color:#0070cc}::ng-deep .theme-sc .bs-datepicker-body .selected{background-color:#0070cc}:host(.label-margin-bottom) label{margin-bottom:7px}@media only screen and (min-width:768px){:host(.label-margin-bottom) label{margin-bottom:4px}}.sc-simple-date-picker{display:block;background-color:#fff}.sc-simple-date-picker input{position:relative;z-index:1;background-color:transparent;margin-bottom:1.75rem}.sc-simple-date-picker .icon{display:inline-block;margin:.75rem 0 0 -2rem;color:#0070cc}.sc-simple-date-picker.readonly input{background-color:#e0e5ed;pointer-events:none;z-index:0}.sc-simple-date-picker.readonly .icon{color:#8993a4;position:relative;z-index:1}:host(.ng-invalid) input{border-color:#de350b}:host(.ng-invalid) .icon{color:#aeb7c8}"]
                }] }
    ];
    /** @nocollapse */
    SimpleDatePickerComponent.ctorParameters = function () { return [
        { type: BsLocaleService }
    ]; };
    SimpleDatePickerComponent.propDecorators = {
        label: [{ type: Input }],
        readonly: [{ type: Input }],
        formControlName: [{ type: Input }],
        minLimitDate: [{ type: Input }],
        maxLimitDate: [{ type: Input }],
        minLimitDateFromNow: [{ type: Input }],
        maxLimitDateFromNow: [{ type: Input }]
    };
    return SimpleDatePickerComponent;
}());
if (false) {
    /** @type {?} */
    SimpleDatePickerComponent.prototype.label;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.readonly;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.formControlName;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.minLimitDate;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.maxLimitDate;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.minLimitDateFromNow;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.maxLimitDateFromNow;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.dateFormControl;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.datePickerConfig;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.maxDate;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.minDate;
    /** @type {?} */
    SimpleDatePickerComponent.prototype.onChange;
    /**
     * @type {?}
     * @private
     */
    SimpleDatePickerComponent.prototype.localeService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/simple-date-picker/simple-date-picker.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
defineLocale('es', esLocale);
var SimpleDatePickerModule = /** @class */ (function () {
    function SimpleDatePickerModule() {
    }
    SimpleDatePickerModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        IconModule,
                        BsDatepickerModule.forRoot()
                    ],
                    declarations: [SimpleDatePickerComponent],
                    exports: [SimpleDatePickerComponent]
                },] }
    ];
    return SimpleDatePickerModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/payment-method-code.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var PaymentMethodCode = {
    responsive: "responsive",
    directDebit: "directDebit",
    creditcard: "creditcard",
    CommitmentToPayment: "CommitmentToPayment",
    Ext_PaymentInKind: "Ext_PaymentInKind",
    GrainExchange: "GrainExchange",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/credit-card-icon.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var CreditCardIcon = {
    'default_data:10001': "american",
    'default_data:10002': "argencard",
    'default_data:10003': "diners",
    'default_data:10004': "master",
    'default_data:10005': "patagonia",
    'default_data:10006': "bbps",
    'default_data:10007': "cabal",
    'default_data:10008': "coopeplus",
    'default_data:10009': "galicia",
    'default_data:10010': "montemar",
    'default_data:10011': "naranja",
    'default_data:10012': "nativa",
    'default_data:10013': "nativa-master",
    'default_data:10014': "nevada",
    'default_data:10015': "italcred",
    'default_data:10016': "credencial",
    'default_data:10020': "visa",
    'bc:1002': "cencosud",
    'bc:1001': "fava",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/payment-method-title.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var PaymentMethodTitle = {
    responsive: "Efectivo",
    directDebit: "D\u00E9bito directo",
    creditcard: "Tarjeta de cr\u00E9dito",
    CommitmentToPayment: "Pagar\u00E9",
    Ext_PaymentInKind: "Pago en especies",
    GrainExchange: "Canje de granos",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-method-card/payment-method.strategy.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var /**
 * @abstract
 */
PaymentMethodStrategy = /** @class */ (function () {
    function PaymentMethodStrategy(type) {
        this.type = type;
        this.title = PaymentMethodTitle[this.type] || 'Otra forma de pago';
    }
    /**
     * @param {?} iconImageBaseUrl
     * @param {?=} entityCode
     * @return {?}
     */
    PaymentMethodStrategy.prototype.getIconImage = /**
     * @param {?} iconImageBaseUrl
     * @param {?=} entityCode
     * @return {?}
     */
    function (iconImageBaseUrl, entityCode) { return iconImageBaseUrl + "/otras.png"; };
    return PaymentMethodStrategy;
}());
if (false) {
    /** @type {?} */
    PaymentMethodStrategy.prototype.title;
    /**
     * @type {?}
     * @protected
     */
    PaymentMethodStrategy.prototype.type;
}
var Cash = /** @class */ (function (_super) {
    __extends(Cash, _super);
    function Cash() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} iconImageBaseUrl
     * @return {?}
     */
    Cash.prototype.getIconImage = /**
     * @param {?} iconImageBaseUrl
     * @return {?}
     */
    function (iconImageBaseUrl) { return iconImageBaseUrl + "/efectivo.png"; };
    return Cash;
}(PaymentMethodStrategy));
var Debit = /** @class */ (function (_super) {
    __extends(Debit, _super);
    function Debit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} iconImageBaseUrl
     * @return {?}
     */
    Debit.prototype.getIconImage = /**
     * @param {?} iconImageBaseUrl
     * @return {?}
     */
    function (iconImageBaseUrl) { return iconImageBaseUrl + "/cbu.png"; };
    return Debit;
}(PaymentMethodStrategy));
var CreditCard = /** @class */ (function (_super) {
    __extends(CreditCard, _super);
    function CreditCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} iconImageBaseUrl
     * @param {?} entityCode
     * @return {?}
     */
    CreditCard.prototype.getIconImage = /**
     * @param {?} iconImageBaseUrl
     * @param {?} entityCode
     * @return {?}
     */
    function (iconImageBaseUrl, entityCode) {
        /** @type {?} */
        var imageUrl = CreditCardIcon[entityCode] || 'generica';
        return iconImageBaseUrl + "/" + imageUrl + ".png";
    };
    return CreditCard;
}(PaymentMethodStrategy));
var OtherPaymentMethod = /** @class */ (function (_super) {
    __extends(OtherPaymentMethod, _super);
    function OtherPaymentMethod() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OtherPaymentMethod;
}(PaymentMethodStrategy));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-method-card/payment-method-card.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodCardComponent = /** @class */ (function () {
    function PaymentMethodCardComponent() {
        var _a;
        this.imageBaseUrl = '/assets/images/payment-method-icons';
        this.strategies = (_a = {},
            _a[PaymentMethodCode.responsive] = Cash,
            _a[PaymentMethodCode.directDebit] = Debit,
            _a[PaymentMethodCode.creditcard] = CreditCard,
            _a);
    }
    /**
     * @return {?}
     */
    PaymentMethodCardComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.setStrategy(this.getCorrectStrategy());
        this.title = this.strategy.title;
        this.formattedLabel = this.formatLabel(this.number);
        this.imageSource = this.strategy.getIconImage(this.imageBaseUrl, this.creditCardTypeCode);
    };
    /**
     * @private
     * @return {?}
     */
    PaymentMethodCardComponent.prototype.getCorrectStrategy = /**
     * @private
     * @return {?}
     */
    function () {
        return new (this.strategies[this.type] || OtherPaymentMethod)(this.type);
    };
    /**
     * @private
     * @param {?} strategy
     * @return {?}
     */
    PaymentMethodCardComponent.prototype.setStrategy = /**
     * @private
     * @param {?} strategy
     * @return {?}
     */
    function (strategy) {
        this.strategy = strategy;
    };
    /**
     * @private
     * @param {?} label
     * @return {?}
     */
    PaymentMethodCardComponent.prototype.formatLabel = /**
     * @private
     * @param {?} label
     * @return {?}
     */
    function (label) {
        return label && label.replace(/#/g, '•');
    };
    PaymentMethodCardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-payment-method-card',
                    template: "<div class=\"payment-method-card\">\n    <div class=\"payment-method-card__left\">\n        <div class=\"payment-method-card__title\" [class.no-label]=\"!formattedLabel\">{{ title }}</div>\n        <div class=\"payment-method-card__label\" *ngIf=\"formattedLabel\">{{ formattedLabel }}</div>\n    </div>\n    <div class=\"payment-method-card__image\">\n        <img [src]=\"imageSource\" alt=\"Payment Method Icon\" />\n    </div>\n</div>",
                    styles: [":host{display:block}:host .payment-method-card{border:1px solid #ccd2dd;width:100%;border-radius:4px;padding:1.5rem;display:flex;justify-content:space-between;align-items:center;font-size:14px;line-height:14px}:host .payment-method-card__title{font-weight:700}:host .payment-method-card__title:not(.no-label){margin-bottom:.75rem}:host .payment-method-card__label{display:inline-block;vertical-align:text-bottom}:host .payment-method-card__image{display:flex;align-items:center}:host .payment-method-card__image img{max-width:48px}"]
                }] }
    ];
    PaymentMethodCardComponent.propDecorators = {
        type: [{ type: Input }],
        creditCardTypeCode: [{ type: Input }],
        number: [{ type: Input }],
        imageBaseUrl: [{ type: Input }]
    };
    return PaymentMethodCardComponent;
}());
if (false) {
    /** @type {?} */
    PaymentMethodCardComponent.prototype.type;
    /** @type {?} */
    PaymentMethodCardComponent.prototype.creditCardTypeCode;
    /** @type {?} */
    PaymentMethodCardComponent.prototype.number;
    /** @type {?} */
    PaymentMethodCardComponent.prototype.imageBaseUrl;
    /** @type {?} */
    PaymentMethodCardComponent.prototype.title;
    /** @type {?} */
    PaymentMethodCardComponent.prototype.imageSource;
    /** @type {?} */
    PaymentMethodCardComponent.prototype.formattedLabel;
    /** @type {?} */
    PaymentMethodCardComponent.prototype.strategy;
    /**
     * @type {?}
     * @private
     */
    PaymentMethodCardComponent.prototype.strategies;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-method-card/payment-method-card.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodCardModule = /** @class */ (function () {
    function PaymentMethodCardModule() {
    }
    PaymentMethodCardModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [PaymentMethodCardComponent],
                    exports: [PaymentMethodCardComponent]
                },] }
    ];
    return PaymentMethodCardModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accordion-item-list/accordion-item-list.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccordionItemList = /** @class */ (function () {
    function AccordionItemList() {
    }
    return AccordionItemList;
}());
if (false) {
    /** @type {?} */
    AccordionItemList.prototype.title;
    /** @type {?} */
    AccordionItemList.prototype.urlLabel;
    /** @type {?} */
    AccordionItemList.prototype.url;
    /** @type {?} */
    AccordionItemList.prototype.id;
    /** @type {?} */
    AccordionItemList.prototype.items;
}
var AccordionItem = /** @class */ (function () {
    function AccordionItem() {
    }
    return AccordionItem;
}());
if (false) {
    /** @type {?} */
    AccordionItem.prototype.title;
    /** @type {?} */
    AccordionItem.prototype.description;
    /** @type {?} */
    AccordionItem.prototype.opened;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accordion-item-list/accordion-item-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccordionItemListComponent = /** @class */ (function () {
    function AccordionItemListComponent() {
    }
    /**
     * @param {?} selectedItem
     * @return {?}
     */
    AccordionItemListComponent.prototype.handleToggleItem = /**
     * @param {?} selectedItem
     * @return {?}
     */
    function (selectedItem) {
        selectedItem.opened = !selectedItem.opened;
        this.content.items.forEach((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            if (item.title !== selectedItem.title) {
                item.opened = false;
            }
        }));
    };
    AccordionItemListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-accordion-item-list',
                    template: "<div class=\"accordion-item-list\">\n  <div class=\"accordion-item-list__title\">\n    <h3 class=\"title\">{{content?.title}}</h3>\n    <a href=\"{{content?.url}}\" id=\"{{content?.id}}\" class=\"link\">{{content?.urlLabel}}</a>\n  </div>\n  <div class=\"accordion-item-list__list\">\n    <div class=\"item\" *ngFor=\"let item of content?.items\">\n      <p class=\"item__title\" (click)=\"handleToggleItem(item)\">\n        {{item.title}}\n        <sc-icon class=\"item__icon\" [icon]=\"item.opened ? 'arrow-down' : 'arrow-right'\"></sc-icon>\n      </p>\n      <div class=\"item__description\"\n        *ngIf=\"item.opened\"\n        [innerHTML]=\"item.description | scSanitizerHtml\">\n      </div>\n    </div>\n  </div>\n</div>\n",
                    styles: [":host{display:block}.accordion-item-list{display:flex;justify-content:center;align-items:center;padding:2rem 1rem;background-color:#edf0f5}.accordion-item-list__title{margin-right:3rem;align-self:flex-start}@media only screen and (max-width:768px){.accordion-item-list{flex-direction:column}.accordion-item-list__title .title{font-size:1.6rem}}.accordion-item-list__title .link{text-decoration:none}.accordion-item-list__list{width:100%}@media only screen and (min-width:768px){.accordion-item-list__title{padding-top:.9rem}.accordion-item-list__list{width:40%}}.accordion-item-list__list .item{border-bottom:1px solid}.accordion-item-list__list .item__title{display:flex;padding:1rem 0;margin:unset;cursor:pointer;font-size:16px}.accordion-item-list__list .item__icon{margin-left:auto;padding-left:.5rem}.accordion-item-list__list .item__description{margin-bottom:1rem}"]
                }] }
    ];
    AccordionItemListComponent.propDecorators = {
        content: [{ type: Input }]
    };
    return AccordionItemListComponent;
}());
if (false) {
    /** @type {?} */
    AccordionItemListComponent.prototype.content;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accordion-item-list/accordion-item-list.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccordionItemListModule = /** @class */ (function () {
    function AccordionItemListModule() {
    }
    AccordionItemListModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        AccordionItemListComponent
                    ],
                    imports: [
                        CommonModule,
                        IconModule,
                        ScPipesModule
                    ],
                    exports: [
                        AccordionItemListComponent
                    ]
                },] }
    ];
    return AccordionItemListModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/progress-bar/progress-bar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProgressBarComponent = /** @class */ (function () {
    function ProgressBarComponent() {
    }
    ProgressBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-progress-bar',
                    template: "<div class=\"progress-bar\">",
                    styles: [":host{position:relative;height:3px;display:block;width:100%;background-color:#76c1f5;border-radius:2px;background-clip:padding-box;overflow:hidden}.progress-bar{background-color:#0070cc}.progress-bar::before{content:\"\";position:absolute;background-color:inherit;top:0;left:0;bottom:0;will-change:left,right;-webkit-animation:2.1s cubic-bezier(.65,.815,.735,.395) infinite indeterminate;animation:2.1s cubic-bezier(.65,.815,.735,.395) infinite indeterminate}.progress-bar::after{content:\"\";position:absolute;background-color:inherit;top:0;left:0;bottom:0;will-change:left,right;-webkit-animation:2.1s cubic-bezier(.165,.84,.44,1) infinite indeterminate-short;animation:2.1s cubic-bezier(.165,.84,.44,1) infinite indeterminate-short;-webkit-animation-delay:1.15s;animation-delay:1.15s}@-webkit-keyframes indeterminate{0%{left:-35%;right:100%}100%,60%{left:100%;right:-90%}}@keyframes indeterminate{0%{left:-35%;right:100%}100%,60%{left:100%;right:-90%}}@-webkit-keyframes indeterminate-short{0%{left:-200%;right:100%}100%,60%{left:107%;right:-8%}}@keyframes indeterminate-short{0%{left:-200%;right:100%}100%,60%{left:107%;right:-8%}}"]
                }] }
    ];
    return ProgressBarComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/progress-bar/progress-bar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ProgressBarModule = /** @class */ (function () {
    function ProgressBarModule() {
    }
    ProgressBarModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ProgressBarComponent],
                    exports: [ProgressBarComponent]
                },] }
    ];
    return ProgressBarModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/animations/fade-in-out.animation.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var fadeInOut = trigger('fadeInOut', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        style({ opacity: 1 }),
        animate('300ms ease-out', style({ opacity: 0 }))
    ])
]);

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: sc-portal.fe.lib.ui-core-components.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbstractMenuItem, AccordionItemListModule, AccordionModule, ActionItem, ActionMenuModule, ActionsColumn, AlphaNumericDirective, Banner, BannerModule, Breakpoints, ButtonModule, CdkDirectivesModule, CheckboxModule, ChipModule, ClickOutsideDirective, Column, ComponentColumn, ComponentFooter, ContextMenuModule, DatePickerModule, DirectivesModule, DomHelper, ErrorScreenModule, FilterBoxModule, Footer, FormControlErrorModule, GridColumnFactoryService, GridFooterFactoryService, GridModule, GridSettings, HelpDeskErrorModalModule, HideHeaderDirective, HourMaskDirective, IconBarModule, IconModule, InfoBoxModule, InputModule, LateralDrawerLightBoxModule, LateralDrawerModule, LateralMenuContentComponent, LateralMenuModule, LateralMenuService, LateralMenuServiceStub, LoadingModule, Menu, MenuItem, ModalModule, NavbarMenuFactoryService, NavbarModule, ObservableWrapper, OnEnterDirective, PaginationInfo, PaginationModule, PaginationOptions, Panel, PanelItem, PasswordRulesModule, PaymentMethodCardComponent, PaymentMethodCardModule, PendingChangesWarningModalModule, PhoneModule, PhoneNumberValidator, PlatformClassDirective, ProgressBarComponent, ProgressBarModule, RadioModule, ScArrayHelper, ScCuitPipe, ScCurrencyPipe, ScHelpersModule, ScNumericDirective, ScPipesModule, ScTabModule, ScTableModule, ScrollService, ScrollServiceStub, ScrollToTopDirective, SearchFieldModule, SelectModule, SimpleDatePickerComponent, SimpleDatePickerModule, StepperComponent, StepperModule, TagsListComponent, TagsListModule, TextareaModule, TitleModule, TooltipCustomModule, TooltipInputDecoratorModule, UiCoreComponentsModule, UploaderComponent, UploaderModule, UpperInputDirective, ValidatePassword, ValueColumn, ValueFooter, WhatsAppService, blurElement, clickElement, cuitValidator, documentFactory, emailValidator, errorMessages, fadeInOut, focusElement, getInnerHTML, getInnerText, getTextContent, passwordRules, selectAllElements, selectElement, AccordionComponent as ɵa, slideFade as ɵb, timelineListAnimation as ɵba, GridComponent as ɵbb, CellComponentAdapterComponent as ɵbc, FooterComponentAdapterComponent as ɵbd, CellCheckboxComponent as ɵbe, GridColumnFactoryService as ɵbf, GridFooterFactoryService as ɵbg, InfoBoxComponent as ɵbh, LateralMenuComponent as ɵbi, LateralMenuContentDirective as ɵbj, LoadingComponent as ɵbk, NavbarComponent as ɵbl, NavItemsComponent as ɵbm, NavSubmenuComponent as ɵbn, NavPanelItemsComponent as ɵbo, NavPanelSubmenuComponent as ɵbp, slideInOut as ɵbq, NavbarMenuFactoryService as ɵbr, AlphaNumericDirective as ɵbs, ClickOutsideDirective as ɵbt, HideHeaderDirective as ɵbu, HourMaskDirective as ɵbv, DomHelper as ɵbw, ScNumericDirective as ɵbx, OnEnterDirective as ɵby, ScrollToTopDirective as ɵbz, IconComponent as ɵc, UpperInputDirective as ɵca, SelectComponent as ɵcb, PaginationComponent as ɵcc, PasswordRulesComponent as ɵcd, PhoneComponent as ɵce, RadioGroupComponent as ɵcf, RadioItemComponent as ɵcg, SearchFieldComponent as ɵch, ScTabComponent as ɵci, TextareaComponent as ɵcj, TooltipInputDecoratorComponent as ɵck, BoxModule as ɵcl, BoxComponent as ɵcm, UploaderComponent as ɵcn, UploaderService as ɵco, ScFileSizePipe as ɵcp, ScArrayHelper as ɵcq, ScCurrencyPipe as ɵcr, ScCuitPipe as ɵcs, ScSanitizerHtmlPipe as ɵct, BannerComponent as ɵcu, HelpDeskErrorModalComponent as ɵcv, getWindow as ɵcw, WindowRef as ɵcx, ErrorScreenComponent as ɵcy, ChipComponent as ɵcz, TitleComponent as ɵd, AccordionItemListComponent as ɵda, EditButtonModule as ɵe, TooltipComponent as ɵf, EditButtonComponent as ɵg, ActionMenuComponent as ɵh, ButtonComponent as ɵi, CheckboxComponent as ɵj, IconBarComponent as ɵk, ModalComponent as ɵl, PendingChangesWarningModalComponent as ɵm, ContextMenuComponent as ɵn, FormControlErrorComponent as ɵo, InputComponent as ɵp, BaseTextInputComponent as ɵq, DatePickerComponent as ɵr, LateralDrawerComponent as ɵs, LateralDrawerLightBoxComponent as ɵt, FilterBoxComponent as ɵu, IconContextMenuModule as ɵv, IconContextMenuComponent as ɵw, ScEmptyTableMessageComponent as ɵx, ScTableComponent as ɵy, tableListAnimation as ɵz };
//# sourceMappingURL=sc-portal.fe.lib.ui-core-components.js.map
